webpackJsonp([0],{

/***/ "+T/6":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\">\n  <div class=\"card-header\" id=\"card-stay-summary\">{{'EVENT.COMMISSION.SUMMARY' | translate}}</div>\n  <div class=\"table-responsive\">\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th>{{'EVENT.COMMISSION.ROOM_TYPE' | translate}}</th>\n        <th class=\"nights\">{{'EVENT.COMMISSION.ROOM_COUNT' | translate}}</th>\n        <th class=\"currency\">{{'EVENT.COMMISSION.ROOM_RATE' | translate}}</th>\n        <th class=\"currency\">{{'EVENT.COMMISSION.ROOM_REVENUE' | translate}}</th>\n        <th class=\"currency\">{{'EVENT.COMMISSION.ROOM_COMMISSION' | translate}}</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let roomTypeRateSummary of roomTypeRateSummaryList | async\"\n          data-se-id=\"roomSummaryRow\">\n        <td data-se-id=\"roomType\">{{roomTypeRateSummary.roomType}}</td>\n        <td class=\"nights\" data-se-id=\"totalNights\">{{roomTypeRateSummary.totalNights}}</td>\n        <td class=\"currency\" data-se-id=\"roomRate\">{{roomTypeRateSummary.roomRate | currency:\n          'USD':true}}\n        </td>\n        <td class=\"currency\" data-se-id=\"totalRevenue\">{{roomTypeRateSummary.totalRevenue |\n          currency: 'USD':true}}\n        </td>\n        <td class=\"currency\" data-se-id=\"totalCommission\">{{\n          getCommission(roomTypeRateSummary.totalRevenue) | currency: 'USD':true}}\n        </td>\n      </tr>\n      </tbody>\n      <tfoot>\n      <tr data-se-id=\"staySummaryRow\">\n        <td>{{'EVENT.COMMISSION.TOTAL' | translate}}</td>\n        <td class=\"nights\" data-se-id=\"totalNights\">{{(staySummary | async)?.totalNights}}</td>\n        <td class=\"currency\"></td>\n        <td class=\"currency\" data-se-id=\"totalRevenue\">{{(staySummary | async)?.totalRevenue |\n          currency: 'USD':true}}\n        </td>\n        <td class=\"currency\" data-se-id=\"totalCommission\">{{ getCommission( (staySummary |\n          async)?.totalRevenue ) | currency: 'USD':true}}\n        </td>\n      </tr>\n      </tfoot>\n    </table>\n  </div>\n</div>\n"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cDNt");


/***/ }),

/***/ "0Dgx":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\" data-se-id=\"adjustmentList\">\n  <label class=\"form-control-label\">\n    {{ 'EVENT.COMMISSION.AMOUNT_DUE' | translate }}\n  </label>\n  <div class=\"commission\">\n    <span class=\"currency\">\n      {{ totalCommission | async | number:'1.2-2' }}\n    </span>\n    <span class=\"desc\">\n      {{ 'EVENT.COMMISSION.COMMISSIONS' | translate }}\n    </span>\n  </div>\n  <div *ngFor=\"let adjustment of modifiers | async\"\n       [class]=\"getModifierCssClass(adjustment)\"\n       data-se-id=\"modifierEntry\">\n    <span [class]=\"getModifierAmountCssClass(adjustment)\"\n          data-se-id=\"modifierAmount\">\n      {{ adjustment.adjustmentAmount | number:'1.2-2' }}\n    </span>\n    <span class=\"desc\">\n      {{ adjustment.adjustmentType | adjustmentType }}\n    </span>\n  </div>\n  <div *ngIf=\"areThereAnyModifiers() | async\" class=\"total\">\n    <span class=\"currency\" data-se-id=\"calculatedPayment\">\n      {{ calculatedPayment | async | number:'1.2-2'  }}\n    </span>\n    <span class=\"desc\">\n      {{ 'EVENT.COMMISSION.CALCULATED_PAYMENT' | translate }}\n    </span>\n  </div>\n</div>\n"

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1DO0":
/***/ (function(module, exports) {

module.exports = "<p>\n  {{'LOGOUT.LOGOUT_CONFIRMATION' | translate}}\n\n  <button (click)=\"onLogout($event)\">{{'LOGOUT.LOGOUT' | translate}}</button>\n</p>\n"

/***/ }),

/***/ "1Wrw":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group form-search\">\n  <div class=\"input-group\" [class.show]=\"hasResults\">\n    <input class=\"form-control dropdown-toggle\" type=\"text\"\n           [(ngModel)]=\"nameSearch\"\n           placeholder=\"{{placeholderText | translate}}\"\n           (blur)=\"onBlur()\">\n    <div class=\"input-group-addon\"><i class=\"glyph-search\"></i></div>\n    <ng-content></ng-content>\n  </div>\n</div>\n"

/***/ }),

/***/ "3XO/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"flash.messages.component.css","sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "6Ls2":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\" [formGroup]=\"contactLookupForm\" id=\"card-{{partyType | lowercase}}\">\n  <div class=\"card-header\">\n    {{ contactTypeTitle }} {{ 'EVENT.CONTACT_TITLE' | translate }}\n    <span class=\"text-danger\" *ngIf=\"isReadyOnlyProperty()\">*</span>\n  </div>\n  <div class=\"card-block\">\n\n    <div *ngIf=\"isPropertyMissing()\" class=\"alert alert-danger\">\n      {{ 'EVENT.PROPERTY_REQUIRED' | translate }}\n    </div>\n\n    <div class=\"col-12\">\n      <pioneer-inline-search-component *ngIf=\"!isReadOnly && partyType === 'PROPERTY'\"\n                                       (results)=\"updateResults($event)\"\n                                       [lookupStore]=\"propertyStore\"\n                                       [placeholderText]=\"'EVENT.PROPERTY_SEARCH'\"\n                                       (blur)=\"inlineSearchTouched()\">\n        <ul class=\"dropdown-menu\">\n          <!--\n            Using mousedown instead of click\n            so that onSelectedProperty runs before\n            inlineSearchTouched is triggered by blur.\n            -->\n          <li class=\"dropdown-item\"\n              *ngFor=\"let searchProperty of summaryResults\"\n              (mousedown)=\"onSelectedProperty(searchProperty)\"\n              data-se-id=\"property-lookup-result\">\n            <p class=\"prop-name\">{{searchProperty.name}}</p>\n            <div *ngIf=\"searchProperty.address\" class=\"prop-info\">\n              <p class=\"addr\" data-se-id=\"property-lookup-address-line1\">{{searchProperty.address.line1}}</p>\n              <p class=\"addr\">\n                {{searchProperty.address.city}}, {{searchProperty.address.state}} {{searchProperty.address.postalCode}}\n              </p>\n              <p class=\"pid\">{{searchProperty.brand}} / {{searchProperty.propertyId}}</p>\n            </div>\n          </li>\n        </ul>\n      </pioneer-inline-search-component>\n\n      <pioneer-inline-search-component *ngIf=\"!isReadOnly && partyType === 'AGENCY'\"\n                                       (results)=\"updateResults($event)\"\n                                       [lookupStore]=\"agencyStore\"\n                                       [placeholderText]=\"'EVENT.AGENCY_SEARCH'\"\n                                       (blur)=\"inlineSearchTouched()\">\n        <ul class=\"dropdown-menu\">\n          <li class=\"dropdown-item\"\n              *ngFor=\"let searchAgency of summaryResults\"\n              (mousedown)=\"onSelectedAgency(searchAgency)\"\n              data-se-id=\"agency-lookup-result\">\n            {{searchAgency.name}} - {{searchAgency.agencyId}}\n          </li>\n        </ul>\n      </pioneer-inline-search-component>\n    </div>\n\n    <pioneer-child-contact-form [contactForm]=\"contactLookupForm\"\n                                [partyType]=\"partyType\"\n                                [event]=\"onyxEvent\"\n                                [contactReferenceNumberTitle]=\"contactReferenceNumberTitle\"\n                                [isReadOnly]=\"isReadOnly\">\n    </pioneer-child-contact-form>\n\n  </div>\n</div>\n"

/***/ }),

/***/ "8Q4s":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"eventFilterForm\"\n      (keydown.enter)=\"$event.preventDefault()\"\n      novalidate>\n\n  <ul class=\"list-group sub-nav collapse show\"\n      id=\"nav-filters\"\n      data-se-id=\"filterEventsNav\">\n    <li class=\"list-group-item\">\n      <a class=\"item-link\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-filters\"\n         href=\"#nav-filters-payment\"\n         data-se-id=\"paymentFilterMenu\">\n            <span class=\"item-text\">\n              {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.LABEL' | translate }}\n            </span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n      <div id=\"nav-filters-payment\"\n           class=\"collapse show\">\n        <div class=\"form-group col\" formGroupName=\"paymentStatus\">\n          <!-- Note: The data-se-id must be on the label for the\n                 checkboxes to receive click actions -->\n          {{ eventFilterForm.getError('validatePaymentStatus') }}\n          <!-- unpaid checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"payment-status-unpaid-filter-checkbox\">\n              <input type=\"checkbox\"\n                     formControlName=\"unpaid\"\n                     class=\"custom-control-input\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">\n                    {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.UNPAID' | translate }}\n                  </span>\n            </label>\n          </div>\n\n          <!-- payment in process checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"payment-status-payment-in-process-filter-checkbox\">\n              <input type=\"checkbox\"\n                     formControlName=\"inProcess\"\n                     class=\"custom-control-input\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">\n                    {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.PAYMENT_IN_PROCESS' | translate }}\n                  </span>\n            </label>\n          </div>\n\n          <!-- paid checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"payment-status-paid-filter-checkbox\">\n              <input type=\"checkbox\"\n                     formControlName=\"paid\"\n                     class=\"custom-control-input\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">\n                    {{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.PAID' | translate }}\n                  </span>\n            </label>\n          </div>\n\n        </div>\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterCommissionId\">{{\n            'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.COMMISSION_ID' | translate }}</label>\n          <input type=\"text\" class=\"form-control form-control-sm\" data-se-id=\"commissionIdInput\"\n                 formControlName=\"commissionId\"\n                 id=\"filterCommissionId\" placeholder=\"Commission ID\">\n        </div>\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterFundingId\">{{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.FUNDING_ID' |\n            translate }}</label>\n          <input type=\"text\" class=\"form-control form-control-sm\"\n                 data-se-id=\"fundingReferenceIdInput\"\n                 formControlName=\"fundingReferenceId\"\n                 id=\"filterFundingId\" placeholder=\"Funding ID\">\n        </div>\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterPaymentId\">{{ 'COMMON.NAV.SEARCH_EVENTS.PAYMENT_FILTERS.PAYMENT_ID' |\n            translate }}</label>\n          <input type=\"text\" class=\"form-control form-control-sm\"\n                 data-se-id=\"paymentReferenceIdInput\"\n                 formControlName=\"paymentReferenceId\"\n                 id=\"filterPaymentId\" placeholder=\"Payment ID\">\n        </div>\n      </div>\n    </li>\n\n    <!-- Event Filters -->\n    <li class=\"list-group-item\">\n\n      <!-- This link expands the section below -->\n      <a class=\"item-link\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-filters\"\n         href=\"#nav-filters-event\"\n         data-se-id=\"eventFilterMenu\">\n        <span\n          class=\"item-text\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.LABEL' | translate }}</span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n\n      <!-- When the 'show' class is applied, this section expanded -->\n      <div class=\"collapse\"\n           [class.show]=\"isEventFilterMenuExpanded\"\n           id=\"nav-filters-event\">\n        <div class=\"form-group col\">\n\n          <!-- Completed Checkbox -->\n          <div class=\"form-check\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"completedEventCheckbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"eventStatusCompleted\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.COMPLETED' | translate }}</span>\n            </label>\n          </div>\n\n          <!-- Missing Agency Checkbox -->\n          <div class=\"form-check\" *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n            <label class=\"custom-control custom-checkbox\"\n                   data-se-id=\"missingAgencyCheckbox\">\n              <input type=\"checkbox\"\n                     class=\"custom-control-input\"\n                     formControlName=\"eventStatusMissingAgency\">\n              <span class=\"custom-control-indicator\"></span>\n              <span class=\"custom-control-description\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.MISSING_AGENCY' | translate }}</span>\n            </label>\n          </div>\n        </div>\n\n        <!-- Date Inputs -->\n        <div class=\"form-group col-sm-auto col-md-12\"\n             [ngClass]=\"{'form-error': eventFilterForm.controls['startDate'].invalid || eventFilterForm.controls['endDate'].invalid || eventFilterForm.getError('greater')}\"\n           >\n          <label for=\"filterDateStart\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.DATE_RANGE' |  translate }}</label>\n          <input type=\"date\" class=\"form-control form-control-sm\"\n                 formControlName=\"startDate\" id=\"filterDateStart\"\n                 placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\"\n                 data-se-id=\"filterDateStart\">\n          <input type=\"date\" class=\"form-control form-control-sm\"\n                 formControlName=\"endDate\" id=\"filterDateEnd\"\n                 placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\" data-se-id=\"filterDateEnd\">\n        </div>\n\n        <!-- Guest Name -->\n        <div class=\"form-group col-sm-auto col-md-12\">\n          <label for=\"filterDateStart\">{{ 'COMMON.NAV.SEARCH_EVENTS.EVENT_FILTERS.GUEST_NAME' |\n            translate }}</label>\n          <input type=\"text\"\n                 formControlName=\"guestName\"\n                 class=\"form-control form-control-sm\"\n                 id=\"filterGuest\"\n                 placeholder=\"First Last\"\n                 data-se-id=\"guestNameInput\">\n        </div>\n      </div>\n    </li>\n\n    <li class=\"list-group-item button-bar\">\n      <button class=\"btn btn-link btn-sm\" (click)=\"resetSearchFilters()\"\n              data-se-id=\"appNavResetButton\">{{ 'COMMON.NAV.SEARCH_EVENTS.RESET' | translate }}\n      </button>\n      <button class=\"btn btn-primary btn-sm\"\n              [disabled]=\"!eventFilterForm.valid\"\n              (click)=\"applySearchFilters(eventFilterForm.value)\"\n              data-se-id=\"appNavFilterButton\">{{ 'COMMON.NAV.SEARCH_EVENTS.FILTER' | translate }}\n      </button>\n    </li>\n  </ul>\n</form>\n"

/***/ }),

/***/ "9I5S":
/***/ (function(module, exports) {

module.exports = "<div [formGroup]=\"contactForm\">\n  <ng-template #firstNameLastName>\n    <div [formGroup]=\"contactForm.controls.contact\">\n    <div class=\"row\">\n      <div class=\"form-container contact-name-first\">\n        <pioneer-form-input label=\"EVENT.CONTACT_FIRST_NAME\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"firstName\"\n                 maxlength=\"80\"\n                 [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_FIRST_NAME_PLACEHOLDER' | translate) : ''\"\n                 [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container contact-name-last\">\n        <pioneer-form-input label=\"EVENT.CONTACT_LAST_NAME\">\n          <input type=\"text\"\n                 class=\"form-control\"\n                 formControlName=\"lastName\"\n                 maxlength=\"80\"\n                 [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_LAST_NAME_PLACEHOLDER' | translate) : ''\"\n                 [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n        </pioneer-form-input>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"form-container contact-email\">\n        <pioneer-form-input label=\"EVENT.CONTACT_EMAIL_ADDRESS\">\n          <input type=\"email\"\n                 class=\"form-control\"\n                 formControlName=\"email\"\n                 maxlength=\"80\"\n                 [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_EMAIL_ADDRESS_PLACEHOLDER' | translate) : ''\"\n                 [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n        </pioneer-form-input>\n      </div>\n      <div class=\"form-container contact-tel\">\n        <div class=\"row\">\n          <div class=\"form-container contact-phone\">\n            <pioneer-form-input label=\"EVENT.CONTACT_PHONE_NUMBER\">\n              <input type=\"tel\"\n                     class=\"form-control\"\n                     formControlName=\"phone\"\n                     maxlength=\"80\"\n                     [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_PHONE_NUMBER_PLACEHOLDER' | translate) : ''\"\n                     [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n            </pioneer-form-input>\n          </div>\n          <div class=\"form-container contact-fax\">\n            <pioneer-form-input label=\"EVENT.CONTACT_FAX_NUMBER\">\n              <input type=\"tel\"\n                     class=\"form-control\"\n                     formControlName=\"fax\"\n                     maxlength=\"80\"\n                     [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_FAX_NUMBER_PLACEHOLDER' | translate) : ''\"\n                     [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  </ng-template>\n\n  <ng-template #companyAddress>\n <div class=\"row\">\n    <div class=\"form-container party-name\">\n      <pioneer-form-input label=\"EVENT.CONTACT_COMPANY_NAME\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"name\"\n               maxlength=\"96\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_COMPANY_NAME_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n      </pioneer-form-input>\n    </div>\n    <div *ngIf=\"partyType === 'CLIENT'\" class=\"form-container party-id\">\n      <!-- These are the Onyx Identifiers and should not be visible after the integration work -->\n      <pioneer-form-input label=\"EVENT.CONTACT_CLIENT_ID\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"clientReferenceNumber\"\n               maxlength=\"20\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_CLIENT_ID_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"isReadOnly\"/>\n      </pioneer-form-input>\n    </div>\n    <div class=\"form-container party-address\">\n      <pioneer-form-input label=\"EVENT.CONTACT_ADDRESS\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"line1\"\n               maxlength=\"120\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_ADDRESS_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n      </pioneer-form-input>\n    </div>\n    <div class=\"form-container party-city\">\n      <pioneer-form-input label=\"EVENT.CONTACT_CITY\">\n        <input type=\"text\"\n               class=\"form-control\"\n               formControlName=\"city\"\n               maxlength=\"120\"\n               [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_CITY_PLACEHOLDER' | translate) : ''\"\n               [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n      </pioneer-form-input>\n    </div>\n    <div class=\"form-container party-state-zip\">\n      <div class=\"row\">\n        <div class=\"form-container party-state\">\n          <pioneer-form-input label=\"EVENT.CONTACT_STATE\">\n            <input type=\"text\"\n                   class=\"form-control\"\n                   formControlName=\"state\"\n                   maxlength=\"2\"\n                   [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_STATE_PLACEHOLDER' | translate) : ''\"\n                   [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n          </pioneer-form-input>\n        </div>\n        <div class=\"form-container party-zip\">\n          <pioneer-form-input label=\"EVENT.CONTACT_POSTAL_CODE\">\n            <input type=\"text\"\n                   class=\"form-control\"\n                   formControlName=\"postalCode\"\n                   maxlength=\"10\"\n                   [attr.placeholder]=\"partyType === 'CLIENT' && !isReadOnly ? ('EVENT.CONTACT_POSTAL_CODE_PLACEHOLDER' | translate) : ''\"\n                   [readonly]=\"isReadOnly || partyType !== 'CLIENT'\"/>\n          </pioneer-form-input>\n        </div>\n      </div>\n    </div>\n  </div>\n  </ng-template>\n\n  <ng-container *ngIf=\"partyType === 'CLIENT'; then firstNameLastName; else companyAddress\"></ng-container>\n  <ng-container *ngIf=\"partyType === 'CLIENT'; then companyAddress; else firstNameLastName\"></ng-container>\n \n</div>\n"

/***/ }),

/***/ "Cww6":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"active-filters\" id=\"filter-control\">\n    <p class=\"filter-label\">{{ 'DASHBOARD.FILTERS_TITLE' | translate }}</p>\n    <div class=\"filter-list form-group\">\n      <div class=\"form-check\">\n        <label class=\"filter-item custom-control custom-checkbox checked\"\n               [class.checked]=\"showCompletedAndUnpaid\"\n               data-toggle=\"collapse\"\n               data-parent=\".card-content\"\n               href=\"#card-1\"\n               data-se-id=\"completedAndUnpaidFilter\"\n               (click)=\"toggleShowCompletedAndUnpaid()\">\n          <i class=\"button-state\"></i>\n          <span class=\"custom-control-description\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID' | translate }}</span>\n        </label>\n        <label class=\"filter-item custom-control custom-checkbox checked\"\n               [class.checked]=\"showMissingAgency\"\n               data-toggle=\"collapse\"\n               data-parent=\".card-content\"\n               href=\"#card-2\"\n               data-se-id=\"missingAgencyFilter\"\n               (click)=\"toggleShowMissingAgency()\"\n               *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n          <i class=\"button-state\"></i>\n          <span class=\"custom-control-description\">{{ 'DASHBOARD.MISSING_AGENCY' | translate }}</span>\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"card-content\">\n    <div class=\"card-deck\">\n      <pioneer-completed-unpaid></pioneer-completed-unpaid>\n    </div>\n    <div class=\"card-deck\" *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n      <pioneer-missing-agency></pioneer-missing-agency>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "EqCs":
/***/ (function(module, exports) {

module.exports = "<div class=\"left-nav\">\n  <ul class=\"nav flex-column\" id=\"nav-left-list\">\n    <li class=\"nav-item menu-toggle\">\n      <i class=\"glyph-hamburger nav-link\" (click)=\"toggleNavCollapsed()\"></i>\n    </li>\n\n    <li class=\"nav-item\">\n      <a *ngIf=\"!isOnDashboard()\"\n         href=\"#nav-dashboard-list\"\n         class=\"nav-link\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\"\n         [routerLink]=\"['/dashboard']\">\n\n        <i class=\"glyph-guage nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.LABEL' | translate }}</span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n      <a *ngIf=\"isOnDashboard()\"\n         href=\"#nav-dashboard-list\"\n         class=\"nav-link active\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\">\n\n        <i class=\"glyph-guage nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.LABEL' | translate }}</span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n      <ul *ngIf=\"isOnDashboard()\"\n          class=\"sub-nav collapse show\"\n          id=\"nav-dashboard-list\">\n        <li class=\"nav-item\">\n          <a href=\"javascript:void(0)\"\n             class=\"nav-link\"\n             (click)=\"completedAndUnpaidPredefinedSearch()\"\n             data-se-id=\"completed-and-unpaid-predefined-search\">\n            <span *ngIf=\"showCompletedAndUnpaidTotals() | async\" class=\"count\">{{ completedAndUnpaidTotal | async }}</span>\n            <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.CARDS.COMPLETED_AND_UNPAID' | translate }}</span>\n          </a>\n        </li>\n        <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'ViewMissingAgencyElements'}\">\n          <a href=\"javascript:void(0)\"\n             (click)=\"missingAgencyPredefinedSearch()\"\n             class=\"nav-link\"\n             data-se-id=\"missing-agency-predefined-search\">\n            <span *ngIf=\"showMissingAgencyTotals() | async\" class=\"count\">{{ missingAgencyTotal | async }}</span>\n            <span class=\"item-text\">{{ 'COMMON.NAV.DASHBOARD.CARDS.MISSING_AGENCY' | translate }}</span>\n          </a>\n        </li>\n      </ul>\n    </li>\n\n    <li class=\"nav-item\">\n      <a *ngIf=\"!isOnSearchEvents()\"\n         class=\"nav-link\"\n         href=\"#nav-filters\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\"\n         (click)=\"navigateToSearch()\"\n         data-se-id=\"viewEventsLink\">\n\n        <i class=\"glyph-search nav-link-addon\"></i>\n        <span class=\"item-text\">\n          {{ 'COMMON.NAV.SEARCH_EVENTS.LABEL' | translate }}\n        </span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n      <a *ngIf=\"isOnSearchEvents()\"\n         class=\"nav-link active\"\n         data-toggle=\"collapse\"\n         data-parent=\"#nav-left-list\"\n         href=\"#nav-filters\"\n         data-se-id=\"viewEventsLink\">\n        <i class=\"glyph-search nav-link-addon\"></i>\n        <span class=\"item-text\">\n          {{ 'COMMON.NAV.SEARCH_EVENTS.LABEL' | translate }}\n        </span>\n        <i class=\"nav-link-addon glyph-arrow-down\"></i>\n      </a>\n\n      <pioneer-event-search-filter *ngIf=\"isOnSearchEvents()\"></pioneer-event-search-filter>\n\n    </li>\n    <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'AddEvent'}\">\n      <a class=\"nav-link\"\n         [routerLink]=\"['/events/add']\"\n         routerLinkActive=\"active\"\n         [routerLinkActiveOptions]=\"{exact:true}\"\n         data-se-id=\"addEventLink\">\n        <i class=\"glyph-plus nav-link-addon\"></i>\n        <span class=\"item-text\">{{ 'COMMON.NAV.ADD_EVENT' | translate }}</span>\n      </a>\n    </li>\n    <router-outlet name=\"event\"></router-outlet>\n  </ul>\n</div>\n"

/***/ }),

/***/ "F5Qg":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\" [formGroup]=\"contactForm\" id=\"card-{{partyType | lowercase}}\">\n  <div class=\"card-header\">\n    {{ contactTypeTitle }} {{ 'EVENT.CONTACT_TITLE' | translate }}\n  </div>\n  <div class=\"card-block\">\n\n    <pioneer-child-contact-form [contactForm]=\"contactForm\"\n                                [partyType]=\"partyType\"\n                                [event]=\"onyxEvent\"\n                                [contactReferenceNumberTitle]=\"contactReferenceNumberTitle\"\n                                [isReadOnly]=\"isReadOnly\">\n    </pioneer-child-contact-form>\n\n\n  </div>\n</div>\n"

/***/ }),

/***/ "FS9g":
/***/ (function(module, exports) {

module.exports = "<p>\n  {{'ROUTE_NOT_FOUND.DESCRIPTION' | translate}}\n</p>\n"

/***/ }),

/***/ "Jeo/":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"attachmentConfirmationModal\"\n  content=\"EVENT.CONFIRM_REMOVE_DOCUMENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.REMOVE_DOCUMENT\"\n  (closed)=\"confirmHandler($event)\">\n</pioneer-confirmation-modal>\n<div class=\"doc-library can-remove\"\n     [class.can-remove]=\"canDeleteFiles()\"\n     id=\"card-attachment\">\n  <div class=\"card\">\n    <div class=\"card-block\">\n      <form>\n        <div class=\"card-title\">{{'EVENT.EVENT_DOCUMENTS' | translate}}<span class=\"document-count\">{{attachments.size}}</span>\n          <div *pioneerAuthorize=\"{permission: 'AddFiles'}\" class=\"button-bar\">\n            <label class=\"upload-link\" for=\"file\">\n              {{'EVENT.UPLOAD_DOCUMENT' | translate}}\n              <i class=\"glyph-cloud-up\"></i>\n            </label>\n            <input #file\n                   id=\"file\"\n                   data-se-id=\"file_upload\"\n                   hidden\n                   type=\"file\"\n                   accept=\"{{fileTypes}}\"\n                   placeholder=\"{{'EVENT.UPLOAD_DOCUMENT' | translate}}\"\n                   (change)=\"uploadFile($event)\"/>\n          </div>\n        </div>\n      </form>\n      <ol class=\"file-list\" data-se-id=\"uploaded_attachments\">\n        <li class=\"file-item file-uploading\" [hidden]=\"!isUploadInProgress\">\n          <div class=\"progress\">\n            <div class=\"progress-bar progress-bar-striped progress-bar-animated\"\n                 role=\"progressbar\"\n                 aria-valuenow=\"100\"\n                 aria-valuemin=\"0\"\n                 aria-valuemax=\"100\"\n                 style=\"width: 100%\">{{'EVENT.UPLOADING' | translate}}\n            </div>\n          </div>\n        </li>\n        <li *ngFor=\"let attachment of attachments\" class=\"file-item\"\n            [class.item-new]=\"isNewAttachment && attachment === attachments.get(0)\"\n            data-se-id=\"attachment\"\n            [class.discarded]=\"removedAttachments.has(attachment.uniqueId)\">\n          <div class=\"item-link document-item\"\n               [attr.filetype]=\"getFileExtension(attachment.name)\">\n            <i class=\"icon-file\"\n               data-se-id=\"attachmentIcon\"\n               (click)=\"canDeleteFiles() ? confirmBeforeDelete(attachment) : openFile(attachment)\"></i>\n            <span class=\"item-file-name\"\n                  (click)=\"openFile(attachment)\"\n                  data-se-id=\"name\">{{attachment.name}}</span>\n          </div>\n          <div class=\"item-detail\">\n            <span class=\"item-detail-user\" data-se-id=\"uploader\">{{attachment.uploader}}</span>\n            <span class=\"item-detail-date\" data-se-id=\"uploadDate\">{{attachment.uploadDate | date:'longDate'}}</span>\n          </div>\n        </li>\n      </ol>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "K2V+":
/***/ (function(module, exports) {

module.exports = "<form class=\"form-signin\" method=\"POST\" action=\"#\" role=\"form\" (ngSubmit)=\"onLogin($event)\">\n  <div class=\"login-content\">\n    <div class=\"login-container\">\n      <div class=\"login-logo\" id=\"loginLogo\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n      <div class=\"login-form\">\n        <h4 id=\"subtitle\">{{ 'LOGIN.TITLE' | translate }}</h4>\n        <div class=\"form-group\">\n          <label for=\"loginUsername\">{{ 'LOGIN.USERNAME' | translate }}</label>\n          <input id=\"loginUsername\" required=\"\" type=\"text\" maxlength=\"100\" class=\"form-control\"\n                 [(ngModel)]=\"email\"\n                 [ngModelOptions]=\"{standalone: true}\"\n                 placeholder=\"{{ 'LOGIN.USERNAME_PLACEHOLDER' | translate }}\"/>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"loginPassword\">{{ 'LOGIN.PASSWORD' | translate }}</label>\n          <input id=\"loginPassword\" required=\"\" type=\"password\" maxlength=\"25\" class=\"form-control\"\n                 length=\"40\" [(ngModel)]=\"password\" [ngModelOptions]=\"{standalone: true}\"\n                 placeholder=\"{{ 'LOGIN.PASSWORD_PLACEHOLDER' | translate }}\"/>\n        </div>\n        <div class=\"form-group\">\n          <button type=\"submit\" id=\"loginSubmit\" class=\"btn btn-primary btn-block\">\n            {{ 'LOGIN.LOGIN' | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ "KTxh":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\" data-se-id=\"event-list\">\n    <div class=\"row\">\n\n      <div class=\"event-search\">\n        <form [formGroup]=\"eventSearchTextForm\" novalidate>\n        <div class=\"form-group form-search\">\n          <div class=\"input-group\">\n            <input class=\"form-control\" type=\"text\" id=\"search\" maxlength=\"100\" name=\"search\"\n                   required autocomplete=\"off\"\n                   formControlName=\"searchText\"\n                   (keydown.enter)=\"addSearchText(eventSearchTextForm.value)\"\n                   placeholder=\"{{ 'EVENTS.SEARCH_PLACEHOLDER' | translate }}\"/>\n            <div class=\"input-group-addon\">\n              <i (click)=\"addSearchText(eventSearchTextForm.value)\" class=\"glyph-search\"></i>\n            </div>\n          </div>\n        </div>\n        </form>\n        <div class=\"active-filters\">\n          <p class=\"filter-label\">{{'EVENTS.ACTIVE_FILTERS' | translate}}</p>\n          <div class=\"view-select float-right\">\n            <div class=\"btn-group btn-group-sm\">\n              <button class=\"btn btn-default\"\n                      [ngClass]=\"{'active': (isDefaultViewSelected | async) }\"\n                      (click)=\"updateToDefaultURL()\"\n                      data-se-id=\"event-default-toggle-button\">\n                <i class=\"glyph-page\"></i>{{'EVENTS.DEFAULT_BUTTON' | translate}}\n              </button>\n              <button class=\"btn btn-default\"\n                      [ngClass]=\"{'active': !(isDefaultViewSelected | async) }\"\n                      (click)=\"updateToFinancialURL()\"\n                      data-se-id=\"event-financial-toggle-button\">\n                <i class=\"glyph-pages\"></i>{{'EVENTS.FINANCIAL_BUTTON' | translate}}\n              </button>\n            </div>\n          </div>\n          <ol class=\"filter-list\">\n            <li *ngFor=\"let searchText of searchTextSet | async\"\n                class=\"filter-item search-filter\"\n                data-se-id=\"searchFilterToken\"\n                (click)=\"removeSearchText($event)\">\n              {{ searchText }}\n            </li>\n            <li *ngFor=\"let searchFilter of searchFilterSet | async\"\n                class=\"filter-item nav-filter\"\n                data-se-id=\"searchFilterToken\"\n                (click)=\"removeSearchFilter($event, searchFilter)\">\n              <span class=\"field-name\">\n                {{ getTokenFilterFieldTranslationKey(searchFilter.filterField) | translate }}\n              </span>\n              <span class=\"field-value\">\n                {{ getTokenValue(searchFilter) }}\n              </span>\n            </li>\n            <li class=\"filter-clear\">\n              <span class=\"clear-link \" (click)=\"resetSearch()\">{{'EVENTS.CLEAR_FILTERS' | translate}}</span>\n            </li>\n            <li class=\"filter-none\">{{'EVENTS.NO_FILTERS' | translate}}</li>\n          </ol>\n        </div>\n      </div>\n\n      <div class=\"card-content\">\n        <div *ngIf=\"!(eventsPresent | async)\" class=\"result-empty\">\n          <h3>{{'EVENTS.NO_EVENTS' | translate}}</h3>\n          <figure class=\"figure\"><i class=\"glyph-calendar figure-img\"></i>\n            <figcaption class=\"figure-caption\">\n              <a (click)=\"resetSearch()\">{{ 'EVENTS.RESET_FILTERS' | translate }}</a>\n            </figcaption>\n          </figure>\n        </div>\n\n        <pioneer-event-list-default-table *ngIf=\"isDefaultViewSelected | async\"></pioneer-event-list-default-table>\n        <pioneer-event-list-financial-table *ngIf=\"!(isDefaultViewSelected | async)\"></pioneer-event-list-financial-table>\n      </div>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "Kbn7":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div id=\"flashMessages\">\n    <div class=\"flash-message alert alert-danger\">\n      {{ error | translate }}\n    </div>\n  </div>\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"

/***/ }),

/***/ "Mz5u":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <pioneer-reservation-filter [event]=\"onyxEvent\"></pioneer-reservation-filter>\n\n      <pioneer-reservation-summary-table *ngIf=\"getSummarySelected() | async\"\n                                         [event]=\"onyxEvent\"></pioneer-reservation-summary-table>\n      <pioneer-reservation-detail-table *ngIf=\"!(getSummarySelected() | async)\"\n                                        [event]=\"onyxEvent\"></pioneer-reservation-detail-table>\n    </div>\n\n    <pioneer-event-nav></pioneer-event-nav>\n  </div>\n</div>\n"

/***/ }),

/***/ "OprT":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"ui.showCards\">\n\n  <!--              No Matches         -->\n  <div *ngIf=\"ui.showNoMatchesCard\"\n       id=\"card-no-match-list\"\n       class=\"card\">\n    <template #commissionNoMatchTooltip>\n      <p class='lead' data-se-id=\"no-match-tooltip-title\">\n        {{ getNoMatchCardHeaderTitleTooltip() | async | translate }}</p>\n      <p class='res-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_TOTAL' | translate }}</span>\n        {{ getReservationTotalCommission(MatchTypeEnum.NO_MATCH) | async | currency:'USD':true }}\n      </p>\n      <div *ngIf=\"!(isRsvpMatchListEmpty(MatchTypeEnum.NO_MATCH) | async)\">\n        <p class='rsvp-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_RSVP' | translate }}</span>\n          {{ getRsvpTotalCommission(MatchTypeEnum.NO_MATCH) | async | currency:'USD':true }}</p>\n        <p class='diff-comm'>\n          <span\n            class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE' | translate }}</span>\n          {{ getCommissionDeltaText(MatchTypeEnum.NO_MATCH) | async }} {{\n          getCommissionDelta(MatchTypeEnum.NO_MATCH) | async | absolute | currency:'USD':true }}\n        </p>\n      </div>\n    </template>\n    <div class=\"card-header\">\n      {{ getNoMatchCardHeaderTitle() | async | translate }}\n      <span class=\"commission-sum\"\n            [ngClass]=\"totalCommissionClass(MatchTypeEnum.NO_MATCH) | async\"\n            data-se-id=\"no-match-top-total-span\">\n        <span class=\"res-value\" [tooltip]=\"commissionNoMatchTooltip\" placement=\"right\"\n              data-se-id=\"no-match-commission-total\">\n          {{ getReservationTotalCommission(MatchTypeEnum.NO_MATCH) | async | currency:'USD':true }}\n        </span>\n      </span>\n    </div>\n\n    <div *ngIf=\"ui.showNoMatchesDetails\"\n         class=\"table-responsive\">\n      <table class=\"table reservation-list match-none\">\n        <thead>\n        <tr>\n          <th>{{ 'EVENT.RESERVATION.NAME' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\">{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.REVENUE' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.COMMISSION' | translate }}</th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailNoMatch\">\n        <tr *ngFor=\"let compare of getMatches(MatchTypeEnum.NO_MATCH) | async\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp)\"\n            [attr.data-res-id]=\"getReservationId(compare.reservation)\"\n            data-se-id=\"reservationDetailEntry\"\n            [class.commission-up]=\"isCommissionUp(compare)\"\n            [class.commission-down]=\"isCommissionDown(compare)\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <td data-se-id=\"name\">\n            <span *ngIf=\"compare.reservation\">{{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}</span>\n            <span\n              *ngIf=\"compare.rsvp\">{{ compare.rsvp.lastName }}, {{ compare.rsvp.firstName }}</span>\n          </td>\n          <td data-se-id=\"confirmation\">\n            <div *ngIf=\"compare.reservation;\">\n              {{ compare.reservation?.confirmation}}\n            </div>\n          </td>\n          <td data-se-id=\"status\" class=\"res-status\">\n            <div *ngIf=\"compare.reservation;\">\n                {{ compare.reservation?.status | reservationStatus }}\n            </div>\n          </td>\n          <td data-se-id=\"roomType\">\n            <div *ngIf=\"compare.reservation;\">\n              {{ compare.reservation?.roomType }}\n            </div>\n          </td>\n          <td data-se-id=\"checkIn\">\n            <div *ngIf=\"compare.reservation;\">\n              {{ compare.reservation?.checkInDate | date:'MMM-dd' }}\n            </div>\n          </td>\n          <td data-se-id=\"checkOut\">\n            <div>\n              {{ compare.reservation?.checkOutDate | date:'MMM-dd' }}\n            </div>\n          </td>\n          <td class=\"nights\" data-se-id=\"nights\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\">\n            <span *ngIf=\"compare.reservation\"\n                  class=\"res-value\">{{ compare.reservation?.nights }}</span>\n            <span *ngIf=\"!compare.reservation\" class=\"res-value\">0</span>\n            <span *ngIf=\"compare.rsvp\" class=\"rsvp-value\">{{ compare.rsvp.nights }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"roomRate\"\n              [class.diff-up]=\"isRoomRateUp(compare)\"\n              [class.diff-down]=\"isRoomRateDown(compare)\">\n            <span *ngIf=\"compare.reservation\"\n                  class=\"res-value\">{{ compare.reservation.roomRate | currency:'USD':true }}</span>\n            <span *ngIf=\"!compare.reservation\"\n                  class=\"res-value\">{{ 0 | currency:'USD':true }}</span>\n            <span *ngIf=\"compare.rsvp\" class=\"rsvp-value\">{{ compare.rsvp.roomRate | currency:'USD':true }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"revenue\"\n              [class.diff-up]=\"isRevenueUp(compare)\"\n              [class.diff-down]=\"isRevenueDown(compare)\">\n            <span *ngIf=\"compare.reservation\"\n                  class=\"res-value\">{{ compare.reservation?.revenue | currency:'USD':true }}</span>\n            <span *ngIf=\"!compare.reservation\"\n                  class=\"res-value\">{{ 0 | currency:'USD':true }}</span>\n            <span *ngIf=\"compare.rsvp\" class=\"rsvp-value\">{{ compare.rsvp.revenue | currency:'USD':true }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"commission\"\n              [class.diff-up]=\"isCommissionUp(compare)\"\n              [class.diff-down]=\"isCommissionDown(compare)\">\n            <span *ngIf=\"compare.reservation\" class=\"res-value\">{{ compare.reservation?.commission | currency:'USD':true }}</span>\n            <span *ngIf=\"!compare.reservation\"\n                  class=\"res-value\">{{ 0 | currency:'USD':true }}</span>\n            <span *ngIf=\"compare.rsvp\" class=\"rsvp-value\">{{ compare.rsvp.commission | currency:'USD':true }}</span>\n          </td>\n        </tr>\n        </tbody>\n        <tfoot>\n        <tr\n          [ngClass]=\"totalCommissionClass(MatchTypeEnum.NO_MATCH) | async\"\n          data-se-id=\"no-match-bottom-total-tr\">\n          <td>{{'EVENT.RESERVATION.TOTAL' | translate}}</td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td class=\"currency\">{{ getReservationFilteredRevenue(MatchTypeEnum.NO_MATCH) | async |\n            currency:'USD':true }}\n          </td>\n          <td class=\"currency rsvp-diff\">\n            <span\n              class=\"res-value\"\n              [class.diff-up]=\"isTotalCommissionUp(MatchTypeEnum.NO_MATCH) | async\"\n              [class.diff-down]=\"isTotalCommissionDown(MatchTypeEnum.NO_MATCH) | async\"\n              data-se-id=\"no-match-bottom-total-span\">{{ getReservationFilteredCommission(MatchTypeEnum.NO_MATCH) | async | currency:'USD':true }}</span>\n            <span *ngIf=\"ui.showNoMatchRsvpTotal\"\n                  class=\"rsvp-value\"\n                  data-se-id=\"noMatchRsvpTotal\">\n              {{ getRsvpFilteredCommission(MatchTypeEnum.NO_MATCH) | async | currency:'USD':true }}\n            </span>\n          </td>\n        </tr>\n        </tfoot>\n      </table>\n    </div>\n\n    <!-- No Matches Warning Card -->\n    <div *ngIf=\"ui.showNoMatchesWarningCard\"\n         class=\"result-empty\"\n         data-se-id=\"no-matches-warning\">\n      <h3>{{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND' | translate }}</h3>\n      <figure class=\"figure\">\n        <i class=\"glyph-page figure-img\"></i>\n        <figcaption class=\"figure-caption\">\n          <a (click)=\"resetStatusCodes()\">\n            {{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION' | translate }}\n          </a>\n        </figcaption>\n      </figure>\n    </div>\n\n  </div>\n\n  <!--              Partial Matches         -->\n  <div *ngIf=\"ui.showPartialMatchesCard\"\n       id=\"card-partial-match-list\"\n       class=\"card\">\n    <div class=\"card-header\">\n      <template #commissionPartialMatchTooltip>\n        <p class='lead' data-se-id=\"partial-match-tooltip-title\">{{\n          getTooltipHeaderText(MatchTypeEnum.PARTIAL_MATCH) | async }}</p>\n        <p class='res-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_TOTAL' | translate }}</span>\n          {{ getReservationTotalCommission(MatchTypeEnum.PARTIAL_MATCH) | async |\n          currency:'USD':true }}</p>\n        <div *ngIf=\"!(isRsvpMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH) | async)\">\n          <p class='rsvp-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_RSVP' | translate }}</span>\n            {{ getRsvpTotalCommission(MatchTypeEnum.PARTIAL_MATCH) | async | currency:'USD':true }}\n          </p>\n          <p class='diff-comm'>\n            <span\n              class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE' | translate }}</span>\n            {{ getCommissionDeltaText(MatchTypeEnum.PARTIAL_MATCH) | async }} {{\n            getCommissionDelta(MatchTypeEnum.PARTIAL_MATCH) | async | absolute | currency:'USD':true\n            }}\n          </p>\n        </div>\n      </template>\n      {{'EVENT.RESERVATION.PARTIAL_MATCH_TITLE' | translate}}\n      <span class=\"commission-sum\"\n            [ngClass]=\"totalCommissionClass(MatchTypeEnum.PARTIAL_MATCH) | async\"\n            data-se-id=\"partial-match-top-total-span\">\n        <span class=\"res-value\" [tooltip]=\"commissionPartialMatchTooltip\" placement=\"right\"\n              data-se-id=\"partial-match-commission-total\"\n              [class.diff-up]=\"isTotalCommissionUp(MatchTypeEnum.PARTIAL_MATCH) | async\"\n              [class.diff-down]=\"isTotalCommissionDown(MatchTypeEnum.PARTIAL_MATCH) | async\">\n          {{ getReservationTotalCommission(MatchTypeEnum.PARTIAL_MATCH) | async | currency:'USD':true }}\n        </span>\n      </span>\n    </div>\n\n    <div *ngIf=\"ui.showPartialMatchesDetails\"  class=\"table-responsive\">\n      <table class=\"table reservation-list match-partial\">\n        <thead>\n        <tr>\n          <th>{{ 'EVENT.RESERVATION.NAME' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\">{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.REVENUE' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.COMMISSION' | translate }}</th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailPartial\">\n        <tr *ngFor=\"let compare of getMatches(MatchTypeEnum.PARTIAL_MATCH) | async\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp)\"\n            [attr.data-res-id]=\"getReservationId(compare.reservation)\"\n            data-se-id=\"reservationDetailEntry\"\n            [class.commission-up]=\"isCommissionUp(compare)\"\n            [class.commission-down]=\"isCommissionDown(compare)\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <td data-se-id=\"name\">{{ compare.reservation.lastName }}, {{ compare.reservation.firstName\n            }}\n          </td>\n          <td data-se-id=\"confirmation\">{{ compare.reservation.confirmation }}</td>\n          <td data-se-id=\"status\" class=\"res-status\">{{ compare.reservation.status | reservationStatus }}</td>\n          <td data-se-id=\"roomType\">{{ compare.reservation.roomType }}</td>\n          <td data-se-id=\"checkIn\">{{ compare.reservation.checkInDate | date:'MMM-dd' }}</td>\n          <td data-se-id=\"checkOut\">{{ compare.reservation.checkOutDate | date:'MMM-dd' }}</td>\n          <td class=\"nights\" data-se-id=\"nights\"\n              [class.diff-up]=\"isNightsUp(compare)\"\n              [class.diff-down]=\"isNightsDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.nights }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.nights }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"roomRate\"\n              [class.diff-up]=\"isRoomRateUp(compare)\"\n              [class.diff-down]=\"isRoomRateDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.roomRate | currency:'USD':true }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.roomRate | currency:'USD':true }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"revenue\"\n              [class.diff-up]=\"isRevenueUp(compare)\"\n              [class.diff-down]=\"isRevenueDown(compare)\">\n            <span class=\"res-value\">{{ compare.reservation.revenue | currency:'USD':true }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.revenue | currency:'USD':true }}</span>\n          </td>\n          <td class=\"currency\" data-se-id=\"commission\"\n              [class.diff-up]=\"isCommissionUp(compare)\"\n              [class.diff-down]=\"isCommissionDown(compare)\">\n            <span\n              class=\"res-value\">{{ compare.reservation.commission | currency:'USD':true }}</span>\n            <span class=\"rsvp-value\">{{ compare.rsvp.commission | currency:'USD':true }}</span>\n          </td>\n        </tr>\n        </tbody>\n        <tfoot>\n        <tr\n          [class.commission-up]=\"isTotalCommissionUp(MatchTypeEnum.PARTIAL_MATCH) | async\"\n          [class.commission-down]=\"isTotalCommissionDown(MatchTypeEnum.PARTIAL_MATCH) | async\"\n          data-se-id=\"partial-match-bottom-total-tr\">\n          <td>{{'EVENT.RESERVATION.TOTAL' | translate}}</td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td class=\"currency\">{{ getReservationFilteredRevenue(MatchTypeEnum.PARTIAL_MATCH) | async\n            | currency:'USD':true }}\n          </td>\n          <td class=\"currency rsvp-diff\">\n            <span\n              class=\"res-value\"\n              [class.diff-up]=\"isTotalCommissionUp(MatchTypeEnum.PARTIAL_MATCH) | async\"\n              [class.diff-down]=\"isTotalCommissionDown(MatchTypeEnum.PARTIAL_MATCH) | async\"\n              data-se-id=\"partial-match-bottom-total-span\">{{ getReservationFilteredCommission(MatchTypeEnum.PARTIAL_MATCH) | async | currency:'USD':true }}</span>\n            <span class=\"rsvp-value\">{{ getRsvpFilteredCommission(MatchTypeEnum.PARTIAL_MATCH) | async | currency:'USD':true }}</span>\n          </td>\n        </tr>\n        </tfoot>\n      </table>\n    </div>\n\n    <!-- Partial Matches Warning Card -->\n    <div *ngIf=\"this.ui.showPartialMatchesWarningCard\"\n         class=\"result-empty\"\n         data-se-id=\"partial-matches-warning\">\n      <h3>{{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND' | translate }}</h3>\n      <figure class=\"figure\">\n        <i class=\"glyph-page figure-img\"></i>\n        <figcaption class=\"figure-caption\">\n          <a (click)=\"resetStatusCodes()\">\n            {{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION' | translate }}\n          </a>\n        </figcaption>\n      </figure>\n    </div>\n\n  </div>\n\n\n  <!--              Exact Matches         -->\n  <div *ngIf=\"ui.showExactMatchesCard\"\n       id=\"card-exact-match-list\"\n       class=\"card\">\n    <div class=\"card-header\">\n      {{'EVENT.RESERVATION.EXACT_MATCH_TITLE' | translate}}\n      <template #commissionExactMatchTooltip>\n        <p class='lead' data-se-id=\"exact-match-tooltip-title\">{{\n          getTooltipHeaderText(MatchTypeEnum.EXACT_MATCH) | async }}</p>\n        <p class='res-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_TOTAL' | translate }}</span>\n          {{ getReservationTotalCommission(MatchTypeEnum.EXACT_MATCH) | async | currency:'USD':true\n          }}</p>\n      </template>\n      <span class=\"commission-sum\">\n        <span class=\"res-value\" [tooltip]=\"commissionExactMatchTooltip\" placement=\"right\"\n              data-se-id=\"exact-match-commission-total\">\n          {{ getReservationTotalCommission('Exact') | async | currency:'USD':true }}\n        </span>\n      </span>\n    </div>\n\n    <div *ngIf=\"ui.showExactMatchesDetails\"\n         class=\"table-responsive\">\n      <table class=\"table reservation-list match-exact\">\n        <thead>\n        <tr>\n          <th>{{ 'EVENT.RESERVATION.NAME' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CHECKIN_DATE' | translate }}</th>\n          <th>{{ 'EVENT.RESERVATION.CHECKOUT_DATE' | translate }}</th>\n          <th class=\"nights\">{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.REVENUE' | translate }}</th>\n          <th class=\"currency\">{{ 'EVENT.RESERVATION.COMMISSION' | translate }}</th>\n        </tr>\n        </thead>\n        <tbody data-se-id=\"reservationDetailExact\">\n        <tr *ngFor=\"let compare of getMatches(MatchTypeEnum.EXACT_MATCH) | async\"\n            [attr.data-rsvp-id]=\"getRsvpId(compare.rsvp.eventRsvpId)\"\n            [attr.data-res-id]=\"getReservationId(compare.reservation)\"\n            data-se-id=\"reservationDetailEntry\"\n            [ngClass]=\"getStatusClass(compare)\">\n          <td data-se-id=\"name\">{{ compare.reservation.lastName }}, {{ compare.reservation.firstName\n            }}\n          </td>\n          <td data-se-id=\"confirmation\">{{ compare.reservation.confirmation }}</td>\n          <td data-se-id=\"status\" class=\"res-status\">{{ compare.reservation.status | reservationStatus }}</td>\n          <td data-se-id=\"roomType\">{{ compare.reservation.roomType }}</td>\n          <td data-se-id=\"checkIn\">{{ compare.reservation.checkInDate | date:'MMM-dd' }}</td>\n          <td data-se-id=\"checkOut\">{{ compare.reservation.checkOutDate | date:'MMM-dd' }}</td>\n          <td class=\"nights\" data-se-id=\"nights\">{{ compare.reservation.nights }}</td>\n          <td class=\"currency\" data-se-id=\"roomRate\">{{ compare.reservation.roomRate |\n            currency:'USD':true }}\n          </td>\n          <td class=\"currency\" data-se-id=\"revenue\">{{ compare.reservation.revenue |\n            currency:'USD':true }}\n          </td>\n          <td class=\"currency\" data-se-id=\"commission\">{{ compare.reservation.commission |\n            currency:'USD':true }}\n          </td>\n        </tr>\n        </tbody>\n        <tfoot>\n        <tr>\n          <td>{{'EVENT.RESERVATION.TOTAL' | translate}}</td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td class=\"currency\">{{ getReservationFilteredRevenue(MatchTypeEnum.EXACT_MATCH) | async |\n            currency:'USD':true }}\n          </td>\n          <td class=\"currency rsvp-diff\"><span\n            class=\"res-value\">{{ getReservationFilteredCommission(MatchTypeEnum.EXACT_MATCH) | async | currency:'USD':true }}</span>\n          </td>\n        </tr>\n        </tfoot>\n      </table>\n    </div>\n\n    <!-- Exact Matches Warning Card -->\n    <div *ngIf=\"ui.showExactMatchesWarningCard\"\n         class=\"result-empty\"\n         data-se-id=\"exact-matches-warning\">\n      <h3>{{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND' | translate }}</h3>\n      <figure class=\"figure\">\n        <i class=\"glyph-page figure-img\"></i>\n        <figcaption class=\"figure-caption\">\n          <a (click)=\"resetStatusCodes()\">\n            {{ 'EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION' | translate }}\n          </a>\n        </figcaption>\n      </figure>\n    </div>\n\n  </div>\n\n</div>\n\n<div *ngIf=\"ui.showNoReservationsWarning\" class=\"result-empty\" data-se-id=\"reservationDetailNotFound\">\n  <h3>{{ \"EVENT.RESERVATION.NO_RESERVATIONS_FOUND\" | translate }}</h3>\n  <figure class=\"figure\">\n    <i class=\"glyph-page figure-img\"></i>\n    <figcaption class=\"figure-caption\">{{ \"EVENT.RESERVATION.NO_RESERVATIONS_FOUND_CAPTION\" | translate }}</figcaption>\n  </figure>\n</div>\n"

/***/ }),

/***/ "P7oG":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-header\">{{ 'DASHBOARD.MISSING_AGENCY' | translate }}</div>\n<div class=\"card-block\">\n  <p class=\"dashboard-display text-warning\">\n    <span data-se-id = \"missingAgencyTotal\" class=\"count\">{{ missingAgencyTotal | async }}</span>\n  </p>\n</div>\n<div class=\"card-footer\">\n  <a href=\"javascript:void(0)\"\n     (click)=\"missingAgencyPredefinedSearch()\"\n     data-se-id=\"missing-agency-predefined-search\">\n    {{ 'DASHBOARD.VIEW_MISSING_AGENCY' | translate }}\n  </a>\n</div>\n"

/***/ }),

/***/ "PUE1":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"event-delete-confirmation-modal\"\n  content=\"MESSAGES.CONFIRMATION.DELETE_EVENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"COMMON.BUTTON.DELETE\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeDeletingHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <form [formGroup]=\"eventForm\"\n            novalidate>\n        <pioneer-basic-event-data [parentForm]=\"eventForm\"\n                                  [event]=\"onyxEvent\"\n                                  [isReadOnly]=\"isReadOnly\"></pioneer-basic-event-data>\n\n        <pioneer-contact-lookup-form\n          [parentForm]=\"eventForm\"\n          partyType=\"PROPERTY\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"isReadOnly\">\n        </pioneer-contact-lookup-form>\n\n        <pioneer-contact-lookup-form\n          [parentForm]=\"eventForm\"\n          partyType=\"AGENCY\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"isReadOnly\">\n        </pioneer-contact-lookup-form>\n\n        <pioneer-contact-form\n          [parentForm]=\"eventForm\"\n          partyType=\"CLIENT\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"isReadOnly\">\n        </pioneer-contact-form>\n\n        <div class=\"button-bar\">\n\n          <a routerLink=\".\" class=\"btn btn-link\" [hidden]=\"isReadOnly\" (click)=\"cancel()\"\n             data-se-id=\"cancelButton\">\n            {{'COMMON.BUTTON.CANCEL' | translate}}\n          </a>\n          <button *pioneerAuthorize=\"{permission: 'AddEvent'}\" type=\"button\"\n                  class=\"btn btn-primary\"\n                  [hidden]=\"isReadOnly\"\n                  [disabled]=\"!eventForm.valid\"\n                  (click)=\"save(eventForm.value)\"\n                  data-se-id=\"saveButton\">\n            {{'COMMON.BUTTON.SAVE' | translate}}\n          </button>\n\n          <a *pioneerAuthorize=\"{permission: 'DeleteEvent'}\" [hidden]=\"!isReadOnly\">\n\n            <button class=\"btn btn-danger\"\n                    [hidden]=\"!canBeDeleted\"\n                    (click)=\"confirmBeforeDeleting()\"\n                    data-se-id=\"deleteButton\">\n              {{'COMMON.BUTTON.DELETE' | translate}}\n            </button>\n\n            <p class=\"text-hint\" [hidden]=\"canBeDeleted\">\n              {{'EVENT.NOT_ELIGIBLE_FOR_DELETION' | translate }}\n            </p>\n          </a>\n\n          <a pageScroll href=\"#card-basic-event-data\">\n            <button *pioneerAuthorize=\"{permission: 'EditEvent'}\" type=\"button\"\n                    class=\"btn btn-primary\" [hidden]=\"!isReadOnly\" (click)=\"edit()\"\n                    data-se-id=\"editButton\">\n              {{'COMMON.BUTTON.EDIT' | translate}}\n            </button>\n          </a>\n        </div>\n\n      </form>\n      <pioneer-attachment [event]=\"onyxEvent\"></pioneer-attachment>\n    </div>\n    <pioneer-event-nav></pioneer-event-nav>\n  </div>\n</div>\n"

/***/ }),

/***/ "QLMO":
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\" [class.form-error]=\"!isValid\" [class.form-required]=\"isRequired\">\n  <label for=\"{{ inputControl.name }}\">{{label | translate}}</label>\n  <ng-content></ng-content>\n  <div class=\"validation-messages\" *ngFor=\"let error of getDefaultErrors\">\n    <pioneer-validation-message [for]=\"inputControl.name\"\n                                [error]=\"error\"\n                                [message]=\"message\">\n    </pioneer-validation-message>\n  </div>\n  <ng-content class=\"form-text form-control-feedback\" select=\".validation-messages\"></ng-content>\n</div>\n"

/***/ }),

/***/ "Upgs":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"rsvpForm\" (ngSubmit)=\"addRsvp()\" data-se-id=\"addRsvpForm\">\n  <div class=\"card\">\n    <div id=\"card-add-rsvp\"\n         class=\"card-header\">\n      {{ \"EVENT.RSVPS.ADD_RSVP_HEADER\" | translate }}\n      <div class=\"header-right\" *pioneerAuthorize=\"{permission: 'UploadRsvp'}\">\n        <label class=\"btn btn-link btn-sm\" for=\"file\">\n          <i class=\"glyph-cloud-up\"></i> {{ \"EVENT.RSVPS.IMPORT_RSVP_LIST\" | translate }}\n        </label>\n        <input #file\n               id=\"file\"\n               data-se-id=\"import-rsvp\"\n               hidden\n               type=\"file\"\n               accept=\"{{fileExtensions}}\"\n               [disabled]=\"isUploadInProgress\"\n               (change)=\"importRsvpViaCsv($event)\"/>\n      </div>\n    </div>\n    <div class=\"card-block\">\n      <div class=\"row\">\n        <div class=\"form-container contact-name-first\">\n          <div class=\"form-group form-required\">\n            <pioneer-form-input label=\"EVENT.RSVPS.FIRST_NAME\">\n              <input formControlName=\"firstName\"\n                     type=\"text\"\n                     class=\"form-control\"\n                     data-se-id=\"firstName\"\n                     placeholder=\"{{ 'EVENT.RSVPS.FIRST_NAME_PLACEHOLDER' | translate }}\">\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"form-container contact-name-last\">\n          <div class=\"form-group form-required\">\n            <pioneer-form-input label=\"EVENT.RSVPS.LAST_NAME\">\n              <input formControlName=\"lastName\"\n                     class=\"form-control\"\n                     type=\"text\"\n                     data-se-id=\"lastName\"\n                     placeholder=\"{{ 'EVENT.RSVPS.LAST_NAME_PLACEHOLDER' | translate }}\">\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"form-container rsvp-room-info\">\n          <div class=\"row\">\n            <div class=\"col form-container room-nights\">\n              <div class=\"form-group form-required\">\n                <pioneer-form-input label=\"EVENT.RSVPS.NIGHTS\">\n                  <input formControlName=\"nights\"\n                         class=\"form-control\"\n                         type=\"number\"\n                         data-se-id=\"nights\"\n                         placeholder=\"{{ 'EVENT.RSVPS.NIGHTS_PLACEHOLDER' | translate }}\">\n                  <pioneer-validation-message for=\"nights\"\n                                              error=\"gte\"\n                                              message=\"MESSAGES.VALIDATION.GT\">\n                  </pioneer-validation-message>\n                </pioneer-form-input>\n              </div>\n            </div>\n            <div class=\"col form-container room-pay\">\n              <div class=\"form-group\">\n                <pioneer-form-input label=\"EVENT.RSVPS.ROOM_RATE\">\n                  <input formControlName=\"roomRate\"\n                         class=\"form-control\"\n                         type=\"number\"\n                         data-se-id=\"roomRate\"\n                         placeholder=\"{{ 'EVENT.RSVPS.ROOM_RATE_PLACEHOLDER' | translate }}\">\n                </pioneer-form-input>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-container rsvp-comm-calc\">\n          <div class=\"row\">\n            <div class=\"col form-container calc-revenue\">\n              <div class=\"form-group\">\n                <label>{{ \"EVENT.RSVPS.REVENUE\" | translate}}</label>\n                <p class=\"form-control readonly\"\n                   data-se-id=\"revenue\">{{ revenue | currency:'USD':true }}</p>\n              </div>\n            </div>\n            <div class=\"col form-container calc-percent\">\n              <div class=\"form-group\">\n                <label>{{\"EVENT.RSVPS.COMMISSION_RATE\" | translate }}</label>\n                <p class=\"form-control readonly\"\n                   data-se-id=\"commissionRate\">{{ commissionRoomPercentage }}%</p>\n              </div>\n            </div>\n            <div class=\"col form-container calc-commission\">\n              <div class=\"form-group\">\n                <label>{{ \"EVENT.RSVPS.COMMISSION\" | translate }}</label>\n                <p class=\"form-control readonly\"\n                   data-se-id=\"commission\">{{ commission | currency:'USD':true}}</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"button-bar\">\n    <button class=\"btn btn-primary\"\n            data-se-id=\"addGuestButton\"\n            [disabled]=\"!rsvpForm.valid\">{{ \"EVENT.RSVPS.ADD_RSVP_BUTTON\" | translate }}\n    </button>\n  </div>\n</form>\n"

/***/ }),

/***/ "Xi0/":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n\n      <form [formGroup]=\"commissionForm\" novalidate>\n        <pioneer-basic-event-data\n          [parentForm]=\"commissionForm\"\n          [event]=\"onyxEvent\"\n          [isReadOnly]=\"true\">\n        </pioneer-basic-event-data>\n      </form>\n\n      <ng-container *ngIf=\"ui.showAddPayment\">\n        <pioneer-add-payment\n          *pioneerAuthorize=\"{permission: 'PayCommission'}\"\n          [event]=\"onyxEvent\"\n          data-se-id=\"addPaymentForm\">\n        </pioneer-add-payment>\n      </ng-container>\n\n      <pioneer-payment-record\n        *ngIf=\"ui.showPaymentRecord\"\n        [event]=\"onyxEvent\"\n        [latestPayment]=\"latestPayment\">\n      </pioneer-payment-record>\n\n      <pioneer-stay-summary [event]=\"onyxEvent\"></pioneer-stay-summary>\n      <pioneer-payment-reservations [event]=\"onyxEvent\"></pioneer-payment-reservations>\n\n    </div>\n    <pioneer-event-nav></pioneer-event-nav>\n  </div>\n</div>\n"

/***/ }),

/***/ "Zu/a":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal fade\" bsModal [config]=\"config\" role=\"dialog\" tabindex=\"-1\"\n     data-se-id=\"confirmation-modal\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-body\">\n        <p class=\"lead\" *ngIf=\"title\" [innerHTML]=\"title | translate\"></p>\n        <p>{{ content | translate }}</p>\n        <div class=\"button-bar\">\n          <button data-se-id=\"confirmation-modal-cancel\" type=\"button\" class=\"btn btn-link btn-sm\"\n                  (click)=\"close(false)\">{{ cancel | translate }}\n          </button>\n          <button data-se-id=\"confirmation-modal-confirm\" type=\"button\" class=\"btn btn-primary btn-sm\"\n                  (click)=\"close(true)\">{{ confirm | translate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "c28g":
/***/ (function(module, exports) {

module.exports = "<div class=\"active-filters\" id=\"filter-control\">\n  <p class=\"filter-label\">{{'EVENT.RESERVATION.STATUS_FILTER_TITLE' | translate }}</p>\n  <div class=\"view-select float-right\">\n    <div class=\"btn-group btn-group-sm\">\n      <button class=\"btn btn-default\"\n              [ngClass]=\"{'active': (getSummarySelected() | async) }\"\n              [routerLink]=\"['/event/' + onyxEvent.eventId + '/reservations']\"\n              data-se-id=\"reservation-summary-toggle-button\">\n        <i class=\"glyph-page\"></i>{{'EVENT.RESERVATION.SUMMARY_BUTTON' | translate}}\n      </button>\n      <button class=\"btn btn-default\"\n              [ngClass]=\"{'active': !(getSummarySelected() | async) }\"\n              [routerLink]=\"['/event/' + onyxEvent.eventId + '/reservations/detail']\"\n              data-se-id=\"reservation-detail-toggle-button\">\n        <i class=\"glyph-pages\"></i>{{'EVENT.RESERVATION.DETAIL_BUTTON' | translate}}\n      </button>\n    </div>\n  </div>\n\n  <div class=\"filter-list form-group\">\n    <div class=\"form-check\">\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleStatusCode(ReservationStatusCode.RESERVED)\"\n             [ngClass]=\"{'checked': reserved}\" data-se-id=\"filter-button-reserved\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">\n          {{ 'RESERVATION_STATUS.RESERVED' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleCheckedIn()\"\n             [ngClass]=\"{'checked': checkedIn}\" data-se-id=\"filter-button-checked-in\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.CHECKED_IN' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleCheckedOut()\"\n             [ngClass]=\"{'checked': checkedOut}\" data-se-id=\"filter-button-checked-out\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.CHECKED_OUT' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleCancelled()\"\n             [ngClass]=\"{'checked': cancelled}\" data-se-id=\"filter-button-cancelled\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.CANCELLED' | translate }}</span>\n      </label>\n      <label class=\"filter-item custom-control custom-checkbox\"\n             (click)=\"toggleNoShow()\"\n             [ngClass]=\"{'checked': noShow}\" data-se-id=\"filter-button-no-show\">\n        <i class=\"button-state\"></i>\n        <span class=\"custom-control-description\">{{\n          'RESERVATION_STATUS.NO_SHOW' | translate }}</span>\n      </label>\n      <!-- <label [hidden]=\"summarySelected\" class=\"filter-item custom-control custom-checkbox\"\n              (click)=\"toggleRsvp()\"\n              [ngClass]=\"{'checked': rsvp}\" data-se-id=\"filter-button-rsvp\">\n         <i class=\"button-state\"></i>\n         <span class=\"custom-control-description\">{{\n           'RESERVATION_STATUS.RSVP' | translate }}</span>\n       </label>-->\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "cDNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/symbol.js
var symbol = __webpack_require__("GWWY");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/object.js
var es6_object = __webpack_require__("f/CF");
var object_default = /*#__PURE__*/__webpack_require__.n(es6_object);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/function.js
var es6_function = __webpack_require__("KvE9");
var function_default = /*#__PURE__*/__webpack_require__.n(es6_function);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/parse-int.js
var parse_int = __webpack_require__("zbpw");
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/parse-float.js
var parse_float = __webpack_require__("NzKl");
var parse_float_default = /*#__PURE__*/__webpack_require__.n(parse_float);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/number.js
var number = __webpack_require__("ajBu");
var number_default = /*#__PURE__*/__webpack_require__.n(number);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/math.js
var math = __webpack_require__("feEK");
var math_default = /*#__PURE__*/__webpack_require__.n(math);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/string.js
var string = __webpack_require__("r24B");
var string_default = /*#__PURE__*/__webpack_require__.n(string);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/date.js
var es6_date = __webpack_require__("pEMT");
var date_default = /*#__PURE__*/__webpack_require__.n(es6_date);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/array.js
var array = __webpack_require__("jOBH");
var array_default = /*#__PURE__*/__webpack_require__.n(array);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/regexp.js
var regexp = __webpack_require__("Rjcp");
var regexp_default = /*#__PURE__*/__webpack_require__.n(regexp);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/map.js
var es6_map = __webpack_require__("W8w6");
var map_default = /*#__PURE__*/__webpack_require__.n(es6_map);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/set.js
var set = __webpack_require__("yJzT");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/classlist.js/classList.js
var classList = __webpack_require__("Fc+4");
var classList_default = /*#__PURE__*/__webpack_require__.n(classList);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es6/reflect.js
var reflect = __webpack_require__("/wY1");
var reflect_default = /*#__PURE__*/__webpack_require__.n(reflect);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/core-js/es7/reflect.js
var es7_reflect = __webpack_require__("+iEx");
var es7_reflect_default = /*#__PURE__*/__webpack_require__.n(es7_reflect);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/web-animations-js/web-animations.min.js
var web_animations_min = __webpack_require__("lDyL");
var web_animations_min_default = /*#__PURE__*/__webpack_require__.n(web_animations_min);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/zone.js/dist/zone.js
var zone = __webpack_require__("eFQL");
var zone_default = /*#__PURE__*/__webpack_require__.n(zone);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/intl/index.js
var intl = __webpack_require__("Pha3");
var intl_default = /*#__PURE__*/__webpack_require__.n(intl);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/polyfills.ts
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */
/***************************************************************************************************
 * BROWSER POLYFILLS
 */
/** IE9, IE10 and IE11 requires all of the following polyfills. **/













/** IE10 and IE11 requires the following for NgClass support on SVG elements */
 // Run `npm install --save classlist.js`.
/** IE10 and IE11 requires the following to support `@angular/animation`. */
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.
/** Evergreen browsers require these. **/


/** ALL Firefox browsers require the following to support `@angular/animation`. **/
 // Run `npm install --save web-animations-js`.
/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
 // Included with Angular-CLI.
/***************************************************************************************************
 * APPLICATION IMPORTS
 */
/**
 * Date, currency, decimal and percent pipes.
 * Needed for: All but Chrome, Firefox, Edge, IE11 and Safari 10
 */
 // Run `npm install --save intl`.
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/polyfills.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/platform-browser-dynamic/@angular/platform-browser-dynamic.es5.js + 1 modules
var platform_browser_dynamic_es5 = __webpack_require__("Qa4U");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/platform-browser/@angular/platform-browser.es5.js
var platform_browser_es5 = __webpack_require__("fc+i");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/core/@angular/core.es5.js
var core_es5 = __webpack_require__("/oeL");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/forms/@angular/forms.es5.js
var forms_es5 = __webpack_require__("bm2B");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/http/@angular/http.es5.js
var http_es5 = __webpack_require__("CPp0");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/router/@angular/router.es5.js
var router_es5 = __webpack_require__("BkNc");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/common/@angular/common.es5.js
var common_es5 = __webpack_require__("qbdv");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@ngx-translate/core/index.js + 8 modules
var core = __webpack_require__("9Qcf");

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/generic-error/generic-error.component.ts
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var GenericErrorComponent = (function () {
    function GenericErrorComponent(route) {
        var _this = this;
        this.route = route;
        this.error = 'MESSAGES.ERROR.GENERIC_ERROR';
        this.route.params.subscribe(function (params) {
            if (params['error']) {
                _this.error = params['error'];
            }
        });
    }
    return GenericErrorComponent;
}());
GenericErrorComponent = __decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-generic-error',
        template: __webpack_require__("Kbn7")
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && _a || Object])
], GenericErrorComponent);

var _a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/generic-error.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/shared.routes.ts

var routes = [
    {
        path: 'error',
        component: GenericErrorComponent
    }
];
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/shared.routes.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/route-not-found/route-not-found.component.ts
var route_not_found_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var route_not_found_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var RouteNotFoundComponent = (function () {
    function RouteNotFoundComponent() {
    }
    RouteNotFoundComponent.prototype.ngOnInit = function () {
    };
    return RouteNotFoundComponent;
}());
RouteNotFoundComponent = route_not_found_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-route-not-found',
        template: __webpack_require__("FS9g"),
        styles: [__webpack_require__("iS/x")]
    }),
    route_not_found_component___metadata("design:paramtypes", [])
], RouteNotFoundComponent);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/route-not-found.component.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/Subject.js
var Subject = __webpack_require__("rlar");
var Subject_default = /*#__PURE__*/__webpack_require__.n(Subject);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/log/log.service.ts
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var log_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var log_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var log_service_LogService = (function () {
    function LogService() {
        // Create a new Subject and expose the stream as an Observable.
        this.logStream = new Subject["Subject"]();
        this.logs = this.logStream.asObservable();
    }
    LogService.prototype.log = function (logMessage) {
        // Add the message to the log stream
        this.logStream.next(logMessage);
    };
    LogService.prototype.error = function (message) {
        this.log(new LogMessage(LogLevel.ERROR, message));
    };
    LogService.prototype.warn = function (message) {
        this.log(new LogMessage(LogLevel.WARN, message));
    };
    LogService.prototype.info = function (message) {
        this.log(new LogMessage(LogLevel.INFO, message));
    };
    LogService.prototype.debug = function (message) {
        this.log(new LogMessage(LogLevel.DEBUG, message));
    };
    LogService.prototype.verbose = function (message) {
        this.log(new LogMessage(LogLevel.VERBOSE, message));
    };
    return LogService;
}());
log_service_LogService = log_service___decorate([
    Object(core_es5["Injectable"])(),
    log_service___metadata("design:paramtypes", [])
], log_service_LogService);

var BaseLogSubscriberService = (function () {
    function BaseLogSubscriberService(logService) {
        this.logService = logService;
        this.logs = this.logService.logs;
    }
    BaseLogSubscriberService.prototype.init = function (level) {
        this.logs.subscribe(this.log.bind(this));
    };
    BaseLogSubscriberService.prototype.log = function (message) {
        // No implementation
    };
    return BaseLogSubscriberService;
}());

var FilteredLogSubscriberService = (function (_super) {
    __extends(FilteredLogSubscriberService, _super);
    function FilteredLogSubscriberService(ls) {
        return _super.call(this, ls) || this;
    }
    FilteredLogSubscriberService.prototype.init = function (level) {
        // Filter the logs to include the specified log level
        this.logs = this.logs.filter(function (logMessage) { return logMessage.level <= level; });
        _super.prototype.init.call(this, level);
    };
    return FilteredLogSubscriberService;
}(BaseLogSubscriberService));

var LogMessage = (function () {
    function LogMessage(level, message) {
        if (level === void 0) { level = LogLevel.INFO; }
        if (message === void 0) { message = ''; }
        this.level = level;
        this.message = message;
    }
    return LogMessage;
}());

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["ERROR"] = 0] = "ERROR";
    LogLevel[LogLevel["WARN"] = 1] = "WARN";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 4] = "VERBOSE";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/log.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment-defaults.ts
var environmentDefaults = {
    // Pioneer Server Endpoints
    baseUrl: 'http://localhost:8080',
    hostname: 'localhost',
    // angular-cli compile mode
    production: true,
    // AWS Configuration
    region: 'us-east-1',
    awsUri: 'amazonaws.com',
    // Log handlers and log levels
    logServices: {
        consoleLogSubscriber: {
            logLevel: 3
        },
        httpLogSubscriber: {
            logLevel: 0
        }
    },
    // Close messages at 3.5 seconds
    alertMessageTimer: 3500,
    events: {
        maxEvents: 50,
        acceptedFileExtensions: '.jpg, .jpeg, .pdf',
        acceptedFileTypes: ['application/pdf', 'image/jpeg'],
        maxFileSize: 100
    },
    bulkEvents: {
        acceptedFileExtensions: '.csv',
        acceptedFileTypes: ['text/csv', 'text/x-csv', 'text/plain', 'application/vnd.ms-excel']
    },
    rsvps: {
        acceptedFileExtensions: '.csv',
        acceptedFileTypes: ['text/csv', 'text/x-csv', 'text/plain', 'application/vnd.ms-excel']
    },
    payments: {
        paymentDelayDaysAfterEventEnd: 3
    },
    googleAnalytics: {
        id: 'UA-92766055-1',
        loadType: 'auto'
    }
};
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment-defaults.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/lodash.defaultsdeep/index.js
var lodash_defaultsdeep = __webpack_require__("Ne7M");
var lodash_defaultsdeep_default = /*#__PURE__*/__webpack_require__.n(lodash_defaultsdeep);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.ci.ts


var override = {
    baseUrl: 'https://pioneer-ci-service.dev.onyxcentersource.com',
    hostname: 'pioneer-ci.dev.onyxcentersource.com',
    googleAnalytics: {
        id: 'UA-96125697-1',
        loadType: 'auto'
    }
};
var environment_ci_environment = lodash_defaultsdeep(override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.ci.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.ci2.ts


var environment_ci2_override = {
    baseUrl: 'https://pioneer-ci2-service.dev.onyxcentersource.com',
    hostname: 'pioneer-ci2.dev.onyxcentersource.com',
    googleAnalytics: {
        id: 'UA-96125697-1',
        loadType: 'auto'
    }
};
var environment_ci2_environment = lodash_defaultsdeep(environment_ci2_override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.ci2.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.dev.ts


var environment_dev_override = {
    baseUrl: 'https://pioneer-service.dev.onyxcentersource.com',
    hostname: 'pioneer.dev.onyxcentersource.com'
};
var environment_dev_environment = lodash_defaultsdeep(environment_dev_override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.dev.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.prod.ts


var environment_prod_override = {
    baseUrl: 'https://groups-service.onyxcentersource.com',
    hostname: 'groups.onyxcentersource.com',
    logServices: {
        consoleLogSubscriber: {
            logLevel: 2
        },
        httpLogSubscriber: {
            logLevel: 0
        }
    }
};
var environment_prod_environment = lodash_defaultsdeep(environment_prod_override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.prod.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.qa.ts


var environment_qa_override = {
    baseUrl: 'https://pioneer-service.qa.onyxcentersource.com',
    hostname: 'pioneer.qa.onyxcentersource.com'
};
var environment_qa_environment = lodash_defaultsdeep(environment_qa_override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.qa.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.sec.ts


var environment_sec_override = {
    baseUrl: 'https://pioneer-sec-service.uat.onyxcentersource.com',
    hostname: 'pioneer-sec.uat.onyxcentersource.com'
};
var environment_sec_environment = lodash_defaultsdeep(environment_sec_override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.sec.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.uat.ts


var environment_uat_override = {
    baseUrl: 'https://pioneer-service.uat.onyxcentersource.com',
    hostname: 'pioneer.uat.onyxcentersource.com'
};
var environment_uat_environment = lodash_defaultsdeep(environment_uat_override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.uat.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.local.ts


// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.local.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
var environment_local_override = {
    baseUrl: 'http://localhost:8080',
    hostname: 'localhost',
    production: false,
    logServices: {
        consoleLogSubscriber: {
            logLevel: 4
        },
        httpLogSubscriber: {
            logLevel: 0
        }
    },
    googleAnalytics: {
        id: 'UA-96125697-1',
        loadType: 'auto'
    }
};
var environment_local_environment = lodash_defaultsdeep(environment_local_override, environmentDefaults);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.local.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/environment/services/environment.configuration.ts
/* tslint:disable:no-shadowed-variable */
var environment_configuration___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var environment_configuration___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};









var environments = {
    default: environment_local_environment,
    ci: environment_ci_environment,
    ci2: environment_ci2_environment,
    dev: environment_dev_environment,
    prod: environment_prod_environment,
    qa: environment_qa_environment,
    sec: environment_sec_environment,
    uat: environment_uat_environment
};
var Environments = new core_es5["InjectionToken"]('Environments');
var EnvironmentConfiguration = (function () {
    function EnvironmentConfiguration(environments) {
        var hostname = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : null;
        var environmentType = environments.default;
        var environmentNames = Object.keys(environments).filter(function (envName) { return envName !== 'default'; });
        var selectedEnvName = environmentNames.find(function (envName) {
            if (environments[envName] && environments[envName].hostname) {
                return environments[envName].hostname.toLowerCase() === hostname;
            }
            else {
                return false;
            }
        });
        if (selectedEnvName && environments[selectedEnvName]) {
            environmentType = environments[selectedEnvName];
        }
        // Override default behavior by setting window.environment in index.html
        if (window['environment'] && environments[window['environment']]) {
            environmentType = environments[window['environment']];
        }
        Object.assign(this, environmentType);
    }
    return EnvironmentConfiguration;
}());
EnvironmentConfiguration = environment_configuration___decorate([
    Object(core_es5["Injectable"])(),
    __param(0, Object(core_es5["Inject"])(Environments)),
    environment_configuration___metadata("design:paramtypes", [Object])
], EnvironmentConfiguration);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.configuration.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/error-handler/error-handler.ts
var error_handler___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var error_handler___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var error_handler___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var error_handler_LogErrorHandler = (function (_super) {
    error_handler___extends(LogErrorHandler, _super);
    function LogErrorHandler(log, environment) {
        var _this = 
        // Tell Angular to rethrow exceptions.  This ensures that operations like
        // bootstrap will fail if there is an error.
        _super.call(this, true) || this;
        _this.log = log;
        _this.environment = environment;
        return _this;
    }
    LogErrorHandler.prototype.handleError = function (error) {
        // Log the error using the LogService
        this.log.error(error.toString());
        // Provide the standard Angular error handling if the log level is verbose
        if (this.environment.logServices.consoleLogSubscriber &&
            this.environment.logServices.consoleLogSubscriber.logLevel >= LogLevel.VERBOSE) {
            _super.prototype.handleError.call(this, error);
        }
    };
    return LogErrorHandler;
}(core_es5["ErrorHandler"]));
error_handler_LogErrorHandler = error_handler___decorate([
    Object(core_es5["Injectable"])(),
    error_handler___metadata("design:paramtypes", [typeof (error_handler__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && error_handler__a || Object, typeof (_b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && _b || Object])
], error_handler_LogErrorHandler);

var error_handler__a, _b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/error-handler.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/log/console-log-subscriber.service.ts
var console_log_subscriber_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var console_log_subscriber_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var console_log_subscriber_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var console_log_subscriber_service_ConsoleLogSubscriberService = (function (_super) {
    console_log_subscriber_service___extends(ConsoleLogSubscriberService, _super);
    function ConsoleLogSubscriberService(logService) {
        return _super.call(this, logService) || this;
    }
    ConsoleLogSubscriberService.prototype.log = function (logMessage) {
        // Since the LogLevel enum is aligned with the the console function names
        // use the string value to call the corresponding logging function.
        var level = LogLevel[logMessage.level].toLowerCase();
        if (console[level]) {
            console[level](logMessage.message);
        }
    };
    return ConsoleLogSubscriberService;
}(FilteredLogSubscriberService));
console_log_subscriber_service_ConsoleLogSubscriberService = console_log_subscriber_service___decorate([
    Object(core_es5["Injectable"])(),
    console_log_subscriber_service___metadata("design:paramtypes", [typeof (console_log_subscriber_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && console_log_subscriber_service__a || Object])
], console_log_subscriber_service_ConsoleLogSubscriberService);

var console_log_subscriber_service__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/console-log-subscriber.service.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/Observable.js
var Observable = __webpack_require__("bKpL");
var Observable_default = /*#__PURE__*/__webpack_require__.n(Observable);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/guid.ts
/*tslint:disable:no-bitwise*/
var Guid = (function () {
    function Guid() {
    }
    Guid.newGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return Guid;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/guid.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/flash-messages/flash.message.record.ts

var MessageLevel;
(function (MessageLevel) {
    MessageLevel[MessageLevel["ERROR"] = 0] = "ERROR";
    MessageLevel[MessageLevel["WARN"] = 1] = "WARN";
    MessageLevel[MessageLevel["INFO"] = 2] = "INFO";
    MessageLevel[MessageLevel["SUCCESS"] = 3] = "SUCCESS";
})(MessageLevel || (MessageLevel = {}));
var flash_message_record_FlashMessage = (function () {
    function FlashMessage(level, message, displayThroughNavigation, autoClose) {
        if (displayThroughNavigation === void 0) { displayThroughNavigation = false; }
        if (autoClose === void 0) { autoClose = false; }
        this.id = Guid.newGuid();
        this.level = level;
        this.message = message;
        this.displayThroughNavigation = displayThroughNavigation;
        this.autoClose = autoClose;
    }
    return FlashMessage;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/flash.message.record.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/flash-messages/service/flash.messages.service.ts
var flash_messages_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var flash_messages_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





/**
 * This will display a message to the user.
 *
 * If it is an error it will wait for the user to click close before removing.
 *
 * Usage:
 *
 * this.flashMessagesService.info('We are in about component!');
 * this.flashMessagesService.error('Failure!');
 * this.flashMessagesService.warn('Warn!');
 * this.flashMessagesService.success('Success!');
 */
var flash_messages_service_FlashMessagesService = (function () {
    function FlashMessagesService(logService, translateService) {
        this.logService = logService;
        this.translateService = translateService;
        // Create a new Subject and expose the stream as an Observable.
        this.messageStream = new Subject["Subject"]();
    }
    Object.defineProperty(FlashMessagesService.prototype, "messages", {
        get: function () {
            return this.messageStream.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    FlashMessagesService.prototype.post = function (flashMessage) {
        // Add the message to the log stream
        this.messageStream.next(flashMessage);
    };
    FlashMessagesService.prototype.error = function (flashMessage, logMessage, translateParams) {
        if (logMessage === void 0) { logMessage = null; }
        if (translateParams === void 0) { translateParams = {}; }
        this.logMessage(LogLevel.ERROR, logMessage);
        this.flashMessage(MessageLevel.ERROR, flashMessage, false, false, translateParams);
    };
    FlashMessagesService.prototype.warn = function (flashMessage, logMessage, translateParams) {
        if (logMessage === void 0) { logMessage = null; }
        if (translateParams === void 0) { translateParams = {}; }
        this.logMessage(LogLevel.WARN, logMessage);
        this.flashMessage(MessageLevel.WARN, flashMessage, false, false, translateParams);
    };
    FlashMessagesService.prototype.info = function (flashMessage, logMessage, translateParams) {
        if (logMessage === void 0) { logMessage = null; }
        if (translateParams === void 0) { translateParams = {}; }
        this.logMessage(LogLevel.INFO, logMessage);
        this.flashMessage(MessageLevel.INFO, flashMessage, false, false, translateParams);
    };
    FlashMessagesService.prototype.success = function (flashMessage, logMessage, translateParams) {
        if (logMessage === void 0) { logMessage = null; }
        if (translateParams === void 0) { translateParams = {}; }
        this.logMessage(LogLevel.VERBOSE, logMessage);
        this.flashMessage(MessageLevel.SUCCESS, flashMessage, true, true, translateParams);
    };
    FlashMessagesService.prototype.flashMessage = function (level, message, displayThroughNavigation, autoClose, translateParams) {
        var _this = this;
        if (translateParams === void 0) { translateParams = {}; }
        /**
         * .subscribe is used instead of .instant because of an issue that exists
         * when a flash message needs to be thrown during ngOnInit.  If .instant is used,
         * the label will be untranslated.
         */
        this.translateService.get(message, translateParams).subscribe(function (translation) {
            _this.post(new flash_message_record_FlashMessage(level, translation, displayThroughNavigation, autoClose));
        });
    };
    FlashMessagesService.prototype.logMessage = function (level, message) {
        if (message) {
            this.logService.log(new LogMessage(level, message));
        }
    };
    return FlashMessagesService;
}());
flash_messages_service_FlashMessagesService = flash_messages_service___decorate([
    Object(core_es5["Injectable"])(),
    flash_messages_service___metadata("design:paramtypes", [typeof (flash_messages_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && flash_messages_service__a || Object, typeof (flash_messages_service__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && flash_messages_service__b || Object])
], flash_messages_service_FlashMessagesService);

var flash_messages_service__a, flash_messages_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/flash.messages.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/error-handler.service.ts
var error_handler_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var error_handler_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var error_handler_service_ErrorHandlerService = (function () {
    function ErrorHandlerService(logService, flashMessageService) {
        this.logService = logService;
        this.flashMessageService = flashMessageService;
    }
    ErrorHandlerService.prototype.handle = function (logMessage, flashMessage, handleType) {
        var _this = this;
        if (flashMessage === void 0) { flashMessage = ''; }
        if (handleType === void 0) { handleType = ErrorHandlerType.THROW_ERROR; }
        // Return a function that conforms to the shape if a catch callback
        return function (error) {
            return _this.processError(logMessage, flashMessage, handleType, error);
        };
    };
    ErrorHandlerService.prototype.handleObservable = function (logMessage, flashMessage) {
        if (flashMessage === void 0) { flashMessage = ''; }
        return this.handle(logMessage, flashMessage, ErrorHandlerType.THROW_OBSERVABLE);
    };
    ErrorHandlerService.prototype.throw = function (logMessage, flashMessage, handleType, error) {
        if (flashMessage === void 0) { flashMessage = ''; }
        if (handleType === void 0) { handleType = ErrorHandlerType.THROW_ERROR; }
        if (error === void 0) { error = logMessage; }
        return this.processError(logMessage, flashMessage, handleType, error);
    };
    ErrorHandlerService.prototype.processError = function (logMessage, flashMessage, handleType, error) {
        if (flashMessage === void 0) { flashMessage = ''; }
        if (handleType === void 0) { handleType = ErrorHandlerType.THROW_ERROR; }
        if (error === void 0) { error = null; }
        if (logMessage) {
            this.logService.error(logMessage);
        }
        if (flashMessage) {
            this.flashMessageService.error(flashMessage);
        }
        switch (handleType) {
            case ErrorHandlerType.DO_NOT_THROW:
                // Do not thow re-throw the error
                break;
            case ErrorHandlerType.THROW_OBSERVABLE:
                return Observable["Observable"].throw(this.getErrorMessage(error));
            // case ErrorHandlerType.THROW_ERROR:
            default:
                throw new Error(error);
        }
    };
    ErrorHandlerService.prototype.getErrorMessage = function (error) {
        if (error && error.json && error.json().error) {
            return error.json().error;
        }
        else {
            return 'An error occurred';
        }
    };
    return ErrorHandlerService;
}());
error_handler_service_ErrorHandlerService = error_handler_service___decorate([
    Object(core_es5["Injectable"])(),
    error_handler_service___metadata("design:paramtypes", [typeof (error_handler_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && error_handler_service__a || Object, typeof (error_handler_service__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && error_handler_service__b || Object])
], error_handler_service_ErrorHandlerService);

var ErrorHandlerType;
(function (ErrorHandlerType) {
    ErrorHandlerType[ErrorHandlerType["DO_NOT_THROW"] = 0] = "DO_NOT_THROW";
    ErrorHandlerType[ErrorHandlerType["THROW_ERROR"] = 1] = "THROW_ERROR";
    ErrorHandlerType[ErrorHandlerType["THROW_OBSERVABLE"] = 2] = "THROW_OBSERVABLE";
})(ErrorHandlerType || (ErrorHandlerType = {}));
var error_handler_service__a, error_handler_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/error-handler.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/log/http-log-subscriber.service.ts
var http_log_subscriber_service___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var http_log_subscriber_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var http_log_subscriber_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var http_log_subscriber_service_HttpLogSubscriberService = (function (_super) {
    http_log_subscriber_service___extends(HttpLogSubscriberService, _super);
    function HttpLogSubscriberService(logService, http, consoleLogSubscriber, environment) {
        var _this = _super.call(this, logService) || this;
        _this.http = http;
        _this.consoleLogSubscriber = consoleLogSubscriber;
        _this.environment = environment;
        _this.errorUrl = _this.environment.baseUrl + "/api/error";
        _this.HTTP_ERROR_MSG = 'HttpLogSubscriberService - Could not stream message to the server;';
        return _this;
    }
    HttpLogSubscriberService.prototype.log = function (logMessage) {
        var _this = this;
        var bodyString = JSON.stringify(logMessage); // Stringify payload
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
        // TODO: Add meta information to the error so it can be identified on
        // the server and correlated to other errors.
        // headers.append('SessionId', user.sessionId)
        // headers.append('UserId', user.userId)
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        var post = this.http.post(this.errorUrl, bodyString, options);
        post.subscribe(undefined, function (error) {
            _this.consoleLogSubscriber.log(new LogMessage(LogLevel.ERROR, _this.HTTP_ERROR_MSG + error));
            _this.consoleLogSubscriber.log(logMessage);
        });
    };
    return HttpLogSubscriberService;
}(FilteredLogSubscriberService));
http_log_subscriber_service_HttpLogSubscriberService = http_log_subscriber_service___decorate([
    Object(core_es5["Injectable"])(),
    http_log_subscriber_service___metadata("design:paramtypes", [typeof (http_log_subscriber_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && http_log_subscriber_service__a || Object, typeof (http_log_subscriber_service__b = typeof http_es5["Http"] !== "undefined" && http_es5["Http"]) === "function" && http_log_subscriber_service__b || Object, typeof (_c = typeof console_log_subscriber_service_ConsoleLogSubscriberService !== "undefined" && console_log_subscriber_service_ConsoleLogSubscriberService) === "function" && _c || Object, typeof (_d = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && _d || Object])
], http_log_subscriber_service_HttpLogSubscriberService);

var http_log_subscriber_service__a, http_log_subscriber_service__b, _c, _d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/http-log-subscriber.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/flash-messages/component/flash.messages.component.ts
var flash_messages_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var flash_messages_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var flash_messages_component_FlashMessagesComponent = (function () {
    function FlashMessagesComponent(flashMessagesService, logService, environment) {
        this.flashMessagesService = flashMessagesService;
        this.logService = logService;
        this.environment = environment;
        this.messages = [];
    }
    FlashMessagesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.flashMessagesService.messages.subscribe(function (newMessage) {
            _this.show(newMessage);
        });
    };
    Object.defineProperty(FlashMessagesComponent.prototype, "alertTimer", {
        get: function () {
            return this.environment.alertMessageTimer != null ? this.environment.alertMessageTimer : 3500;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Removes any non-persistent error messages.
     * Unless specified, no error messages are persistent.
     * For other messages, they will close via timerClose
     * unless specified as persistent.
     */
    FlashMessagesComponent.prototype.clearNonPersistentMessages = function () {
        this.messages = this.messages.filter(function (message) { return message.displayThroughNavigation; });
    };
    FlashMessagesComponent.prototype.show = function (newMessage) {
        this.logService.debug("Received message " + JSON.stringify(newMessage));
        this.messages.push(newMessage);
        this.timerClose(newMessage);
    };
    FlashMessagesComponent.prototype.findClass = function (message) {
        var messageCssClass;
        switch (message.level) {
            case MessageLevel.ERROR:
                messageCssClass = 'alert-danger';
                break;
            case MessageLevel.SUCCESS:
                messageCssClass = 'alert-success';
                break;
            case MessageLevel.WARN:
                messageCssClass = 'alert-warning';
                break;
            default: {
                messageCssClass = 'alert-info';
            }
        }
        return messageCssClass;
    };
    FlashMessagesComponent.prototype.closeMessage = function (message) {
        this.remove(message);
    };
    FlashMessagesComponent.prototype.showClose = function (message) {
        return !message.autoClose;
    };
    FlashMessagesComponent.prototype.timerClose = function (message) {
        var _this = this;
        if (message.autoClose) {
            /**
             * .take(1) ensures that interval(this.alertTimer)  only happens once and then cleans up the observable.
             * Otherwise, the selenium tests will timeout waiting for the flashMessage interval to resolve.
             */
            Observable["Observable"].interval(this.alertTimer).take(1).subscribe(function () {
                _this.logService.debug("Observable.timer executing for id: " + message.id);
                _this.remove(message);
            });
        }
    };
    FlashMessagesComponent.prototype.remove = function (message) {
        this.messages = this.messages.filter(function (value, key) { return value.id !== message.id; });
    };
    return FlashMessagesComponent;
}());
flash_messages_component_FlashMessagesComponent = flash_messages_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-flash-messages',
        template: __webpack_require__("vFLc"),
        styles: [__webpack_require__("3XO/")]
    }),
    flash_messages_component___metadata("design:paramtypes", [typeof (flash_messages_component__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && flash_messages_component__a || Object, typeof (flash_messages_component__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && flash_messages_component__b || Object, typeof (flash_messages_component__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && flash_messages_component__c || Object])
], flash_messages_component_FlashMessagesComponent);

var flash_messages_component__a, flash_messages_component__b, flash_messages_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/flash.messages.component.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/immutable/dist/immutable.js
var immutable = __webpack_require__("2xpM");
var immutable_default = /*#__PURE__*/__webpack_require__.n(immutable);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/BehaviorSubject.js
var BehaviorSubject = __webpack_require__("gvep");
var BehaviorSubject_default = /*#__PURE__*/__webpack_require__.n(BehaviorSubject);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/angular2-jwt/angular2-jwt.js
var angular2_jwt = __webpack_require__("W4CS");
var angular2_jwt_default = /*#__PURE__*/__webpack_require__.n(angular2_jwt);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/lookup-address.ts
var lookup_address___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LookupAddressRecord = Object(immutable["Record"])({
    line1: null,
    line2: null,
    city: null,
    state: null,
    postalCode: null
});
var LookupAddress = (function (_super) {
    lookup_address___extends(LookupAddress, _super);
    function LookupAddress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LookupAddress;
}(LookupAddressRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/lookup-address.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/models/property-lookup-summary.ts
var property_lookup_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var PropertyLookupSummaryRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    propertyId: null,
    name: null,
    address: new LookupAddress({})
});
var PropertyLookupSummary = (function (_super) {
    property_lookup_summary___extends(PropertyLookupSummary, _super);
    function PropertyLookupSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyLookupSummary;
}(PropertyLookupSummaryRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/property-lookup-summary.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/lookup-contact.ts
var lookup_contact___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LookupContactRecord = Object(immutable["Record"])({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    fax: null
});
var LookupContact = (function (_super) {
    lookup_contact___extends(LookupContact, _super);
    function LookupContact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LookupContact;
}(LookupContactRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/lookup-contact.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/models/property-lookup-detail.ts
var property_lookup_detail___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var PropertyLookupDetailRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    propertyId: null,
    name: null,
    contact: new LookupContact({}),
    address: new LookupAddress({})
});
var PropertyLookupDetail = (function (_super) {
    property_lookup_detail___extends(PropertyLookupDetail, _super);
    function PropertyLookupDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyLookupDetail;
}(PropertyLookupDetailRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/property-lookup-detail.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/response-util.ts

var response_util_ResponseUtil = (function () {
    function ResponseUtil() {
    }
    ResponseUtil.unwrapErrorMessage = function (response) {
        var customMessage = '';
        if (response.json() && response.json().error) {
            customMessage = response.json().error;
        }
        var errorMessage = "Response with status " + response.status + ": " + customMessage;
        return Observable["Observable"].throw(errorMessage);
    };
    return ResponseUtil;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/response-util.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/property-lookup/property-lookup.http.service.ts
var property_lookup_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_lookup_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var property_lookup_http_service_PropertyLookupHttpService = (function () {
    function PropertyLookupHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.propertySearchURL = this.environment.baseUrl + "/api/lookup/properties";
        this.propertyDetailsURL = this.environment.baseUrl + "/api/lookup/properties/details";
    }
    PropertyLookupHttpService.prototype.search = function (propertyName) {
        var params = new http_es5["URLSearchParams"]();
        params.set('propertyName', propertyName);
        return this.http.get(this.propertySearchURL, { search: params })
            .map(function (res) { return res.json().map(function (object) { return new PropertyLookupSummary(object); }); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    PropertyLookupHttpService.prototype.getDetail = function (summaryRecord) {
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.post("" + this.propertyDetailsURL, JSON.stringify(summaryRecord), options)
            .map(function (response) { return new PropertyLookupDetail(response.json()); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return PropertyLookupHttpService;
}());
property_lookup_http_service_PropertyLookupHttpService = property_lookup_http_service___decorate([
    Object(core_es5["Injectable"])(),
    property_lookup_http_service___metadata("design:paramtypes", [typeof (property_lookup_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && property_lookup_http_service__a || Object, typeof (property_lookup_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && property_lookup_http_service__b || Object])
], property_lookup_http_service_PropertyLookupHttpService);

var property_lookup_http_service__a, property_lookup_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/property-lookup.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/property-lookup/property-lookup.store.ts
var property_lookup_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var property_lookup_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var property_lookup_store_PropertyLookupStore = (function () {
    function PropertyLookupStore(propertyLookupService, logService, flashMessagesService) {
        this.propertyLookupService = propertyLookupService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.mySelectedResults = new Subject["Subject"]();
        this.mySearchResults = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
    }
    Object.defineProperty(PropertyLookupStore.prototype, "selected", {
        get: function () {
            return this.mySelectedResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyLookupStore.prototype, "searchResults", {
        get: function () {
            return this.mySearchResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    PropertyLookupStore.prototype.clearSearchResults = function () {
        this.mySearchResults.next(Object(immutable["List"])([]));
    };
    PropertyLookupStore.prototype.search = function (searchText) {
        var _this = this;
        this.logService.debug("searchText: " + searchText);
        return this.propertyLookupService.search(searchText)
            .catch(function (error) {
            _this.flashMessagesService.warn('MESSAGES.ERROR.PROPERTY_LOOKUP_SEARCH', "Error retrieving PropertyLookupSearch: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySearchResults.next(res);
            return res;
        });
    };
    PropertyLookupStore.prototype.getDetail = function (summaryRecord) {
        var _this = this;
        this.logService.debug("summaryRecord: " + JSON.stringify(summaryRecord));
        return this.propertyLookupService.getDetail(summaryRecord)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.PROPERTY_LOOKUP_GET_DETAILS', "Error retrieving PropertyLookupDetail: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySelectedResults.next(res);
            return res;
        });
    };
    return PropertyLookupStore;
}());
property_lookup_store_PropertyLookupStore = property_lookup_store___decorate([
    Object(core_es5["Injectable"])(),
    property_lookup_store___metadata("design:paramtypes", [typeof (property_lookup_store__a = typeof property_lookup_http_service_PropertyLookupHttpService !== "undefined" && property_lookup_http_service_PropertyLookupHttpService) === "function" && property_lookup_store__a || Object, typeof (property_lookup_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && property_lookup_store__b || Object, typeof (property_lookup_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && property_lookup_store__c || Object])
], property_lookup_store_PropertyLookupStore);

var property_lookup_store__a, property_lookup_store__b, property_lookup_store__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/property-lookup.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/agency-lookup/agency-lookup.http.service.ts
var agency_lookup_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_lookup_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var agency_lookup_http_service_AgencyLookupHttpService = (function () {
    function AgencyLookupHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.agencySearchURL = this.environment.baseUrl + "/api/lookup/agencies";
        this.agencyDetailsURL = this.environment.baseUrl + "/api/lookup/agencies/details";
    }
    AgencyLookupHttpService.prototype.search = function (searchText) {
        var params = new http_es5["URLSearchParams"]();
        params.set('query', searchText);
        return this.http.get(this.agencySearchURL, { search: params })
            .map(function (res) { return res.json(); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AgencyLookupHttpService.prototype.getDetail = function (summaryRecord) {
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.post("" + this.agencyDetailsURL, JSON.stringify(summaryRecord), options)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return AgencyLookupHttpService;
}());
agency_lookup_http_service_AgencyLookupHttpService = agency_lookup_http_service___decorate([
    Object(core_es5["Injectable"])(),
    agency_lookup_http_service___metadata("design:paramtypes", [typeof (agency_lookup_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && agency_lookup_http_service__a || Object, typeof (agency_lookup_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && agency_lookup_http_service__b || Object])
], agency_lookup_http_service_AgencyLookupHttpService);

var agency_lookup_http_service__a, agency_lookup_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/agency-lookup.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/agency-lookup/agency-lookup.store.ts
var agency_lookup_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var agency_lookup_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var agency_lookup_store_AgencyLookupStore = (function () {
    function AgencyLookupStore(propertyLookupService, logService, flashMessagesService) {
        this.propertyLookupService = propertyLookupService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.mySelectedResults = new Subject["Subject"]();
        this.mySearchResults = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
    }
    Object.defineProperty(AgencyLookupStore.prototype, "selected", {
        get: function () {
            return this.mySelectedResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AgencyLookupStore.prototype, "searchResults", {
        get: function () {
            return this.mySearchResults.asObservable().share();
        },
        enumerable: true,
        configurable: true
    });
    AgencyLookupStore.prototype.clearSearchResults = function () {
        this.mySearchResults.next(Object(immutable["List"])([]));
    };
    AgencyLookupStore.prototype.search = function (searchText) {
        var _this = this;
        this.logService.debug("searchText: " + searchText);
        return this.propertyLookupService.search(searchText)
            .catch(function (error) {
            _this.flashMessagesService.warn('MESSAGES.ERROR.AGENCY_LOOKUP_SEARCH', "Error retrieving AgencyLookupSearch: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySearchResults.next(res);
            return res;
        });
    };
    AgencyLookupStore.prototype.getDetail = function (summaryRecord) {
        var _this = this;
        this.logService.debug("summaryRecord: " + JSON.stringify(summaryRecord));
        return this.propertyLookupService.getDetail(summaryRecord)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_LOOKUP_GET_DETAILS', "Error retrieving AgencyLookupDetail: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySelectedResults.next(res);
            return res;
        });
    };
    return AgencyLookupStore;
}());
agency_lookup_store_AgencyLookupStore = agency_lookup_store___decorate([
    Object(core_es5["Injectable"])(),
    agency_lookup_store___metadata("design:paramtypes", [typeof (agency_lookup_store__a = typeof agency_lookup_http_service_AgencyLookupHttpService !== "undefined" && agency_lookup_http_service_AgencyLookupHttpService) === "function" && agency_lookup_store__a || Object, typeof (agency_lookup_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && agency_lookup_store__b || Object, typeof (agency_lookup_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && agency_lookup_store__c || Object])
], agency_lookup_store_AgencyLookupStore);

var agency_lookup_store__a, agency_lookup_store__b, agency_lookup_store__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/agency-lookup.store.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ngx-bootstrap/accordion/index.js + 6 modules
var accordion = __webpack_require__("C2n2");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ngx-bootstrap/alert/index.js + 3 modules
var ngx_bootstrap_alert = __webpack_require__("fSDq");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ngx-bootstrap/dropdown/index.js + 7 modules
var dropdown = __webpack_require__("ZBFC");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ngx-bootstrap/modal/index.js + 7 modules
var modal = __webpack_require__("WYiA");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ngx-bootstrap/popover/index.js + 4 modules
var popover = __webpack_require__("eTxu");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ngx-bootstrap/tooltip/index.js + 5 modules
var tooltip = __webpack_require__("In3T");

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/bootstrap/bootstrap.module.ts
var bootstrap_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var bootstrap_module___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var BootstrapModule = (function () {
    function BootstrapModule() {
    }
    return BootstrapModule;
}());
BootstrapModule = bootstrap_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            accordion["a" /* AccordionModule */].forRoot(),
            ngx_bootstrap_alert["a" /* AlertModule */].forRoot(),
            dropdown["a" /* BsDropdownModule */].forRoot(),
            modal["b" /* ModalModule */].forRoot(),
            popover["a" /* PopoverModule */].forRoot(),
            tooltip["a" /* TooltipModule */].forRoot() // Don't work for bootstrap 4 Alpha 6 at the moment
        ],
        exports: [
            accordion["a" /* AccordionModule */],
            ngx_bootstrap_alert["a" /* AlertModule */],
            modal["b" /* ModalModule */],
            popover["a" /* PopoverModule */],
            tooltip["a" /* TooltipModule */]
        ],
        declarations: [],
        providers: []
    }),
    bootstrap_module___metadata("design:paramtypes", [])
], BootstrapModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/bootstrap.module.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/validation-message/validation-message.component.ts
var validation_message_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var validation_message_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ValidationMessageComponent = (function () {
    function ValidationMessageComponent(form, translateService) {
        this.form = form;
        this.translateService = translateService;
        if (!this.form) {
            throw new Error("A form ControlContainer could not be found. The ValidationMessageComponent must exists within a \"formGroup\"");
        }
    }
    Object.defineProperty(ValidationMessageComponent.prototype, "valid", {
        get: function () {
            // If the user has touched the control then validate it, otherwise it should be considered valid.
            return this.control.touched ? !this.control.hasError(this.error.toLowerCase()) : true;
        },
        enumerable: true,
        configurable: true
    });
    ValidationMessageComponent.prototype.getValidationMessage = function (error) {
        // Return the user specified validation message if present, otherwise
        // fall back to the default message configured in the transaltion service
        var key = "MESSAGES.VALIDATION." + error.toUpperCase();
        return this.translateService.instant(this.message || key);
    };
    ValidationMessageComponent.prototype.ngOnInit = function () {
        // If the "for" attribute is specified find the control with a matching value in the formControlName attribute
        // otherwise return the form itself.  This allows for both input and form level validation to be handled.
        this.control = this.for ? this.form.control.get(this.for) : this.form;
        // Ensure that a form control is found with the correct name if the "for" attribute is specified
        if (this.for && !this.control) {
            throw new Error("Value in the \"for\" attribute: \"" + this.for + "\" could not be located in a corresponding \"formControlName\"");
        }
        // Ensure the "error" attribute is specified. IE: "required", "minlength"
        if (!this.error) {
            throw new Error("A value in the \"error\" attribute is required and should be the name of the rule associated with this message.");
        }
    };
    return ValidationMessageComponent;
}());
validation_message_component___decorate([
    Object(core_es5["Input"])(),
    validation_message_component___metadata("design:type", String)
], ValidationMessageComponent.prototype, "for", void 0);
validation_message_component___decorate([
    Object(core_es5["Input"])(),
    validation_message_component___metadata("design:type", String)
], ValidationMessageComponent.prototype, "error", void 0);
validation_message_component___decorate([
    Object(core_es5["Input"])(),
    validation_message_component___metadata("design:type", String)
], ValidationMessageComponent.prototype, "message", void 0);
ValidationMessageComponent = validation_message_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-validation-message',
        template: __webpack_require__("wvGA")
    }),
    validation_message_component___metadata("design:paramtypes", [typeof (validation_message_component__a = typeof forms_es5["ControlContainer"] !== "undefined" && forms_es5["ControlContainer"]) === "function" && validation_message_component__a || Object, typeof (validation_message_component__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && validation_message_component__b || Object])
], ValidationMessageComponent);

var validation_message_component__a, validation_message_component__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/validation-message.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/form-input/form-input.component.ts
var form_input_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var form_input_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var FormInputComponent = (function () {
    function FormInputComponent(logService) {
        this.logService = logService;
        this.isReadOnly = false;
        this.overrideErrors = [];
    }
    FormInputComponent.prototype.ngOnInit = function () {
    };
    FormInputComponent.prototype.ngAfterContentInit = function () {
        this.overrideErrors = this.getOverrideErrors();
    };
    FormInputComponent.prototype.getOverrideErrors = function () {
        // The overrideErrors are gathered from any 'ValidationMessageComponent' that are
        // declared as part of the FormInputComponent content. <ng-content>
        return this.overrideValidationMessages.map(function (message) { return message.error; });
    };
    /**
     * Default errors generated from the errors associated with the control.
     * These are typically created when the FormBuild group is initialized.
     * By eliminating the override errors (those the developer specifies in ng-content)
     * the control can automatically generate validation messages for any errors
     * that have not been specifically overridden.
     *
     * @returns {Array}
     */
    FormInputComponent.prototype.getFormControlErrors = function () {
        var errorObject = this.inputControl.errors;
        if (!errorObject) {
            return [];
        }
        return Object.keys(errorObject);
    };
    Object.defineProperty(FormInputComponent.prototype, "getDefaultErrors", {
        get: function () {
            if (this.isReadOnly) {
                // Show no errors while component is in readonly mode.
                return [];
            }
            var defaultErrors = this.getFormControlErrors();
            var overrideErrors = this.overrideErrors;
            // Get the errors from the form error object and filter out any that are
            // provided in the override errors.
            var filteredErrors = defaultErrors.filter(function (error) { return overrideErrors.indexOf(error) === -1; });
            return filteredErrors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormInputComponent.prototype, "isRequired", {
        get: function () {
            return this.getFormControlErrors().filter(function (error) { return error === 'required'; }).length > 0;
        },
        enumerable: true,
        configurable: true
    });
    FormInputComponent.prototype.isFormControlValid = function () {
        if (this.inputControl && this.inputControl.control) {
            return this.inputControl.control.valid;
        }
        return false;
    };
    FormInputComponent.prototype.isFormControlTouched = function () {
        if (this.inputControl && this.inputControl.control) {
            return this.inputControl.control.touched;
        }
        return false;
    };
    FormInputComponent.prototype.getFormControlName = function () {
        if (this.inputControl) {
            return this.inputControl.name;
        }
        return null;
    };
    Object.defineProperty(FormInputComponent.prototype, "isValid", {
        get: function () {
            var overrideErrorsAreValid = !this.overrideValidationMessages.some(function (message) { return !message.valid; });
            var defaultErrorsAreValid = this.isFormControlValid();
            var touched = this.isFormControlTouched();
            if (touched) {
                this.logService.verbose(this.getFormControlName() + ' - touched {' + touched + '} ' +
                    'defaultErrorsAreValid: {' + defaultErrorsAreValid + '} ' +
                    'overrideErrorsAreValid: {' + overrideErrorsAreValid + '}');
            }
            return touched ? defaultErrorsAreValid && overrideErrorsAreValid : true;
        },
        enumerable: true,
        configurable: true
    });
    return FormInputComponent;
}());
form_input_component___decorate([
    Object(core_es5["Input"])(),
    form_input_component___metadata("design:type", Object)
], FormInputComponent.prototype, "isReadOnly", void 0);
form_input_component___decorate([
    Object(core_es5["Input"])(),
    form_input_component___metadata("design:type", String)
], FormInputComponent.prototype, "label", void 0);
form_input_component___decorate([
    Object(core_es5["Input"])(),
    form_input_component___metadata("design:type", String)
], FormInputComponent.prototype, "message", void 0);
form_input_component___decorate([
    Object(core_es5["ContentChild"])(forms_es5["FormControlName"]),
    form_input_component___metadata("design:type", typeof (form_input_component__a = typeof forms_es5["FormControlName"] !== "undefined" && forms_es5["FormControlName"]) === "function" && form_input_component__a || Object)
], FormInputComponent.prototype, "inputControl", void 0);
form_input_component___decorate([
    Object(core_es5["ContentChildren"])(ValidationMessageComponent),
    form_input_component___metadata("design:type", typeof (form_input_component__b = typeof core_es5["QueryList"] !== "undefined" && core_es5["QueryList"]) === "function" && form_input_component__b || Object)
], FormInputComponent.prototype, "overrideValidationMessages", void 0);
FormInputComponent = form_input_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-form-input',
        template: __webpack_require__("QLMO")
    }),
    form_input_component___metadata("design:paramtypes", [typeof (form_input_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && form_input_component__c || Object])
], FormInputComponent);

var form_input_component__a, form_input_component__b, form_input_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/form-input.component.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/lookup.store.ts
var lookup_store = __webpack_require__("roPR");
var lookup_store_default = /*#__PURE__*/__webpack_require__.n(lookup_store);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/inline-search/inline-search.component.ts
var inline_search_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var inline_search_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var inline_search_component_InlineSearchComponent = (function () {
    function InlineSearchComponent(el, logService) {
        this.el = el;
        this.logService = logService;
        this.results = new core_es5["EventEmitter"]();
        this.blur = new core_es5["EventEmitter"]();
        this.hasResults = false;
    }
    InlineSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        var eventStream = Observable["Observable"].fromEvent(this.el.nativeElement, 'keyup')
            .map(function () { return _this.nameSearch; })
            .debounceTime(250)
            .share();
        eventStream.filter(function (text) { return text && text.length === 0; })
            .subscribe(function (_) { return _this.setResults(Object(immutable["List"])([])); });
        eventStream.filter(function (text) { return text && text.length > 1; })
            .map(function (query) { return _this.lookupStore.search(query); })
            .switch()
            .subscribe(function (results) {
            _this.logService.info("InlineSearchBox: results " + JSON.stringify(results));
            _this.setResults(results);
        }, function (error) {
            _this.logService.error("InlineSearchBox: " + error);
        });
        this.lookupStore.selected.subscribe(function () {
            // Clear the search field and result dropdown upon selecting a lookup.
            _this.resetSearch();
        });
    };
    InlineSearchComponent.prototype.setResults = function (results) {
        if (results instanceof immutable["List"]) {
            this.hasResults = !results.isEmpty();
        }
        if (results instanceof Array) {
            this.hasResults = results.length > 0;
        }
        this.results.next(results);
    };
    InlineSearchComponent.prototype.onBlur = function () {
        this.blur.next(true);
        this.resetSearch();
    };
    InlineSearchComponent.prototype.resetSearch = function () {
        this.nameSearch = '';
        this.setResults(Object(immutable["List"])([]));
    };
    return InlineSearchComponent;
}());
inline_search_component___decorate([
    Object(core_es5["Output"])('results'),
    inline_search_component___metadata("design:type", typeof (inline_search_component__a = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && inline_search_component__a || Object)
], inline_search_component_InlineSearchComponent.prototype, "results", void 0);
inline_search_component___decorate([
    Object(core_es5["Output"])('blur'),
    inline_search_component___metadata("design:type", typeof (inline_search_component__b = typeof core_es5["EventEmitter"] !== "undefined" && core_es5["EventEmitter"]) === "function" && inline_search_component__b || Object)
], inline_search_component_InlineSearchComponent.prototype, "blur", void 0);
inline_search_component___decorate([
    Object(core_es5["Input"])('placeholderText'),
    inline_search_component___metadata("design:type", String)
], inline_search_component_InlineSearchComponent.prototype, "placeholderText", void 0);
inline_search_component___decorate([
    Object(core_es5["Input"])('lookupStore'),
    inline_search_component___metadata("design:type", typeof (inline_search_component__c = typeof lookup_store["LookupStore"] !== "undefined" && lookup_store["LookupStore"]) === "function" && inline_search_component__c || Object)
], inline_search_component_InlineSearchComponent.prototype, "lookupStore", void 0);
inline_search_component_InlineSearchComponent = inline_search_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-inline-search-component',
        template: __webpack_require__("1Wrw")
    }),
    inline_search_component___metadata("design:paramtypes", [typeof (inline_search_component__d = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && inline_search_component__d || Object, typeof (_e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && _e || Object])
], inline_search_component_InlineSearchComponent);

var inline_search_component__a, inline_search_component__b, inline_search_component__c, inline_search_component__d, _e;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/inline-search.component.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ng2-page-scroll/ng2-page-scroll.js + 6 modules
var ng2_page_scroll = __webpack_require__("U89H");

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal.component.ts
var confirmation_modal_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var confirmation_modal_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


/*
 * Template Implementation Example
 *
 * <!-- Button to activate modal -->
 * <button type="button" class="btn btn-primary" (click)="confirmBeforeAuthorizingPayment()">Save</button>
 *
 * <!-- Modal component -->
 * <pioneer-confirmation-modal (closed)="confirmHandler($event)"></pioneer-confirmation-modal>
 *
 *
 * Component Implementation Example
 *
 * import { Component, OnInit, ViewChild } from '@angular/core';
 * import { ModalDirective } from 'ngx-bootstrap/modal';
 * import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
 * @Component({
 *  selector: 'pioneer-example',
 *  templateUrl: './example.component.html'
 * })
 * export class ExampleComponent {
 *   @ViewChild(ConfirmationModalComponent)
 *   public confirmationModal: ConfirmationModalComponent;
 *
 *   public confirmBeforeAuthorizingPayment(): void {
 *     this.confirmationModal.open();
 *   }
 *
 *   public confirmHandler(value) {
 *     if (value) {
 *       this.save();
 *     }
 *   }
 *
 *   public save() {
 *     ...
 *   }
 * }
 */
var confirmation_modal_component_ConfirmationModalComponent = (function () {
    function ConfirmationModalComponent() {
        this.cancel = 'COMMON.BUTTON.DISCARD';
        this.confirm = 'COMMON.BUTTON.CONTINUE';
        this.title = 'MESSAGES.CONFIRMATION.EXIT_TITLE';
        this.content = 'MESSAGES.CONFIRMATION.EXIT_MESSAGE';
        this.config = {
            backdrop: 'static'
        };
        this.closed = new core_es5["EventEmitter"]();
    }
    ConfirmationModalComponent.prototype.ngOnInit = function () {
    };
    ConfirmationModalComponent.prototype.open = function () {
        this.confirmationModal.show();
    };
    ConfirmationModalComponent.prototype.close = function (value) {
        this.closed.emit(value);
        this.confirmationModal.hide();
    };
    return ConfirmationModalComponent;
}());
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "cancel", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "confirm", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "title", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "content", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Input"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "config", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["Output"])(),
    confirmation_modal_component___metadata("design:type", Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "closed", void 0);
confirmation_modal_component___decorate([
    Object(core_es5["ViewChild"])(modal["a" /* ModalDirective */]),
    confirmation_modal_component___metadata("design:type", typeof (confirmation_modal_component__a = typeof modal["a" /* ModalDirective */] !== "undefined" && modal["a" /* ModalDirective */]) === "function" && confirmation_modal_component__a || Object)
], confirmation_modal_component_ConfirmationModalComponent.prototype, "confirmationModal", void 0);
confirmation_modal_component_ConfirmationModalComponent = confirmation_modal_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-confirmation-modal',
        template: __webpack_require__("Zu/a")
    }),
    confirmation_modal_component___metadata("design:paramtypes", [])
], confirmation_modal_component_ConfirmationModalComponent);

var confirmation_modal_component__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/confirmation-modal.component.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/observable/combineLatest.js
var combineLatest = __webpack_require__("vJ3t");
var combineLatest_default = /*#__PURE__*/__webpack_require__.n(combineLatest);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/observable/from.js
var from = __webpack_require__("XL2q");
var from_default = /*#__PURE__*/__webpack_require__.n(from);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/observable/fromEvent.js
var fromEvent = __webpack_require__("Xtvq");
var fromEvent_default = /*#__PURE__*/__webpack_require__.n(fromEvent);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/observable/interval.js
var interval = __webpack_require__("ACG2");
var interval_default = /*#__PURE__*/__webpack_require__.n(interval);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/observable/throw.js
var observable_throw = __webpack_require__("S7im");
var throw_default = /*#__PURE__*/__webpack_require__.n(observable_throw);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/observable/never.js
var never = __webpack_require__("dyFf");
var never_default = /*#__PURE__*/__webpack_require__.n(never);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/catch.js
var operator_catch = __webpack_require__("xpf9");
var catch_default = /*#__PURE__*/__webpack_require__.n(operator_catch);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/concat.js
var concat = __webpack_require__("R0J0");
var concat_default = /*#__PURE__*/__webpack_require__.n(concat);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/debounceTime.js
var debounceTime = __webpack_require__("azLz");
var debounceTime_default = /*#__PURE__*/__webpack_require__.n(debounceTime);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/delay.js
var delay = __webpack_require__("l3Q+");
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/filter.js
var operator_filter = __webpack_require__("gbhw");
var filter_default = /*#__PURE__*/__webpack_require__.n(operator_filter);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/finally.js
var operator_finally = __webpack_require__("zc4d");
var finally_default = /*#__PURE__*/__webpack_require__.n(operator_finally);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/first.js
var first = __webpack_require__("ZQKz");
var first_default = /*#__PURE__*/__webpack_require__.n(first);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/map.js
var operator_map = __webpack_require__("5v8a");
var operator_map_default = /*#__PURE__*/__webpack_require__.n(operator_map);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/share.js
var share = __webpack_require__("qm+V");
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/add/operator/switch.js
var operator_switch = __webpack_require__("mvrJ");
var switch_default = /*#__PURE__*/__webpack_require__.n(operator_switch);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/version/service/version.http.service.ts
var version_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var version_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var version_http_service_VersionHttpService = (function () {
    function VersionHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.pulse = this.environment.baseUrl + '/pulse';
    }
    VersionHttpService.prototype.getFrontendVersion = function () {
        return this.http.get('/assets/version.json')
            .map(function (res) { return res.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    VersionHttpService.prototype.getBackendVersion = function () {
        return this.http.get(this.pulse)
            .map(function (res) { return res.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return VersionHttpService;
}());
version_http_service_VersionHttpService = version_http_service___decorate([
    Object(core_es5["Injectable"])(),
    version_http_service___metadata("design:paramtypes", [typeof (version_http_service__a = typeof http_es5["Http"] !== "undefined" && http_es5["Http"]) === "function" && version_http_service__a || Object, typeof (version_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && version_http_service__b || Object])
], version_http_service_VersionHttpService);

var version_http_service__a, version_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/version.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/version/service/version.store.ts
var version_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var version_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var version_store_VersionStore = (function () {
    function VersionStore(versionHttp, logService) {
        this.versionHttp = versionHttp;
        this.logService = logService;
        this.currentFrontendVersion = new Subject["Subject"]();
        this.currentBackendVersion = new Subject["Subject"]();
    }
    VersionStore.prototype.getFrontendVersion = function () {
        var _this = this;
        this.versionHttp.getFrontendVersion().subscribe(function (versionObj) {
            _this.logService.verbose("VersionStore versionObj: " + JSON.stringify(versionObj));
            _this.currentFrontendVersion.next(versionObj);
        });
        return this.currentFrontendVersion.asObservable();
    };
    VersionStore.prototype.getBackendVersion = function () {
        var _this = this;
        this.versionHttp.getBackendVersion().subscribe(function (versionObj) {
            _this.logService.verbose("VersionStore versionObj: " + JSON.stringify(versionObj));
            _this.currentBackendVersion.next(versionObj);
        });
        return this.currentBackendVersion.asObservable();
    };
    return VersionStore;
}());
version_store_VersionStore = version_store___decorate([
    Object(core_es5["Injectable"])(),
    version_store___metadata("design:paramtypes", [typeof (version_store__a = typeof version_http_service_VersionHttpService !== "undefined" && version_http_service_VersionHttpService) === "function" && version_store__a || Object, typeof (version_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && version_store__b || Object])
], version_store_VersionStore);

var version_store__a, version_store__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/version.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/version/version.component.ts
var version_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var version_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var VersionComponent = (function () {
    function VersionComponent(versionStore, logService) {
        this.versionStore = versionStore;
        this.logService = logService;
        this.frontendVersionObj = {};
        this.backendVersionObj = {};
    }
    VersionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.versionStore.getFrontendVersion().subscribe(function (versionObj) {
            _this.frontendVersionObj = versionObj;
        });
        this.versionStore.getBackendVersion().subscribe(function (versionObj) {
            _this.backendVersionObj = versionObj;
        });
    };
    return VersionComponent;
}());
VersionComponent = version_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-version',
        template: __webpack_require__("xhPN")
    }),
    version_component___metadata("design:paramtypes", [typeof (version_component__a = typeof version_store_VersionStore !== "undefined" && version_store_VersionStore) === "function" && version_component__a || Object, typeof (version_component__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && version_component__b || Object])
], VersionComponent);

var version_component__a, version_component__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/version.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/models/user-permission.model.ts
var user_permission_model___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UserPermissionRecord = Object(immutable["Record"])({
    token: null,
    permissions: []
});
var UserPermission = (function (_super) {
    user_permission_model___extends(UserPermission, _super);
    function UserPermission() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UserPermission;
}(UserPermissionRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/user-permission.model.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard-filter.ts
var dashboard_filter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var DashboardFilterStateRecord = Object(immutable["Record"])({
    completedAndUnpaid: true,
    missingAgency: true
});
var DashboardFilterState = (function (_super) {
    dashboard_filter___extends(DashboardFilterState, _super);
    function DashboardFilterState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DashboardFilterState;
}(DashboardFilterStateRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/dashboard-filter.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/services/user.local.storage.service.ts
var user_local_storage_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var user_local_storage_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var user_local_storage_service_UserLocalStorageService = (function () {
    function UserLocalStorageService(logService) {
        this.logService = logService;
        this.TOKEN_NAME = 'id_token';
        this.EMAIL_PREFIX = 'dashboard_filters_';
    }
    UserLocalStorageService.prototype.getToken = function () {
        try {
            return this.fromUserPermissions().token;
        }
        catch (error) {
            this.removeUserToken();
            this.logService.error('Unable to read token' + error);
            return null;
        }
    };
    UserLocalStorageService.prototype.getPermissions = function () {
        try {
            return this.fromUserPermissions().permissions;
        }
        catch (error) {
            this.removeUserToken();
            this.logService.error('Unable to read token' + error);
            return [];
        }
    };
    UserLocalStorageService.prototype.getDashboardFilterState = function (email) {
        email = this.EMAIL_PREFIX + email;
        var dashboardFilterStateJson = this.getItemAsJson(email);
        return new DashboardFilterState(dashboardFilterStateJson);
    };
    UserLocalStorageService.prototype.removeUserToken = function () {
        this.removeItem(this.TOKEN_NAME);
    };
    UserLocalStorageService.prototype.setUserToken = function (userPermission) {
        this.setItem(this.TOKEN_NAME, JSON.stringify(userPermission));
    };
    UserLocalStorageService.prototype.setDashboardFilterState = function (email, dashboardFilterState) {
        email = this.EMAIL_PREFIX + email;
        this.setItem(email, JSON.stringify(dashboardFilterState));
    };
    UserLocalStorageService.prototype.fromUserPermissions = function () {
        return new UserPermission(this.getItemAsJson(this.TOKEN_NAME));
    };
    UserLocalStorageService.prototype.setItem = function (key, value) {
        localStorage.setItem(key, value);
    };
    UserLocalStorageService.prototype.getItem = function (key) {
        return localStorage.getItem(key);
    };
    UserLocalStorageService.prototype.getItemAsJson = function (key) {
        try {
            var stringItem = this.getItem(key);
            if (stringItem != null) {
                return JSON.parse(stringItem);
            }
        }
        catch (error) {
            this.removeItem(key);
            this.logService.error('Unable to read token' + error);
        }
        return null;
    };
    UserLocalStorageService.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    Object.defineProperty(UserLocalStorageService.prototype, "length", {
        get: function () {
            return localStorage.length;
        },
        enumerable: true,
        configurable: true
    });
    UserLocalStorageService.prototype.key = function (i) {
        return localStorage.key(i);
    };
    return UserLocalStorageService;
}());
user_local_storage_service_UserLocalStorageService = user_local_storage_service___decorate([
    Object(core_es5["Injectable"])(),
    user_local_storage_service___metadata("design:paramtypes", [typeof (user_local_storage_service__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && user_local_storage_service__a || Object])
], user_local_storage_service_UserLocalStorageService);

var user_local_storage_service__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/user.local.storage.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/services/authentication.http.service.ts
var authentication_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var authentication_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var authentication_http_service_AuthenticationHttpService = (function () {
    function AuthenticationHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.loginURL = this.environment.baseUrl + '/api/auth/login';
        this.permissionURL = this.environment.baseUrl + '/api/auth/permissions';
    }
    AuthenticationHttpService.prototype.login = function (username, password) {
        var loginPayload = { 'userId': username, 'password': password };
        return this.http.post(this.loginURL, loginPayload)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AuthenticationHttpService.prototype.getPermissions = function (token) {
        var headers = new http_es5["Headers"]({
            'Content-Type': 'application/json',
            'Authorization': token
        });
        var options = new http_es5["RequestOptions"]({ headers: headers }); // Create a request option
        return this.http.get(this.permissionURL, options)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return AuthenticationHttpService;
}());
authentication_http_service_AuthenticationHttpService = authentication_http_service___decorate([
    Object(core_es5["Injectable"])(),
    authentication_http_service___metadata("design:paramtypes", [typeof (authentication_http_service__a = typeof http_es5["Http"] !== "undefined" && http_es5["Http"]) === "function" && authentication_http_service__a || Object, typeof (authentication_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && authentication_http_service__b || Object])
], authentication_http_service_AuthenticationHttpService);

var authentication_http_service__a, authentication_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/authentication.http.service.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/rxjs/ReplaySubject.js
var ReplaySubject = __webpack_require__("0imh");
var ReplaySubject_default = /*#__PURE__*/__webpack_require__.n(ReplaySubject);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@ngx-translate/core/src/util.js
var util = __webpack_require__("ansA");

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/models/User.ts
var User___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var UserRecord = Object(immutable["Record"])({
    email: null,
    firstName: null,
    lastName: null
});
var User = (function (_super) {
    User___extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return User;
}(UserRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/User.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/services/authentication.store.ts
var authentication_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var authentication_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var authentication_store_AuthenticationStore = AuthenticationStore_1 = (function () {
    function AuthenticationStore(authenticationHttpService, logService, userLocalStorageService) {
        this.authenticationHttpService = authenticationHttpService;
        this.logService = logService;
        this.userLocalStorageService = userLocalStorageService;
        this.jwtHelper = new angular2_jwt["JwtHelper"]();
        this.userAuthenticated = new ReplaySubject["ReplaySubject"](1);
        this.userBehaviorSubject = new BehaviorSubject["BehaviorSubject"](new User());
        this.init();
    }
    AuthenticationStore.prototype.init = function () {
        var encodedToken = this.getToken();
        this.setUserFromToken(encodedToken);
    };
    Object.defineProperty(AuthenticationStore.prototype, "user", {
        get: function () {
            return this.userBehaviorSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationStore.prototype.login = function (username, password) {
        var _this = this;
        var login = this.authenticationHttpService.login(username, password);
        return login.map(function (userPermission) {
            if (userPermission && userPermission.token) {
                // set token property
                var tokenString = userPermission.token;
                _this.logService.debug("expiration: " + _this.jwtHelper.getTokenExpirationDate(tokenString));
                _this.logService.debug("is expired: " + _this.jwtHelper.isTokenExpired(tokenString));
                _this.logService.debug("decoded: " + JSON.stringify(_this.jwtHelper.decodeToken(tokenString)));
                // store username and jwt token in local storage to keep user logged in between page refreshes
                _this.userLocalStorageService.setUserToken(userPermission);
                _this.setExternalLogin(false);
                _this.updateState();
                _this.setUserFromToken(userPermission.token);
                // return true to indicate successful login
                return true;
            }
            else {
                _this.userLocalStorageService.removeUserToken();
                // return false to indicate failed login
                return false;
            }
        });
    };
    AuthenticationStore.prototype.handleTokenFromExternalSource = function (token) {
        var _this = this;
        try {
            // Make sure token is in the right format.  This will throw an error if it's not.
            this.jwtHelper.decodeToken(token);
        }
        catch (error) {
            this.logService.error("Invalid token format [" + token + "] with error: " + error);
            return Observable["Observable"].throw(ExternalSourceError.TOKEN_INVALID_FORMAT);
        }
        // Make sure token is not expired
        if (this.jwtHelper.isTokenExpired(token)) {
            this.logService.error("Token is expired: " + token);
            return Observable["Observable"].throw(ExternalSourceError.TOKEN_EXPIRED);
        }
        return this.authenticationHttpService.getPermissions(token)
            .catch(function (error) {
            _this.logService.error("Failed to get permissions");
            return Observable["Observable"].throw(ExternalSourceError.DEFAULT_ERROR);
        })
            .map(function (userPermission) {
            _this.logService.debug('Returned user permissions');
            // Make sure we got a valid response back from the server
            if (userPermission && userPermission.token) {
                // store username and jwt token in local storage to keep user logged in between page refreshes
                _this.userLocalStorageService.setUserToken(userPermission);
                _this.setExternalLogin(true);
                _this.setUserFromToken(userPermission.token);
                return userPermission;
            }
            else {
                _this.logService.error("Received invalid permissions");
                throw new Error('Invalid UserPermission');
            }
        });
    };
    AuthenticationStore.prototype.getToken = function () {
        return this.userLocalStorageService.getToken();
    };
    AuthenticationStore.prototype.removeToken = function () {
        this.userLocalStorageService.removeItem(AuthenticationStore_1.TOKEN_NAME);
    };
    AuthenticationStore.prototype.isExternalLogin = function () {
        var loginSourceStr = this.userLocalStorageService.getItem(AuthenticationStore_1.EXTERNAL_LOGIN);
        return loginSourceStr === 'true';
    };
    AuthenticationStore.prototype.setExternalLogin = function (externalLogin) {
        this.userLocalStorageService.setItem(AuthenticationStore_1.EXTERNAL_LOGIN, externalLogin ? 'true' : 'false');
    };
    AuthenticationStore.prototype.removeExternalLogin = function () {
        this.userLocalStorageService.removeItem(AuthenticationStore_1.EXTERNAL_LOGIN);
    };
    AuthenticationStore.prototype.hasPermission = function (arg) {
        var testPermissions;
        if (arg instanceof Array) {
            // arg must be string[]
            testPermissions = arg.map(function (perm) { return perm.toLowerCase(); });
        }
        else {
            // arg must be a string
            testPermissions = [arg.toLowerCase()];
        }
        var userPermissions = this.userLocalStorageService.getPermissions().map(function (perm) { return perm.toLowerCase(); });
        if (userPermissions.find(function (up) { return Object(util["b" /* isDefined */])(testPermissions.find(function (tp) { return tp === up; })); })) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthenticationStore.prototype.isTokenExpired = function () {
        var token = this.userLocalStorageService.getToken();
        if (!token) {
            return true;
        }
        return this.jwtHelper.isTokenExpired(token);
    };
    AuthenticationStore.prototype.isTokenValid = function () {
        var isTokenValid = !this.isTokenExpired();
        this.logService.verbose("isTokenValid: " + isTokenValid);
        return isTokenValid;
    };
    /**
     * This method will test to determine if the current token is expired.  It will put those
     * results in the Subject so that listeners will be made aware.
     *
     */
    AuthenticationStore.prototype.updateState = function () {
        this.userAuthenticated.next(this.isTokenValid());
    };
    AuthenticationStore.prototype.isLoggedIn = function () {
        this.updateState();
        return this.userAuthenticated.asObservable();
    };
    Object.defineProperty(AuthenticationStore.prototype, "permissions", {
        get: function () {
            return this.userLocalStorageService.getPermissions();
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationStore.prototype.logout = function () {
        this.removeToken();
        this.removeExternalLogin();
        this.updateState();
    };
    AuthenticationStore.prototype.setUserFromToken = function (token) {
        if (!token) {
            return;
        }
        var decodedToken = this.jwtHelper.decodeToken(token);
        var user = new User({
            email: decodedToken.email || '',
            firstName: decodedToken.firstname || '',
            lastName: decodedToken.lastname || ''
        });
        this.setUserBehaviorSubject(user);
    };
    // marked protected so that MockAuthenticationStore can override as public
    AuthenticationStore.prototype.setUserBehaviorSubject = function (user) {
        this.userBehaviorSubject.next(user);
    };
    return AuthenticationStore;
}());
authentication_store_AuthenticationStore.TOKEN_NAME = 'id_token';
authentication_store_AuthenticationStore.EXTERNAL_LOGIN = 'external_login';
authentication_store_AuthenticationStore = AuthenticationStore_1 = authentication_store___decorate([
    Object(core_es5["Injectable"])(),
    authentication_store___metadata("design:paramtypes", [typeof (authentication_store__a = typeof authentication_http_service_AuthenticationHttpService !== "undefined" && authentication_http_service_AuthenticationHttpService) === "function" && authentication_store__a || Object, typeof (authentication_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && authentication_store__b || Object, typeof (authentication_store__c = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && authentication_store__c || Object])
], authentication_store_AuthenticationStore);

var ExternalSourceError;
(function (ExternalSourceError) {
    ExternalSourceError[ExternalSourceError["TOKEN_EXPIRED"] = 0] = "TOKEN_EXPIRED";
    ExternalSourceError[ExternalSourceError["TOKEN_INVALID_FORMAT"] = 1] = "TOKEN_INVALID_FORMAT";
    ExternalSourceError[ExternalSourceError["DEFAULT_ERROR"] = 2] = "DEFAULT_ERROR";
})(ExternalSourceError || (ExternalSourceError = {}));
var AuthenticationStore_1, authentication_store__a, authentication_store__b, authentication_store__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/authentication.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/services/angular2-jwt.config.ts




function authFactory(http, options, userLocalStorageService) {
    return new angular2_jwt["AuthHttp"](new angular2_jwt["AuthConfig"]({
        // Config options if you want
        noTokenScheme: true,
        tokenName: authentication_store_AuthenticationStore.TOKEN_NAME,
        tokenGetter: (function () { return userLocalStorageService.getToken(); })
    }), http, options);
}
;
// Include this in your ngModule providers
var authProvider = {
    provide: angular2_jwt["AuthHttp"],
    deps: [http_es5["Http"], http_es5["RequestOptions"], user_local_storage_service_UserLocalStorageService],
    useFactory: authFactory
};
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/angular2-jwt.config.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/models/authorize.model.ts
var AuthorizationModel = (function () {
    function AuthorizationModel() {
    }
    return AuthorizationModel;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/authorize.model.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/directive/authorization-directive.ts
var authorization_directive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var authorization_directive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





/**
 *
 @example <caption>Example usage of AuthorizeDirective.</caption>
 * <div *pioneerAuthorize="{permission: 'AddEvent'}"></div>
 * and
 * <div *pioneerAuthorize="{permissions: ['AddEvent', 'EditEvent']}"></div>
 */
var AuthorizeDirective = (function () {
    function AuthorizeDirective(viewContainer, template, authStore, translateService, logService) {
        this.viewContainer = viewContainer;
        this.template = template;
        this.authStore = authStore;
        this.translateService = translateService;
        this.logService = logService;
    }
    Object.defineProperty(AuthorizeDirective.prototype, "authorize", {
        set: function (authorizationModel) {
            this.logService.info('authorize - authorizationModel: ' + JSON.stringify(authorizationModel));
            if (this.authStore.hasPermission(this.getPermissions(authorizationModel))) {
                this.logService.verbose('show me');
                this.viewContainer.createEmbeddedView(this.template);
            }
            else {
                this.logService.verbose('hide me');
                this.viewContainer.clear();
            }
        },
        enumerable: true,
        configurable: true
    });
    AuthorizeDirective.prototype.getPermissions = function (authorizationModel) {
        if (authorizationModel.permission) {
            return Array.of(authorizationModel.permission.toLowerCase());
        }
        else if (authorizationModel.permissions) {
            return authorizationModel.permissions.map(function (perm) { return perm.toLowerCase(); });
        }
        else {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.INVALID_AUTHORIZE_FORMAT'));
        }
    };
    return AuthorizeDirective;
}());
authorization_directive___decorate([
    Object(core_es5["Input"])('pioneerAuthorize'),
    authorization_directive___metadata("design:type", typeof (authorization_directive__a = typeof AuthorizationModel !== "undefined" && AuthorizationModel) === "function" && authorization_directive__a || Object),
    authorization_directive___metadata("design:paramtypes", [typeof (authorization_directive__b = typeof AuthorizationModel !== "undefined" && AuthorizationModel) === "function" && authorization_directive__b || Object])
], AuthorizeDirective.prototype, "authorize", null);
AuthorizeDirective = authorization_directive___decorate([
    Object(core_es5["Directive"])({
        selector: '[pioneerAuthorize]'
    }),
    authorization_directive___metadata("design:paramtypes", [typeof (authorization_directive__c = typeof core_es5["ViewContainerRef"] !== "undefined" && core_es5["ViewContainerRef"]) === "function" && authorization_directive__c || Object, typeof (authorization_directive__d = typeof core_es5["TemplateRef"] !== "undefined" && core_es5["TemplateRef"]) === "function" && authorization_directive__d || Object, typeof (authorization_directive__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && authorization_directive__e || Object, typeof (_f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && _f || Object, typeof (_g = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && _g || Object])
], AuthorizeDirective);

var authorization_directive__a, authorization_directive__b, authorization_directive__c, authorization_directive__d, authorization_directive__e, _f, _g;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/authorization-directive.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/permission.module.ts
var permission_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var PermissionModule = (function () {
    function PermissionModule() {
    }
    return PermissionModule;
}());
PermissionModule = permission_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"]
        ],
        declarations: [
            AuthorizeDirective
        ],
        providers: [
            log_service_LogService,
            console_log_subscriber_service_ConsoleLogSubscriberService,
            http_log_subscriber_service_HttpLogSubscriberService,
            user_local_storage_service_UserLocalStorageService,
            authProvider
        ],
        exports: [
            AuthorizeDirective
        ]
    })
], PermissionModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/permission.module.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/reservation-status-code.enum.ts
/**
 * GroupPay status codes
 * https://onyxpayments.atlassian.net/wiki/display/PION/GroupPay+Status+Codes
 */
/**
 * GroupPay status codes
 * https://onyxpayments.atlassian.net/wiki/display/PION/GroupPay+Status+Codes
 */ var ReservationStatusCode;
(function (ReservationStatusCode) {
    ReservationStatusCode[ReservationStatusCode["RESERVED"] = 'R'] = "RESERVED";
    ReservationStatusCode[ReservationStatusCode["CHECKED_IN"] = 'I'] = "CHECKED_IN";
    ReservationStatusCode[ReservationStatusCode["CHECKED_OUT"] = 'O'] = "CHECKED_OUT";
    ReservationStatusCode[ReservationStatusCode["CANCELLED"] = 'C'] = "CANCELLED";
    ReservationStatusCode[ReservationStatusCode["NO_SHOW"] = 'N'] = "NO_SHOW";
    ReservationStatusCode[ReservationStatusCode["RSVP"] = 'RSVP'] = "RSVP";
})(ReservationStatusCode || (ReservationStatusCode = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-status-code.enum.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/pipes/reservation-status.pipe.ts
var reservation_status_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_status_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var reservation_status_pipe_ReservationStatusPipe = (function () {
    function ReservationStatusPipe(translateService) {
        this.translateService = translateService;
    }
    ReservationStatusPipe.prototype.transform = function (value, args) {
        value = value.toUpperCase().toString();
        var returnValue = '';
        switch (value) {
            case 'rsvp':
                returnValue = this.translateService.instant('RESERVATION_STATUS.READY');
                break;
            case ReservationStatusCode.CANCELLED.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.CANCELLED');
                break;
            case ReservationStatusCode.CHECKED_IN.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.CHECKED_IN');
                break;
            case ReservationStatusCode.CHECKED_OUT.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.CHECKED_OUT');
                break;
            case ReservationStatusCode.NO_SHOW.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.NO_SHOW');
                break;
            case ReservationStatusCode.RESERVED.toString():
                returnValue = this.translateService.instant('RESERVATION_STATUS.RESERVED');
                break;
            default:
                returnValue = this.translateService.instant('RESERVATION_STATUS.UNKNOWN', { key: value });
        }
        return returnValue;
    };
    return ReservationStatusPipe;
}());
reservation_status_pipe_ReservationStatusPipe = reservation_status_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'reservationStatus'
    }),
    reservation_status_pipe___metadata("design:paramtypes", [typeof (reservation_status_pipe__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_status_pipe__a || Object])
], reservation_status_pipe_ReservationStatusPipe);

var reservation_status_pipe__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-status.pipe.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/pipes/payment-status.pipe.ts
var payment_status_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_status_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PaymentStatusPipe = (function () {
    function PaymentStatusPipe(translateService, logService) {
        this.translateService = translateService;
        this.logService = logService;
    }
    PaymentStatusPipe.prototype.transform = function (value, args) {
        // Pipes need to handle nulls/undefined
        if (!value) {
            value = '';
        }
        value = value.toLowerCase().toString();
        var returnValue = '';
        switch (value) {
            case 'ready':
                returnValue = this.translateService.instant('PAYMENT_STATUS.READY');
                break;
            case 'pending':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PENDING');
                break;
            case 'invoiced':
                returnValue = this.translateService.instant('PAYMENT_STATUS.INVOICED');
                break;
            case 'invoice-rejected':
                returnValue = this.translateService.instant('PAYMENT_STATUS.INVOICE_REJECTED');
                break;
            case 'funded':
                returnValue = this.translateService.instant('PAYMENT_STATUS.FUNDED');
                break;
            case 'pay-sent':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_SENT');
                break;
            case 'pay-rejected':
                returnValue = this.translateService.instant('PAYMENT_STATUS.PAY_REJECTED');
                break;
            case 'error':
                returnValue = this.translateService.instant('PAYMENT_STATUS.ERROR');
                break;
            default:
                this.logService.info(this.translateService.instant('PAYMENT_STATUS.UNKNOWN', { key: value }));
        }
        return returnValue;
    };
    return PaymentStatusPipe;
}());
PaymentStatusPipe = payment_status_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'paymentStatus'
    }),
    payment_status_pipe___metadata("design:paramtypes", [typeof (payment_status_pipe__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_status_pipe__a || Object, typeof (payment_status_pipe__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_status_pipe__b || Object])
], PaymentStatusPipe);

var payment_status_pipe__a, payment_status_pipe__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment-status.pipe.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/environment/environment.module.ts
var environment_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EnvironmentModule = (function () {
    function EnvironmentModule() {
    }
    return EnvironmentModule;
}());
EnvironmentModule = environment_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"]
        ],
        declarations: [],
        exports: [],
        providers: [
            {
                provide: Environments,
                useValue: environments,
            },
            EnvironmentConfiguration
        ]
    })
], EnvironmentModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environment.module.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/util/util.js
var util_util = __webpack_require__("N+n4");
var util_default = /*#__PURE__*/__webpack_require__.n(util_util);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/pipes/absolute-value.pipe.ts
var absolute_value_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var absolute_value_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var absolute_value_pipe_AbsoluteValuePipe = (function () {
    function AbsoluteValuePipe() {
    }
    AbsoluteValuePipe.prototype.transform = function (value, args) {
        if (Object(util_util["isNumber"])(value)) {
            return Math.abs(value);
        }
        return value;
    };
    return AbsoluteValuePipe;
}());
absolute_value_pipe_AbsoluteValuePipe = absolute_value_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'absolute'
    }),
    absolute_value_pipe___metadata("design:paramtypes", [])
], absolute_value_pipe_AbsoluteValuePipe);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/absolute-value.pipe.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/adjustment-type.enum.ts
var AdjustmentType;
(function (AdjustmentType) {
    AdjustmentType[AdjustmentType["PREPAYMENT"] = 'PREPAYMENT'] = "PREPAYMENT";
    AdjustmentType[AdjustmentType["REBATE"] = 'REBATE'] = "REBATE";
})(AdjustmentType || (AdjustmentType = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/adjustment-type.enum.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/pipes/adjustment-type.pipe.ts
var adjustment_type_pipe___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_type_pipe___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var adjustment_type_pipe_AdjustmentTypePipe = (function () {
    function AdjustmentTypePipe(translateService) {
        this.translateService = translateService;
    }
    AdjustmentTypePipe.prototype.transform = function (value, args) {
        value = value.toUpperCase().toString();
        var returnValue = '';
        switch (value) {
            case AdjustmentType.PREPAYMENT.toString():
                returnValue = this.translateService.instant('ADJUSTMENT_REASON.PREPAYMENT');
                break;
            case AdjustmentType.REBATE.toString():
                returnValue = this.translateService.instant('ADJUSTMENT_REASON.REBATE');
                break;
            default:
                returnValue = this.translateService.instant('ADJUSTMENT_REASON.UNKNOWN', { key: value });
        }
        return returnValue;
    };
    return AdjustmentTypePipe;
}());
adjustment_type_pipe_AdjustmentTypePipe = adjustment_type_pipe___decorate([
    Object(core_es5["Pipe"])({
        name: 'adjustmentType'
    }),
    adjustment_type_pipe___metadata("design:paramtypes", [typeof (adjustment_type_pipe__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && adjustment_type_pipe__a || Object])
], adjustment_type_pipe_AdjustmentTypePipe);

var adjustment_type_pipe__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/adjustment-type.pipe.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/shared.module.ts
var shared_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var shared_module___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

























// Add RXJS operators so that they can be used throughout the app


























var SharedModule = (function () {
    function SharedModule(consoleLogSubscriber, httpLogSubscriber, environment) {
        if (environment.logServices.consoleLogSubscriber) {
            consoleLogSubscriber.init(environment.logServices.consoleLogSubscriber.logLevel);
        }
        if (environment.logServices.httpLogSubscriber) {
            httpLogSubscriber.init(environment.logServices.httpLogSubscriber.logLevel);
        }
    }
    return SharedModule;
}());
SharedModule = shared_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"],
            BootstrapModule,
            core["b" /* TranslateModule */],
            forms_es5["FormsModule"],
            PermissionModule,
            EnvironmentModule,
            router_es5["RouterModule"].forChild(routes),
            ng2_page_scroll["a" /* Ng2PageScrollModule */].forRoot()
        ],
        exports: [
            common_es5["CommonModule"],
            BootstrapModule,
            core["b" /* TranslateModule */],
            inline_search_component_InlineSearchComponent,
            flash_messages_component_FlashMessagesComponent,
            FormInputComponent,
            ValidationMessageComponent,
            ng2_page_scroll["a" /* Ng2PageScrollModule */],
            confirmation_modal_component_ConfirmationModalComponent,
            VersionComponent,
            PermissionModule,
            EnvironmentModule,
            PaymentStatusPipe,
            reservation_status_pipe_ReservationStatusPipe,
            absolute_value_pipe_AbsoluteValuePipe,
            adjustment_type_pipe_AdjustmentTypePipe
        ],
        declarations: [
            confirmation_modal_component_ConfirmationModalComponent,
            RouteNotFoundComponent,
            inline_search_component_InlineSearchComponent,
            flash_messages_component_FlashMessagesComponent,
            FormInputComponent,
            ValidationMessageComponent,
            VersionComponent,
            GenericErrorComponent,
            PaymentStatusPipe,
            reservation_status_pipe_ReservationStatusPipe,
            absolute_value_pipe_AbsoluteValuePipe,
            adjustment_type_pipe_AdjustmentTypePipe
        ],
        providers: [
            agency_lookup_http_service_AgencyLookupHttpService,
            agency_lookup_store_AgencyLookupStore,
            error_handler_service_ErrorHandlerService,
            log_service_LogService,
            console_log_subscriber_service_ConsoleLogSubscriberService,
            flash_messages_service_FlashMessagesService,
            http_log_subscriber_service_HttpLogSubscriberService,
            property_lookup_http_service_PropertyLookupHttpService,
            property_lookup_store_PropertyLookupStore,
            version_store_VersionStore,
            version_http_service_VersionHttpService,
            { provide: core_es5["ErrorHandler"], useClass: error_handler_LogErrorHandler }
        ]
    }),
    shared_module___metadata("design:paramtypes", [typeof (shared_module__a = typeof console_log_subscriber_service_ConsoleLogSubscriberService !== "undefined" && console_log_subscriber_service_ConsoleLogSubscriberService) === "function" && shared_module__a || Object, typeof (shared_module__b = typeof http_log_subscriber_service_HttpLogSubscriberService !== "undefined" && http_log_subscriber_service_HttpLogSubscriberService) === "function" && shared_module__b || Object, typeof (shared_module__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && shared_module__c || Object])
], SharedModule);

var shared_module__a, shared_module__b, shared_module__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/shared.module.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/user/user.routes.ts
var user_routes_routes = [];
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/user.routes.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/user/user.module.ts
var user_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var UserModule = (function () {
    function UserModule() {
    }
    return UserModule;
}());
UserModule = user_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            SharedModule,
            router_es5["RouterModule"].forChild(user_routes_routes)
        ],
        declarations: []
    })
], UserModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/user.module.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event.http.service.ts
var event_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var event_http_service_EventHttpService = (function () {
    function EventHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.eventsGetUrl = this.environment.baseUrl + '/api/events';
        this.eventSearchUrl = this.environment.baseUrl + '/api/events/search';
        this.eventsAddUrl = this.environment.baseUrl + '/api/events';
        this.eventsUpdateUrl = this.environment.baseUrl + '/api/events';
        this.eventsBulkUploadUrl = this.environment.baseUrl + '/api/events/bulkUpload';
    }
    Object.defineProperty(EventHttpService.prototype, "jsonOptions", {
        get: function () {
            var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
            var options = new http_es5["RequestOptions"]({ headers: headers });
            return options;
        },
        enumerable: true,
        configurable: true
    });
    EventHttpService.prototype.search = function (searchParameters) {
        return this.http.post(this.eventSearchUrl, JSON.stringify(searchParameters), this.jsonOptions)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    EventHttpService.prototype.get = function (eventId) {
        return this.http.get(this.eventsGetUrl + "/" + eventId)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    EventHttpService.prototype.add = function (newRec) {
        return this.http.post(this.eventsAddUrl, JSON.stringify(newRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    EventHttpService.prototype.update = function (updatedRec) {
        return this.http.put(this.eventsUpdateUrl, JSON.stringify(updatedRec.toJS()), this.jsonOptions)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    EventHttpService.prototype.delete = function (eventId) {
        return this.http.delete(this.eventsGetUrl + "/" + eventId)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    EventHttpService.prototype.importEventsViaCsv = function (file) {
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post("" + this.eventsBulkUploadUrl, formData)
            .map(function (response) { return response.json(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    EventHttpService.prototype.downloadInvalidEventsCsv = function (fileId) {
        this.http.get("" + this.eventsBulkUploadUrl + "/" + fileId);
        return Observable["Observable"].of(null);
    };
    return EventHttpService;
}());
event_http_service_EventHttpService = event_http_service___decorate([
    Object(core_es5["Injectable"])(),
    event_http_service___metadata("design:paramtypes", [typeof (event_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && event_http_service__a || Object, typeof (event_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_http_service__b || Object])
], event_http_service_EventHttpService);

var event_http_service__a, event_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/models/page.ts

var page_Page = (function () {
    function Page() {
    }
    Page.empty = function () {
        var pageObj = new Page();
        pageObj.content = Object(immutable["List"])();
        pageObj.number = 0;
        pageObj.size = 25;
        pageObj.totalElements = 0;
        pageObj.totalPages = 0;
        pageObj.sort = Object(immutable["List"])();
        return pageObj;
    };
    return Page;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/page.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-search-params.ts
var event_search_params___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventSearchParametersRecord = Object(immutable["Record"])({
    maxEvents: 0,
    searchText: Object(immutable["Set"])([]),
    filters: Object(immutable["Set"])([])
});
var EventSearchParameters = (function (_super) {
    event_search_params___extends(EventSearchParameters, _super);
    function EventSearchParameters() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSearchParameters;
}(EventSearchParametersRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-search-params.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-filter.ts
var event_filter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventSearchFilterRecord = Object(immutable["Record"])({
    filterField: null,
    filterValue: null
});
var EventSearchFilter = (function (_super) {
    event_filter___extends(EventSearchFilter, _super);
    function EventSearchFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSearchFilter;
}(EventSearchFilterRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-filter.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-filter-type-enum.ts
/**
 * Even search filter types
 */
/**
 * Even search filter types
 */ var EventFilterType;
(function (EventFilterType) {
    EventFilterType[EventFilterType["COMMISSION_ID"] = 'commissionId'] = "COMMISSION_ID";
    EventFilterType[EventFilterType["FUNDING_REFERENCE_ID"] = 'fundingReferenceId'] = "FUNDING_REFERENCE_ID";
    EventFilterType[EventFilterType["PAYMENT_REFERENCE_ID"] = 'paymentReferenceId'] = "PAYMENT_REFERENCE_ID";
    EventFilterType[EventFilterType["DATE_RANGE"] = 'dateRange'] = "DATE_RANGE";
    EventFilterType[EventFilterType["DATE_AFTER"] = 'dateAfter'] = "DATE_AFTER";
    EventFilterType[EventFilterType["DATE_BEFORE"] = 'dateBefore'] = "DATE_BEFORE";
    EventFilterType[EventFilterType["GUEST_NAME"] = 'guestName'] = "GUEST_NAME";
    EventFilterType[EventFilterType["COMPLETED"] = 'eventStatusCompleted'] = "COMPLETED";
    EventFilterType[EventFilterType["MISSING_AGENCY"] = 'eventStatusMissingAgency'] = "MISSING_AGENCY";
    EventFilterType[EventFilterType["PAYMENT_STATUS"] = 'paymentStatus'] = "PAYMENT_STATUS";
})(EventFilterType || (EventFilterType = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-filter-type-enum.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/date-fns/format/index.js
var date_fns_format = __webpack_require__("r5wF");
var format_default = /*#__PURE__*/__webpack_require__.n(date_fns_format);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/date-fns/is_valid/index.js
var is_valid = __webpack_require__("lzRm");
var is_valid_default = /*#__PURE__*/__webpack_require__.n(is_valid);

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/date-fns/parse/index.js
var parse = __webpack_require__("hAEu");
var parse_default = /*#__PURE__*/__webpack_require__.n(parse);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/date.util.ts



var date_util_DateUtil = (function () {
    function DateUtil() {
    }
    DateUtil.formatDate = function (date, formatStr) {
        if (formatStr === void 0) { formatStr = 'YYYY-MM-DD'; }
        if (date !== null && is_valid(new Date(date))) {
            return date_fns_format(date, formatStr);
        }
        else {
            return '';
        }
    };
    DateUtil.parseDate = function (date) {
        return parse(date);
    };
    DateUtil.isValidDate = function (date) {
        return date instanceof Date && !isNaN(date.valueOf());
    };
    return DateUtil;
}());

date_util_DateUtil.MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/date.util.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/ui-search-status-mapping-enum.ts
// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
// https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
var UISearchStatusMappingEnum;
(function (UISearchStatusMappingEnum) {
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAYMENT_IN_PROCESS"] = 'paymentInProcess'] = "PAYMENT_IN_PROCESS";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["UNPAID"] = 'unpaid'] = "UNPAID";
    UISearchStatusMappingEnum[UISearchStatusMappingEnum["PAID"] = 'paid'] = "PAID";
})(UISearchStatusMappingEnum || (UISearchStatusMappingEnum = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/ui-search-status-mapping-enum.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event-filter-util-service.ts
var event_filter_util_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_filter_util_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var event_filter_util_service_EventFilterUtilsService = EventFilterUtilsService_1 = (function () {
    function EventFilterUtilsService(translateService) {
        this.translateService = translateService;
    }
    /**
     * Parses 2 dates represented as strings and returns the value to store in the EventFilterType.DATE_RANGE filter
     * @param date1
     * @param date2
     * @returns {string}
     */
    EventFilterUtilsService.getDateRangeFilterValue = function (date1, date2) {
        return date_util_DateUtil.formatDate(date1) + this.dateRangeValueSeparator + date_util_DateUtil.formatDate(date2);
    };
    EventFilterUtilsService.parseFilterValueAsDateRange = function (dateRangeString) {
        return dateRangeString.split(this.dateRangeValueSeparator);
    };
    /**
     * This method returns a key to identify what kind of token to make.
     * This is useful to ensure that two filters with the same key can't be present at the same time.
     * @param filter
     * @returns string
     */
    EventFilterUtilsService.prototype.getUniqueTokenKey = function (filter) {
        // only 1 date filter is allowed at a time
        if (filter.filterField === EventFilterType.DATE_RANGE.toString() ||
            filter.filterField === EventFilterType.DATE_BEFORE.toString() ||
            filter.filterField === EventFilterType.DATE_AFTER.toString()) {
            return EventFilterType.DATE_RANGE.toString();
        }
        else if (filter.filterField === EventFilterType.GUEST_NAME.toString() ||
            filter.filterField === EventFilterType.PAYMENT_STATUS.toString()) {
            // these filters allow for for multiple tokens
            return filter.filterField + ':' + filter.filterValue;
        }
        // by default, there can only be 1 instance of a filter token at a time
        return filter.filterField;
    };
    /**
     * Returns a string representation of a given Date that will be displayed in a search filter token
     * @param date
     * @returns {string}
     */
    EventFilterUtilsService.prototype.getDateStringForToken = function (date) {
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    };
    /**
     * This method will return the string used to display the value of the filter in a token
     * @param filter
     * @returns {string}
     */
    EventFilterUtilsService.prototype.getTokenDisplayString = function (filter) {
        if (filter.filterField === EventFilterType.COMPLETED.toString()) {
            return this.translateService.instant('EVENTS.EVENT_STATUS_COMPLETED');
        }
        else if (filter.filterField === EventFilterType.MISSING_AGENCY.toString()) {
            return this.translateService.instant('EVENTS.EVENT_STATUS_MISSING_AGENCY');
        }
        else if (filter.filterField === EventFilterType.DATE_RANGE.toString()) {
            var strings = filter.filterValue.split(EventFilterUtilsService_1.dateRangeValueSeparator);
            if (strings.length === 2) {
                return this.getDateStringForToken(date_util_DateUtil.parseDate(strings[0])) + ' - ' +
                    this.getDateStringForToken(date_util_DateUtil.parseDate(strings[1]));
            }
            else {
                return 'error';
            }
        }
        else if (filter.filterField === EventFilterType.DATE_BEFORE.toString() ||
            filter.filterField === EventFilterType.DATE_AFTER.toString()) {
            return this.getDateStringForToken(date_util_DateUtil.parseDate(filter.filterValue));
        }
        else if (filter.filterField === EventFilterType.PAYMENT_STATUS.toString()) {
            return this.labelForPaymentStatusValue(filter.filterValue);
        }
        else {
            return filter.filterValue;
        }
    };
    EventFilterUtilsService.prototype.labelForPaymentStatusValue = function (filterValue) {
        var label = filterValue;
        if (filterValue === UISearchStatusMappingEnum.PAID.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAID';
        }
        else if (filterValue === UISearchStatusMappingEnum.UNPAID.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.UNPAID';
        }
        else if (filterValue === UISearchStatusMappingEnum.PAYMENT_IN_PROCESS.toString()) {
            label = 'EVENTS.PAYMENT_STATUS_FILTER_VALUE.PAYMENT_IN_PROCESS';
        }
        return this.translateService.instant(label);
    };
    return EventFilterUtilsService;
}());
event_filter_util_service_EventFilterUtilsService.dateRangeValueSeparator = ';';
event_filter_util_service_EventFilterUtilsService = EventFilterUtilsService_1 = event_filter_util_service___decorate([
    Object(core_es5["Injectable"])(),
    event_filter_util_service___metadata("design:paramtypes", [typeof (event_filter_util_service__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_filter_util_service__a || Object])
], event_filter_util_service_EventFilterUtilsService);

var EventFilterUtilsService_1, event_filter_util_service__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-filter-util-service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-menu-search-filter.ts
var event_menu_search_filter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventMenuSearchFilterPaymentStatusRecord = Object(immutable["Record"])({
    inProcess: true,
    unpaid: true,
    paid: true
});
var EventMenuSearchFilterPaymentStatus = (function (_super) {
    event_menu_search_filter___extends(EventMenuSearchFilterPaymentStatus, _super);
    function EventMenuSearchFilterPaymentStatus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventMenuSearchFilterPaymentStatus;
}(EventMenuSearchFilterPaymentStatusRecord));

var EventMenuSearchFilterRecord = Object(immutable["Record"])({
    commissionId: null,
    fundingReferenceId: null,
    paymentReferenceId: null,
    startDate: null,
    endDate: null,
    guestName: null,
    eventStatusCompleted: false,
    eventStatusMissingAgency: false,
    paymentStatus: {
        inProcess: true,
        unpaid: true,
        paid: true
    }
});
var EventMenuSearchFilter = (function (_super) {
    event_menu_search_filter___extends(EventMenuSearchFilter, _super);
    function EventMenuSearchFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventMenuSearchFilter;
}(EventMenuSearchFilterRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-menu-search-filter.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/event-search-filter/event-menu-search-filter-mapper.ts
var event_menu_search_filter_mapper___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};







var event_menu_search_filter_mapper_EventMenuSearchFilterMapper = (function () {
    function EventMenuSearchFilterMapper() {
    }
    EventMenuSearchFilterMapper.prototype.toSearchFilterSet = function (filterRecord) {
        var filterSet = Object(immutable["OrderedSet"])([]);
        if (filterRecord.commissionId && filterRecord.commissionId !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.COMMISSION_ID, filterRecord.commissionId));
        }
        if (filterRecord.fundingReferenceId && filterRecord.fundingReferenceId !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.FUNDING_REFERENCE_ID, filterRecord.fundingReferenceId));
        }
        if (filterRecord.paymentReferenceId && filterRecord.paymentReferenceId !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_REFERENCE_ID, filterRecord.paymentReferenceId));
        }
        if ((filterRecord.endDate && filterRecord.endDate !== '') && (filterRecord.startDate && filterRecord.startDate !== '')) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_RANGE, event_filter_util_service_EventFilterUtilsService.getDateRangeFilterValue(filterRecord.startDate, filterRecord.endDate)));
        }
        else if (filterRecord.startDate && filterRecord.startDate !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_AFTER, date_util_DateUtil.formatDate(filterRecord.startDate)));
        }
        else if (filterRecord.endDate && filterRecord.endDate !== '') {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.DATE_BEFORE, date_util_DateUtil.formatDate(filterRecord.endDate)));
        }
        if (filterRecord.eventStatusCompleted) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.COMPLETED, JSON.stringify(filterRecord.eventStatusCompleted)));
        }
        if (filterRecord.eventStatusMissingAgency) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.MISSING_AGENCY, JSON.stringify(filterRecord.eventStatusMissingAgency)));
        }
        if (filterRecord.guestName) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.GUEST_NAME, filterRecord.guestName));
        }
        filterSet = this.buildPaymentFilters(filterRecord, filterSet);
        return filterSet;
    };
    EventMenuSearchFilterMapper.prototype.asSearchFilter = function (filterField, filterValue) {
        var filter = new EventSearchFilter({
            filterField: filterField.toString(),
            filterValue: filterValue ? filterValue.trim() : filterValue
        });
        return filter;
    };
    EventMenuSearchFilterMapper.prototype.buildPaymentFilters = function (filterRecord, filterSet) {
        var paymentStatusRecord = filterRecord.paymentStatus;
        var allPaymentFiltersSelected = paymentStatusRecord.unpaid &&
            paymentStatusRecord.paid &&
            paymentStatusRecord.inProcess;
        // no need to filter if all 3 are selected
        if (allPaymentFiltersSelected) {
            return filterSet;
        }
        // reapply selected filters
        if (paymentStatusRecord.inProcess) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, 'paymentInProcess'));
        }
        if (paymentStatusRecord.paid) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, 'paid'));
        }
        if (paymentStatusRecord.unpaid) {
            filterSet = filterSet.add(this.asSearchFilter(EventFilterType.PAYMENT_STATUS, 'unpaid'));
        }
        return filterSet;
    };
    EventMenuSearchFilterMapper.prototype.toEventMenuSearchFilter = function (filterSet) {
        var filterRecord = {};
        filterRecord.eventStatusMissingAgency = this.hasSearchFilter(filterSet, EventFilterType.MISSING_AGENCY);
        filterRecord.eventStatusCompleted = this.hasSearchFilter(filterSet, EventFilterType.COMPLETED);
        filterRecord.guestName = this.getSearchFilterValue(filterSet, EventFilterType.GUEST_NAME);
        filterRecord.commissionId = this.getSearchFilterValue(filterSet, EventFilterType.COMMISSION_ID);
        filterRecord.paymentReferenceId = this.getSearchFilterValue(filterSet, EventFilterType.PAYMENT_REFERENCE_ID);
        filterRecord.fundingReferenceId = this.getSearchFilterValue(filterSet, EventFilterType.FUNDING_REFERENCE_ID);
        filterRecord.startDate = this.getSearchFilterValue(filterSet, EventFilterType.DATE_AFTER);
        filterRecord.endDate = this.getSearchFilterValue(filterSet, EventFilterType.DATE_BEFORE);
        if (this.hasSearchFilter(filterSet, EventFilterType.DATE_RANGE)) {
            var dates = event_filter_util_service_EventFilterUtilsService.parseFilterValueAsDateRange(this.getSearchFilterValue(filterSet, EventFilterType.DATE_RANGE));
            filterRecord.startDate = dates[0];
            filterRecord.endDate = dates[1];
        }
        var paymentStatusRecord = {};
        paymentStatusRecord.unpaid =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_STATUS, 'unpaid');
        paymentStatusRecord.inProcess =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_STATUS, 'paymentInProcess');
        paymentStatusRecord.paid =
            this.hasSearchFilterByFieldAndValue(filterSet, EventFilterType.PAYMENT_STATUS, 'paid');
        var allPaymentStatusFiltersAreFalse = !paymentStatusRecord.unpaid &&
            !paymentStatusRecord.inProcess &&
            !paymentStatusRecord.paid;
        if (allPaymentStatusFiltersAreFalse) {
            // then they they all need to be enabled
            paymentStatusRecord.unpaid = true;
            paymentStatusRecord.inProcess = true;
            paymentStatusRecord.paid = true;
        }
        filterRecord.paymentStatus = paymentStatusRecord;
        var updatedRecord = new EventMenuSearchFilter(filterRecord);
        return updatedRecord;
    };
    EventMenuSearchFilterMapper.prototype.hasSearchFilter = function (filterSet, filterField) {
        var isEmpty = filterSet.filter(function (filter) {
            return filterField.toString() === filter.filterField;
        }).isEmpty();
        return !isEmpty;
    };
    EventMenuSearchFilterMapper.prototype.getSearchFilterValue = function (filterSet, filterField) {
        return filterSet.filter(function (filter) {
            return filterField.toString() === filter.filterField;
        }).map(function (filter) { return filter.filterValue; }).first();
    };
    EventMenuSearchFilterMapper.prototype.hasSearchFilterByFieldAndValue = function (filterSet, filterField, filterValue) {
        var isEmpty = filterSet.filter(function (filter) {
            return filterField.toString() === filter.filterField && filterValue === filter.filterValue;
        }).isEmpty();
        return !isEmpty;
    };
    return EventMenuSearchFilterMapper;
}());
event_menu_search_filter_mapper_EventMenuSearchFilterMapper = event_menu_search_filter_mapper___decorate([
    Object(core_es5["Injectable"])()
], event_menu_search_filter_mapper_EventMenuSearchFilterMapper);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-menu-search-filter-mapper.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event-search-parameters.store.ts
var event_search_parameters_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_search_parameters_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var event_search_parameters_store_EventSearchParametersStore = (function () {
    function EventSearchParametersStore(environment, router, eventFilterUtils, eventMenuMapper, logger) {
        this.environment = environment;
        this.router = router;
        this.eventFilterUtils = eventFilterUtils;
        this.eventMenuMapper = eventMenuMapper;
        this.logger = logger;
        this.searchTextSetSubject = new BehaviorSubject["BehaviorSubject"](Object(immutable["OrderedSet"])([]));
        this.searchFilterMapSubject = new BehaviorSubject["BehaviorSubject"](Object(immutable["OrderedMap"])());
        this.defaultViewSubject = new BehaviorSubject["BehaviorSubject"](true);
    }
    Object.defineProperty(EventSearchParametersStore.prototype, "searchTextSet", {
        get: function () {
            return this.searchTextSetSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchFilterSet", {
        get: function () {
            return this.searchFilterMapSubject.asObservable().map(function (map) { return map.toOrderedSet(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchFilterRecord", {
        get: function () {
            var _this = this;
            return this.searchFilterMapSubject.asObservable().map(function (map) { return _this.eventMenuMapper.toEventMenuSearchFilter(map.toOrderedSet()); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchTextSetSnapshot", {
        get: function () {
            return this.searchTextSetSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "searchFilterSetSnapshot", {
        get: function () {
            return this.searchFilterMapSubject.getValue().toOrderedSet();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "eventSearchParametersSnapshot", {
        get: function () {
            return new EventSearchParameters({
                searchText: this.searchTextSetSnapshot,
                filters: this.searchFilterSetSnapshot,
                maxEvents: this.environment.events.maxEvents
            });
        },
        enumerable: true,
        configurable: true
    });
    EventSearchParametersStore.prototype.reset = function (updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchTextSetSubject(Object(immutable["OrderedSet"])([]));
        this.setSearchFilterMapSubject(Object(immutable["OrderedMap"])());
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.resetFilters = function (updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchFilterMapSubject(Object(immutable["OrderedMap"])());
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.setSearchTextSet = function (searchTextSet, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchTextSetSubject(searchTextSet);
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.setFilterSet = function (filterSet, updateUrl) {
        var _this = this;
        if (updateUrl === void 0) { updateUrl = false; }
        var map = Object(immutable["OrderedMap"])();
        filterSet.forEach(function (filter) {
            map = map.set(_this.eventFilterUtils.getUniqueTokenKey(filter), filter);
        });
        this.setSearchFilterMapSubject(map);
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.addSearchText = function (searchText, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchTextSetSubject(this.searchTextSetSubject.getValue().add(searchText ? searchText.trim() : searchText));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.addSearchFilter = function (filterField, filterValue, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        var filter = new EventSearchFilter({
            filterField: filterField,
            filterValue: filterValue ? filterValue.trim() : filterValue
        });
        this.setSearchFilterMapSubject(this.searchFilterMapSubject.getValue().set(this.eventFilterUtils.getUniqueTokenKey(filter), filter));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.removeSearchText = function (searchText, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchTextSetSubject(this.searchTextSetSubject.getValue().delete(searchText));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.removeSearchFilterByFieldAndValue = function (filterField, filterValue, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        var filter = new EventSearchFilter({
            filterField: filterField,
            filterValue: filterValue ? filterValue.trim() : filterValue
        });
        this.removeSearchFilter(filter, updateUrl);
    };
    EventSearchParametersStore.prototype.removeSearchFilter = function (filter, updateUrl) {
        if (updateUrl === void 0) { updateUrl = false; }
        this.setSearchFilterMapSubject(this.searchFilterMapSubject.getValue().delete(this.eventFilterUtils.getUniqueTokenKey(filter)));
        if (updateUrl) {
            this.updateUrl();
        }
    };
    EventSearchParametersStore.prototype.hasSearchFilter = function (filterField) {
        var filters = this.searchFilterSetSnapshot;
        var found = false;
        filters.map(function (filter) {
            if (filterField === filter.filterField) {
                found = true;
            }
        });
        return found;
    };
    EventSearchParametersStore.prototype.hasSearchFilterByFieldAndValue = function (filterField, filterValue) {
        var found = false;
        this.searchFilterSetSnapshot.map(function (filter) {
            if (filterField === filter.filterField && filterValue === filter.filterValue) {
                found = true;
            }
        });
        return found;
    };
    EventSearchParametersStore.prototype.getQueryParams = function () {
        var queryParams = new Object();
        if (this.searchTextSetSnapshot
            && this.searchTextSetSnapshot.toArray()
            && this.searchTextSetSnapshot.toArray().length > 0) {
            queryParams['search'] = this.searchTextSetSnapshot.toArray();
        }
        if (this.searchFilterSetSnapshot
            && this.searchFilterSetSnapshot.toArray()
            && this.searchFilterSetSnapshot.toArray().length > 0) {
            queryParams['filters'] = JSON.stringify(this.searchFilterSetSnapshot.toArray());
        }
        return queryParams;
    };
    EventSearchParametersStore.prototype.updateUrl = function () {
        if (this.isDefaultViewSelectedSnapshot) {
            this.defaultViewUrl();
        }
        else {
            this.financialViewUrl();
        }
    };
    EventSearchParametersStore.prototype.defaultViewUrl = function () {
        this.logger.info('EventSearchParametersStore: Navigating to default');
        this.router.navigate(['/events'], {
            queryParams: this.getQueryParams()
        });
    };
    EventSearchParametersStore.prototype.financialViewUrl = function () {
        this.logger.info('EventSearchParametersStore: Navigating to financial');
        this.router.navigate(['/events/financial'], {
            queryParams: this.getQueryParams()
        });
    };
    Object.defineProperty(EventSearchParametersStore.prototype, "isDefaultViewSelected", {
        get: function () {
            return this.defaultViewSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchParametersStore.prototype, "isDefaultViewSelectedSnapshot", {
        get: function () {
            return this.defaultViewSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchParametersStore.prototype.setDefaultViewSelected = function (showDefaultView) {
        if (showDefaultView === null) {
            throw new Error('showDefaultView must be true or false');
        }
        this.logger.debug("EventSearchParametersStore.setDefaultViewSelected: " + JSON.stringify(showDefaultView));
        this.defaultViewSubject.next(showDefaultView);
    };
    EventSearchParametersStore.prototype.setSearchTextSetSubject = function (value) {
        if (value === null) {
            throw new Error('searchText must exist');
        }
        this.logger.debug("EventSearchParametersStore.setSearchTextSetSubject: " + JSON.stringify(value));
        this.searchTextSetSubject.next(value);
    };
    EventSearchParametersStore.prototype.setSearchFilterMapSubject = function (value) {
        if (value === null) {
            throw new Error('searchFilter must exist');
        }
        this.logger.debug("EventSearchParametersStore.setSearchFilterMapSubject: " + JSON.stringify(value));
        this.searchFilterMapSubject.next(value);
    };
    EventSearchParametersStore.prototype.removePaymentStatusFilters = function () {
        var setWithoutPaymentStatus = this.searchFilterSetSnapshot.filter(function (eventSearchFilter) {
            return eventSearchFilter.filterField !== EventFilterType.PAYMENT_STATUS.toString();
        }).toOrderedSet();
        this.setFilterSet(setWithoutPaymentStatus);
    };
    return EventSearchParametersStore;
}());
event_search_parameters_store_EventSearchParametersStore = event_search_parameters_store___decorate([
    Object(core_es5["Injectable"])(),
    event_search_parameters_store___metadata("design:paramtypes", [typeof (event_search_parameters_store__a = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_search_parameters_store__a || Object, typeof (event_search_parameters_store__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_search_parameters_store__b || Object, typeof (event_search_parameters_store__c = typeof event_filter_util_service_EventFilterUtilsService !== "undefined" && event_filter_util_service_EventFilterUtilsService) === "function" && event_search_parameters_store__c || Object, typeof (event_search_parameters_store__d = typeof event_menu_search_filter_mapper_EventMenuSearchFilterMapper !== "undefined" && event_menu_search_filter_mapper_EventMenuSearchFilterMapper) === "function" && event_search_parameters_store__d || Object, typeof (event_search_parameters_store__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_search_parameters_store__e || Object])
], event_search_parameters_store_EventSearchParametersStore);

var event_search_parameters_store__a, event_search_parameters_store__b, event_search_parameters_store__c, event_search_parameters_store__d, event_search_parameters_store__e;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-search-parameters.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event-list.store.ts
var event_list_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var event_list_store_EventListStore = (function () {
    function EventListStore(eventHttpService, errorHandlerService, searchParametersStore) {
        this.eventHttpService = eventHttpService;
        this.errorHandlerService = errorHandlerService;
        this.searchParametersStore = searchParametersStore;
        this.eventPage = new BehaviorSubject["BehaviorSubject"](page_Page.empty());
    }
    Object.defineProperty(EventListStore.prototype, "events", {
        get: function () {
            return this.eventPage.asObservable().map(function (page) { return page.content; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListStore.prototype, "totalEventCount", {
        get: function () {
            return this.eventPage.asObservable().map(function (page) { return page.totalElements; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListStore.prototype, "sortOptionsApplied", {
        get: function () {
            return this.eventPage.asObservable().map(function (page) { return page.sort; });
        },
        enumerable: true,
        configurable: true
    });
    EventListStore.prototype.loadEvents = function () {
        var _this = this;
        var obs = this.eventHttpService.search(this.searchParametersStore.eventSearchParametersSnapshot)
            .catch(this.errorHandlerService.handleObservable('Error retrieving events', 'Could not retrieve events!'))
            .map(function (page) {
            _this.eventPage.next(page);
            return page;
        });
        return obs;
    };
    return EventListStore;
}());
event_list_store_EventListStore = event_list_store___decorate([
    Object(core_es5["Injectable"])(),
    event_list_store___metadata("design:paramtypes", [typeof (event_list_store__a = typeof event_http_service_EventHttpService !== "undefined" && event_http_service_EventHttpService) === "function" && event_list_store__a || Object, typeof (event_list_store__b = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && event_list_store__b || Object, typeof (event_list_store__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_list_store__c || Object])
], event_list_store_EventListStore);

var event_list_store__a, event_list_store__b, event_list_store__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-list.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/service/menu.store.ts
var menu_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var menu_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var menu_store_MenuStore = (function () {
    function MenuStore(translateService) {
        this.translateService = translateService;
        this.currentPageTitle = new BehaviorSubject["BehaviorSubject"](null);
        this.isPageReadOnly = new BehaviorSubject["BehaviorSubject"](true);
        this.isNavCollapsed = false;
    }
    Object.defineProperty(MenuStore.prototype, "pageTitle", {
        get: function () {
            return this.currentPageTitle.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MenuStore.prototype, "isReadOnly", {
        get: function () {
            return this.isPageReadOnly.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MenuStore.prototype.setPageTitle = function (title) {
        var _this = this;
        this.translateService.get(title).subscribe(function (text) { return _this.currentPageTitle.next(text); });
    };
    MenuStore.prototype.setIsReadOnly = function (readOnly) {
        this.isPageReadOnly.next(readOnly);
    };
    MenuStore.prototype.toggleIsNavCollapsed = function () {
        this.isNavCollapsed = !this.isNavCollapsed;
        return this.isNavCollapsed;
    };
    return MenuStore;
}());
menu_store_MenuStore = menu_store___decorate([
    Object(core_es5["Injectable"])(),
    menu_store___metadata("design:paramtypes", [typeof (menu_store__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && menu_store__a || Object])
], menu_store_MenuStore);

var menu_store__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/menu.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/event-search-filter/event-search-filter.validator.ts


var event_search_filter_validator_EventSearchFilterValidator = (function () {
    function EventSearchFilterValidator() {
    }
    EventSearchFilterValidator.validate = function (formGroup) {
        var payStatus = EventSearchFilterValidator.validatePaymentStatus(formGroup);
        var dateCompare = EventSearchFilterValidator.dateCompare(formGroup);
        if (payStatus && dateCompare) {
            return Object.assign({}, payStatus, dateCompare);
        }
        else if (payStatus) {
            return payStatus;
        }
        else if (dateCompare) {
            return dateCompare;
        }
        else {
            return null;
        }
    };
    EventSearchFilterValidator.validatePaymentStatus = function (formGroup) {
        var paymentStatusGroup = formGroup.get('paymentStatus');
        var unpaid = paymentStatusGroup.get('unpaid').value;
        var paid = paymentStatusGroup.get('paid').value;
        var inProcess = paymentStatusGroup.get('inProcess').value;
        var paymentArray = immutable["List"].of({ name: 'unpaid', value: unpaid }, { name: 'paid', value: paid }, { name: 'inProcess', value: inProcess });
        var isSelected = paymentArray.filter(function (obj) { return obj.value === true; }).toList();
        if (isSelected.isEmpty()) {
            paymentStatusGroup.get('paid').markAsTouched();
            var obj = {};
            obj[EventSearchFilterValidator.PAYMENT_STATUS_ERROR] = true;
            return obj;
        }
        return null;
    };
    EventSearchFilterValidator.dateCompare = function (formGroup) {
        var startDate = formGroup.get('startDate').value;
        var endDate = formGroup.get('endDate').value;
        if (!startDate || !endDate) {
            return null;
        }
        else {
            // Convert to string if object
            if (!Object(util_util["isString"])(startDate)) {
                startDate = startDate.toUTCString();
            }
            if (!Object(util_util["isString"])(endDate)) {
                endDate = endDate.toUTCString();
            }
        }
        var isInvalid = new Date(startDate) >= new Date(endDate);
        if (isInvalid) {
            formGroup.get('endDate').markAsTouched();
            var obj = {};
            obj[EventSearchFilterValidator.DATE_ERROR] = true;
            return obj;
        }
        return null;
    };
    return EventSearchFilterValidator;
}());

event_search_filter_validator_EventSearchFilterValidator.PAYMENT_STATUS_ERROR = 'validatePaymentStatus';
event_search_filter_validator_EventSearchFilterValidator.DATE_ERROR = 'greater';
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-search-filter.validator.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/pioneer.validators.ts
var pioneer_validators___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var pioneer_validators___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var pioneer_validators_PioneerValidators = PioneerValidators_1 = (function () {
    function PioneerValidators(logService) {
        this.logService = logService;
        PioneerValidators_1.LOG_SERVICE = logService;
    }
    PioneerValidators.isInteger = function (formControl) {
        if (!formControl.value) {
            return null;
        }
        if (!Number.isInteger(formControl.value)) {
            return { 'not_integer': true };
        }
        return null;
    };
    PioneerValidators.isValidCurrency = function (formControl) {
        // get the failure message from Validators.required instead
        if (forms_es5["Validators"].required(formControl)) {
            return null;
        }
        // regular expression to match 1 to 8 digits, optionally followed by a decimal and up to 2 more digits
        var format = /^\d{1,8}(\.\d\d?)?$/;
        if (formControl.value <= 0 || !format.test(formControl.value)) {
            return { 'invalid_currency': true };
        }
        return null;
    };
    PioneerValidators.isDate = function (formControl) {
        if (!formControl.value) {
            return null;
        }
        var isValid = false;
        try {
            var dateWrapper = date_util_DateUtil.parseDate(formControl.value);
            isValid = !isNaN(dateWrapper.getDate());
        }
        catch (error) {
            PioneerValidators_1.LOG_SERVICE.error(error);
            isValid = false;
        }
        if (!isValid) {
            return { 'date': true };
        }
        return null;
    };
    return PioneerValidators;
}());
pioneer_validators_PioneerValidators = PioneerValidators_1 = pioneer_validators___decorate([
    Object(core_es5["Injectable"])(),
    pioneer_validators___metadata("design:paramtypes", [typeof (pioneer_validators__a = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && pioneer_validators__a || Object])
], pioneer_validators_PioneerValidators);

var PioneerValidators_1, pioneer_validators__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/pioneer.validators.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-search-text.ts
var event_search_text___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var EventSearchTextRecord = Object(immutable["Record"])({
    searchText: ''
});
var EventSearchText = (function (_super) {
    event_search_text___extends(EventSearchText, _super);
    function EventSearchText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EventSearchText;
}(EventSearchTextRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-search-text.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event-search-forms.store.ts
var event_search_forms_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_search_forms_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var event_search_forms_store_EventSearchFormsStore = (function () {
    function EventSearchFormsStore(formBuilder, logger, eventSearchParametersStore, eventMenuMapper) {
        this.formBuilder = formBuilder;
        this.logger = logger;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventMenuMapper = eventMenuMapper;
        this.filterMenuErrorSubject = new BehaviorSubject["BehaviorSubject"](null);
        this.filterEventMenuSearchFilterSubject = new BehaviorSubject["BehaviorSubject"](null);
        this.filterSearchTextSubject = new BehaviorSubject["BehaviorSubject"](null);
        this.init();
    }
    /**
     * Both the searchFilterRecord and valueChanges subscriptions take the populated form and set the
     *   EventMenuSearchFilter business subject.
     *
     * This allows the store to correctly initialize the EventMenuSearchFilter subject from
     *   the EventSearchParametersStore OR the eventFilterForm FormGroup.
     */
    EventSearchFormsStore.prototype.init = function () {
        var _this = this;
        this.logger.debug('EventSearchFormsStore.init');
        this.filterRecord = new EventMenuSearchFilter();
        this.searchText = new EventSearchText();
        this.populateSearchTextForm('');
        this.populateSearchFilterForm(this.filterRecord);
        this.eventSearchTextForm.valueChanges.debounceTime(250).subscribe(function (value) {
            _this.logger.info("EventSearchFormsStore: ngOnInit: eventSearchTextForm.valueChanges: " + JSON.stringify(value));
            _this.setFilterSearchText(new EventSearchText(value));
        });
        this.eventSearchParametersStore.searchFilterRecord.subscribe(function (searchFilterRecord) {
            // tslint:disable-next-line:max-line-length
            _this.logger.info("EventSearchFormsStore: ngOnInit: eventSearchParametersStore.searchFilterRecord: " + JSON.stringify(searchFilterRecord));
            _this.populateSearchFilterForm(searchFilterRecord);
            var formValue = _this.eventFilterForm.value;
            _this.formValueToEventMenuSearchFilter(formValue);
        });
        this.eventFilterForm.valueChanges.subscribe(function (formValue) {
            _this.logger.info("EventSearchFormsStore: ngOnInit: eventFilterForm.valueChanges: " + JSON.stringify(formValue));
            _this.formValueToEventMenuSearchFilter(formValue);
        });
        this.eventFilterForm.statusChanges.subscribe(function (value) {
            _this.setFilterMenuErrors(_this.eventFilterForm.errors);
            _this.logger.info("EventSearchFormsStore: statusChanges: " + JSON.stringify(_this.eventFilterForm.errors) + " ");
        });
    };
    EventSearchFormsStore.prototype.formValueToEventMenuSearchFilter = function (formValue) {
        var eventMenuSearchFilter = this.createFilterRecord(formValue);
        this.setFilterEventMenuSearchFilter(eventMenuSearchFilter);
        this.updatePaymentStatusGroup();
    };
    EventSearchFormsStore.prototype.populateSearchFilterForm = function (filterRecord) {
        this.logger.debug('EventSearchFormsStore.populateSearchFilterForm');
        if (!this.eventFilterForm) {
            this.eventFilterForm = this.formBuilder.group({
                'commissionId': [filterRecord.commissionId],
                'fundingReferenceId': [filterRecord.fundingReferenceId],
                'paymentReferenceId': [filterRecord.paymentReferenceId],
                'startDate': [date_util_DateUtil.formatDate(filterRecord.startDate), [pioneer_validators_PioneerValidators.isDate]],
                'endDate': [date_util_DateUtil.formatDate(filterRecord.endDate), [pioneer_validators_PioneerValidators.isDate]],
                'guestName': [filterRecord.guestName],
                'eventStatusMissingAgency': [filterRecord.eventStatusMissingAgency],
                'eventStatusCompleted': [filterRecord.eventStatusCompleted],
                'paymentStatus': this.formBuilder.group({
                    'unpaid': [filterRecord.paymentStatus.unpaid],
                    'paid': [filterRecord.paymentStatus.paid],
                    'inProcess': [filterRecord.paymentStatus.inProcess]
                })
            }, { validator: event_search_filter_validator_EventSearchFilterValidator.validate });
        }
        else {
            this.eventFilterForm.patchValue({
                'commissionId': filterRecord.commissionId,
                'fundingReferenceId': filterRecord.fundingReferenceId,
                'paymentReferenceId': filterRecord.paymentReferenceId,
                'startDate': date_util_DateUtil.formatDate(filterRecord.startDate),
                'endDate': date_util_DateUtil.formatDate(filterRecord.endDate),
                'guestName': filterRecord.guestName,
                'eventStatusMissingAgency': filterRecord.eventStatusMissingAgency,
                'eventStatusCompleted': filterRecord.eventStatusCompleted
            });
            this.eventFilterForm.get('paymentStatus').patchValue({
                'unpaid': filterRecord.paymentStatus.unpaid,
                'paid': filterRecord.paymentStatus.paid,
                'inProcess': filterRecord.paymentStatus.inProcess
            });
        }
    };
    EventSearchFormsStore.prototype.populateSearchTextForm = function (searchText) {
        if (!this.eventSearchTextForm) {
            this.eventSearchTextForm = this.formBuilder.group({
                'searchText': [searchText, [forms_es5["Validators"].required]]
            });
        }
        else {
            this.eventSearchTextForm.patchValue({
                'searchText': searchText
            });
        }
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "searchTextForm", {
        get: function () {
            return this.eventSearchTextForm;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterForm", {
        get: function () {
            return this.eventFilterForm;
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.searchFromSearchText = function (searchText) {
        var filterRecord = this.filterEventMenuSearchFilterSnapshot;
        if (filterRecord !== null) {
            var filterOptionsSet = this.eventMenuMapper.toSearchFilterSet(filterRecord);
            this.eventSearchParametersStore.setFilterSet(filterOptionsSet);
        }
        this.eventSearchParametersStore.addSearchText(searchText.searchText);
        this.eventSearchParametersStore.updateUrl();
        this.populateSearchTextForm('');
    };
    EventSearchFormsStore.prototype.searchFromFilter = function (record) {
        this.filterRecord = record;
        var filterOptionsSet = this.eventMenuMapper.toSearchFilterSet(this.filterRecord);
        this.eventSearchParametersStore.setFilterSet(filterOptionsSet);
        var filterText = this.filterSearchTextSnapshot;
        if (filterText && filterText.searchText) {
            this.eventSearchParametersStore.addSearchText(filterText.searchText);
            this.populateSearchTextForm('');
        }
        this.eventSearchParametersStore.updateUrl();
    };
    EventSearchFormsStore.prototype.updatePaymentStatusGroup = function () {
        var paymentStatusGroup = this.eventFilterForm.get('paymentStatus');
        var unpaid = paymentStatusGroup.get('unpaid').value;
        var paid = paymentStatusGroup.get('paid').value;
        var inProcess = paymentStatusGroup.get('inProcess').value;
        var paymentArray = immutable["List"].of({ name: 'unpaid', value: unpaid }, { name: 'paid', value: paid }, { name: 'inProcess', value: inProcess });
        // Returns only those records where the value is true
        var selectedOptionsList = paymentArray.filter(function (obj) { return obj.value === true; }).toList();
        this.logger.verbose("updatePaymentStatusGroup: is Selected count: " + selectedOptionsList.size);
        if (selectedOptionsList.size === 1) {
            // The other 2 options have been unchecked, disable the last option so that it cannot be
            // unchecked
            if (paymentStatusGroup.get(selectedOptionsList.first().name).enabled) {
                paymentStatusGroup.get(selectedOptionsList.first().name).disable();
            }
        }
        else {
            paymentArray.forEach(function (opt) {
                if (paymentStatusGroup.get(opt.name).disabled) {
                    paymentStatusGroup.get(opt.name).enable();
                }
            });
        }
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "filterMenuErrors", {
        get: function () {
            return this.filterMenuErrorSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterMenuErrorsSnapshot", {
        get: function () {
            return this.filterMenuErrorSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.setFilterMenuErrors = function (value) {
        this.logger.debug("EventSearchFormsStore.setFilterMenuErrors: " + JSON.stringify(value));
        this.filterMenuErrorSubject.next(value);
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "filterEventMenuSearchFilter", {
        get: function () {
            return this.filterEventMenuSearchFilterSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterEventMenuSearchFilterSnapshot", {
        get: function () {
            return this.filterEventMenuSearchFilterSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.setFilterEventMenuSearchFilter = function (value) {
        this.logger.debug("EventSearchFormsStore.setFilterEventMenuSearchFilter: " + JSON.stringify(value));
        this.filterEventMenuSearchFilterSubject.next(value);
    };
    Object.defineProperty(EventSearchFormsStore.prototype, "filterSearchText", {
        get: function () {
            return this.filterSearchTextSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventSearchFormsStore.prototype, "filterSearchTextSnapshot", {
        get: function () {
            return this.filterSearchTextSubject.getValue();
        },
        enumerable: true,
        configurable: true
    });
    EventSearchFormsStore.prototype.setFilterSearchText = function (value) {
        this.logger.debug("EventSearchFormsStore.setFilterSearchText: " + JSON.stringify(value));
        this.filterSearchTextSubject.next(value);
    };
    EventSearchFormsStore.prototype.createFilterRecord = function (model) {
        this.logger.debug("createFilterRecord: model: " + JSON.stringify(model));
        /*
         * The last payment status can get disabled so we read the value directly from the form rather
         * than what comes in with the form submission for paymentStatus
         */
        var paymentStatusGroup = this.eventFilterForm.get('paymentStatus');
        var unpaid = paymentStatusGroup.get('unpaid').value;
        var paid = paymentStatusGroup.get('paid').value;
        var inProcess = paymentStatusGroup.get('inProcess').value;
        model.paymentStatus = {
            unpaid: unpaid,
            paid: paid,
            inProcess: inProcess
        };
        return new EventMenuSearchFilter(model);
    };
    EventSearchFormsStore.prototype.isEventFilterOptionSelected = function () {
        var eventMenuSearchFilter = this.filterEventMenuSearchFilterSnapshot;
        if (eventMenuSearchFilter === null) {
            // this should be setup during the initialization of this store
            throw new Error('eventMenuSearchFilter can not be null');
        }
        this.logger.debug("EventSearchFormsStore: isEventFilterOptionSelected: " + JSON.stringify(eventMenuSearchFilter));
        var isExpanded = eventMenuSearchFilter.eventStatusCompleted ||
            eventMenuSearchFilter.eventStatusMissingAgency ||
            Boolean(eventMenuSearchFilter.startDate) ||
            Boolean(eventMenuSearchFilter.endDate) ||
            Boolean(eventMenuSearchFilter.guestName);
        this.logger.debug("EventSearchFormsStore: isEventFilterOptionSelected: isExpanded " + JSON.stringify(isExpanded));
        return isExpanded;
    };
    return EventSearchFormsStore;
}());
event_search_forms_store_EventSearchFormsStore = event_search_forms_store___decorate([
    Object(core_es5["Injectable"])(),
    event_search_forms_store___metadata("design:paramtypes", [typeof (event_search_forms_store__a = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && event_search_forms_store__a || Object, typeof (event_search_forms_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_search_forms_store__b || Object, typeof (event_search_forms_store__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_search_forms_store__c || Object, typeof (event_search_forms_store__d = typeof event_menu_search_filter_mapper_EventMenuSearchFilterMapper !== "undefined" && event_menu_search_filter_mapper_EventMenuSearchFilterMapper) === "function" && event_search_forms_store__d || Object])
], event_search_forms_store_EventSearchFormsStore);

var event_search_forms_store__a, event_search_forms_store__b, event_search_forms_store__c, event_search_forms_store__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-search-forms.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-list/event-list.component.ts
var event_list_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};













var event_list_component_EventListComponent = (function () {
    function EventListComponent(eventListStore, environment, router, menuStore, logger, flashMessagesService, eventSearchParametersStore, eventFilterUtils, eventSearchFormsStore) {
        this.eventListStore = eventListStore;
        this.environment = environment;
        this.router = router;
        this.menuStore = menuStore;
        this.logger = logger;
        this.flashMessagesService = flashMessagesService;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventFilterUtils = eventFilterUtils;
        this.eventSearchFormsStore = eventSearchFormsStore;
    }
    EventListComponent.prototype.ngOnInit = function () {
        this.data = this.eventListStore.events;
        this.menuStore.setPageTitle('EVENTS.TITLE');
        this.eventSearchFormsStore.populateSearchTextForm('');
        this.eventSearchTextForm = this.eventSearchFormsStore.searchTextForm;
    };
    Object.defineProperty(EventListComponent.prototype, "events", {
        get: function () {
            return this.data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "searchTextSet", {
        get: function () {
            return this.eventSearchParametersStore.searchTextSet;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "searchFilterSet", {
        get: function () {
            return this.eventSearchParametersStore.searchFilterSet;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "eventCount", {
        get: function () {
            return this.eventListStore.totalEventCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "eventCountForTranslate", {
        get: function () {
            return this.eventCount.map(function (count) {
                return {
                    eventCount: count
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "eventsAboveMax", {
        get: function () {
            var _this = this;
            return this.eventCount.map(function (eventCount) {
                return eventCount > _this.maxEvents;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "eventsPresent", {
        get: function () {
            return this.eventCount.map(function (eventCount) {
                return eventCount > 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "maxEvents", {
        get: function () {
            return this.environment.events.maxEvents;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListComponent.prototype, "maxEventsForTranslate", {
        get: function () {
            return {
                maxEvents: this.maxEvents
            };
        },
        enumerable: true,
        configurable: true
    });
    EventListComponent.prototype.onSelect = function (event) {
        this.router.navigate(['/event', event.eventId]);
    };
    EventListComponent.prototype.onSubmit = function (models) {
        this.logger.info('onSubmit');
        this.addSearchText(models);
        return false;
    };
    EventListComponent.prototype.resetSearch = function () {
        this.eventSearchParametersStore.reset(true);
        this.eventSearchFormsStore.populateSearchTextForm('');
    };
    EventListComponent.prototype.addSearchText = function (models) {
        this.logger.info("addSearchText: " + JSON.stringify(models));
        var eventSearchText = new EventSearchText(models);
        if (!eventSearchText.searchText) {
            return;
        }
        var filterErrors = this.eventSearchFormsStore.filterMenuErrorsSnapshot;
        if (filterErrors != null) {
            if (filterErrors[event_search_filter_validator_EventSearchFilterValidator.DATE_ERROR]) {
                this.flashMessagesService.error('MESSAGES.ERROR.INVALID_DATE_RANGE');
            }
            if (filterErrors[event_search_filter_validator_EventSearchFilterValidator.PAYMENT_STATUS_ERROR]) {
                this.flashMessagesService.error('MESSAGES.ERROR.NO_PAYMENT_STATUS_SELECTED');
            }
            return;
        }
        this.eventSearchFormsStore.searchFromSearchText(eventSearchText);
    };
    EventListComponent.prototype.addSearchFilter = function (filterField, filterValue) {
        this.eventSearchParametersStore.addSearchFilter(filterField, filterValue);
        this.eventSearchParametersStore.updateUrl();
    };
    EventListComponent.prototype.removeSearchText = function (event) {
        var element = (event.target || event.srcElement);
        var searchText = element.innerHTML.trim();
        this.eventSearchParametersStore.removeSearchText(searchText, true);
    };
    Object.defineProperty(EventListComponent.prototype, "isDefaultViewSelected", {
        get: function () {
            return this.eventSearchParametersStore.isDefaultViewSelected;
        },
        enumerable: true,
        configurable: true
    });
    EventListComponent.prototype.updateToDefaultURL = function () {
        this.eventSearchParametersStore.defaultViewUrl();
    };
    EventListComponent.prototype.updateToFinancialURL = function () {
        this.eventSearchParametersStore.financialViewUrl();
    };
    EventListComponent.prototype.removeSearchFilter = function (event, filter) {
        this.eventSearchParametersStore.removeSearchFilter(filter, true);
        var element = (event.target || event.srcElement);
        element.innerHTML.trim();
    };
    EventListComponent.prototype.getTokenFilterFieldTranslationKey = function (filterField) {
        switch (filterField) {
            case EventFilterType.COMPLETED.toString():
            case EventFilterType.MISSING_AGENCY.toString():
                return 'EVENTS.FILTER_LABEL.EVENT_STATUS';
            default:
                return 'EVENTS.FILTER_LABEL.' + filterField;
        }
    };
    EventListComponent.prototype.getTokenValue = function (filter) {
        return this.eventFilterUtils.getTokenDisplayString(filter);
    };
    return EventListComponent;
}());
event_list_component_EventListComponent = event_list_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-list',
        template: __webpack_require__("KTxh")
    }),
    event_list_component___metadata("design:paramtypes", [typeof (event_list_component__a = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && event_list_component__a || Object, typeof (event_list_component__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_component__b || Object, typeof (event_list_component__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_list_component__c || Object, typeof (event_list_component__d = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_list_component__d || Object, typeof (event_list_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && event_list_component__e || Object, typeof (event_list_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_list_component__f || Object, typeof (event_list_component__g = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_list_component__g || Object, typeof (_h = typeof event_filter_util_service_EventFilterUtilsService !== "undefined" && event_filter_util_service_EventFilterUtilsService) === "function" && _h || Object, typeof (_j = typeof event_search_forms_store_EventSearchFormsStore !== "undefined" && event_search_forms_store_EventSearchFormsStore) === "function" && _j || Object])
], event_list_component_EventListComponent);

var event_list_component__a, event_list_component__b, event_list_component__c, event_list_component__d, event_list_component__e, event_list_component__f, event_list_component__g, _h, _j;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-list.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/contact.ts
var contact___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ContactRecord = Object(immutable["Record"])({
    eventContactId: 0,
    version: 0,
    createDate: null,
    modifiedDate: null,
    partyType: null,
    eventId: null,
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    fax: null
});
var Contact = (function (_super) {
    contact___extends(Contact, _super);
    function Contact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Contact;
}(ContactRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/contact.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/party.ts
var party___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var PartyRecord = Object(immutable["Record"])({
    eventPartyId: 0,
    version: 0,
    createDate: null,
    modifiedDate: null,
    brand: null,
    chain: null,
    propertyId: null,
    agencyId: null,
    clientReferenceNumber: null,
    partyType: null,
    name: null,
    eventId: null,
    line1: null,
    line2: null,
    city: null,
    state: null,
    postalCode: null,
    eventReferenceNumber: null,
    contact: new Contact()
});
var Party = (function (_super) {
    party___extends(Party, _super);
    function Party() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Party;
}(PartyRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/party.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event.ts
var event___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var EventRecord = Object(immutable["Record"])({
    eventId: null,
    version: null,
    createdDate: null,
    modifiedDate: null,
    name: null,
    eventAgency: new Party(),
    eventClient: new Party(),
    eventProperty: new Party(),
    brand: null,
    chain: null,
    propertyId: null,
    agencyId: null,
    clientReferenceNumber: null,
    startDate: null,
    endDate: null,
    attritionGuaranteePercentage: null,
    attritionMinRoomNights: null,
    commissionRoomPercentage: 0,
    attritionCutoffDate: null,
    roomRateCutoffDate: null,
    depositAmount: null,
    totalFoodBeverageRevenue: null,
    inactive: null,
    autoGenerated: false,
    autoPayment: null,
    canBeDeleted: false
});
var OnyxEvent = (function (_super) {
    event___extends(OnyxEvent, _super);
    function OnyxEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OnyxEvent;
}(EventRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event.store.ts
var event_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var event_store_EventStore = (function () {
    function EventStore(eventHttpService, flashMessagesService) {
        this.eventHttpService = eventHttpService;
        this.flashMessagesService = flashMessagesService;
        this.mySelectedEvent = new BehaviorSubject["BehaviorSubject"](null);
    }
    Object.defineProperty(EventStore.prototype, "selectedEvent", {
        /**
         * Returns an observable containing the current event.
         * Used in any case when data needs to be shown on a screen.
         *
         * @returns {Observable<T>}
         */
        get: function () {
            return this.mySelectedEvent.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Retrieves event.  This method returns an observable
     * and should be used only in route resolvers.
     *
     * @param eventId
     * @returns {Observable<OnyxEvent>}
     */
    EventStore.prototype.getEvent = function (eventId) {
        var _this = this;
        return this.eventHttpService.get(eventId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_EVENT', "Error retrieving OnyxEvent: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.mySelectedEvent.next(res);
            return res;
        });
    };
    EventStore.prototype.addEvent = function (newRec) {
        var _this = this;
        return this.eventHttpService.add(newRec)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            return res;
        });
    };
    EventStore.prototype.updateEvent = function (newRec) {
        var _this = this;
        return this.eventHttpService.update(newRec)
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.SAVE_EVENT');
            _this.mySelectedEvent.next(res);
            return res;
        });
    };
    EventStore.prototype.downloadInvalidEventsCsv = function (fileId) {
        return this.eventHttpService.downloadInvalidEventsCsv(fileId);
    };
    EventStore.prototype.deleteEvent = function (eventId) {
        var _this = this;
        return this.eventHttpService.delete(eventId)
            .catch((function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_EVENT');
            return Observable["Observable"].throw(error);
        }))
            .map(function (res) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.DELETE_EVENT');
            _this.mySelectedEvent.next(null);
            return res;
        });
    };
    EventStore.prototype.importEventsViaCsv = function (file) {
        return this.eventHttpService.importEventsViaCsv(file)
            .catch((function (error) {
            return Observable["Observable"].throw(error);
        }))
            .map(function (importResponse) {
            return importResponse;
        });
    };
    return EventStore;
}());
event_store_EventStore = event_store___decorate([
    Object(core_es5["Injectable"])(),
    event_store___metadata("design:paramtypes", [typeof (event_store__a = typeof event_http_service_EventHttpService !== "undefined" && event_http_service_EventHttpService) === "function" && event_store__a || Object, typeof (event_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_store__b || Object])
], event_store_EventStore);

var event_store__a, event_store__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/pioneer-utils.ts
var PioneerUtils = (function () {
    function PioneerUtils() {
    }
    PioneerUtils.getLastElement = function (elements) {
        return elements && elements.length > 0 ? elements[elements.length - 1] : null;
    };
    return PioneerUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/pioneer-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/route-utils.ts

var route_utils_RouteUtils = (function () {
    function RouteUtils() {
    }
    RouteUtils.getLastUrlSegment = function (route) {
        return route.url.map(function (segments) {
            return PioneerUtils.getLastElement(segments);
        });
    };
    RouteUtils.getLastUrlSegmentSnapshot = function (route) {
        var segments = route.snapshot.url;
        return PioneerUtils.getLastElement(segments);
    };
    return RouteUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/route-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/event-utils.ts
var EventUtils = (function () {
    function EventUtils() {
    }
    EventUtils.isEventValid = function (onyxEvent) {
        return Boolean(onyxEvent &&
            this.isEventBasicInformationValid(onyxEvent) &&
            this.isEventStartEndDateValid(onyxEvent) &&
            this.isEventPropertyValid(onyxEvent.eventProperty) &&
            this.isEventAgencyValid(onyxEvent.eventAgency));
    };
    EventUtils.isEventBasicInformationValid = function (onyxEvent) {
        return Boolean(onyxEvent.name &&
            onyxEvent.chain &&
            onyxEvent.brand &&
            onyxEvent.propertyId);
    };
    EventUtils.isEventPropertyValid = function (eventProperty) {
        return Boolean(eventProperty && eventProperty.eventReferenceNumber && eventProperty.name);
    };
    EventUtils.isEventAgencyValid = function (eventAgency) {
        return Boolean(eventAgency && eventAgency.name);
    };
    EventUtils.isEventStartEndDateValid = function (onyxEvent) {
        return Boolean(onyxEvent.startDate &&
            onyxEvent.endDate &&
            new Date(onyxEvent.startDate) < new Date(onyxEvent.endDate));
    };
    EventUtils.doesEventHaveAgency = function (onyxEvent) {
        return Boolean(onyxEvent.agencyId && onyxEvent.eventAgency);
    };
    return EventUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/confirmation-modal/confirmation-modal-config.ts
var ConfirmationModalConfig = (function () {
    function ConfirmationModalConfig(content, cancel, confirm, title, closed) {
        this.content = content;
        this.cancel = cancel;
        this.confirm = confirm;
        this.title = title;
        this.closed = closed;
    }
    return ConfirmationModalConfig;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/confirmation-modal-config.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event/event.component.ts
var event_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
















var event_component_EventComponent = (function () {
    function EventComponent(router, eventStore, formBuilder, menuStore, flashMessagesService, translateService, route, authenticationSore, eventSearchParametersStore) {
        this.router = router;
        this.eventStore = eventStore;
        this.formBuilder = formBuilder;
        this.menuStore = menuStore;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.route = route;
        this.authenticationSore = authenticationSore;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.isReadOnly = true;
        this.confirmationModalConfig = new ConfirmationModalConfig();
    }
    EventComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageTitle('EVENT.EVENT_INFO_TITLE');
        this.menuStore.setIsReadOnly(true);
        this.menuStore.isReadOnly.subscribe(function (isReadOnly) {
            _this.isReadOnly = isReadOnly;
        });
        this.onyxEvent = new OnyxEvent();
        this.eventStore.selectedEvent.subscribe(function (value) {
            _this.onyxEvent = new OnyxEvent(value);
        });
        this.eventForm = this.formBuilder.group({
            'event': this.formBuilder.group({
                'eventAgency': this.formBuilder.group({}),
                'eventClient': this.formBuilder.group({}),
                'eventProperty': this.formBuilder.group({})
            })
        });
        // toggle page to editable if the URL ends with "edit" (it will default to read only)
        // otherwise, check if we need to show a warning flash message when in view modeFD
        route_utils_RouteUtils.getLastUrlSegment(this.route)
            .subscribe(function (lastSegment) {
            if (lastSegment && lastSegment.path === 'edit') {
                _this.togglePageToReadOnly(false);
            }
            else {
                if (_this.authenticationSore.hasPermission('EditEvent') && !_this.isEventValid()) {
                    _this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO', null, { hrefValue: "/#/event/" + _this.onyxEvent.eventId + "/edit" });
                }
            }
        });
    };
    EventComponent.prototype.save = function (model) {
        var _this = this;
        model.event.eventAgency = model.eventAgency;
        model.event.eventClient = model.eventClient;
        model.event.eventProperty = model.eventProperty;
        var formModel = Object.assign({}, this.onyxEvent.toJS(), model.event);
        var updatedFields = {};
        if (formModel.eventAgency) {
            var eventAgency = this.onyxEvent.eventAgency || new Party({ contact: new Contact() });
            updatedFields['agencyId'] = formModel.eventAgency.agencyId;
            updatedFields['eventAgency'] = Object.assign({}, eventAgency, model['eventAgency']);
            updatedFields['eventAgency']['contact'] = Object.assign({}, eventAgency.contact, model['eventAgency']['contact']);
        }
        if (formModel.eventClient) {
            var eventClient = this.onyxEvent.eventClient || new Party({ contact: new Contact() });
            updatedFields['clientReferenceNumber'] = formModel.eventClient.clientReferenceNumber;
            updatedFields['eventClient'] = Object.assign({}, eventClient, model['eventClient']);
            updatedFields['eventClient']['contact'] = Object.assign({}, eventClient.contact, model['eventClient']['contact']);
        }
        if (formModel.eventProperty) {
            var eventProperty = this.onyxEvent.eventProperty || new Party({ contact: new Contact() });
            updatedFields['brand'] = formModel.eventProperty.brand;
            updatedFields['chain'] = formModel.eventProperty.chain;
            updatedFields['propertyId'] = formModel.eventProperty.propertyId;
            updatedFields['eventProperty'] = Object.assign({}, eventProperty, model['eventProperty']);
            updatedFields['eventProperty']['contact'] = Object.assign({}, eventProperty.contact, model['eventProperty']['contact']);
        }
        updatedFields['startDate'] = new Date(formModel.startDate).toISOString();
        updatedFields['endDate'] = new Date(formModel.endDate).toISOString();
        var updatedModel = new OnyxEvent(Object.assign({}, formModel, updatedFields));
        updatedModel.eventProperty.eventReferenceNumber = formModel.groupCodeNumber;
        var returnedEvent = this.eventStore.updateEvent(updatedModel);
        returnedEvent.subscribe(function () {
            _this.router.navigate(['/event', _this.onyxEvent.eventId]);
        }, function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_EVENT', error);
        });
        return returnedEvent;
    };
    EventComponent.prototype.edit = function () {
        this.router.navigate(['/event', this.onyxEvent.eventId, 'edit']);
    };
    EventComponent.prototype.confirmBeforeDeleting = function () {
        // set up the title of the confirmation modal
        var label = 'EVENT.DELETE_EVENT';
        this.confirmationModalConfig.title = this.translateService.instant(label);
        this.confirmationModal.open();
    };
    EventComponent.prototype.confirmBeforeDeletingHandler = function (value) {
        if (value) {
            var eventId = this.onyxEvent.eventId;
            this.delete();
        }
    };
    Object.defineProperty(EventComponent.prototype, "canBeDeleted", {
        get: function () {
            return this.onyxEvent.canBeDeleted;
        },
        enumerable: true,
        configurable: true
    });
    EventComponent.prototype.delete = function () {
        var _this = this;
        this.eventStore.deleteEvent(this.onyxEvent.eventId).subscribe(function () {
            _this.eventSearchParametersStore.updateUrl();
        });
    };
    EventComponent.prototype.cancel = function () {
        var _this = this;
        this.router.navigate(['/event', this.onyxEvent.eventId]);
        this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
        });
    };
    EventComponent.prototype.togglePageToReadOnly = function (readOnly) {
        this.menuStore.setPageTitle(readOnly ? 'EVENT.EVENT_INFO_TITLE' : 'EVENT.TITLE_EDIT');
        this.menuStore.setIsReadOnly(readOnly);
    };
    EventComponent.prototype.isEventValid = function () {
        return EventUtils.isEventValid(this.onyxEvent);
    };
    return EventComponent;
}());
event_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    event_component___metadata("design:type", typeof (event_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && event_component__a || Object)
], event_component_EventComponent.prototype, "confirmationModal", void 0);
event_component_EventComponent = event_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event',
        template: __webpack_require__("PUE1")
    }),
    event_component___metadata("design:paramtypes", [typeof (event_component__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_component__b || Object, typeof (event_component__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_component__c || Object, typeof (event_component__d = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && event_component__d || Object, typeof (event_component__e = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_component__e || Object, typeof (event_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && event_component__f || Object, typeof (event_component__g = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_component__g || Object, typeof (event_component__h = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && event_component__h || Object, typeof (event_component__j = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && event_component__j || Object, typeof (_k = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && _k || Object])
], event_component_EventComponent);

var event_component__a, event_component__b, event_component__c, event_component__d, event_component__e, event_component__f, event_component__g, event_component__h, event_component__j, _k;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/add-event/add-event.component.ts
var add_event_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_event_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var add_event_component_AddEventComponent = (function () {
    function AddEventComponent(router, formBuilder, eventStore, logService, menuStore, flashMessagesService, eventSearchParametersStore) {
        this.router = router;
        this.formBuilder = formBuilder;
        this.eventStore = eventStore;
        this.logService = logService;
        this.menuStore = menuStore;
        this.flashMessagesService = flashMessagesService;
        this.eventSearchParametersStore = eventSearchParametersStore;
    }
    AddEventComponent.prototype.ngOnInit = function () {
        this.isReadOnly = false;
        this.onyxEvent = new OnyxEvent();
        this.eventForm = this.formBuilder.group({
            'event': this.formBuilder.group({})
        });
        this.menuStore.setPageTitle('EVENT.TITLE_ADD');
    };
    AddEventComponent.prototype.save = function (model) {
        var _this = this;
        model.event.eventAgency = model.eventAgency;
        model.event.eventClient = model.eventClient;
        model.event.eventProperty = model.eventProperty;
        var formModel = new OnyxEvent(model.event);
        var updatedRefCodes = {};
        if (formModel.eventAgency) {
            updatedRefCodes['agencyId'] = formModel.eventAgency.agencyId;
        }
        if (formModel.eventClient) {
            updatedRefCodes['clientReferenceNumber'] = formModel.eventClient.clientReferenceNumber;
        }
        if (formModel.eventProperty) {
            formModel.eventProperty.eventReferenceNumber = model.event.groupCodeNumber;
            updatedRefCodes['brand'] = formModel.eventProperty.brand;
            updatedRefCodes['chain'] = formModel.eventProperty.chain;
            updatedRefCodes['propertyId'] = formModel.eventProperty.propertyId;
        }
        updatedRefCodes['startDate'] = new Date(formModel.startDate).toISOString();
        updatedRefCodes['endDate'] = new Date(formModel.endDate).toISOString();
        this.logService.debug("updatedRefCodes " + updatedRefCodes);
        var updatedModel = formModel.merge(updatedRefCodes);
        this.logService.debug("updatedModel " + updatedModel);
        var returnedEvent = this.eventStore.addEvent(updatedModel);
        returnedEvent.subscribe(function () {
            _this.returnToSearchList();
        }, function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_EVENT', error);
        });
        return returnedEvent;
    };
    AddEventComponent.prototype.returnToSearchList = function () {
        this.eventSearchParametersStore.updateUrl();
    };
    return AddEventComponent;
}());
add_event_component_AddEventComponent = add_event_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-event',
        template: __webpack_require__("iC+n")
    }),
    add_event_component___metadata("design:paramtypes", [typeof (add_event_component__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && add_event_component__a || Object, typeof (add_event_component__b = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && add_event_component__b || Object, typeof (add_event_component__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && add_event_component__c || Object, typeof (add_event_component__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && add_event_component__d || Object, typeof (add_event_component__e = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && add_event_component__e || Object, typeof (add_event_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && add_event_component__f || Object, typeof (add_event_component__g = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && add_event_component__g || Object])
], add_event_component_AddEventComponent);

var add_event_component__a, add_event_component__b, add_event_component__c, add_event_component__d, add_event_component__e, add_event_component__f, add_event_component__g;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/add-event.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/guards/can-activate-via-auth-guard.ts
var can_activate_via_auth_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var can_activate_via_auth_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var CanActivateViaAuthGuard = (function () {
    function CanActivateViaAuthGuard(router, authService, logService) {
        this.router = router;
        this.authService = authService;
        this.logService = logService;
    }
    CanActivateViaAuthGuard.prototype.canActivate = function () {
        var _this = this;
        return this.authService.isLoggedIn().map(function (isLoggedIn) {
            _this.logService.debug("isAuthenticated " + isLoggedIn);
            if (!isLoggedIn) {
                if (_this.authService.isExternalLogin()) {
                    _this.router.navigate(['/external-login-expired']);
                }
                else {
                    _this.router.navigate(['/login']);
                }
            }
            return isLoggedIn;
        });
    };
    return CanActivateViaAuthGuard;
}());
CanActivateViaAuthGuard = can_activate_via_auth_guard___decorate([
    Object(core_es5["Injectable"])(),
    can_activate_via_auth_guard___metadata("design:paramtypes", [typeof (can_activate_via_auth_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && can_activate_via_auth_guard__a || Object, typeof (can_activate_via_auth_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && can_activate_via_auth_guard__b || Object, typeof (can_activate_via_auth_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && can_activate_via_auth_guard__c || Object])
], CanActivateViaAuthGuard);

var can_activate_via_auth_guard__a, can_activate_via_auth_guard__b, can_activate_via_auth_guard__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/can-activate-via-auth-guard.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/guards/permission-guard.ts
var permission_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var permission_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PermissionGuard = (function () {
    function PermissionGuard(authStore, flashMessagesService) {
        this.authStore = authStore;
        this.flashMessagesService = flashMessagesService;
    }
    PermissionGuard.prototype.canActivate = function (route, state) {
        if (route.data && route.data['allowedPermissions']) {
            return this.authStore.hasPermission(route.data['allowedPermissions']);
        }
        else {
            this.flashMessagesService.error('MESSAGES.ERROR.UNABLE_TO_NAVIGATE', "The route [" + route.toString() + "] was not given data specifying allowed permissions");
            return false;
        }
    };
    return PermissionGuard;
}());
PermissionGuard = permission_guard___decorate([
    Object(core_es5["Injectable"])(),
    permission_guard___metadata("design:paramtypes", [typeof (permission_guard__a = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && permission_guard__a || Object, typeof (permission_guard__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && permission_guard__b || Object])
], PermissionGuard);

var permission_guard__a, permission_guard__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/permission-guard.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/search-event-utils.ts


var search_event_utils_SearchEventUtils = (function () {
    function SearchEventUtils() {
    }
    SearchEventUtils.convertParamsToSearchTextSet = function (queryParams) {
        var searchQueryParams = queryParams['search'];
        if (searchQueryParams) {
            var searchTextArray = searchQueryParams instanceof Array ? searchQueryParams : [searchQueryParams];
            return Object(immutable["OrderedSet"])(searchTextArray);
        }
        else {
            return null;
        }
    };
    SearchEventUtils.convertParamsToSearchFilterSet = function (queryParams) {
        var filterParams = queryParams['filters'];
        var filterSet = Object(immutable["OrderedSet"])([]);
        var jsonParams;
        try {
            jsonParams = JSON.parse(filterParams);
        }
        catch (e) {
            return filterSet;
        }
        var searchFilterArray = jsonParams instanceof Array ? jsonParams : [jsonParams];
        searchFilterArray.forEach(function (eachFilter) {
            if (eachFilter.filterField && eachFilter.filterValue) {
                var filterField = eachFilter.filterField;
                var filterValue = eachFilter.filterValue;
                var filter = new EventSearchFilter({
                    filterField: filterField,
                    filterValue: filterValue
                });
                filterSet = filterSet.add(filter);
            }
        });
        return filterSet;
    };
    return SearchEventUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/search-event-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/events.resolver.ts
var events_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var events_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var events_resolver_EventsResolver = (function () {
    function EventsResolver(eventsListStore, searchParametersStore, logService) {
        this.eventsListStore = eventsListStore;
        this.searchParametersStore = searchParametersStore;
        this.logService = logService;
    }
    EventsResolver.prototype.resolve = function (route, state) {
        var searchTextList = search_event_utils_SearchEventUtils.convertParamsToSearchTextSet(route.queryParams);
        var searchFilterList = search_event_utils_SearchEventUtils.convertParamsToSearchFilterSet(route.queryParams);
        if (!searchTextList && !searchFilterList) {
            this.searchParametersStore.reset();
        }
        else {
            if (searchTextList) {
                this.searchParametersStore.setSearchTextSet(searchTextList);
            }
            if (searchFilterList) {
                this.searchParametersStore.setFilterSet(searchFilterList);
            }
        }
        this.logService.debug('route.url: ' + route.url);
        this.logService.debug('state.url: ' + state.url);
        if (route.data && route.data['view']) {
            this.logService.debug('route.data[ \'view\' ]: ' + route.data['view']);
            var showDefaultView = route.data['view'];
            this.logService.debug('showDefaultView: ' + showDefaultView);
            this.searchParametersStore.setDefaultViewSelected(showDefaultView === 'default');
        }
        return this.eventsListStore.loadEvents();
    };
    return EventsResolver;
}());
events_resolver_EventsResolver = events_resolver___decorate([
    Object(core_es5["Injectable"])(),
    events_resolver___metadata("design:paramtypes", [typeof (events_resolver__a = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && events_resolver__a || Object, typeof (events_resolver__b = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && events_resolver__b || Object, typeof (events_resolver__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && events_resolver__c || Object])
], events_resolver_EventsResolver);

var events_resolver__a, events_resolver__b, events_resolver__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/events.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event/event.resolver.ts
var event_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var EventResolver = (function () {
    function EventResolver(eventStore, translateService) {
        this.eventStore = eventStore;
        this.translateService = translateService;
    }
    EventResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
        }
        return this.eventStore.getEvent(route.params['id']);
    };
    return EventResolver;
}());
EventResolver = event_resolver___decorate([
    Object(core_es5["Injectable"])(),
    event_resolver___metadata("design:paramtypes", [typeof (event_resolver__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_resolver__a || Object, typeof (event_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && event_resolver__b || Object])
], EventResolver);

var event_resolver__a, event_resolver__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/payment.ts
var payment___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PaymentRecord = Object(immutable["Record"])({
    eventPaymentId: 0,
    commissionAmount: 0,
    feeAmount: 0,
    commissionCurrency: 'USD',
    description: null,
    commissionId: null,
    fundingReferenceId: null,
    paymentReferenceId: null,
    status: null,
    createdDate: null,
    modifiedDate: null,
    createdBy: null,
    modifiedBy: null,
    eventId: 0,
    eventPaymentModifiers: null
});
var Payment = (function (_super) {
    payment___extends(Payment, _super);
    function Payment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Payment;
}(PaymentRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/payment.http.service.ts
var payment_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var payment_http_service_PaymentHttpService = (function () {
    function PaymentHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
        this.paymentUrl = this.eventsUrl + '/payments';
    }
    PaymentHttpService.prototype.add = function (payment) {
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.paymentUrl, JSON.stringify(payment.toJS()), options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    PaymentHttpService.prototype.getPayments = function (eventId) {
        return this.http.get(this.eventsUrl + "/" + eventId + "/payments")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (element) { return new Payment(element); })); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    PaymentHttpService.prototype.getLatestPayment = function (eventId) {
        return this.http.get(this.eventsUrl + "/" + eventId + "/latestPayment")
            .map(function (response) {
            var data = response.json();
            return new Payment(data);
        })
            .catch(response_util_ResponseUtil.unwrapErrorMessage)
            .share();
    };
    return PaymentHttpService;
}());
payment_http_service_PaymentHttpService = payment_http_service___decorate([
    Object(core_es5["Injectable"])(),
    payment_http_service___metadata("design:paramtypes", [typeof (payment_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && payment_http_service__a || Object, typeof (payment_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && payment_http_service__b || Object])
], payment_http_service_PaymentHttpService);

var payment_http_service__a, payment_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/payment-status.enum.ts
/**
 * GroupPay Payment status codes
 * https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
 */
/**
 * GroupPay Payment status codes
 * https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
 */ var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["READY"] = 'ready'] = "READY";
    PaymentStatus[PaymentStatus["PENDING"] = 'pending'] = "PENDING";
    PaymentStatus[PaymentStatus["INVOICED"] = 'invoiced'] = "INVOICED";
    PaymentStatus[PaymentStatus["INVOICE_REJECTED"] = 'invoice-rejected'] = "INVOICE_REJECTED";
    PaymentStatus[PaymentStatus["FUNDED"] = 'funded'] = "FUNDED";
    PaymentStatus[PaymentStatus["PAY_SENT"] = 'pay-sent'] = "PAY_SENT";
    PaymentStatus[PaymentStatus["PAY_REJECTED"] = 'pay-rejected'] = "PAY_REJECTED";
    PaymentStatus[PaymentStatus["ERROR"] = 'error'] = "ERROR";
})(PaymentStatus || (PaymentStatus = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment-status.enum.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/payment-status-utils.ts


var PaymentStatusUtils = (function () {
    function PaymentStatusUtils() {
    }
    PaymentStatusUtils.isError = function (paymentStatus) {
        return this.ERROR_CODES.contains(paymentStatus);
    };
    return PaymentStatusUtils;
}());

PaymentStatusUtils.ERROR_CODES = Object(immutable["List"])([
    PaymentStatus.INVOICE_REJECTED,
    PaymentStatus.PAY_REJECTED,
    PaymentStatus.ERROR
]);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment-status-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/payment.store.ts
var payment_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var payment_store_PaymentStore = (function () {
    function PaymentStore(paymentHttpService, logService, flashMessagesService, translateService) {
        this.paymentHttpService = paymentHttpService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        // This is the same as BehaviorSubject but without a default value
        this.bufferSize = 1;
        this.paymentList = new ReplaySubject["ReplaySubject"](this.bufferSize);
        this.latestPayment = new ReplaySubject["ReplaySubject"](this.bufferSize);
    }
    PaymentStore.prototype.addPayment = function (payment) {
        var _this = this;
        return this.paymentHttpService.add(payment)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_PAYMENT', "Error adding Payment: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.COMMISSION.PAYMENT_SAVED');
            return result;
        });
    };
    Object.defineProperty(PaymentStore.prototype, "payments", {
        get: function () {
            return this.paymentList.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    PaymentStore.prototype.getLatestPayment = function () {
        return this.latestPayment.asObservable();
    };
    PaymentStore.prototype.loadPayments = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getPayments(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_PAYMENTS'));
            _this.logService.error("Error adding Payment: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.paymentList.next(result);
            return result;
        });
    };
    PaymentStore.prototype.loadLatestPayment = function (eventId) {
        var _this = this;
        return this.paymentHttpService.getLatestPayment(eventId).catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
            _this.logService.error("Error getting last Payment: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (result) {
            _this.latestPayment.next(result);
            return result;
        });
    };
    Object.defineProperty(PaymentStore.prototype, "commissionTotal", {
        get: function () {
            var _this = this;
            return this.payments.map(function (payments) {
                return payments
                    .filter(function (payment) { return !_this.isPaymentRejected(payment); })
                    .map(function (payment) { return payment.commissionAmount; })
                    .reduce(function (prev, current) { return !!current ? prev + current : prev; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentStore.prototype, "containsRejectedPayments", {
        get: function () {
            var _this = this;
            return this.payments.map(function (payments) { return payments.some(_this.isPaymentRejected); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentStore.prototype, "currentPayment", {
        /**
         * Gets the payment with the latest created date
         */
        get: function () {
            return this.payments.map(function (list) {
                return list.max(function (payment1, payment2) {
                    if (payment1.createdDate < payment2.createdDate) {
                        return -1;
                    }
                    else if (payment1.createdDate > payment2.createdDate) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentStore.prototype, "isCurrentPaymentValid", {
        /**
         * Returns true if the current payment exists and does not have a rejected or error status
         * @returns {Observable<R>}
         */
        get: function () {
            var _this = this;
            return this.currentPayment.map(function (lastPayment) {
                return !!lastPayment && !_this.isPaymentRejected(lastPayment);
            });
        },
        enumerable: true,
        configurable: true
    });
    PaymentStore.prototype.isPaymentRejected = function (payment) {
        return PaymentStatusUtils.isError(payment.status);
    };
    return PaymentStore;
}());
payment_store_PaymentStore = payment_store___decorate([
    Object(core_es5["Injectable"])(),
    payment_store___metadata("design:paramtypes", [typeof (payment_store__a = typeof payment_http_service_PaymentHttpService !== "undefined" && payment_http_service_PaymentHttpService) === "function" && payment_store__a || Object, typeof (payment_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_store__b || Object, typeof (payment_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && payment_store__c || Object, typeof (payment_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_store__d || Object])
], payment_store_PaymentStore);

var payment_store__a, payment_store__b, payment_store__c, payment_store__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/commission/commission.component.ts
var commission_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var commission_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var commission_component_CommissionComponent = (function () {
    function CommissionComponent(formBuilder, menuStore, eventStore, paymentStore) {
        this.formBuilder = formBuilder;
        this.menuStore = menuStore;
        this.eventStore = eventStore;
        this.paymentStore = paymentStore;
        this.ui = {
            showAddPayment: false,
            showPaymentRecord: false
        };
    }
    CommissionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
        });
        this.paymentStore.getLatestPayment().subscribe(function (latestPayment) {
            _this.latestPayment = latestPayment;
            var status = _this.latestPayment.status;
            if (status) {
                _this.ui.showPaymentRecord = true;
                _this.ui.showAddPayment = false;
            }
            else {
                _this.ui.showPaymentRecord = false;
                _this.ui.showAddPayment = true;
            }
        });
        this.commissionForm = this.formBuilder.group({});
        this.menuStore.setPageTitle('EVENT.EVENT_INFO_TITLE');
    };
    return CommissionComponent;
}());
commission_component_CommissionComponent = commission_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-commission',
        template: __webpack_require__("Xi0/")
    }),
    commission_component___metadata("design:paramtypes", [typeof (commission_component__a = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && commission_component__a || Object, typeof (commission_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && commission_component__b || Object, typeof (commission_component__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && commission_component__c || Object, typeof (commission_component__d = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && commission_component__d || Object])
], commission_component_CommissionComponent);

var commission_component__a, commission_component__b, commission_component__c, commission_component__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/commission.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/event-menu/event-menu.component.ts
var event_menu_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_menu_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var event_menu_component_EventMenuComponent = (function () {
    function EventMenuComponent(eventStore, menuStore, eventSearchParameterStore) {
        this.eventStore = eventStore;
        this.menuStore = menuStore;
        this.eventSearchParameterStore = eventSearchParameterStore;
        this.eventTitle = 'COMMON.NAV.EVENT_INFORMATION';
        this.includeSubNav = true;
    }
    EventMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.isReadOnly.subscribe(function (isReadOnly) {
            _this.includeSubNav = isReadOnly;
            _this.eventTitle = isReadOnly ? 'COMMON.NAV.EVENT_INFORMATION' : 'COMMON.NAV.EDIT_EVENT';
        });
        this.onyxEvent = new OnyxEvent();
        this.eventStore.selectedEvent.subscribe(function (value) {
            _this.onyxEvent = new OnyxEvent(value);
        });
    };
    EventMenuComponent.prototype.navigateToSearch = function () {
        this.eventSearchParameterStore.updateUrl();
    };
    return EventMenuComponent;
}());
event_menu_component_EventMenuComponent = event_menu_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-menu',
        template: __webpack_require__("tzTa")
    }),
    event_menu_component___metadata("design:paramtypes", [typeof (event_menu_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_menu_component__a || Object, typeof (event_menu_component__b = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_menu_component__b || Object, typeof (event_menu_component__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_menu_component__c || Object])
], event_menu_component_EventMenuComponent);

var event_menu_component__a, event_menu_component__b, event_menu_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-menu.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/dashboard-totals.http.service.ts
var dashboard_totals_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dashboard_totals_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var dashboard_totals_http_service_DashboardTotalsHttpService = (function () {
    function DashboardTotalsHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.aggregateBaseURL = '/api/events/dashboard';
        this.missingAgencyCountURL = this.environment.baseUrl + this.aggregateBaseURL + '/missing-agency';
        this.completeAndUnpaidCountURL = this.environment.baseUrl + this.aggregateBaseURL + '/complete-and-unpaid';
    }
    DashboardTotalsHttpService.prototype.getCompletedAndUnpaidCounts = function () {
        return this.http.get(this.completeAndUnpaidCountURL)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    DashboardTotalsHttpService.prototype.getMissingAgencyCount = function () {
        return this.http.get(this.missingAgencyCountURL)
            .map(function (response) { return Number(response.text()); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return DashboardTotalsHttpService;
}());
dashboard_totals_http_service_DashboardTotalsHttpService = dashboard_totals_http_service___decorate([
    Object(core_es5["Injectable"])(),
    dashboard_totals_http_service___metadata("design:paramtypes", [typeof (dashboard_totals_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && dashboard_totals_http_service__a || Object, typeof (dashboard_totals_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && dashboard_totals_http_service__b || Object])
], dashboard_totals_http_service_DashboardTotalsHttpService);

var dashboard_totals_http_service__a, dashboard_totals_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/dashboard-totals.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/dashboard/dashboard-card-state.ts
var DashboardCardState;
(function (DashboardCardState) {
    DashboardCardState[DashboardCardState["LOADED"] = 0] = "LOADED";
    DashboardCardState[DashboardCardState["NOT_LOADED"] = 1] = "NOT_LOADED";
    DashboardCardState[DashboardCardState["STALE"] = 2] = "STALE";
})(DashboardCardState || (DashboardCardState = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/dashboard-card-state.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/abstract-dashboard.store.ts



var abstract_dashboard_store_AbstractDashboardStore = (function () {
    function AbstractDashboardStore() {
        this.cardStateSubject = new BehaviorSubject["BehaviorSubject"](DashboardCardState.NOT_LOADED);
    }
    AbstractDashboardStore.prototype.beginLoad = function () {
        if (this.cardStateSubject.getValue() !== DashboardCardState.NOT_LOADED) {
            this.cardStateSubject.next(DashboardCardState.STALE);
        }
    };
    AbstractDashboardStore.prototype.endLoad = function () {
        this.cardStateSubject.next(DashboardCardState.LOADED);
    };
    Object.defineProperty(AbstractDashboardStore.prototype, "cardState", {
        get: function () {
            return this.cardStateSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AbstractDashboardStore.prototype.isStale = function () {
        return this.cardState.map(function (state) {
            return Boolean(state === DashboardCardState.STALE);
        });
    };
    AbstractDashboardStore.prototype.isLoading = function () {
        return this.cardState.map(function (state) {
            return Boolean(state === DashboardCardState.NOT_LOADED);
        });
    };
    AbstractDashboardStore.prototype.cardStateCssClass = function () {
        return Observable["Observable"].combineLatest(this.isStale(), this.isLoading()).map(function (values) {
            var stale = values[0], loading = values[1];
            var newClasses = '';
            if (stale) {
                newClasses += ' stale';
            }
            if (loading) {
                newClasses += ' loading';
            }
            return newClasses;
        });
    };
    AbstractDashboardStore.prototype.loadTotals = function () {
        var _this = this;
        this.beginLoad();
        return this.loadTotalsWithCardStateHandled()
            .map(function (totals) {
            _this.endLoad();
            return totals;
        });
    };
    return AbstractDashboardStore;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/abstract-dashboard.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/completed-unpaid-dashboard.store.ts
var completed_unpaid_dashboard_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var completed_unpaid_dashboard_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var completed_unpaid_dashboard_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore = (function (_super) {
    completed_unpaid_dashboard_store___extends(CompletedUnpaidDashboardStore, _super);
    function CompletedUnpaidDashboardStore(dashboardTotalsHttpService, flashMessagesService, authenticationStore, userLocalStorageService) {
        var _this = _super.call(this) || this;
        _this.dashboardTotalsHttpService = dashboardTotalsHttpService;
        _this.flashMessagesService = flashMessagesService;
        _this.authenticationStore = authenticationStore;
        _this.userLocalStorageService = userLocalStorageService;
        _this.completedAndUnpaidLessThan14DaysTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        _this.completedAndUnpaidBetween15And28DaysTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        _this.completedAndUnpaidGreaterThan28DaysTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        return _this;
    }
    CompletedUnpaidDashboardStore.prototype.showCard = function () {
        var _this = this;
        return this.authenticationStore.user.map(function (user) {
            var dashboardFilterState = _this.userLocalStorageService.getDashboardFilterState(user.email);
            return dashboardFilterState.completedAndUnpaid;
        });
    };
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "completedAndUnpaidTotal", {
        get: function () {
            return Observable["Observable"].combineLatest(this.lessThan14DaysTotal, this.between15And28DaysTotal, this.greaterThan28DaysTotal).map(function (latestValues) {
                return latestValues.reduce(function (previousTotal, currentTotal) { return previousTotal + currentTotal; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "lessThan14DaysTotal", {
        get: function () {
            return this.completedAndUnpaidLessThan14DaysTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "between15And28DaysTotal", {
        get: function () {
            return this.completedAndUnpaidBetween15And28DaysTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidDashboardStore.prototype, "greaterThan28DaysTotal", {
        get: function () {
            return this.completedAndUnpaidGreaterThan28DaysTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CompletedUnpaidDashboardStore.prototype.loadTotalsWithCardStateHandled = function () {
        var _this = this;
        return this.dashboardTotalsHttpService.getCompletedAndUnpaidCounts().catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_COMPLETED_UNPAID_TOTALS', "Error retrieving completed and unpaid totals: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (result) {
            result.map(function (eachBucket) {
                _this.setTotal(eachBucket);
            });
            return result;
        });
    };
    CompletedUnpaidDashboardStore.prototype.setTotal = function (bucket) {
        if (bucket.key === 'lessThan14DaysTotal') {
            this.completedAndUnpaidLessThan14DaysTotalSubject.next(bucket.totalEvents);
        }
        else if (bucket.key === 'between15And28DaysTotal') {
            this.completedAndUnpaidBetween15And28DaysTotalSubject.next(bucket.totalEvents);
        }
        else if (bucket.key === 'greaterThan28DaysTotal') {
            this.completedAndUnpaidGreaterThan28DaysTotalSubject.next(bucket.totalEvents);
        }
    };
    return CompletedUnpaidDashboardStore;
}(abstract_dashboard_store_AbstractDashboardStore));
completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore = completed_unpaid_dashboard_store___decorate([
    Object(core_es5["Injectable"])(),
    completed_unpaid_dashboard_store___metadata("design:paramtypes", [typeof (completed_unpaid_dashboard_store__a = typeof dashboard_totals_http_service_DashboardTotalsHttpService !== "undefined" && dashboard_totals_http_service_DashboardTotalsHttpService) === "function" && completed_unpaid_dashboard_store__a || Object, typeof (completed_unpaid_dashboard_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && completed_unpaid_dashboard_store__b || Object, typeof (completed_unpaid_dashboard_store__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && completed_unpaid_dashboard_store__c || Object, typeof (completed_unpaid_dashboard_store__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && completed_unpaid_dashboard_store__d || Object])
], completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore);

var completed_unpaid_dashboard_store__a, completed_unpaid_dashboard_store__b, completed_unpaid_dashboard_store__c, completed_unpaid_dashboard_store__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/completed-unpaid-dashboard.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/dashboard-util.ts
var DashboardUtils = (function () {
    function DashboardUtils() {
    }
    DashboardUtils.totalAsStringClampedTo99 = function (totalObs) {
        return totalObs.map(function (total) { return total >= 99 ? '99+' : String(total); });
    };
    return DashboardUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/dashboard-util.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/missing-agency-dashboard.store.ts
var missing_agency_dashboard_store___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var missing_agency_dashboard_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var missing_agency_dashboard_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var missing_agency_dashboard_store_MissingAgencyDashboardStore = (function (_super) {
    missing_agency_dashboard_store___extends(MissingAgencyDashboardStore, _super);
    function MissingAgencyDashboardStore(dashboardTotalsHttpService, flashMessagesService, authenticationStore, userLocalStorageService) {
        var _this = _super.call(this) || this;
        _this.dashboardTotalsHttpService = dashboardTotalsHttpService;
        _this.flashMessagesService = flashMessagesService;
        _this.authenticationStore = authenticationStore;
        _this.userLocalStorageService = userLocalStorageService;
        _this.missingAgencyTotalSubject = new BehaviorSubject["BehaviorSubject"](0);
        return _this;
    }
    MissingAgencyDashboardStore.prototype.showCard = function () {
        var _this = this;
        return this.authenticationStore.user.map(function (user) {
            var dashboardFilterState = _this.userLocalStorageService.getDashboardFilterState(user.email);
            return dashboardFilterState.missingAgency;
        });
    };
    Object.defineProperty(MissingAgencyDashboardStore.prototype, "missingAgencyTotal", {
        get: function () {
            return this.missingAgencyTotalSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    MissingAgencyDashboardStore.prototype.loadTotalsWithCardStateHandled = function () {
        var _this = this;
        return this.dashboardTotalsHttpService.getMissingAgencyCount().catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_MISSING_AGENCY_TOTALS', "Error retrieving missing agency totals: " + error);
            return Observable["Observable"].throw(error);
        }).map(function (missingAgencyTotal) {
            _this.missingAgencyTotalSubject.next(missingAgencyTotal);
            return missingAgencyTotal;
        });
    };
    return MissingAgencyDashboardStore;
}(abstract_dashboard_store_AbstractDashboardStore));
missing_agency_dashboard_store_MissingAgencyDashboardStore = missing_agency_dashboard_store___decorate([
    Object(core_es5["Injectable"])(),
    missing_agency_dashboard_store___metadata("design:paramtypes", [typeof (missing_agency_dashboard_store__a = typeof dashboard_totals_http_service_DashboardTotalsHttpService !== "undefined" && dashboard_totals_http_service_DashboardTotalsHttpService) === "function" && missing_agency_dashboard_store__a || Object, typeof (missing_agency_dashboard_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && missing_agency_dashboard_store__b || Object, typeof (missing_agency_dashboard_store__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && missing_agency_dashboard_store__c || Object, typeof (missing_agency_dashboard_store__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && missing_agency_dashboard_store__d || Object])
], missing_agency_dashboard_store_MissingAgencyDashboardStore);

var missing_agency_dashboard_store__a, missing_agency_dashboard_store__b, missing_agency_dashboard_store__c, missing_agency_dashboard_store__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/missing-agency-dashboard.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/predefined-search.service.ts
var predefined_search_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var predefined_search_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




/**
 * This class is used to store the predefined searches such as "missing agency" and "completed and unpaid"
 */
var predefined_search_service_PredefinedSearchService = (function () {
    function PredefinedSearchService(eventSearchParametersStore, eventMenuSearchFilterMapper) {
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventMenuSearchFilterMapper = eventMenuSearchFilterMapper;
    }
    PredefinedSearchService.prototype.missingAgencySearch = function () {
        var eventMenuSearchFilter = new EventMenuSearchFilter({
            eventStatusMissingAgency: true
        });
        this.eventSearchParametersStore.setDefaultViewSelected(true);
        this.navigate(eventMenuSearchFilter);
    };
    PredefinedSearchService.prototype.completedAndUnpaid = function () {
        var paymentStatus = new EventMenuSearchFilterPaymentStatus({
            unpaid: true,
            inProcess: false,
            paid: false
        });
        var eventMenuSearchFilter = new EventMenuSearchFilter({
            paymentStatus: paymentStatus,
            eventStatusCompleted: true
        });
        this.eventSearchParametersStore.setDefaultViewSelected(false);
        this.navigate(eventMenuSearchFilter);
    };
    /**
     * This method should be used by all predefined searches because it handles conversion and navigation
     *
     * @param {EventMenuSearchFilter} eventMenuSearchFilter
     */
    PredefinedSearchService.prototype.navigate = function (eventMenuSearchFilter) {
        // convert EventMenuSearchFilter to an OrderedSet
        var eventSearchFilterSet = this.eventMenuSearchFilterMapper.toSearchFilterSet(eventMenuSearchFilter);
        // update the search parameter store and navigate
        var updateUrl = true;
        this.eventSearchParametersStore.setFilterSet(eventSearchFilterSet, updateUrl);
    };
    return PredefinedSearchService;
}());
predefined_search_service_PredefinedSearchService = predefined_search_service___decorate([
    Object(core_es5["Injectable"])(),
    predefined_search_service___metadata("design:paramtypes", [typeof (predefined_search_service__a = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && predefined_search_service__a || Object, typeof (predefined_search_service__b = typeof event_menu_search_filter_mapper_EventMenuSearchFilterMapper !== "undefined" && event_menu_search_filter_mapper_EventMenuSearchFilterMapper) === "function" && predefined_search_service__b || Object])
], predefined_search_service_PredefinedSearchService);

var predefined_search_service__a, predefined_search_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/predefined-search.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/app-menu/app-menu.component.ts
var app_menu_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_menu_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var app_menu_component_AppMenuComponent = (function () {
    function AppMenuComponent(menuStore, router, eventSearchParametersStore, completedUnpaidStore, missingAgencyStore, predefinedSearchService) {
        this.menuStore = menuStore;
        this.router = router;
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.completedUnpaidStore = completedUnpaidStore;
        this.missingAgencyStore = missingAgencyStore;
        this.predefinedSearchService = predefinedSearchService;
    }
    AppMenuComponent.prototype.ngOnInit = function () {
        this.isNavCollapsed = this.menuStore.isNavCollapsed;
    };
    AppMenuComponent.prototype.toggleNavCollapsed = function () {
        this.isNavCollapsed = this.menuStore.toggleIsNavCollapsed();
    };
    /**
     * Matches the '/events' route
     * Matches the '/events?...' route
     * Does NOT match the '/events/add' route
     * @return {boolean}
     */
    AppMenuComponent.prototype.isOnSearchEvents = function () {
        return this.isUrlOnPath('/events') || this.isUrlOnPath('/events/financial');
    };
    AppMenuComponent.prototype.isOnDashboard = function () {
        return this.isUrlOnPath('/dashboard');
    };
    AppMenuComponent.prototype.isUrlOnPath = function (path) {
        var url = this.router.url;
        var indexOfQuestionMark = url.indexOf('?');
        // if there is a question mark in the url,
        //   then get the url up to the question mark
        if (indexOfQuestionMark >= 0) {
            url = url.substr(0, indexOfQuestionMark);
        }
        // check to see if on the events route
        return !!(url && url === (path));
    };
    AppMenuComponent.prototype.navigateToSearch = function () {
        this.eventSearchParametersStore.updateUrl();
    };
    Object.defineProperty(AppMenuComponent.prototype, "completedAndUnpaidTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.completedAndUnpaidTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppMenuComponent.prototype, "missingAgencyTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.missingAgencyStore.missingAgencyTotal);
        },
        enumerable: true,
        configurable: true
    });
    AppMenuComponent.prototype.showCompletedAndUnpaidTotals = function () {
        return Observable["Observable"].combineLatest(this.completedUnpaidStore.isLoading(), this.completedUnpaidStore.isStale()).map(function (values) {
            var loading = values[0], stale = values[1];
            return !Boolean(loading || stale);
        });
    };
    AppMenuComponent.prototype.showMissingAgencyTotals = function () {
        return Observable["Observable"].combineLatest(this.missingAgencyStore.isLoading(), this.missingAgencyStore.isStale()).map(function (values) {
            var loading = values[0], stale = values[1];
            return !Boolean(loading || stale);
        });
    };
    AppMenuComponent.prototype.missingAgencyPredefinedSearch = function () {
        this.predefinedSearchService.missingAgencySearch();
    };
    AppMenuComponent.prototype.completedAndUnpaidPredefinedSearch = function () {
        this.predefinedSearchService.completedAndUnpaid();
    };
    return AppMenuComponent;
}());
app_menu_component___decorate([
    Object(core_es5["HostBinding"])('class.left-nav'),
    app_menu_component___metadata("design:type", Object)
], app_menu_component_AppMenuComponent.prototype, "true", void 0);
app_menu_component___decorate([
    Object(core_es5["HostBinding"])('class.nav-collapsed'),
    app_menu_component___metadata("design:type", Object)
], app_menu_component_AppMenuComponent.prototype, "isNavCollapsed", void 0);
app_menu_component_AppMenuComponent = app_menu_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-app-menu',
        template: __webpack_require__("EqCs")
    }),
    app_menu_component___metadata("design:paramtypes", [typeof (app_menu_component__a = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && app_menu_component__a || Object, typeof (app_menu_component__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && app_menu_component__b || Object, typeof (app_menu_component__c = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && app_menu_component__c || Object, typeof (app_menu_component__d = typeof completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore !== "undefined" && completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore) === "function" && app_menu_component__d || Object, typeof (app_menu_component__e = typeof missing_agency_dashboard_store_MissingAgencyDashboardStore !== "undefined" && missing_agency_dashboard_store_MissingAgencyDashboardStore) === "function" && app_menu_component__e || Object, typeof (app_menu_component__f = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && app_menu_component__f || Object])
], app_menu_component_AppMenuComponent);

var app_menu_component__a, app_menu_component__b, app_menu_component__c, app_menu_component__d, app_menu_component__e, app_menu_component__f;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app-menu.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/attachment/attachment.http.service.ts
var attachment_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var attachment_http_service_AttachmentHttpService = (function () {
    function AttachmentHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
    }
    AttachmentHttpService.prototype.getForEvent = function (eventId) {
        return this.http.get(this.eventsUrl + "/" + eventId + "/attachments")
            .map(function (res) { return res.json(); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AttachmentHttpService.prototype.add = function (eventId, file) {
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(this.eventsUrl + "/" + eventId + "/attachments", formData)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AttachmentHttpService.prototype.get = function (uniqueId) {
        return this.http.get(this.eventsUrl + "/attachments/" + uniqueId)
            .map(function (resp) { return resp.text(); }).catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AttachmentHttpService.prototype.delete = function (uniqueId) {
        return this.http.delete(this.eventsUrl + "/attachments/" + uniqueId)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return AttachmentHttpService;
}());
attachment_http_service_AttachmentHttpService = attachment_http_service___decorate([
    Object(core_es5["Injectable"])(),
    attachment_http_service___metadata("design:paramtypes", [typeof (attachment_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && attachment_http_service__a || Object, typeof (attachment_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && attachment_http_service__b || Object])
], attachment_http_service_AttachmentHttpService);

var attachment_http_service__a, attachment_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/attachment.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/attachment/attachment.store.ts
var attachment_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var attachment_store_AttachmentStore = (function () {
    function AttachmentStore(attachmentHttpService, flashMessagesService) {
        this.attachmentHttpService = attachmentHttpService;
        this.flashMessagesService = flashMessagesService;
        this.currentAttachments = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
    }
    Object.defineProperty(AttachmentStore.prototype, "attachments", {
        get: function () {
            return this.currentAttachments.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AttachmentStore.prototype.loadAttachments = function (eventId) {
        this.getAttachments(eventId).subscribe();
    };
    AttachmentStore.prototype.getAttachments = function (eventId) {
        var _this = this;
        return this.attachmentHttpService.getForEvent(eventId)
            .catch(function (error) {
            // Catch error here so resolver also displays error.
            _this.flashMessagesService.error('MESSAGES.ERROR.GET_ATTACHMENTS', "Error retrieving attachments; " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (res) {
            _this.currentAttachments.next(Object(immutable["List"])(res));
            return res;
        });
    };
    AttachmentStore.prototype.addAttachment = function (eventId, file) {
        var _this = this;
        return this.attachmentHttpService.add(eventId, file)
            .map(function (res) {
            _this.loadAttachments(eventId);
            return res;
        });
    };
    AttachmentStore.prototype.deleteAttachment = function (eventId, uniqueId) {
        var _this = this;
        return this.attachmentHttpService.delete(uniqueId)
            .map(function (res) {
            _this.loadAttachments(eventId);
            return res;
        });
    };
    AttachmentStore.prototype.get = function (uniqueId) {
        return this.attachmentHttpService.get(uniqueId)
            .map(function (res) {
            window.open(res);
            return res;
        });
    };
    return AttachmentStore;
}());
attachment_store_AttachmentStore = attachment_store___decorate([
    Object(core_es5["Injectable"])(),
    attachment_store___metadata("design:paramtypes", [typeof (attachment_store__a = typeof attachment_http_service_AttachmentHttpService !== "undefined" && attachment_http_service_AttachmentHttpService) === "function" && attachment_store__a || Object, typeof (attachment_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && attachment_store__b || Object])
], attachment_store_AttachmentStore);

var attachment_store__a, attachment_store__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/attachment.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/attachment/attachment.resolver.ts
var attachment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var AttachmentResolver = (function () {
    function AttachmentResolver(attachmentStore, translateService) {
        this.attachmentStore = attachmentStore;
        this.translateService = translateService;
    }
    AttachmentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
        }
        return this.attachmentStore.getAttachments(id).first();
    };
    return AttachmentResolver;
}());
AttachmentResolver = attachment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    attachment_resolver___metadata("design:paramtypes", [typeof (attachment_resolver__a = typeof attachment_store_AttachmentStore !== "undefined" && attachment_store_AttachmentStore) === "function" && attachment_resolver__a || Object, typeof (attachment_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && attachment_resolver__b || Object])
], AttachmentResolver);

var attachment_resolver__a, attachment_resolver__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/attachment.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/rsvp/rsvp.component.ts
var rsvp_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var RsvpComponent = (function () {
    function RsvpComponent(eventStore) {
        this.eventStore = eventStore;
    }
    RsvpComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (event) { return _this.onyxEvent = event; });
    };
    return RsvpComponent;
}());
RsvpComponent = rsvp_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp',
        template: __webpack_require__("kD7v")
    }),
    rsvp_component___metadata("design:paramtypes", [typeof (rsvp_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && rsvp_component__a || Object])
], RsvpComponent);

var rsvp_component__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/rsvp.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/rsvp.ts
var rsvp___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RsvpRecord = Object(immutable["Record"])({
    eventRsvpId: null,
    eventId: null,
    firstName: null,
    lastName: null,
    nights: null,
    roomRate: null,
    revenue: null,
    commission: null
});
var Rsvp = (function (_super) {
    rsvp___extends(Rsvp, _super);
    function Rsvp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Rsvp;
}(RsvpRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/rsvp.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/rsvp.http.service.ts
var rsvp_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var rsvp_http_service_RsvpHttpService = (function () {
    function RsvpHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
    }
    RsvpHttpService.prototype.getRsvps = function (eventId) {
        return this.http.get(this.eventsUrl + "/" + eventId + "/rsvps")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (rsvpObject) { return new Rsvp(rsvpObject); })); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    RsvpHttpService.prototype.add = function (rsvp) {
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        var rsvpAsJSON = JSON.stringify(rsvp.toJS());
        return this.http.post(this.eventsUrl + "/rsvps", rsvpAsJSON, options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    RsvpHttpService.prototype.delete = function (rsvp) {
        return this.http.delete(this.eventsUrl + "/rsvps/" + rsvp.eventRsvpId)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    RsvpHttpService.prototype.importRsvpViaCsv = function (eventId, file) {
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(this.eventsUrl + "/" + eventId + "/rsvps/csv", formData)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return RsvpHttpService;
}());
rsvp_http_service_RsvpHttpService = rsvp_http_service___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_http_service___metadata("design:paramtypes", [typeof (rsvp_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && rsvp_http_service__a || Object, typeof (rsvp_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && rsvp_http_service__b || Object])
], rsvp_http_service_RsvpHttpService);

var rsvp_http_service__a, rsvp_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/rsvp.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/comparator-utils.ts
var ComparatorUtils = (function () {
    function ComparatorUtils() {
    }
    ComparatorUtils.isDefined = function (obj) {
        if (obj === null || typeof obj === 'undefined') {
            return false;
        }
        else {
            return true;
        }
    };
    ComparatorUtils.isUndefined = function (obj) {
        return !ComparatorUtils.isDefined(obj);
    };
    ComparatorUtils.compareNullable = function (obj1, obj2) {
        if (ComparatorUtils.isUndefined(obj1) && ComparatorUtils.isUndefined(obj2)) {
            return 0;
        }
        else if (ComparatorUtils.isDefined(obj1) && ComparatorUtils.isUndefined(obj2)) {
            return -1;
        }
        else if (ComparatorUtils.isUndefined(obj1) && ComparatorUtils.isDefined(obj2)) {
            return 1;
        }
        else {
            return 0;
        }
    };
    ComparatorUtils.compareString = function (string1, string2) {
        var nullCompare = ComparatorUtils.compareNullable(string1, string2);
        if (nullCompare !== 0) {
            return nullCompare;
        }
        else if (string1.toLowerCase() < string2.toLowerCase()) {
            return -1;
        }
        else if (string1.toLowerCase() > string2.toLowerCase()) {
            return 1;
        }
        else {
            return 0;
        }
    };
    ComparatorUtils.compareLastNameFirstName = function (fullName1, fullName2) {
        var nullCompare = ComparatorUtils.compareNullable(fullName1, fullName2);
        if (nullCompare !== 0) {
            return nullCompare;
        }
        var firstNameNullCompare = ComparatorUtils.compareNullable(fullName1.firstName, fullName2.firstName);
        if (firstNameNullCompare !== 0) {
            return firstNameNullCompare;
        }
        var lastNameNullCompare = ComparatorUtils.compareNullable(fullName1.lastName, fullName2.lastName);
        if (lastNameNullCompare !== 0) {
            return lastNameNullCompare;
        }
        if (ComparatorUtils.isDefined(fullName1.lastName) && ComparatorUtils.isDefined(fullName2.lastName)) {
            var lastNameCompare = ComparatorUtils.compareString(fullName1.lastName, fullName2.lastName);
            if (lastNameCompare !== 0) {
                return lastNameCompare;
            }
        }
        if (ComparatorUtils.isDefined(fullName1.firstName) && ComparatorUtils.isDefined(fullName2.firstName)) {
            var firstNameCompare = ComparatorUtils.compareString(fullName1.firstName, fullName2.firstName);
            if (firstNameCompare !== 0) {
                return firstNameCompare;
            }
        }
        return 0;
    };
    ComparatorUtils.compareRsvps = function (rsvp1, rsvp2) {
        return ComparatorUtils.compareLastNameFirstName({ firstName: rsvp1.firstName, lastName: rsvp1.lastName }, { firstName: rsvp2.firstName, lastName: rsvp2.lastName });
    };
    return ComparatorUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/comparator-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/rsvp.store.ts
var rsvp_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var rsvp_store_RsvpStore = (function () {
    function RsvpStore(rsvpHttpService, flashMessagesService) {
        this.rsvpHttpService = rsvpHttpService;
        this.flashMessagesService = flashMessagesService;
        this.rsvpSubject = new ReplaySubject["ReplaySubject"](1);
    }
    Object.defineProperty(RsvpStore.prototype, "rsvps", {
        get: function () {
            return this.rsvpSubject.asObservable().map(function (rsvpList) { return rsvpList.sort(function (rsvp1, rsvp2) { return ComparatorUtils.compareRsvps(rsvp1, rsvp2); }).toList(); });
        },
        enumerable: true,
        configurable: true
    });
    RsvpStore.prototype.loadRsvps = function (eventId) {
        var _this = this;
        return this.rsvpHttpService.getRsvps(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_RSVPS', "Error getting RSVPs: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (rsvpList) {
            _this.rsvpSubject.next(rsvpList);
            return rsvpList;
        });
    };
    Object.defineProperty(RsvpStore.prototype, "totalNights", {
        get: function () {
            return this.rsvps.map(function (rsvpList) {
                return rsvpList
                    .map(function (rsvp) { return rsvp.nights; })
                    .reduce(function (sum, current) { return !!current ? sum + current : sum; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpStore.prototype, "totalRevenue", {
        get: function () {
            return this.rsvps.map(function (rsvpList) {
                return rsvpList
                    .map(function (rsvp) { return rsvp.revenue; })
                    .reduce(function (sum, currentRevenue) { return !!currentRevenue ? sum + currentRevenue : sum; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpStore.prototype, "totalCommission", {
        get: function () {
            return this.rsvps.map(function (rsvpList) {
                return rsvpList
                    .map(function (rsvp) { return rsvp.commission; })
                    .reduce(function (sum, current) { return !!current ? sum + current : sum; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    RsvpStore.prototype.addRsvp = function (rsvp) {
        var _this = this;
        return this.rsvpHttpService.add(rsvp)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_RSVP', "Error adding rsvp: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.RSVPS.RSVP_ADDED');
            _this.loadRsvps(rsvp.eventId).subscribe();
            return result;
        });
    };
    RsvpStore.prototype.importRsvpViaCsv = function (eventId, file) {
        var _this = this;
        return this.rsvpHttpService
            .importRsvpViaCsv(eventId, file)
            .map(function (importResponse) {
            _this.loadRsvps(eventId).subscribe();
            return importResponse;
        });
    };
    RsvpStore.prototype.deleteRsvp = function (rsvp) {
        var _this = this;
        return this.rsvpHttpService.delete(rsvp)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_RSVP', "Error adding rsvp: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            _this.flashMessagesService.success('EVENT.RSVPS.RSVP_DELETED');
            _this.loadRsvps(rsvp.eventId).subscribe();
            return result;
        });
    };
    return RsvpStore;
}());
rsvp_store_RsvpStore = rsvp_store___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_store___metadata("design:paramtypes", [typeof (rsvp_store__a = typeof rsvp_http_service_RsvpHttpService !== "undefined" && rsvp_http_service_RsvpHttpService) === "function" && rsvp_store__a || Object, typeof (rsvp_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && rsvp_store__b || Object])
], rsvp_store_RsvpStore);

var rsvp_store__a, rsvp_store__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/rsvp.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/rsvp-list/rsvp-list.resolver.ts
var rsvp_list_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_list_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var RsvpListResolver = (function () {
    function RsvpListResolver(rsvpStore, translateService) {
        this.rsvpStore = rsvpStore;
        this.translateService = translateService;
    }
    RsvpListResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RSVPS'));
        }
        return this.rsvpStore.loadRsvps(route.params['id']).first();
    };
    return RsvpListResolver;
}());
RsvpListResolver = rsvp_list_resolver___decorate([
    Object(core_es5["Injectable"])(),
    rsvp_list_resolver___metadata("design:paramtypes", [typeof (rsvp_list_resolver__a = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && rsvp_list_resolver__a || Object, typeof (rsvp_list_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && rsvp_list_resolver__b || Object])
], RsvpListResolver);

var rsvp_list_resolver__a, rsvp_list_resolver__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/rsvp-list.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/reservation-compare-http-service.ts
var reservation_compare_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_compare_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var reservation_compare_http_service_ReservationCompareService = (function () {
    function ReservationCompareService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.eventUrl = this.environment.baseUrl + '/api/events';
    }
    ReservationCompareService.prototype.get = function (eventId) {
        var reservationUrl = this.eventUrl + "/" + eventId + "/compare";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return ReservationCompareService;
}());
reservation_compare_http_service_ReservationCompareService = reservation_compare_http_service___decorate([
    Object(core_es5["Injectable"])(),
    reservation_compare_http_service___metadata("design:paramtypes", [typeof (reservation_compare_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && reservation_compare_http_service__a || Object, typeof (reservation_compare_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && reservation_compare_http_service__b || Object])
], reservation_compare_http_service_ReservationCompareService);

var reservation_compare_http_service__a, reservation_compare_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-compare-http-service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/number.util.ts
var NumberUtils = (function () {
    function NumberUtils() {
    }
    NumberUtils.round2Fixed = function (value) {
        value = +value;
        if (isNaN(value)) {
            return NaN;
        }
        // Shift
        value = value.toString().split('e');
        value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + 2) : 2)));
        // Shift back
        value = value.toString().split('e');
        return Number((+(value[0] + 'e' + (value[1] ? (+value[1] - 2) : -2))).toFixed(2));
    };
    return NumberUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/number.util.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/reservation-utils.ts




var reservation_utils_ReservationUtils = (function () {
    function ReservationUtils() {
    }
    /**
     * Do not include reservation value when the reservation no longer has possible value.
     *
     * If the record has a status of No Show or Cancelled exclude reservations from the calculations.
     *
     * @param reservation
     * @returns {boolean}
     */
    ReservationUtils.hasReservationValue = function (reservation) {
        var value = reservation.status;
        if (value) {
            value = value.toUpperCase();
        }
        var returnValue = false;
        switch (value) {
            case ReservationStatusCode.CANCELLED.toString():
                returnValue = false;
                break;
            case ReservationStatusCode.NO_SHOW.toString():
                returnValue = false;
                break;
            default:
                returnValue = true;
        }
        return returnValue;
    };
    ReservationUtils.getCommissionRate = function (onyxEvent) {
        if (onyxEvent) {
            return onyxEvent.commissionRoomPercentage;
        }
        else {
            return 0;
        }
    };
    ReservationUtils.getRevenue = function (reservation) {
        if (this.hasReservationValue(reservation)) {
            return reservation.nights * reservation.roomRate;
        }
        else {
            return 0;
        }
    };
    ReservationUtils.getCommission = function (reservation, onyxEvent) {
        if (!this.hasReservationValue(reservation)) {
            return 0;
        }
        var revenue = reservation.revenue;
        if (!revenue) {
            revenue = this.getRevenue(reservation);
        }
        return (revenue * this.getCommissionRate(onyxEvent)) / 100;
    };
    ReservationUtils.reservationCompareComparator = function (obj1, obj2) {
        var compareValue = ComparatorUtils.compareNullable(obj1, obj2);
        if (compareValue !== 0 || (Object(util_util["isNullOrUndefined"])(obj1) && Object(util_util["isNullOrUndefined"])(obj2))) {
            return compareValue;
        }
        compareValue = ComparatorUtils.compareNullable(obj1.reservation, obj2.reservation);
        if (compareValue !== 0 || (Object(util_util["isNullOrUndefined"])(obj1.reservation) && Object(util_util["isNullOrUndefined"])(obj2.reservation))) {
            return compareValue;
        }
        return ComparatorUtils.compareLastNameFirstName({ firstName: obj1.reservation.firstName, lastName: obj1.reservation.lastName }, { firstName: obj2.reservation.firstName, lastName: obj2.reservation.lastName });
    };
    ReservationUtils.calculateRevenueTotal = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.revenue); })
                .map(function (compare) { return compare.reservation.revenue; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationUtils.calculateCommissionTotal = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.commission); })
                .map(function (compare) { return compare.reservation.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationUtils.calculateRsvpCommissionTotal = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.rsvp) && !Object(util_util["isNullOrUndefined"])(compare.rsvp.commission); })
                .map(function (compare) { return compare.rsvp.commission; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationUtils.calculateReservationTotalNights = function (obsReservationList) {
        return obsReservationList.map(function (compareList) {
            return compareList
                .filter(function (compare) { return !Object(util_util["isNullOrUndefined"])(compare.reservation) && !Object(util_util["isNullOrUndefined"])(compare.reservation.nights); })
                .map(function (compare) { return compare.reservation.nights; })
                .reduce(function (prev, current) { return prev + current; }, 0);
        });
    };
    ReservationUtils.isListEmpty = function (obsReservationList) {
        return ReservationUtils.getListSize(obsReservationList).map(function (compareListSize) { return compareListSize === 0; });
    };
    ReservationUtils.getListSize = function (obsReservationList) {
        return obsReservationList.map(function (compareList) { return compareList.size; });
    };
    ReservationUtils.onlyReservationsFilter = function (reservationList) {
        return reservationList.filter(function (compare) { return compare.reservation ? true : false; }).toList();
    };
    ReservationUtils.onlyRsvpFilter = function (reservationList) {
        return reservationList.filter(function (compare) { return compare.rsvp ? true : false; }).toList();
    };
    ReservationUtils.getNumberOfRsvps = function (obsReservationList) {
        var _this = this;
        return obsReservationList.map(function (compareList) {
            return (compareList ? _this.onlyRsvpFilter(compareList).size : 0);
        });
    };
    ReservationUtils.calculateCommission = function (revenue, commissionPercentage) {
        return revenue * commissionPercentage / 100;
    };
    return ReservationUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/reservation-compare-store.ts
var reservation_compare_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_compare_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var reservation_compare_store_ReservationCompareStore = ReservationCompareStore_1 = (function () {
    function ReservationCompareStore(flashMessagesService, reservationCompareService) {
        this.flashMessagesService = flashMessagesService;
        this.reservationCompareService = reservationCompareService;
        this.currentReservationList = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        this.currentActiveStatusCodes = new BehaviorSubject["BehaviorSubject"](ReservationCompareStore_1.STATUS_CODES);
        this.currentReservationSummaryState = new BehaviorSubject["BehaviorSubject"](true);
        this.selectedRsvpId = null;
        this.selectedReservationId = null;
    }
    ReservationCompareStore.prototype.setActiveStatusCodes = function (statusCodes) {
        this.currentActiveStatusCodes.next(statusCodes);
    };
    ReservationCompareStore.prototype.getActiveStatusCodes = function () {
        return this.currentActiveStatusCodes.asObservable().share();
    };
    ReservationCompareStore.prototype.getInstantActiveStatusCodes = function () {
        return this.currentActiveStatusCodes.getValue();
    };
    ReservationCompareStore.prototype.getReservationList = function () {
        return this.currentReservationList.asObservable();
    };
    ReservationCompareStore.prototype.getShowReservationSummary = function () {
        return this.currentReservationSummaryState.asObservable();
    };
    ReservationCompareStore.prototype.setShowReservationSummary = function (showSummary) {
        return this.currentReservationSummaryState.next(showSummary);
    };
    ReservationCompareStore.prototype.getReservations = function (eventId) {
        var _this = this;
        return this.reservationCompareService.get(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.RESERVATION_COMPARE', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            reservationList = reservationList.sort(reservation_utils_ReservationUtils.reservationCompareComparator).toList();
            _this.currentReservationList.next(reservationList);
            return reservationList;
        });
    };
    ReservationCompareStore.prototype.getFilteredReservations = function (eventId) {
        var _this = this;
        return this.getActiveStatusCodes().flatMap(function (statusCodes) {
            return _this.getReservations(eventId).map(function (reservationList) {
                return _this.getReservationListFilteredByStatus(reservationList, statusCodes);
            });
        });
    };
    ReservationCompareStore.prototype.getCurrentFilteredReservations = function () {
        var _this = this;
        return this.getActiveStatusCodes().flatMap(function (statusCodes) {
            return _this.getReservationList().map(function (reservationList) {
                return _this.getReservationListFilteredByStatus(reservationList, statusCodes);
            });
        });
    };
    ReservationCompareStore.prototype.getReservationListFilteredByStatus = function (reservationList, statusCodes) {
        return reservationList.filter(function (reservation) {
            return statusCodes.find(function (statusCode) { return statusCode.toString() === reservation.status; }) != null;
        }).toList();
    };
    ReservationCompareStore.prototype.resetStatusCodes = function () {
        this.setActiveStatusCodes(ReservationCompareStore_1.STATUS_CODES);
    };
    ReservationCompareStore.prototype.resetReservationList = function () {
        this.setReservationList(Object(immutable["List"])([]));
    };
    ReservationCompareStore.prototype.setReservationList = function (list) {
        this.currentReservationList.next(list);
    };
    ReservationCompareStore.prototype.isFilteredMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getCurrentFilteredReservations().map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        }));
    };
    ReservationCompareStore.prototype.isMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getReservationList().map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        }));
    };
    ReservationCompareStore.prototype.areRsvpsPresent = function () {
        return reservation_utils_ReservationUtils.getNumberOfRsvps(this.getReservationList()).map(function (size) {
            return size > 0;
        });
    };
    return ReservationCompareStore;
}());
reservation_compare_store_ReservationCompareStore.STATUS_CODES = [
    ReservationStatusCode.RSVP,
    ReservationStatusCode.RESERVED,
    ReservationStatusCode.NO_SHOW,
    ReservationStatusCode.CANCELLED,
    ReservationStatusCode.CHECKED_OUT,
    ReservationStatusCode.CHECKED_IN
];
reservation_compare_store_ReservationCompareStore = ReservationCompareStore_1 = reservation_compare_store___decorate([
    Object(core_es5["Injectable"])(),
    reservation_compare_store___metadata("design:paramtypes", [typeof (reservation_compare_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && reservation_compare_store__a || Object, typeof (reservation_compare_store__b = typeof reservation_compare_http_service_ReservationCompareService !== "undefined" && reservation_compare_http_service_ReservationCompareService) === "function" && reservation_compare_store__b || Object])
], reservation_compare_store_ReservationCompareStore);

var ReservationCompareStore_1, reservation_compare_store__a, reservation_compare_store__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-compare-store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-page/reservation-page.component.ts
var reservation_page_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_page_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var reservation_page_component_ReservationPageComponent = (function () {
    function ReservationPageComponent(eventStore, reservationCompareStore) {
        this.eventStore = eventStore;
        this.reservationCompareStore = reservationCompareStore;
    }
    ReservationPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.eventStore.selectedEvent.subscribe(function (event) {
            _this.onyxEvent = new OnyxEvent(event);
        });
    };
    ReservationPageComponent.prototype.getSummarySelected = function () {
        return this.reservationCompareStore.getShowReservationSummary();
    };
    return ReservationPageComponent;
}());
reservation_page_component_ReservationPageComponent = reservation_page_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-page',
        template: __webpack_require__("Mz5u")
    }),
    reservation_page_component___metadata("design:paramtypes", [typeof (reservation_page_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && reservation_page_component__a || Object, typeof (reservation_page_component__b = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_page_component__b || Object])
], reservation_page_component_ReservationPageComponent);

var reservation_page_component__a, reservation_page_component__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-page.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation.compare.resolver.ts
var reservation_compare_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_compare_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var reservation_compare_resolver_ReservationCompareResolver = (function () {
    function ReservationCompareResolver(reservationCompareStore, translateService, logService, router) {
        var _this = this;
        this.reservationCompareStore = reservationCompareStore;
        this.translateService = translateService;
        this.logService = logService;
        this.router = router;
        this.previousRoute = null;
        // This code is required in order to know the previous route in resolve.
        // Note that first the NavigationStart event will happen, then resolve() is called if the resolver is attached
        // to the route, then NavigationEnd happens.
        this.router.events
            .filter(function (e) { return e instanceof router_es5["NavigationEnd"]; })
            .subscribe(function (e) {
            _this.previousRoute = e.url;
        });
    }
    ReservationCompareResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.RESERVATION_COMPARE'));
        }
        // Reset the filters unless the last route was reservations summary or detail
        // Note that this resolve happens before the NavigationEnd event for the route we're about to go to,
        // so we can find the last route that was navigated to successfully by checking the last NavigationEnd event.
        if (this.previousRoute && !this.previousRoute.includes("/" + id + "/reservations")) {
            this.reservationCompareStore.resetStatusCodes();
        }
        this.reservationCompareStore.selectedRsvpId = Number(route.queryParams['rsvp']);
        this.reservationCompareStore.selectedReservationId = Number(route.queryParams['reservation']);
        var path = route.url.map(function (urlSegment) { return urlSegment.path; }).join('/');
        this.logService.info('router URL path ends with /detail: ' + path.endsWith('/detail'));
        this.reservationCompareStore.setShowReservationSummary(!path.endsWith('/detail'));
        return this.reservationCompareStore.getReservations(route.params['id']);
    };
    return ReservationCompareResolver;
}());
reservation_compare_resolver_ReservationCompareResolver = reservation_compare_resolver___decorate([
    Object(core_es5["Injectable"])(),
    reservation_compare_resolver___metadata("design:paramtypes", [typeof (reservation_compare_resolver__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_compare_resolver__a || Object, typeof (reservation_compare_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_compare_resolver__b || Object, typeof (reservation_compare_resolver__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_compare_resolver__c || Object, typeof (reservation_compare_resolver__d = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && reservation_compare_resolver__d || Object])
], reservation_compare_resolver_ReservationCompareResolver);

var reservation_compare_resolver__a, reservation_compare_resolver__b, reservation_compare_resolver__c, reservation_compare_resolver__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation.compare.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/adjustment.ts
var adjustment___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AdjustmentRecord = Object(immutable["Record"])({
    eventAdjustmentId: null,
    eventId: null,
    adjustmentAmount: 0,
    adjustmentType: null,
    createdDate: null
});
var Adjustment = (function (_super) {
    adjustment___extends(Adjustment, _super);
    function Adjustment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Adjustment;
}(AdjustmentRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/adjustment.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/adjustment.http.service.ts
var adjustment_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var adjustment_http_service_AdjustmentHttpService = (function () {
    function AdjustmentHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.eventsUrl = this.environment.baseUrl + '/api/events';
        this.adjustmentUrl = this.eventsUrl + '/adjustments';
    }
    AdjustmentHttpService.prototype.addAdjustment = function (adjustment) {
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.adjustmentUrl, JSON.stringify(adjustment.toJS()), options)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AdjustmentHttpService.prototype.getAdjustments = function (eventId) {
        return this.http.get(this.eventsUrl + "/" + eventId + "/adjustments")
            .map(function (response) { return Object(immutable["List"])(response.json().map(function (element) { return new Adjustment(element); })); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    AdjustmentHttpService.prototype.deleteAdjustment = function (adjustmentId) {
        var url = this.adjustmentUrl + "/" + adjustmentId;
        return this.http.delete(url)
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return AdjustmentHttpService;
}());
adjustment_http_service_AdjustmentHttpService = adjustment_http_service___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_http_service___metadata("design:paramtypes", [typeof (adjustment_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && adjustment_http_service__a || Object, typeof (adjustment_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && adjustment_http_service__b || Object])
], adjustment_http_service_AdjustmentHttpService);

var adjustment_http_service__a, adjustment_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/adjustment.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/reservation-http-service.ts
var reservation_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var reservation_http_service_ReservationService = (function () {
    function ReservationService(http, eventStore, environment) {
        var _this = this;
        this.http = http;
        this.eventStore = eventStore;
        this.environment = environment;
        this.eventUrl = this.environment.baseUrl + '/api/events';
        eventStore.selectedEvent.map(function (event) { return _this.selectedEvent = event; });
    }
    ReservationService.prototype.get = function (eventId) {
        var reservationUrl = this.eventUrl + "/" + eventId + "/reservations/consumed";
        return this.http.get(reservationUrl)
            .map(function (res) { return Object(immutable["List"])(res.json()); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage).share();
    };
    return ReservationService;
}());
reservation_http_service_ReservationService = reservation_http_service___decorate([
    Object(core_es5["Injectable"])(),
    reservation_http_service___metadata("design:paramtypes", [typeof (reservation_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && reservation_http_service__a || Object, typeof (reservation_http_service__b = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && reservation_http_service__b || Object, typeof (reservation_http_service__c = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && reservation_http_service__c || Object])
], reservation_http_service_ReservationService);

var reservation_http_service__a, reservation_http_service__b, reservation_http_service__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-http-service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/room-type-rate-summary.ts
var room_type_rate_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RoomTypeRateSummaryRecord = Object(immutable["Record"])({
    roomType: null,
    roomRate: null,
    totalNights: 0,
    totalRevenue: 0
});
var RoomTypeRateSummary = (function (_super) {
    room_type_rate_summary___extends(RoomTypeRateSummary, _super);
    function RoomTypeRateSummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RoomTypeRateSummary;
}(RoomTypeRateSummaryRecord));

/**
 * RoomTypeRateSummary has multiple fields
 * This method defines sort algorithm for List<RoomTypeRateSummary>
 *
 * 1. Sort by room type. e.g king, queen, etc
 * 2. If room types are equal:
 *    - Sort by room rate
 *
 * Returns a number bc that is what is used for immutable-js list sort
 *
 * immutable-js List sort()
 * https://facebook.github.io/immutable-js/docs/#/List/sort
 *
 * @param a {RoomTypeRateSummary}
 * @param b {RoomTypeRateSummary}
 * @returns number
 */
var RoomTypeRateSummarySort = function (a, b) {
    // check if roomType is equal
    if (a.roomType.localeCompare(b.roomType) !== 0) {
        return a.roomType.localeCompare(b.roomType);
    }
    // fallback: sort by roomRate and cast to number for
    // immutable-js sort
    return a.roomRate < b.roomRate ? -1 : 1;
};
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/room-type-rate-summary.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/stay-summary.ts
var stay_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var StaySummaryRecord = Object(immutable["Record"])({
    totalNights: 0,
    totalRevenue: 0
});
var StaySummary = (function (_super) {
    stay_summary___extends(StaySummary, _super);
    function StaySummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StaySummary;
}(StaySummaryRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/stay-summary.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/room-stay-summary.ts
var room_stay_summary___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RoomStaySummaryRecord = Object(immutable["Record"])({
    roomTypeRateSummaryList: null,
    staySummary: null
});
var RoomStaySummary = (function (_super) {
    room_stay_summary___extends(RoomStaySummary, _super);
    function RoomStaySummary() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RoomStaySummary;
}(RoomStaySummaryRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/room-stay-summary.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/reservation-store.ts
var reservation_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var reservation_store_ReservationStore = (function () {
    function ReservationStore(flashMessagesService, reservationHttpService, eventStore) {
        this.flashMessagesService = flashMessagesService;
        this.reservationHttpService = reservationHttpService;
        this.eventStore = eventStore;
        this.currentReservations = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        this.currentRoomSummary = new BehaviorSubject["BehaviorSubject"](Object(immutable["List"])([]));
        this.currentStaySummary = new BehaviorSubject["BehaviorSubject"](null);
    }
    Object.defineProperty(ReservationStore.prototype, "reservations", {
        get: function () {
            return this.currentReservations.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReservationStore.prototype, "roomSummary", {
        get: function () {
            return this.currentRoomSummary.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReservationStore.prototype, "staySummary", {
        get: function () {
            return this.currentStaySummary.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Has to be called to retrieve reservations.
     * Is called by resolver.
     *
     * @param eventId
     * @returns RESERVATION_LIST
     */
    ReservationStore.prototype.getReservations = function (eventId) {
        var _this = this;
        return this.reservationHttpService.get(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COMMISSION.ROOM_DETAIL', "Error retrieving room details: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (reservationList) {
            _this.currentReservations.next(reservationList);
            var summary = _this.transformReservationsToSummary(reservationList);
            _this.currentRoomSummary.next(summary.roomTypeRateSummaryList);
            _this.currentStaySummary.next(summary.staySummary);
            return reservationList;
        });
    };
    /**
     * Filters reservation list by a status code
     * e.g. checked out
     *
     * @param statusCode
     * @returns {Observable<List<Reservation>>}
     */
    ReservationStore.prototype.getReservationListFilteredByStatus = function (statusCode) {
        return this.currentReservations.asObservable().map(function (reservationList) {
            return reservationList.filter(function (reservation) {
                return reservation.status === statusCode.toString();
            }).toList();
        });
    };
    /**
     * Gets the filtered reservation list by status code and transforms the list into a room stay summary
     *
     * @param statusCode{ReservationStatusCode}
     * @returns {Observable<StaySummary>}
     */
    ReservationStore.prototype.getRoomStaySummaryFilteredByStatus = function (statusCode) {
        var _this = this;
        return this.getReservationListFilteredByStatus(statusCode).map(function (reservationList) {
            return _this.transformReservationsToSummary(reservationList);
        });
    };
    ReservationStore.prototype.getTotalCommissions = function (reservationStatusCode) {
        var _this = this;
        var commissionPercentage = null;
        return this.eventStore.selectedEvent.flatMap(function (event) {
            commissionPercentage = event.commissionRoomPercentage;
            return _this.getRoomStaySummaryFilteredByStatus(reservationStatusCode);
        }).map(function (summary) {
            var staySummary = summary.staySummary;
            var totalRevenue = staySummary.totalRevenue;
            var totalCommission = reservation_utils_ReservationUtils.calculateCommission(totalRevenue, commissionPercentage);
            return totalCommission;
        });
    };
    /**
     * Transforms a list of Reservations into a RoomStaySummary object
     * Contains a stay summary and a room summary
     *
     * Immutable JS doc on groupBy
     * https://facebook.github.io/immutable-js/docs/#/List/groupBy
     *
     * @param reservations {List<Reservation>}
     * @returns RoomStaySummary
     */
    ReservationStore.prototype.transformReservationsToSummary = function (reservations) {
        var _this = this;
        var staySummary = new StaySummary();
        var roomTypeRateSummaryList = Object(immutable["List"])([]);
        // create lists of Reservations grouped by type and rate
        var listOfReservationsGroupedByTypeAndRate = Object(immutable["List"])([]);
        // this has to be re-created as a list or else groupBy is not available
        Object(immutable["List"])(reservations).groupBy(function (roomTypeGroup) { return roomTypeGroup.roomType; })
            .forEach(function (roomTypeGroup) {
            roomTypeGroup
                .groupBy(function (roomRateGroup) { return roomRateGroup.roomRate; })
                .forEach(function (roomRateGroup) {
                listOfReservationsGroupedByTypeAndRate = listOfReservationsGroupedByTypeAndRate.push(roomRateGroup.toList());
            });
        });
        // iterate through each list (grouped by type and rate)
        // and generate a room summary
        listOfReservationsGroupedByTypeAndRate.forEach(function (roomTypeAndRateGroup) {
            var roomTypeRateSummary = _this.transformReservationListToRoomSummary(roomTypeAndRateGroup);
            // updating stay summary totals each iteration
            staySummary = new StaySummary({
                totalNights: staySummary.totalNights + roomTypeRateSummary.totalNights,
                totalRevenue: staySummary.totalRevenue + roomTypeRateSummary.totalRevenue
            });
            // adding room type and rate summary to list
            roomTypeRateSummaryList = roomTypeRateSummaryList.push(roomTypeRateSummary);
        });
        // build the room stay Summary
        return new RoomStaySummary({
            roomTypeRateSummaryList: roomTypeRateSummaryList.sort(RoomTypeRateSummarySort).toList(),
            staySummary: staySummary
        });
    };
    /**
     * Transforms a list of reservations into a RoomTypeRateSummary
     *
     * @param roomList {List<Reservation>}
     * @returns RoomTypeRateSummary
     */
    ReservationStore.prototype.transformReservationListToRoomSummary = function (roomList) {
        var roomTypeRateSummary = new RoomTypeRateSummary();
        roomList.forEach(function (room) {
            roomTypeRateSummary = new RoomTypeRateSummary({
                roomType: room.roomType,
                roomRate: room.roomRate,
                totalNights: roomTypeRateSummary.totalNights + room.nights,
                totalRevenue: roomTypeRateSummary.totalRevenue + (room.roomRate * room.nights)
            });
        });
        return roomTypeRateSummary;
    };
    return ReservationStore;
}());
reservation_store_ReservationStore = reservation_store___decorate([
    Object(core_es5["Injectable"])(),
    reservation_store___metadata("design:paramtypes", [typeof (reservation_store__a = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && reservation_store__a || Object, typeof (reservation_store__b = typeof reservation_http_service_ReservationService !== "undefined" && reservation_http_service_ReservationService) === "function" && reservation_store__b || Object, typeof (reservation_store__c = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && reservation_store__c || Object])
], reservation_store_ReservationStore);

var reservation_store__a, reservation_store__b, reservation_store__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/adjustment.store.ts
var adjustment_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var adjustment_store_AdjustmentStore = (function () {
    function AdjustmentStore(adjustmentHttpService, flashMessagesService, reservationStore) {
        this.adjustmentHttpService = adjustmentHttpService;
        this.flashMessagesService = flashMessagesService;
        this.reservationStore = reservationStore;
        this.adjustmentList = new ReplaySubject["ReplaySubject"](1);
    }
    AdjustmentStore.prototype.addAdjustment = function (adjustment) {
        var _this = this;
        return this.adjustmentHttpService.addAdjustment(adjustment)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.ADD_ADJUSTMENT', "Error adding adjustment: " + error);
            return Observable["Observable"].throw(error);
        });
    };
    Object.defineProperty(AdjustmentStore.prototype, "adjustments", {
        get: function () {
            return this.adjustmentList.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AdjustmentStore.prototype.loadAdjustments = function (eventId) {
        var _this = this;
        return this.adjustmentHttpService.getAdjustments(eventId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.COULD_NOT_GET_PAYMENTS', "Error getting adjustments: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (result) {
            var sortedIterable = result.sort(function (adjustment1, adjustment2) {
                if (adjustment1.createdDate < adjustment2.createdDate) {
                    return -1;
                }
                else if (adjustment1.createdDate > adjustment2.createdDate) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
            _this.adjustmentList.next(sortedIterable.toList());
            return result;
        });
    };
    AdjustmentStore.prototype.deleteAdjustment = function (adjustmentId, eventId) {
        var _this = this;
        return this.adjustmentHttpService.deleteAdjustment(adjustmentId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_ADJUSTMENT', "Error deleting adjustment: " + error);
            return Observable["Observable"].of(error);
        })
            .map(function (res) {
            _this.loadAdjustments(eventId).subscribe();
            return res;
        });
    };
    AdjustmentStore.prototype.getCalculatedPayment = function (reservationStatusCode) {
        var _this = this;
        var totalCommissions = 0;
        return this.reservationStore.getTotalCommissions(reservationStatusCode).flatMap(function (total) {
            totalCommissions = total;
            return _this.adjustments;
        }).map(function (list) {
            var adjustmentTotal = list.reduce(function (sum, adjustment) {
                return sum + adjustment.adjustmentAmount;
            }, 0);
            return adjustmentTotal + totalCommissions;
        });
    };
    return AdjustmentStore;
}());
adjustment_store_AdjustmentStore = adjustment_store___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_store___metadata("design:paramtypes", [typeof (adjustment_store__a = typeof adjustment_http_service_AdjustmentHttpService !== "undefined" && adjustment_http_service_AdjustmentHttpService) === "function" && adjustment_store__a || Object, typeof (adjustment_store__b = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && adjustment_store__b || Object, typeof (adjustment_store__c = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && adjustment_store__c || Object])
], adjustment_store_AdjustmentStore);

var adjustment_store__a, adjustment_store__b, adjustment_store__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/adjustment.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/adjustment.resolver.ts
var adjustment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var adjustment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var AdjustmentResolver = (function () {
    function AdjustmentResolver(adjustmentStore, translateService) {
        this.adjustmentStore = adjustmentStore;
        this.translateService = translateService;
    }
    AdjustmentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
        }
        return this.adjustmentStore.loadAdjustments(route.params['id']).first();
    };
    return AdjustmentResolver;
}());
AdjustmentResolver = adjustment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    adjustment_resolver___metadata("design:paramtypes", [typeof (adjustment_resolver__a = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && adjustment_resolver__a || Object, typeof (adjustment_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && adjustment_resolver__b || Object])
], AdjustmentResolver);

var adjustment_resolver__a, adjustment_resolver__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/adjustment.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/reservation.resolver.ts
var reservation_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var ReservationResolver = (function () {
    function ReservationResolver(reservationStore, translateService) {
        this.reservationStore = reservationStore;
        this.translateService = translateService;
    }
    ReservationResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_RESERVATIONS'));
        }
        return this.reservationStore.getReservations(route.params['id']);
    };
    return ReservationResolver;
}());
ReservationResolver = reservation_resolver___decorate([
    Object(core_es5["Injectable"])(),
    reservation_resolver___metadata("design:paramtypes", [typeof (reservation_resolver__a = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && reservation_resolver__a || Object, typeof (reservation_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_resolver__b || Object])
], ReservationResolver);

var reservation_resolver__a, reservation_resolver__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/latest-payment.resolver.ts
var latest_payment_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var latest_payment_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var LatestPaymentResolver = (function () {
    function LatestPaymentResolver(translateService, paymentStore) {
        this.translateService = translateService;
        this.paymentStore = paymentStore;
    }
    LatestPaymentResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_LATEST_PAYMENT'));
        }
        return this.paymentStore.loadLatestPayment(id);
    };
    return LatestPaymentResolver;
}());
LatestPaymentResolver = latest_payment_resolver___decorate([
    Object(core_es5["Injectable"])(),
    latest_payment_resolver___metadata("design:paramtypes", [typeof (latest_payment_resolver__a = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && latest_payment_resolver__a || Object, typeof (latest_payment_resolver__b = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && latest_payment_resolver__b || Object])
], LatestPaymentResolver);

var latest_payment_resolver__a, latest_payment_resolver__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/latest-payment.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payments.resolver.ts
var payments_resolver___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payments_resolver___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var PaymentsResolver = (function () {
    function PaymentsResolver(paymentStore, translateService) {
        this.paymentStore = paymentStore;
        this.translateService = translateService;
    }
    PaymentsResolver.prototype.resolve = function (route, state) {
        var id = route.params['id'];
        if (!id) {
            throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
        }
        return this.paymentStore.loadPayments(id).first();
    };
    return PaymentsResolver;
}());
PaymentsResolver = payments_resolver___decorate([
    Object(core_es5["Injectable"])(),
    payments_resolver___metadata("design:paramtypes", [typeof (payments_resolver__a = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && payments_resolver__a || Object, typeof (payments_resolver__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payments_resolver__b || Object])
], PaymentsResolver);

var payments_resolver__a, payments_resolver__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payments.resolver.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard.component.ts
var dashboard_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dashboard_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var dashboard_component_DashboardComponent = (function () {
    function DashboardComponent(menuStore, completedUnpaidDashboardStore, missingAgencyDashboardStore, userLocalStorageService, authenticationStore) {
        this.menuStore = menuStore;
        this.completedUnpaidDashboardStore = completedUnpaidDashboardStore;
        this.missingAgencyDashboardStore = missingAgencyDashboardStore;
        this.userLocalStorageService = userLocalStorageService;
        this.authenticationStore = authenticationStore;
    }
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuStore.setPageTitle('DASHBOARD.TITLE');
        this.showCompletedAndUnpaid = true;
        this.showMissingAgency = true;
        this.completedUnpaidDashboardStore.loadTotals().subscribe();
        this.missingAgencyDashboardStore.loadTotals().subscribe();
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
        this.completedUnpaidDashboardStore.showCard().subscribe(function (bool) {
            _this.showCompletedAndUnpaid = bool;
        });
        this.missingAgencyDashboardStore.showCard().subscribe(function (bool) {
            _this.showMissingAgency = bool;
        });
    };
    DashboardComponent.prototype.toggleShowCompletedAndUnpaid = function () {
        this.showCompletedAndUnpaid = !this.showCompletedAndUnpaid;
        this.saveDashboardStateToLocalStorage();
    };
    DashboardComponent.prototype.toggleShowMissingAgency = function () {
        this.showMissingAgency = !this.showMissingAgency;
        this.saveDashboardStateToLocalStorage();
    };
    DashboardComponent.prototype.saveDashboardStateToLocalStorage = function () {
        var dashboardFilters = new DashboardFilterState({
            completedAndUnpaid: this.showCompletedAndUnpaid,
            missingAgency: this.showMissingAgency
        });
        var email = this.user.email;
        this.userLocalStorageService.setDashboardFilterState(email, dashboardFilters);
    };
    return DashboardComponent;
}());
dashboard_component_DashboardComponent = dashboard_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-dashboard',
        template: __webpack_require__("Cww6")
    }),
    dashboard_component___metadata("design:paramtypes", [typeof (dashboard_component__a = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && dashboard_component__a || Object, typeof (dashboard_component__b = typeof completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore !== "undefined" && completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore) === "function" && dashboard_component__b || Object, typeof (dashboard_component__c = typeof missing_agency_dashboard_store_MissingAgencyDashboardStore !== "undefined" && missing_agency_dashboard_store_MissingAgencyDashboardStore) === "function" && dashboard_component__c || Object, typeof (dashboard_component__d = typeof user_local_storage_service_UserLocalStorageService !== "undefined" && user_local_storage_service_UserLocalStorageService) === "function" && dashboard_component__d || Object, typeof (dashboard_component__e = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && dashboard_component__e || Object])
], dashboard_component_DashboardComponent);

var dashboard_component__a, dashboard_component__b, dashboard_component__c, dashboard_component__d, dashboard_component__e;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/dashboard.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-can-deactive.ts
var reservation_detail_can_deactive___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_detail_can_deactive___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};


var CanDeactiveReservationDetailTable = (function () {
    function CanDeactiveReservationDetailTable(reservationCompareStore) {
        this.reservationCompareStore = reservationCompareStore;
    }
    CanDeactiveReservationDetailTable.prototype.canDeactivate = function (component, currentRoute, currentState, nextState) {
        this.reservationCompareStore.setShowReservationSummary(true);
        return true;
    };
    return CanDeactiveReservationDetailTable;
}());
CanDeactiveReservationDetailTable = reservation_detail_can_deactive___decorate([
    Object(core_es5["Injectable"])(),
    reservation_detail_can_deactive___metadata("design:paramtypes", [typeof (reservation_detail_can_deactive__a = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_detail_can_deactive__a || Object])
], CanDeactiveReservationDetailTable);

var reservation_detail_can_deactive__a;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-detail-can-deactive.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event.routes.ts





















var event_routes_routes = [
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
    },
    {
        path: 'dashboard',
        canActivate: [CanActivateViaAuthGuard],
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent
            },
            {
                path: '',
                component: dashboard_component_DashboardComponent
            }
        ]
    },
    {
        path: 'events',
        canActivate: [CanActivateViaAuthGuard],
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent
            },
            {
                path: '',
                component: event_list_component_EventListComponent,
                resolve: {
                    eventsData: events_resolver_EventsResolver
                },
                runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                data: { view: 'default' }
            },
            {
                path: 'financial',
                component: event_list_component_EventListComponent,
                resolve: {
                    eventsData: events_resolver_EventsResolver
                },
                runGuardsAndResolvers: 'paramsOrQueryParamsChange',
                data: { view: 'financial' }
            },
            {
                path: 'add',
                component: add_event_component_AddEventComponent,
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['addevent'] }
            }
        ]
    },
    {
        path: 'event/:id',
        canActivate: [CanActivateViaAuthGuard],
        resolve: {
            eventsData: EventResolver
        },
        children: [
            {
                path: '',
                outlet: 'navigation',
                component: app_menu_component_AppMenuComponent,
                children: [
                    {
                        path: '',
                        component: event_menu_component_EventMenuComponent,
                        outlet: 'event'
                    }
                ]
            },
            {
                path: '',
                component: event_component_EventComponent,
                resolve: {
                    attachmentData: AttachmentResolver
                }
            },
            {
                path: 'edit',
                component: event_component_EventComponent,
                resolve: {
                    attachmentData: AttachmentResolver
                },
                canActivate: [PermissionGuard],
                data: { allowedPermissions: ['editevent'] }
            },
            {
                path: 'commission',
                component: commission_component_CommissionComponent,
                resolve: {
                    reservationData: ReservationResolver,
                    adjustmentData: AdjustmentResolver,
                    latestPaymentData: LatestPaymentResolver,
                    paymentsData: PaymentsResolver
                }
            },
            {
                path: 'rsvp',
                component: RsvpComponent,
                resolve: {
                    rsvpData: RsvpListResolver
                }
            },
            {
                path: 'reservations',
                component: reservation_page_component_ReservationPageComponent,
                resolve: {
                    reservations: reservation_compare_resolver_ReservationCompareResolver
                }
            },
            {
                path: 'reservations/detail',
                component: reservation_page_component_ReservationPageComponent,
                resolve: {
                    reservations: reservation_compare_resolver_ReservationCompareResolver
                },
                canDeactivate: [CanDeactiveReservationDetailTable]
            }
        ]
    }
];
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event.routes.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-list/event-list-default-table/event-list-default-table.component.ts
var event_list_default_table_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_default_table_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var EventListDefaultTableComponent = (function () {
    function EventListDefaultTableComponent(eventListStore, environment, router) {
        this.eventListStore = eventListStore;
        this.environment = environment;
        this.router = router;
    }
    EventListDefaultTableComponent.prototype.ngOnInit = function () {
        this.data = this.eventListStore.events;
    };
    Object.defineProperty(EventListDefaultTableComponent.prototype, "events", {
        get: function () {
            return this.data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListDefaultTableComponent.prototype, "eventCount", {
        get: function () {
            return this.eventListStore.totalEventCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListDefaultTableComponent.prototype, "eventCountForTranslate", {
        get: function () {
            return this.eventCount.map(function (count) {
                return {
                    eventCount: count
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListDefaultTableComponent.prototype, "eventsAboveMax", {
        get: function () {
            var _this = this;
            return this.eventCount.map(function (eventCount) {
                return eventCount > _this.maxEvents;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListDefaultTableComponent.prototype, "eventsPresent", {
        get: function () {
            return this.eventCount.map(function (eventCount) {
                return eventCount > 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListDefaultTableComponent.prototype, "maxEvents", {
        get: function () {
            return this.environment.events.maxEvents;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListDefaultTableComponent.prototype, "maxEventsForTranslate", {
        get: function () {
            return {
                maxEvents: this.maxEvents
            };
        },
        enumerable: true,
        configurable: true
    });
    EventListDefaultTableComponent.prototype.onSelect = function (event) {
        this.router.navigate(['/event', event.eventId]);
    };
    return EventListDefaultTableComponent;
}());
EventListDefaultTableComponent = event_list_default_table_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-list-default-table',
        template: __webpack_require__("lOyP")
    }),
    event_list_default_table_component___metadata("design:paramtypes", [typeof (event_list_default_table_component__a = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && event_list_default_table_component__a || Object, typeof (event_list_default_table_component__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_default_table_component__b || Object, typeof (event_list_default_table_component__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_list_default_table_component__c || Object])
], EventListDefaultTableComponent);

var event_list_default_table_component__a, event_list_default_table_component__b, event_list_default_table_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-list-default-table.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-list/event-list-financial-table/event-list-financial.component.ts
var event_list_financial_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_list_financial_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var event_list_financial_component_EventListFinancialComponent = (function () {
    function EventListFinancialComponent(eventListStore, environment, router, menuStore) {
        this.eventListStore = eventListStore;
        this.environment = environment;
        this.router = router;
        this.menuStore = menuStore;
    }
    EventListFinancialComponent.prototype.ngOnInit = function () {
        this.data = this.eventListStore.events;
        this.menuStore.setPageTitle('EVENTS.TITLE');
        this.searchText = '';
    };
    Object.defineProperty(EventListFinancialComponent.prototype, "events", {
        get: function () {
            return this.data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListFinancialComponent.prototype, "eventCount", {
        get: function () {
            return this.eventListStore.totalEventCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListFinancialComponent.prototype, "eventCountForTranslate", {
        get: function () {
            return this.eventCount.map(function (count) {
                return {
                    eventCount: count
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListFinancialComponent.prototype, "eventsAboveMax", {
        get: function () {
            var _this = this;
            return this.eventCount.map(function (eventCount) {
                return eventCount > _this.maxEvents;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListFinancialComponent.prototype, "eventsPresent", {
        get: function () {
            return this.eventCount.map(function (eventCount) {
                return eventCount > 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListFinancialComponent.prototype, "maxEvents", {
        get: function () {
            return this.environment.events.maxEvents;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventListFinancialComponent.prototype, "maxEventsForTranslate", {
        get: function () {
            return {
                maxEvents: this.maxEvents
            };
        },
        enumerable: true,
        configurable: true
    });
    EventListFinancialComponent.prototype.getPaymentAmount = function (eventSummary) {
        if (PaymentStatusUtils.isError(eventSummary.payStatus)) {
            return 0;
        }
        else {
            return Number(eventSummary.paymentAmount);
        }
    };
    EventListFinancialComponent.prototype.getEstimatedDue = function (eventSummary) {
        var estimatedDue = Number(eventSummary.dueAmount);
        estimatedDue = Math.max(estimatedDue, 0);
        estimatedDue = Math.round(estimatedDue);
        return estimatedDue;
    };
    EventListFinancialComponent.prototype.onSelect = function (event) {
        this.router.navigate(['/event', event.eventId]);
    };
    return EventListFinancialComponent;
}());
event_list_financial_component_EventListFinancialComponent = event_list_financial_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-list-financial-table',
        template: __webpack_require__("qwMY")
    }),
    event_list_financial_component___metadata("design:paramtypes", [typeof (event_list_financial_component__a = typeof event_list_store_EventListStore !== "undefined" && event_list_store_EventListStore) === "function" && event_list_financial_component__a || Object, typeof (event_list_financial_component__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && event_list_financial_component__b || Object, typeof (event_list_financial_component__c = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && event_list_financial_component__c || Object, typeof (event_list_financial_component__d = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && event_list_financial_component__d || Object])
], event_list_financial_component_EventListFinancialComponent);

var event_list_financial_component__a, event_list_financial_component__b, event_list_financial_component__c, event_list_financial_component__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-list-financial.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/basic-event-data/basic-event-data.validator.ts

var basic_event_data_validator_BasicEventDataValidator = (function () {
    function BasicEventDataValidator() {
    }
    BasicEventDataValidator.dateCompare = function (formControl) {
        var startDate = formControl.get('startDate').value;
        var endDate = formControl.get('endDate').value;
        if (!startDate || !endDate) {
            return null;
        }
        else {
            // Convert to string if object
            if (!Object(util_util["isString"])(startDate)) {
                startDate = startDate.toUTCString();
            }
            if (!Object(util_util["isString"])(endDate)) {
                endDate = endDate.toUTCString();
            }
        }
        var isInvalid = new Date(startDate) >= new Date(endDate);
        if (isInvalid) {
            formControl.get('endDate').markAsTouched();
            return { 'greater': true };
        }
        return null;
    };
    return BasicEventDataValidator;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/basic-event-data.validator.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/ng2-validation/dist/index.js
var dist = __webpack_require__("+idH");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/config-request.ts
var config_request___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ConfigRequestRecord = Object(immutable["Record"])({
    config: null,
    property: null,
    agency: null
});
var ConfigRequest = (function (_super) {
    config_request___extends(ConfigRequest, _super);
    function ConfigRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConfigRequest;
}(ConfigRequestRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/config-request.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/config-response.ts
var config_response___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var ConfigResponseRecord = Object(immutable["Record"])({
    config: null,
    value: null,
    level: null
});
var ConfigResponse = (function (_super) {
    config_response___extends(ConfigResponse, _super);
    function ConfigResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ConfigResponse;
}(ConfigResponseRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/config-response.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/config-lookup-type.ts
var ConfigLookupType;
(function (ConfigLookupType) {
    ConfigLookupType[ConfigLookupType["COMMISSION_RATE"] = 'COMMISSION_RATE'] = "COMMISSION_RATE";
    ConfigLookupType[ConfigLookupType["AUTO_PAY"] = 'AUTO_PAY'] = "AUTO_PAY";
    ConfigLookupType[ConfigLookupType["DEFAULT_END_DATE_PLUS_DAYS"] = 'DEFAULT_END_DATE_PLUS_DAYS'] = "DEFAULT_END_DATE_PLUS_DAYS";
    ConfigLookupType[ConfigLookupType["ALL"] = 'ALL'] = "ALL";
})(ConfigLookupType || (ConfigLookupType = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/config-lookup-type.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/property-config-lookup.ts
var property_config_lookup___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PropertyConfigLookupRecord = Object(immutable["Record"])({
    chain: null,
    brand: null,
    propertyId: null
});
var PropertyConfigLookup = (function (_super) {
    property_config_lookup___extends(PropertyConfigLookup, _super);
    function PropertyConfigLookup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyConfigLookup;
}(PropertyConfigLookupRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/property-config-lookup.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/agency-config-lookup.ts
var agency_config_lookup___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AgencyConfigLookupRecord = Object(immutable["Record"])({
    agencyId: null,
});
var AgencyConfigLookup = (function (_super) {
    agency_config_lookup___extends(AgencyConfigLookup, _super);
    function AgencyConfigLookup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AgencyConfigLookup;
}(AgencyConfigLookupRecord));

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/agency-config-lookup.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/config-level-type.ts
var ConfigLevelType;
(function (ConfigLevelType) {
    ConfigLevelType[ConfigLevelType["AGENCY"] = 'AGENCY'] = "AGENCY";
    ConfigLevelType[ConfigLevelType["BRAND"] = 'BRAND'] = "BRAND";
    ConfigLevelType[ConfigLevelType["CHAIN"] = 'CHAIN'] = "CHAIN";
    ConfigLevelType[ConfigLevelType["PROPERTY"] = 'PROPERTY'] = "PROPERTY";
    ConfigLevelType[ConfigLevelType["SYSTEM"] = 'SYSTEM'] = "SYSTEM";
    ConfigLevelType[ConfigLevelType["UNKNOWN"] = 'UNKNOWN'] = "UNKNOWN";
})(ConfigLevelType || (ConfigLevelType = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/config-level-type.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/grouppay-config.http.service.ts
var grouppay_config_http_service___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var grouppay_config_http_service___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var grouppay_config_http_service_GroupPayConfigHttpService = (function () {
    function GroupPayConfigHttpService(http, environment) {
        this.http = http;
        this.environment = environment;
        this.configLookupUrl = this.environment.baseUrl + '/api/lookup/config';
    }
    GroupPayConfigHttpService.prototype.getGroupPayConfig = function (request) {
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.configLookupUrl, JSON.stringify(request.toJS()), options)
            .map(function (response) { return new ConfigResponse(response.json()); })
            .catch(response_util_ResponseUtil.unwrapErrorMessage)
            .share();
    };
    GroupPayConfigHttpService.prototype.getGroupPayConfigByValues = function (key, chain, brand, propertyId, agencyId) {
        return this.getGroupPayConfig(this.buildConfigRequest(key, chain, brand, propertyId, agencyId));
    };
    GroupPayConfigHttpService.prototype.getAllGroupPayConfig = function (request) {
        var headers = new http_es5["Headers"]({ 'Content-Type': 'application/json' });
        var options = new http_es5["RequestOptions"]({ headers: headers });
        return this.http.post(this.configLookupUrl + '/all', JSON.stringify(request.toJS()), options)
            .map(function (response) {
            var result = [];
            var json = response.json();
            for (var property in json) {
                if (json.hasOwnProperty(property)) {
                    var key = ConfigLookupType[property];
                    var value = new ConfigResponse({
                        config: ConfigLookupType[json[property].config],
                        value: json[property].value,
                        level: ConfigLevelType[json[property].level]
                    });
                    result.push([key, value]);
                }
            }
            return Object(immutable["Map"])(result);
        })
            .catch(response_util_ResponseUtil.unwrapErrorMessage)
            .share();
    };
    GroupPayConfigHttpService.prototype.getAllGroupPayConfigByValues = function (chain, brand, propertyId, agencyId) {
        return this.getAllGroupPayConfig(this.buildConfigRequest(ConfigLookupType.ALL, chain, brand, propertyId, agencyId));
    };
    GroupPayConfigHttpService.prototype.buildConfigRequest = function (key, chain, brand, propertyId, agencyId) {
        var propertyConfigLookup = null;
        var agencyConfigLookup = null;
        if (chain != null || brand != null || propertyId != null) {
            propertyConfigLookup = new PropertyConfigLookup({
                chain: chain,
                brand: brand,
                propertyId: propertyId
            });
        }
        if (agencyId != null) {
            agencyConfigLookup = new AgencyConfigLookup({ agencyId: agencyId });
        }
        return new ConfigRequest({
            config: key,
            property: propertyConfigLookup,
            agency: agencyConfigLookup
        });
    };
    return GroupPayConfigHttpService;
}());
grouppay_config_http_service_GroupPayConfigHttpService = grouppay_config_http_service___decorate([
    Object(core_es5["Injectable"])(),
    grouppay_config_http_service___metadata("design:paramtypes", [typeof (grouppay_config_http_service__a = typeof angular2_jwt["AuthHttp"] !== "undefined" && angular2_jwt["AuthHttp"]) === "function" && grouppay_config_http_service__a || Object, typeof (grouppay_config_http_service__b = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && grouppay_config_http_service__b || Object])
], grouppay_config_http_service_GroupPayConfigHttpService);

var grouppay_config_http_service__a, grouppay_config_http_service__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/grouppay-config.http.service.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/grouppay-config.store.ts
var grouppay_config_store___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var grouppay_config_store___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};










var grouppay_config_store_GroupPayConfigStore = (function () {
    function GroupPayConfigStore(groupPayConfigHttpService, logService, flashMessagesService, translateService) {
        this.groupPayConfigHttpService = groupPayConfigHttpService;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        this.commissionRateSubject = new ReplaySubject["ReplaySubject"](1);
        this.defaultEndDateDelayDaysSubject = new ReplaySubject["ReplaySubject"](1);
        this.allSubject = new BehaviorSubject["BehaviorSubject"](Object(immutable["Map"])([]));
    }
    Object.defineProperty(GroupPayConfigStore.prototype, "commissionRate", {
        get: function () {
            return this.commissionRateSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupPayConfigStore.prototype, "commissionRateValue", {
        get: function () {
            return this.commissionRate.map(function (configResponse) { return Number(configResponse.value); });
        },
        enumerable: true,
        configurable: true
    });
    GroupPayConfigStore.prototype.setCommissionRate = function (configResponse) {
        this.commissionRateSubject.next(configResponse);
    };
    Object.defineProperty(GroupPayConfigStore.prototype, "defaultEndDateDelayDays", {
        get: function () {
            return this.defaultEndDateDelayDaysSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupPayConfigStore.prototype, "defaultEndDateDelayDaysValue", {
        get: function () {
            return this.defaultEndDateDelayDays.map(function (configResponse) { return Number(configResponse.value); });
        },
        enumerable: true,
        configurable: true
    });
    GroupPayConfigStore.prototype.setDefaultEndDateDelayDays = function (configResponse) {
        this.defaultEndDateDelayDaysSubject.next(configResponse);
    };
    Object.defineProperty(GroupPayConfigStore.prototype, "allConfigurations", {
        get: function () {
            return this.allSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    GroupPayConfigStore.prototype.loadConfig = function (key, chain, brand, propertyId, agencyId) {
        var _this = this;
        var response = this.groupPayConfigHttpService.getGroupPayConfigByValues(key, chain, brand, propertyId, agencyId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_SINGLE', {
                configValue: key.toString()
            }));
            _this.logService.error("Error retrieving configuration value (" + key.toString() + "): " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (configResponse) {
            _this.updateOneConfig(key, configResponse);
            return configResponse;
        });
        return response;
    };
    GroupPayConfigStore.prototype.loadAllConfig = function (chain, brand, propertyId, agencyId) {
        var _this = this;
        var response = this.groupPayConfigHttpService.getAllGroupPayConfigByValues(chain, brand, propertyId, agencyId)
            .catch(function (error) {
            _this.flashMessagesService.error(_this.translateService.instant('MESSAGES.ERROR.GROUPPAY_CONFIG_ALL'));
            _this.logService.error("Error retrieveing all configuration values: " + error);
            return Observable["Observable"].throw(error);
        })
            .map(function (responseMap) {
            _this.updateAllConfig(responseMap);
            return responseMap;
        });
        return response;
    };
    GroupPayConfigStore.prototype.updateOneConfig = function (key, configResponse) {
        var map = this.allSubject.getValue();
        this.allSubject.next(map.set(key, configResponse));
        switch (key) {
            case ConfigLookupType.COMMISSION_RATE:
                this.setCommissionRate(configResponse);
                break;
            case ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS:
                this.setDefaultEndDateDelayDays(configResponse);
                break;
            case ConfigLookupType.AUTO_PAY:
                // TODO add this later
                break;
        }
    };
    GroupPayConfigStore.prototype.updateAllConfig = function (configMap) {
        this.allSubject.next(configMap);
        if (configMap.has(ConfigLookupType.COMMISSION_RATE)) {
            this.setCommissionRate(configMap.get(ConfigLookupType.COMMISSION_RATE));
        }
        if (configMap.has(ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS)) {
            this.setDefaultEndDateDelayDays(configMap.get(ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS));
        }
        if (configMap.has(ConfigLookupType.AUTO_PAY)) {
            // TODO add this later
        }
    };
    return GroupPayConfigStore;
}());
grouppay_config_store_GroupPayConfigStore = grouppay_config_store___decorate([
    Object(core_es5["Injectable"])(),
    grouppay_config_store___metadata("design:paramtypes", [typeof (grouppay_config_store__a = typeof grouppay_config_http_service_GroupPayConfigHttpService !== "undefined" && grouppay_config_http_service_GroupPayConfigHttpService) === "function" && grouppay_config_store__a || Object, typeof (grouppay_config_store__b = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && grouppay_config_store__b || Object, typeof (grouppay_config_store__c = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && grouppay_config_store__c || Object, typeof (grouppay_config_store__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && grouppay_config_store__d || Object])
], grouppay_config_store_GroupPayConfigStore);

var grouppay_config_store__a, grouppay_config_store__b, grouppay_config_store__c, grouppay_config_store__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/grouppay-config.store.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/basic-event-data/basic-event-data.component.ts
var basic_event_data_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var basic_event_data_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};















var basic_event_data_component_BasicEventDataComponent = (function () {
    function BasicEventDataComponent(formBuilder, propertyLookupStore, eventStore, environment, groupPayConfigStore, flashMessagesService, authenticationStore) {
        this.formBuilder = formBuilder;
        this.propertyLookupStore = propertyLookupStore;
        this.eventStore = eventStore;
        this.environment = environment;
        this.groupPayConfigStore = groupPayConfigStore;
        this.flashMessagesService = flashMessagesService;
        this.authenticationStore = authenticationStore;
        this.isReadOnly = true;
        this.isNewEvent = false;
    }
    Object.defineProperty(BasicEventDataComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    BasicEventDataComponent.prototype.dataToFormGroup = function (event) {
        var _groupCodeNumber = '';
        if (event.eventProperty) {
            _groupCodeNumber = event.eventProperty.eventReferenceNumber;
        }
        if (!this.basicEventDataForm) {
            this.basicEventDataForm = this.formBuilder.group({
                'name': [event.name, forms_es5["Validators"].required],
                'commissionRoomPercentage': [event.commissionRoomPercentage,
                    [forms_es5["Validators"].required, dist["CustomValidators"].range([0, 100]), pioneer_validators_PioneerValidators.isInteger]],
                'startDate': [date_util_DateUtil.formatDate(event.startDate), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                'endDate': [date_util_DateUtil.formatDate(event.endDate), [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isDate]],
                'eventAgency': this.formBuilder.group({}),
                'eventClient': this.formBuilder.group({}),
                'eventProperty': this.formBuilder.group({}),
                'groupCodeNumber': [_groupCodeNumber, forms_es5["Validators"].required]
            }, { validator: basic_event_data_validator_BasicEventDataValidator.dateCompare });
        }
        else {
            this.basicEventDataForm.patchValue({
                'name': event.name,
                'commissionRoomPercentage': event.commissionRoomPercentage,
                'startDate': date_util_DateUtil.formatDate(event.startDate),
                'endDate': date_util_DateUtil.formatDate(event.endDate),
                'groupCodeNumber': _groupCodeNumber
            });
        }
    };
    BasicEventDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dataToFormGroup(this.onyxEvent);
        this.parentForm.setControl('event', this.basicEventDataForm);
        this.isUploadInProgress = false;
        this.fileExtensions = this.environment.bulkEvents.acceptedFileExtensions;
        this.propertyLookupSubscription =
            this.propertyLookupStore.selected.subscribe(function (propertyLookup) {
                _this.groupPayConfigStore.loadConfig(ConfigLookupType.COMMISSION_RATE, propertyLookup.chain, propertyLookup.brand, propertyLookup.propertyId, null)
                    .map(function (res) { return Number(res.value); })
                    .subscribe(function (rate) {
                    if (_this.isNewEvent && !_this.isCommissionRateManuallyEntered()) {
                        _this.basicEventDataForm.patchValue({
                            'commissionRoomPercentage': rate
                        });
                    }
                });
            });
    };
    BasicEventDataComponent.prototype.ngOnDestroy = function () {
        this.propertyLookupSubscription.unsubscribe();
    };
    BasicEventDataComponent.prototype.ngOnChanges = function (changes) {
        /*
         * Since we're subscribed to the selectedEvent in the event store,
         * this will detect if something changes (or if loading finishes) and we need to update the form.
         */
        if (!changes['event']) {
            return;
        }
        this.dataToFormGroup(this.onyxEvent);
    };
    BasicEventDataComponent.prototype.isAutoGenerated = function () {
        return this.onyxEvent.autoGenerated;
    };
    BasicEventDataComponent.prototype.isCommissionRateManuallyEntered = function () {
        return this.basicEventDataForm.controls['commissionRoomPercentage'].touched &&
            this.basicEventDataForm.controls['commissionRoomPercentage'].dirty;
    };
    BasicEventDataComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    BasicEventDataComponent.prototype.clearFileInput = function () {
        this.bulkEventFileInput.nativeElement.value = null;
    };
    BasicEventDataComponent.prototype.downloadInvalidEventsCsv = function (fileId) {
        this.eventStore.downloadInvalidEventsCsv(fileId);
    };
    BasicEventDataComponent.prototype.importEventsViaCsv = function (inputEvent) {
        var _this = this;
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_EVENTS');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        this.clearFileInput();
        if (this.environment.bulkEvents.acceptedFileTypes.indexOf(file.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_BULK_EVENTS');
            return;
        }
        if (file.size > Math.pow(2, 20)) {
            this.handleUploadError('MESSAGES.ERROR.BULK_UPLOAD_TOO_LARGE');
            return;
        }
        ;
        this.eventStore.importEventsViaCsv(file)
            .finally(function () {
            _this.isUploadInProgress = false;
        })
            .catch((function (error) {
            _this.showErrorMessage(error);
            return Observable["Observable"].throw(error);
        }))
            .subscribe(function (response) {
            if (response.successful && response.successful > 0) {
                _this.showSuccessfulRecordsMessage(response);
            }
            if (response.failed && response.failed > 0) {
                _this.showInvalidRecordsMessage(response);
            }
        });
    };
    BasicEventDataComponent.prototype.showErrorMessage = function (error) {
        this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_BULK_EVENTS', "Error uploading bulk events: " + error);
    };
    BasicEventDataComponent.prototype.showSuccessfulRecordsMessage = function (response) {
        this.flashMessagesService.success('MESSAGES.SUCCESS.UPLOAD_BULK_EVENTS', null, { eventCount: Number(response.successful) });
    };
    BasicEventDataComponent.prototype.showInvalidRecordsMessage = function (response) {
        this.flashMessagesService.warn('MESSAGES.SUCCESS.UPLOAD_BULK_EVENTS_INVALID', null, { eventCount: Number(response.failed),
            href: this.environment.baseUrl + '/api/events/bulkUpload/'
                + response.fileId + '?Authorization=' + this.authenticationStore.getToken() });
    };
    BasicEventDataComponent.prototype.setEndDateAfterStartDateEntered = function (daysToAdd) {
        var startDate = date_util_DateUtil.parseDate(this.basicEventDataForm.controls.startDate.value);
        if (date_util_DateUtil.isValidDate(startDate)) {
            var newEndDate = new Date(startDate.setTime(startDate.getTime() + daysToAdd * date_util_DateUtil.MILLISECONDS_PER_DAY));
            var dateStr = date_util_DateUtil.formatDate(newEndDate);
            this.basicEventDataForm.controls['endDate'].setValue(dateStr);
        }
    };
    BasicEventDataComponent.prototype.onStartDateEntered = function (inputEvent) {
        if (inputEvent) {
            this.loadDefaultEndDateDelayDays();
        }
    };
    BasicEventDataComponent.prototype.loadDefaultEndDateDelayDays = function () {
        var _this = this;
        var startDate = date_util_DateUtil.parseDate(this.basicEventDataForm.controls.startDate.value);
        if (date_util_DateUtil.isValidDate(startDate)) {
            this.groupPayConfigStore.loadConfig(ConfigLookupType.DEFAULT_END_DATE_PLUS_DAYS, null, null, null, null)
                .map(function (res) { return Number(res.value); })
                .subscribe(function (daysToAdd) {
                _this.setEndDateAfterStartDateEntered(daysToAdd);
            });
        }
    };
    return BasicEventDataComponent;
}());
basic_event_data_component___decorate([
    Object(core_es5["Input"])('parentForm'),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__a = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && basic_event_data_component__a || Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "parentForm", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "isReadOnly", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])(),
    basic_event_data_component___metadata("design:type", Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "isNewEvent", void 0);
basic_event_data_component___decorate([
    Object(core_es5["ViewChild"])('bulkEventFile'),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__b = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && basic_event_data_component__b || Object)
], basic_event_data_component_BasicEventDataComponent.prototype, "bulkEventFileInput", void 0);
basic_event_data_component___decorate([
    Object(core_es5["Input"])('event'),
    basic_event_data_component___metadata("design:type", typeof (basic_event_data_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && basic_event_data_component__c || Object),
    basic_event_data_component___metadata("design:paramtypes", [typeof (basic_event_data_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && basic_event_data_component__d || Object])
], basic_event_data_component_BasicEventDataComponent.prototype, "event", null);
basic_event_data_component_BasicEventDataComponent = basic_event_data_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-basic-event-data',
        template: __webpack_require__("pGxJ")
    }),
    basic_event_data_component___metadata("design:paramtypes", [typeof (basic_event_data_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && basic_event_data_component__e || Object, typeof (basic_event_data_component__f = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && basic_event_data_component__f || Object, typeof (basic_event_data_component__g = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && basic_event_data_component__g || Object, typeof (basic_event_data_component__h = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && basic_event_data_component__h || Object, typeof (basic_event_data_component__j = typeof grouppay_config_store_GroupPayConfigStore !== "undefined" && grouppay_config_store_GroupPayConfigStore) === "function" && basic_event_data_component__j || Object, typeof (basic_event_data_component__k = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && basic_event_data_component__k || Object, typeof (_l = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && _l || Object])
], basic_event_data_component_BasicEventDataComponent);

var basic_event_data_component__a, basic_event_data_component__b, basic_event_data_component__c, basic_event_data_component__d, basic_event_data_component__e, basic_event_data_component__f, basic_event_data_component__g, basic_event_data_component__h, basic_event_data_component__j, basic_event_data_component__k, _l;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/basic-event-data.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/party-type.ts
var PartyType;
(function (PartyType) {
    PartyType[PartyType["CLIENT"] = 'CLIENT'] = "CLIENT";
    PartyType[PartyType["PROPERTY"] = 'PROPERTY'] = "PROPERTY";
    PartyType[PartyType["AGENCY"] = 'AGENCY'] = "AGENCY";
})(PartyType || (PartyType = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/party-type.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/contact-form/contact-form.component.ts
var contact_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var contact_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var contact_form_component_ContactFormComponent = (function () {
    function ContactFormComponent(formBuilder, translateService) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.isReadOnly = true;
    }
    Object.defineProperty(ContactFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ContactFormComponent.prototype.dataToFormGroup = function (event) {
        var party = new Party();
        switch (this.partyType) {
            case PartyType.CLIENT:
                party = this.onyxEvent.eventClient;
                break;
            case PartyType.AGENCY:
                party = this.onyxEvent.eventAgency;
                break;
            case PartyType.PROPERTY:
                party = this.onyxEvent.eventProperty;
                break;
            default:
                throw Error("Invalid partyType " + this.partyType);
        }
        if (!party) {
            party = new Party({ contact: new Contact() });
        }
        else if (!party.contact) {
            party = party.set('contact', new Contact());
        }
        var refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
        if (this.partyType === PartyType.PROPERTY) {
            refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
        }
        if (!this.contactForm) {
            this.contactForm = this.formBuilder.group({
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: this.partyType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: event.agencyId,
                clientReferenceNumber: event.clientReferenceNumber,
                propertyId: event.propertyId,
                chain: event.chain,
                brand: event.brand,
                eventReferenceNumber: refCodeValidator,
                contact: this.formBuilder.group({
                    firstName: party.contact.firstName,
                    lastName: party.contact.lastName,
                    partyType: this.partyType,
                    email: [party.contact.email, dist["CustomValidators"].email],
                    phone: [party.contact.phone, dist["CustomValidators"].phone],
                    fax: [party.contact.fax, dist["CustomValidators"].phone]
                })
            });
        }
        else {
            this.contactForm.patchValue({
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: this.partyType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: event.agencyId,
                clientReferenceNumber: event.clientReferenceNumber,
                propertyId: event.propertyId,
                chain: event.chain,
                brand: event.brand,
                eventReferenceNumber: party.eventReferenceNumber,
            });
            this.contactForm.controls['contact'].patchValue({
                firstName: party.contact.firstName,
                lastName: party.contact.lastName,
                partyType: this.partyType,
                email: party.contact.email,
                phone: party.contact.phone,
                fax: party.contact.fax
            });
        }
    };
    ContactFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        switch (this.partyType) {
            case PartyType.CLIENT:
                this.translateService.get('EVENT.CONTACT_CLIENT').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_CLIENT_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.dataToFormGroup(this.onyxEvent);
                this.parentForm.setControl('eventClient', this.contactForm);
                break;
            case PartyType.AGENCY:
                this.translateService.get('EVENT.CONTACT_AGENCY').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_AGENCY_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.dataToFormGroup(this.onyxEvent);
                this.parentForm.setControl('eventAgency', this.contactForm);
                break;
            case PartyType.PROPERTY:
                this.translateService.get('EVENT.CONTACT_PROPERTY').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_PROPERTY_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.dataToFormGroup(this.onyxEvent);
                this.parentForm.setControl('eventProperty', this.contactForm);
                break;
            default:
                throw Error("Invalid partyType " + this.partyType);
        }
    };
    ContactFormComponent.prototype.ngOnChanges = function (changes) {
        if (!changes['event']) {
            return;
        }
        this.dataToFormGroup(this.onyxEvent);
    };
    return ContactFormComponent;
}());
contact_form_component___decorate([
    Object(core_es5["Input"])('partyType'),
    contact_form_component___metadata("design:type", typeof (contact_form_component__a = typeof PartyType !== "undefined" && PartyType) === "function" && contact_form_component__a || Object)
], contact_form_component_ContactFormComponent.prototype, "partyType", void 0);
contact_form_component___decorate([
    Object(core_es5["Input"])('parentForm'),
    contact_form_component___metadata("design:type", typeof (contact_form_component__b = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && contact_form_component__b || Object)
], contact_form_component_ContactFormComponent.prototype, "parentForm", void 0);
contact_form_component___decorate([
    Object(core_es5["Input"])('event'),
    contact_form_component___metadata("design:type", typeof (contact_form_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && contact_form_component__c || Object),
    contact_form_component___metadata("design:paramtypes", [typeof (contact_form_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && contact_form_component__d || Object])
], contact_form_component_ContactFormComponent.prototype, "event", null);
contact_form_component___decorate([
    Object(core_es5["Input"])(),
    contact_form_component___metadata("design:type", Object)
], contact_form_component_ContactFormComponent.prototype, "isReadOnly", void 0);
contact_form_component_ContactFormComponent = contact_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-contact-form',
        template: __webpack_require__("F5Qg")
    }),
    contact_form_component___metadata("design:paramtypes", [typeof (contact_form_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && contact_form_component__e || Object, typeof (contact_form_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && contact_form_component__f || Object])
], contact_form_component_ContactFormComponent);

var contact_form_component__a, contact_form_component__b, contact_form_component__c, contact_form_component__d, contact_form_component__e, contact_form_component__f;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/contact-form.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/property-lookup-converter.ts
var PropertyLookupConverter = (function () {
    function PropertyLookupConverter() {
    }
    PropertyLookupConverter.updateFormFields = function (detail, contactLookupForm, propertyLookupStore) {
        contactLookupForm.patchValue({
            name: detail.name,
            line1: detail.address.line1,
            line2: detail.address.line2,
            city: detail.address.city,
            state: detail.address.state,
            postalCode: detail.address.postalCode,
            propertyId: detail.propertyId,
            chain: detail.chain,
            brand: detail.brand
        });
        contactLookupForm.controls['contact'].patchValue({
            firstName: detail.contact.firstName,
            lastName: detail.contact.lastName,
            email: detail.contact.email,
            phone: detail.contact.phone,
            fax: detail.contact.fax
        });
        contactLookupForm.controls['propertyNameSearch'].setValue('');
        propertyLookupStore.clearSearchResults();
    };
    return PropertyLookupConverter;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/property-lookup-converter.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/agency-lookup-converter.ts
var AgencyLookupConverter = (function () {
    function AgencyLookupConverter() {
    }
    AgencyLookupConverter.updateFormFields = function (detail, contactLookupForm, agencyLookupStore) {
        contactLookupForm.patchValue({
            name: detail.name,
            line1: detail.address.line1,
            line2: detail.address.line2,
            city: detail.address.city,
            state: detail.address.state,
            postalCode: detail.address.postalCode,
            agencyId: detail.agencyId
        });
        contactLookupForm.controls['contact'].patchValue({
            firstName: detail.contact.firstName,
            lastName: detail.contact.lastName,
            email: detail.contact.email,
            phone: detail.contact.phone,
            fax: detail.contact.fax
        });
        agencyLookupStore.clearSearchResults();
    };
    return AgencyLookupConverter;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/agency-lookup-converter.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/contact-lookup-form/contact-lookup-form.component.ts
var contact_lookup_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var contact_lookup_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};












var contact_lookup_form_component_ContactLookupFormComponent = ContactLookupFormComponent_1 = (function () {
    function ContactLookupFormComponent(formBuilder, translateService, propertyLookupStore, agencyLookupStore, logService) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.propertyLookupStore = propertyLookupStore;
        this.agencyLookupStore = agencyLookupStore;
        this.logService = logService;
        this.isReadOnly = false;
    }
    Object.defineProperty(ContactLookupFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactLookupFormComponent.prototype, "agencyStore", {
        get: function () {
            return this.agencyLookupStore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContactLookupFormComponent.prototype, "propertyStore", {
        get: function () {
            return this.propertyLookupStore;
        },
        enumerable: true,
        configurable: true
    });
    ContactLookupFormComponent.isPropertyError = function (group) {
        if (group.get('partyType').value === PartyType.PROPERTY.toString() &&
            (!group.get('propertyId').value || !group.get('chain').value || !group.get('brand').value)) {
            return { 'propertyRequired': true };
        }
        else {
            return null;
        }
    };
    ContactLookupFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkError = false;
        this.contactFormFilled = false;
        if (!this.onyxEvent) {
            this.onyxEvent = new OnyxEvent();
        }
        switch (this.partyType) {
            case PartyType.CLIENT:
                this.translateService.get('EVENT.CONTACT_CLIENT').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_CLIENT_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.contactLookupForm = this.dataToFormGroup(this.onyxEvent.eventClient);
                this.parentForm.setControl('eventClient', this.contactLookupForm);
                break;
            case PartyType.AGENCY:
                this.translateService.get('EVENT.CONTACT_AGENCY').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_AGENCY_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.contactLookupForm = this.dataToFormGroup(this.onyxEvent.eventAgency);
                this.parentForm.setControl('eventAgency', this.contactLookupForm);
                break;
            case PartyType.PROPERTY:
                this.translateService.get('EVENT.CONTACT_PROPERTY').subscribe(function (text) { return _this.contactTypeTitle = text; });
                this.translateService.get('EVENT.CONTACT_PROPERTY_REF_CODE')
                    .subscribe(function (text) { return _this.contactReferenceNumberTitle = text; });
                this.contactLookupForm = this.dataToFormGroup(this.onyxEvent.eventProperty);
                this.parentForm.setControl('eventProperty', this.contactLookupForm);
                break;
            default:
                throw Error("Invalid partyType " + this.partyType);
        }
        /*
         Wire up Property Name Search
         */
        if (this.partyType === PartyType.PROPERTY) {
            this.propertyLookupStore.selected.subscribe(function (details) {
                _this.logService.verbose("property details " + JSON.stringify(details));
                PropertyLookupConverter.updateFormFields(details, _this.contactLookupForm, _this.propertyLookupStore);
            });
        }
        if (this.partyType === PartyType.AGENCY) {
            this.agencyLookupStore.selected.subscribe(function (details) {
                _this.logService.verbose("agency details " + JSON.stringify(details));
                AgencyLookupConverter.updateFormFields(details, _this.contactLookupForm, _this.agencyLookupStore);
            });
        }
    };
    ContactLookupFormComponent.prototype.ngOnChanges = function (changes) {
        if (!changes['event']) {
            return;
        }
        switch (this.partyType) {
            case PartyType.CLIENT:
                this.dataToFormGroup(this.onyxEvent.eventClient);
                break;
            case PartyType.AGENCY:
                this.dataToFormGroup(this.onyxEvent.eventAgency);
                break;
            case PartyType.PROPERTY:
                this.dataToFormGroup(this.onyxEvent.eventProperty);
                break;
            default:
                throw Error("Invalid partyType " + this.partyType);
        }
    };
    ContactLookupFormComponent.prototype.inlineSearchTouched = function () {
        var _this = this;
        // Check for an error if the user has never tried to select a property
        // A delay is required so that this logic is done after onSelectedProperty()
        setTimeout(function () {
            if (_this.partyType === PartyType.PROPERTY) {
                _this.checkError = !_this.contactFormFilled;
            }
            if (!_this.lookupSelected) {
                _this.propertyLookupStore.clearSearchResults();
                _this.agencyLookupStore.clearSearchResults();
            }
            else {
                _this.lookupSelected = false;
            }
        }, 100);
    };
    ContactLookupFormComponent.prototype.isPropertyMissing = function () {
        return this.checkError && this.contactLookupForm.hasError('propertyRequired');
    };
    ContactLookupFormComponent.prototype.isReadyOnlyProperty = function () {
        return !this.isReadOnly && this.partyType === PartyType.PROPERTY;
    };
    ContactLookupFormComponent.prototype.updateResults = function (results) {
        this.logService.verbose("results: " + results);
        this.summaryResults = results;
    };
    ContactLookupFormComponent.prototype.onSelectedProperty = function (propertySummary) {
        this.contactFormFilled = true;
        this.lookupSelected = true;
        this.logService.debug("propertySummary " + JSON.stringify(propertySummary));
        this.propertyLookupStore.getDetail(propertySummary).subscribe();
    };
    ContactLookupFormComponent.prototype.onSelectedAgency = function (summary) {
        this.contactFormFilled = true;
        this.lookupSelected = true;
        this.logService.debug("agencySummary " + JSON.stringify(summary));
        this.agencyLookupStore.getDetail(summary).subscribe();
    };
    ContactLookupFormComponent.prototype.dataToFormGroup = function (party) {
        if (!party) {
            party = new Party();
        }
        else {
            if (!party.contact) {
                party.contact = new Contact();
            }
            party = new Party(party);
        }
        var refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
        switch (this.partyType) {
            case PartyType.CLIENT:
                party = party.set('clientReferenceNumber', this.onyxEvent.clientReferenceNumber);
                break;
            case PartyType.AGENCY:
                party = party.set('agencyId', this.onyxEvent.agencyId);
                break;
            case PartyType.PROPERTY:
                party = party.merge({
                    propertyId: this.onyxEvent.propertyId,
                    chain: this.onyxEvent.chain,
                    brand: this.onyxEvent.brand
                });
                refCodeValidator = [party.eventReferenceNumber, forms_es5["Validators"].nullValidator];
                break;
            default:
                throw Error("Invalid partyType " + this.partyType);
        }
        if (!this.contactLookupForm) {
            this.contactLookupForm = this.formBuilder.group({
                propertyNameSearch: '',
                agencyNameSearch: '',
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: this.partyType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.agencyId,
                clientReferenceNumber: party.clientReferenceNumber,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: refCodeValidator,
                contact: this.formBuilder.group({
                    firstName: [party.contact.firstName],
                    lastName: [party.contact.lastName],
                    partyType: this.partyType,
                    email: [party.contact.email],
                    phone: [party.contact.phone],
                    fax: [party.contact.fax]
                })
            }, {
                validator: ContactLookupFormComponent_1.isPropertyError
            });
        }
        else {
            this.contactLookupForm.patchValue({
                propertyNameSearch: '',
                agencyNameSearch: '',
                name: party.name,
                line1: party.line1,
                line2: party.line2,
                partyType: this.partyType,
                city: party.city,
                state: party.state,
                postalCode: party.postalCode,
                agencyId: party.agencyId,
                clientReferenceNumber: party.clientReferenceNumber,
                propertyId: party.propertyId,
                chain: party.chain,
                brand: party.brand,
                eventReferenceNumber: party.eventReferenceNumber,
            });
            this.contactLookupForm.controls['contact'].patchValue({
                firstName: party.contact.firstName,
                lastName: party.contact.lastName,
                partyType: this.partyType,
                email: party.contact.email,
                phone: party.contact.phone,
                fax: party.contact.fax
            });
        }
        return this.contactLookupForm;
    };
    return ContactLookupFormComponent;
}());
contact_lookup_form_component___decorate([
    Object(core_es5["Input"])('partyType'),
    contact_lookup_form_component___metadata("design:type", typeof (contact_lookup_form_component__a = typeof PartyType !== "undefined" && PartyType) === "function" && contact_lookup_form_component__a || Object)
], contact_lookup_form_component_ContactLookupFormComponent.prototype, "partyType", void 0);
contact_lookup_form_component___decorate([
    Object(core_es5["Input"])('parentForm'),
    contact_lookup_form_component___metadata("design:type", typeof (contact_lookup_form_component__b = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && contact_lookup_form_component__b || Object)
], contact_lookup_form_component_ContactLookupFormComponent.prototype, "parentForm", void 0);
contact_lookup_form_component___decorate([
    Object(core_es5["Input"])('event'),
    contact_lookup_form_component___metadata("design:type", typeof (contact_lookup_form_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && contact_lookup_form_component__c || Object),
    contact_lookup_form_component___metadata("design:paramtypes", [typeof (contact_lookup_form_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && contact_lookup_form_component__d || Object])
], contact_lookup_form_component_ContactLookupFormComponent.prototype, "event", null);
contact_lookup_form_component___decorate([
    Object(core_es5["Input"])(),
    contact_lookup_form_component___metadata("design:type", Object)
], contact_lookup_form_component_ContactLookupFormComponent.prototype, "isReadOnly", void 0);
contact_lookup_form_component_ContactLookupFormComponent = ContactLookupFormComponent_1 = contact_lookup_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-contact-lookup-form',
        template: __webpack_require__("6Ls2")
    }),
    contact_lookup_form_component___metadata("design:paramtypes", [typeof (contact_lookup_form_component__e = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && contact_lookup_form_component__e || Object, typeof (contact_lookup_form_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && contact_lookup_form_component__f || Object, typeof (contact_lookup_form_component__g = typeof property_lookup_store_PropertyLookupStore !== "undefined" && property_lookup_store_PropertyLookupStore) === "function" && contact_lookup_form_component__g || Object, typeof (contact_lookup_form_component__h = typeof agency_lookup_store_AgencyLookupStore !== "undefined" && agency_lookup_store_AgencyLookupStore) === "function" && contact_lookup_form_component__h || Object, typeof (contact_lookup_form_component__j = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && contact_lookup_form_component__j || Object])
], contact_lookup_form_component_ContactLookupFormComponent);

var ContactLookupFormComponent_1, contact_lookup_form_component__a, contact_lookup_form_component__b, contact_lookup_form_component__c, contact_lookup_form_component__d, contact_lookup_form_component__e, contact_lookup_form_component__f, contact_lookup_form_component__g, contact_lookup_form_component__h, contact_lookup_form_component__j;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/contact-lookup-form.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/reservations/payment-reservations.component.ts
var payment_reservations_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_reservations_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var payment_reservations_component_PaymentReservationsComponent = (function () {
    function PaymentReservationsComponent(roomStore) {
        this.roomStore = roomStore;
    }
    Object.defineProperty(PaymentReservationsComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentReservationsComponent.prototype.ngOnInit = function () {
        this.reservations = this.roomStore.getReservationListFilteredByStatus(ReservationStatusCode.CHECKED_OUT);
        this.staySummary = this.roomStore.getRoomStaySummaryFilteredByStatus(ReservationStatusCode.CHECKED_OUT)
            .map(function (summary) {
            return summary.staySummary;
        });
    };
    PaymentReservationsComponent.prototype.getRevenue = function (reservation) {
        return reservation_utils_ReservationUtils.getRevenue(reservation);
    };
    PaymentReservationsComponent.prototype.getCommission = function (reservation) {
        return reservation_utils_ReservationUtils.getCommission(reservation, this.onyxEvent);
    };
    PaymentReservationsComponent.prototype.getCommissionFromStaySummary = function (staySummary) {
        return staySummary.totalRevenue * this.onyxEvent.commissionRoomPercentage / 100;
    };
    return PaymentReservationsComponent;
}());
payment_reservations_component___decorate([
    Object(core_es5["Input"])('event'),
    payment_reservations_component___metadata("design:type", typeof (payment_reservations_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_reservations_component__a || Object),
    payment_reservations_component___metadata("design:paramtypes", [typeof (payment_reservations_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_reservations_component__b || Object])
], payment_reservations_component_PaymentReservationsComponent.prototype, "event", null);
payment_reservations_component_PaymentReservationsComponent = payment_reservations_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-reservations',
        template: __webpack_require__("ys9C")
    }),
    payment_reservations_component___metadata("design:paramtypes", [typeof (payment_reservations_component__c = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && payment_reservations_component__c || Object])
], payment_reservations_component_PaymentReservationsComponent);

var payment_reservations_component__a, payment_reservations_component__b, payment_reservations_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment-reservations.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/child-contact-form/child-contact-form.component.ts
var child_contact_form_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var child_contact_form_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var ChildContactFormComponent = (function () {
    function ChildContactFormComponent() {
        this.isReadOnly = true;
    }
    Object.defineProperty(ChildContactFormComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ChildContactFormComponent.prototype.ngOnInit = function () {
    };
    return ChildContactFormComponent;
}());
child_contact_form_component___decorate([
    Object(core_es5["Input"])('partyType'),
    child_contact_form_component___metadata("design:type", typeof (child_contact_form_component__a = typeof PartyType !== "undefined" && PartyType) === "function" && child_contact_form_component__a || Object)
], ChildContactFormComponent.prototype, "partyType", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])('contactReferenceNumberTitle'),
    child_contact_form_component___metadata("design:type", Object)
], ChildContactFormComponent.prototype, "contactReferenceNumberTitle", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])('contactForm'),
    child_contact_form_component___metadata("design:type", typeof (child_contact_form_component__b = typeof forms_es5["FormGroup"] !== "undefined" && forms_es5["FormGroup"]) === "function" && child_contact_form_component__b || Object)
], ChildContactFormComponent.prototype, "contactForm", void 0);
child_contact_form_component___decorate([
    Object(core_es5["Input"])('event'),
    child_contact_form_component___metadata("design:type", typeof (child_contact_form_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && child_contact_form_component__c || Object),
    child_contact_form_component___metadata("design:paramtypes", [typeof (child_contact_form_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && child_contact_form_component__d || Object])
], ChildContactFormComponent.prototype, "event", null);
child_contact_form_component___decorate([
    Object(core_es5["Input"])(),
    child_contact_form_component___metadata("design:type", Object)
], ChildContactFormComponent.prototype, "isReadOnly", void 0);
ChildContactFormComponent = child_contact_form_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-child-contact-form',
        template: __webpack_require__("9I5S")
    }),
    child_contact_form_component___metadata("design:paramtypes", [])
], ChildContactFormComponent);

var child_contact_form_component__a, child_contact_form_component__b, child_contact_form_component__c, child_contact_form_component__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/child-contact-form.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/stay-summary/stay-summary.component.ts
var stay_summary_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var stay_summary_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var stay_summary_component_StaySummaryComponent = (function () {
    function StaySummaryComponent(roomStore) {
        this.roomStore = roomStore;
    }
    Object.defineProperty(StaySummaryComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    StaySummaryComponent.prototype.ngOnInit = function () {
        this.roomTypeRateSummaryList = this.roomStore.getRoomStaySummaryFilteredByStatus(ReservationStatusCode.CHECKED_OUT)
            .map(function (roomStaySummary) {
            return roomStaySummary.roomTypeRateSummaryList;
        });
        this.staySummary = this.roomStore.getRoomStaySummaryFilteredByStatus(ReservationStatusCode.CHECKED_OUT)
            .map(function (roomStaySummary) {
            return roomStaySummary.staySummary;
        });
    };
    StaySummaryComponent.prototype.getCommission = function (revenue) {
        return revenue * this.onyxEvent.commissionRoomPercentage / 100;
    };
    return StaySummaryComponent;
}());
stay_summary_component___decorate([
    Object(core_es5["Input"])('event'),
    stay_summary_component___metadata("design:type", typeof (stay_summary_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && stay_summary_component__a || Object),
    stay_summary_component___metadata("design:paramtypes", [typeof (stay_summary_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && stay_summary_component__b || Object])
], stay_summary_component_StaySummaryComponent.prototype, "event", null);
stay_summary_component_StaySummaryComponent = stay_summary_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-stay-summary',
        template: __webpack_require__("+T/6")
    }),
    stay_summary_component___metadata("design:paramtypes", [typeof (stay_summary_component__c = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && stay_summary_component__c || Object])
], stay_summary_component_StaySummaryComponent);

var stay_summary_component__a, stay_summary_component__b, stay_summary_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/stay-summary.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/adjustment-utils.ts

var adjustment_utils_AdjustmentUtils = (function () {
    function AdjustmentUtils() {
    }
    AdjustmentUtils.isAdjustmentTypePositive = function (adjustmentType) {
        switch (adjustmentType) {
            case AdjustmentType.PREPAYMENT:
                return false;
            case AdjustmentType.REBATE:
                return true;
            default:
                return true;
        }
    };
    return AdjustmentUtils;
}());

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/adjustment-utils.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/add-payment/add-payment.component.ts
var add_payment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_payment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





















var add_payment_component_AddPaymentComponent = (function () {
    function AddPaymentComponent(formBuilder, paymentStore, adjustmentStore, translateService, environment, errorHandlerService, logService, currencyPipe, eventStore) {
        this.formBuilder = formBuilder;
        this.paymentStore = paymentStore;
        this.adjustmentStore = adjustmentStore;
        this.translateService = translateService;
        this.environment = environment;
        this.errorHandlerService = errorHandlerService;
        this.logService = logService;
        this.currencyPipe = currencyPipe;
        this.eventStore = eventStore;
        this.addPaymentEnabled = true;
        // this property exists so that the template can use the AdjustmentType enum
        this.adjustmentTypes = AdjustmentType;
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this.ui = {
            showDescription: false,
            showAuthorizePaymentButton: false
        };
    }
    Object.defineProperty(AddPaymentComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    AddPaymentComponent.prototype.ngOnInit = function () {
        this.paymentForm = this.formBuilder.group({
            'description': ['', forms_es5["Validators"].maxLength(255)]
        });
        this.adjustmentForm = this.formBuilder.group({
            // defaults to undefined so that someone is required to enter an amount before submitting
            'adjustmentAmount': [undefined, [forms_es5["Validators"].required, pioneer_validators_PioneerValidators.isValidCurrency]]
        });
        if (!this.onyxEvent) {
            this.errorHandlerService.throw('Input property onyxEvent is null in AddPaymentComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'AddPaymentComponent'
            }));
        }
        this.autoPaymentUI();
    };
    AddPaymentComponent.prototype.ngOnChanges = function (changes) {
        if (!changes['event']) {
            return;
        }
        this.autoPaymentUI();
    };
    AddPaymentComponent.prototype.isValidPaymentDate = function () {
        if (!this.onyxEvent || !this.onyxEvent.endDate) {
            return false;
        }
        var firstPayDate = new Date(this.onyxEvent.endDate);
        firstPayDate.setDate(firstPayDate.getDate() + this.environment.payments.paymentDelayDaysAfterEventEnd + 1);
        var firstPayDateUtcSeconds = firstPayDate.getTime();
        var currentUtcSeconds = new Date().getTime();
        var isValid = currentUtcSeconds >= firstPayDateUtcSeconds;
        this.logService.verbose("allow: " + firstPayDateUtcSeconds + ", current: " + currentUtcSeconds + ", isValid: " + isValid);
        return isValid;
    };
    AddPaymentComponent.prototype.confirmBeforeAuthorizingPayment = function () {
        var _this = this;
        // set up the title of the confirmation modal
        this.calculatedPayment.map(function (calculatedPayment) {
            var label = 'EVENT.COMMISSION.AUTHORIZE_PAYMENT_CONFIRMATION_TITLE';
            var currencyFormat = _this.currencyPipe.transform(calculatedPayment, 'USD', true);
            var params = { paymentAmount: currencyFormat };
            var title = _this.translateService.instant(label, params);
            _this.confirmationModalConfig.title = title;
        }).subscribe();
        this.confirmationModal.open();
    };
    AddPaymentComponent.prototype.addPayment = function () {
        var _this = this;
        var obs = this.calculatedPayment.first().flatMap(function (commissionAmount) {
            var description = _this.paymentForm.value.description;
            var payment = new Payment({
                commissionAmount: commissionAmount,
                description: description,
                currency: 'USD',
                eventId: _this.onyxEvent.eventId
            });
            _this.addPaymentEnabled = false;
            return _this.paymentStore.addPayment(payment).finally(function () {
                _this.addPaymentEnabled = true;
            });
        }).map(function () {
            _this.resetPaymentForm();
            var eventId = _this.onyxEvent.eventId;
            // firing off both calls because both have impacts elsewhere:
            //   CommissionComponent and PaymentEquationComponent
            _this.paymentStore.loadPayments(eventId).subscribe();
            _this.paymentStore.loadLatestPayment(eventId).subscribe();
        });
        obs.subscribe();
        return obs;
    };
    AddPaymentComponent.prototype.isAddPaymentEnabled = function () {
        var _this = this;
        return this.calculatedPayment.flatMap(function (currentCalculatedPayment) {
            return _this.eventStore.selectedEvent.flatMap(function (event) {
                return _this.paymentStore.isCurrentPaymentValid.map(function (currentPaymentValid) {
                    return _this.addPaymentEnabled &&
                        currentCalculatedPayment > 0 &&
                        !currentPaymentValid &&
                        _this.isValidPaymentDate() &&
                        _this.paymentForm.valid &&
                        EventUtils.doesEventHaveAgency(event);
                });
            });
        });
    };
    AddPaymentComponent.prototype.resetPaymentForm = function () {
        this.paymentForm.reset({
            description: ''
        });
    };
    AddPaymentComponent.prototype.addAdjustment = function (adjustmentType) {
        var _this = this;
        if (this.adjustmentForm.valid && this.adjustmentForm.value.adjustmentAmount > 0) {
            var adjustmentAmount = this.adjustmentForm.value.adjustmentAmount;
            if (!adjustment_utils_AdjustmentUtils.isAdjustmentTypePositive(adjustmentType)) {
                adjustmentAmount = -adjustmentAmount;
            }
            var adjustment = new Adjustment({
                eventId: this.onyxEvent.eventId,
                adjustmentAmount: adjustmentAmount,
                adjustmentType: adjustmentType
            });
            // this.adjustmentForm.disable();
            var obs = this.adjustmentStore.addAdjustment(adjustment).finally(function () {
                _this.adjustmentForm.enable();
            }).map(function () {
                _this.resetAdjustmentForm();
                _this.adjustmentStore.loadAdjustments(_this.onyxEvent.eventId).subscribe();
            });
            obs.subscribe();
            return obs;
        }
        else {
            return Observable["Observable"].of(false);
        }
    };
    AddPaymentComponent.prototype.resetAdjustmentForm = function () {
        this.adjustmentForm.reset({
            adjustmentAmount: undefined,
        });
    };
    AddPaymentComponent.prototype.confirmBeforeAddPaymentHandler = function (value) {
        if (value) {
            this.addPayment();
        }
    };
    Object.defineProperty(AddPaymentComponent.prototype, "calculatedPayment", {
        get: function () {
            return this.adjustmentStore.getCalculatedPayment(ReservationStatusCode.CHECKED_OUT);
        },
        enumerable: true,
        configurable: true
    });
    AddPaymentComponent.prototype.autoPaymentUI = function () {
        var autoPayment = this.onyxEvent.autoPayment;
        if (autoPayment === true) {
            this.ui.showDescription = false;
            this.ui.showAuthorizePaymentButton = false;
        }
        else {
            this.ui.showDescription = true;
            this.ui.showAuthorizePaymentButton = true;
        }
    };
    return AddPaymentComponent;
}());
add_payment_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    add_payment_component___metadata("design:type", typeof (add_payment_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && add_payment_component__a || Object)
], add_payment_component_AddPaymentComponent.prototype, "confirmationModal", void 0);
add_payment_component___decorate([
    Object(core_es5["Input"])('event'),
    add_payment_component___metadata("design:type", typeof (add_payment_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_payment_component__b || Object),
    add_payment_component___metadata("design:paramtypes", [typeof (add_payment_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_payment_component__c || Object])
], add_payment_component_AddPaymentComponent.prototype, "event", null);
add_payment_component_AddPaymentComponent = add_payment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-payment',
        template: __webpack_require__("vWpv")
    }),
    add_payment_component___metadata("design:paramtypes", [typeof (add_payment_component__d = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && add_payment_component__d || Object, typeof (add_payment_component__e = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && add_payment_component__e || Object, typeof (add_payment_component__f = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && add_payment_component__f || Object, typeof (add_payment_component__g = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && add_payment_component__g || Object, typeof (add_payment_component__h = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && add_payment_component__h || Object, typeof (add_payment_component__j = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && add_payment_component__j || Object, typeof (add_payment_component__k = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && add_payment_component__k || Object, typeof (add_payment_component__l = typeof common_es5["CurrencyPipe"] !== "undefined" && common_es5["CurrencyPipe"]) === "function" && add_payment_component__l || Object, typeof (_m = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && _m || Object])
], add_payment_component_AddPaymentComponent);

var add_payment_component__a, add_payment_component__b, add_payment_component__c, add_payment_component__d, add_payment_component__e, add_payment_component__f, add_payment_component__g, add_payment_component__h, add_payment_component__j, add_payment_component__k, add_payment_component__l, _m;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/add-payment.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/attachment/attachment.component.ts
var attachment_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var attachment_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};









var attachment_component_AttachmentComponent = (function () {
    function AttachmentComponent(attachmentStore, flashMessagesService, authStore, environment) {
        this.attachmentStore = attachmentStore;
        this.flashMessagesService = flashMessagesService;
        this.authStore = authStore;
        this.environment = environment;
        /**
         * Used to determine if the upload bar should be shown while an attachment is uploading.
         * Determines animation delay before attachment list is refreshed.
         * @type {boolean}
         */
        this.isUploadInProgress = false;
        /**
         * Set when attachment delete starts.
         * Determines animation length before attachment list is refreshed.
         * @type {boolean}
         */
        this.isDeleteInProgress = false;
        /**
         * Sets css class on newest item.
         * @type {boolean}
         */
        this.isNewAttachment = false;
        this.startDate = new Date();
        this.fileTypes = this.environment.events.acceptedFileTypes;
        this.maxFileSize = this.environment.events.maxFileSize * 1024 * 1024;
        this.attachments = Object(immutable["List"])([]);
    }
    Object.defineProperty(AttachmentComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    AttachmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.removedAttachments = new Set();
        if (!this.onyxEvent) {
            throw new Error("An event is required to create the \"pioneer-attachement\" component");
        }
        this.attachmentStore.attachments.subscribe(function (attachments) {
            // No animation delay needed if we're not deleting or uploading an attachment.
            var animationDelay = 0;
            if (_this.isDeleteInProgress) {
                animationDelay = 500;
            }
            else if (_this.isUploadInProgress) {
                animationDelay = 1000;
            }
            setTimeout(function () {
                _this.attachments = attachments;
                _this.isNewAttachment = _this.isUploadInProgress;
                // When attachments are refreshed, "reset" page (nothing uploading or being deleted)
                _this.isUploadInProgress = false;
                _this.isDeleteInProgress = false;
                _this.removedAttachments = new Set();
            }, _this.getAnimationDelay(animationDelay, _this.startDate));
        });
    };
    AttachmentComponent.prototype.uploadFile = function (inputEvent) {
        var _this = this;
        this.startDate = new Date();
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_ATTACHMENT');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        this.clearFileInput();
        if (file.size > this.maxFileSize) {
            this.handleUploadError('MESSAGES.ERROR.ATTACHMENT_TOO_LARGE');
            return;
        }
        if (this.environment.events.acceptedFileTypes.indexOf(file.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.ATTACHMENT_UNSUPPORTED_FILE_TYPE');
            return;
        }
        this.attachmentStore.addAttachment(this.onyxEvent.eventId, file)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_ATTACHMENT', "Error uploading attachment: " + error);
            _this.isUploadInProgress = false;
            _this.isNewAttachment = false;
            return Observable["Observable"].throw(error);
        }).subscribe();
    };
    AttachmentComponent.prototype.openFile = function (attachment) {
        var _this = this;
        this.attachmentStore.get(attachment.uniqueId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DOWNLOAD_ATTACHMENT', "Error retrieving attachments; " + error);
            return Observable["Observable"].throw(error);
        }).subscribe();
    };
    /**
     * Deletes attachment as well as triggers deletion animation.
     * @param attachment
     * @returns {Observable<R|T>}
     */
    AttachmentComponent.prototype.deleteFile = function (attachment) {
        var _this = this;
        this.startDate = new Date();
        this.isDeleteInProgress = true;
        // This triggers the animation on the specific item.
        this.removedAttachments.add(attachment.uniqueId);
        this.attachmentStore.deleteAttachment(this.onyxEvent.eventId, attachment.uniqueId)
            .catch(function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.DELETE_ATTACHMENT', error);
            _this.removedAttachments.delete(attachment.uniqueId);
            return Observable["Observable"].throw(error);
        }).subscribe();
    };
    AttachmentComponent.prototype.confirmBeforeDelete = function (attachment) {
        this.attachmentToRemove = attachment;
        this.confirmationModal.open();
    };
    AttachmentComponent.prototype.confirmHandler = function (value) {
        if (value) {
            this.deleteFile(this.attachmentToRemove);
        }
        this.attachmentToRemove = null;
    };
    AttachmentComponent.prototype.getAnimationDelay = function (delayMillis, startDate) {
        var animationDelay = delayMillis - (new Date().valueOf() - startDate.valueOf());
        return animationDelay > 0 ? animationDelay : 0;
    };
    AttachmentComponent.prototype.getFileExtension = function (filename) {
        if (!filename) {
            return '';
        }
        var filenameParts = filename.split('.');
        return filenameParts[filenameParts.length - 1];
    };
    AttachmentComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    AttachmentComponent.prototype.canDeleteFiles = function () {
        return this.authStore.hasPermission('DeleteFiles');
    };
    AttachmentComponent.prototype.clearFileInput = function () {
        this.fileInput.nativeElement.value = null;
    };
    return AttachmentComponent;
}());
attachment_component___decorate([
    Object(core_es5["HostBinding"])('class.margin-content'),
    attachment_component___metadata("design:type", Object)
], attachment_component_AttachmentComponent.prototype, "true", void 0);
attachment_component___decorate([
    Object(core_es5["ViewChild"])('file'),
    attachment_component___metadata("design:type", typeof (attachment_component__a = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && attachment_component__a || Object)
], attachment_component_AttachmentComponent.prototype, "fileInput", void 0);
attachment_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    attachment_component___metadata("design:type", typeof (attachment_component__b = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && attachment_component__b || Object)
], attachment_component_AttachmentComponent.prototype, "confirmationModal", void 0);
attachment_component___decorate([
    Object(core_es5["Input"])(),
    attachment_component___metadata("design:type", typeof (attachment_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && attachment_component__c || Object),
    attachment_component___metadata("design:paramtypes", [typeof (attachment_component__d = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && attachment_component__d || Object])
], attachment_component_AttachmentComponent.prototype, "event", null);
attachment_component_AttachmentComponent = attachment_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-attachment',
        template: __webpack_require__("Jeo/")
    }),
    attachment_component___metadata("design:paramtypes", [typeof (attachment_component__e = typeof attachment_store_AttachmentStore !== "undefined" && attachment_store_AttachmentStore) === "function" && attachment_component__e || Object, typeof (attachment_component__f = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && attachment_component__f || Object, typeof (attachment_component__g = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && attachment_component__g || Object, typeof (attachment_component__h = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && attachment_component__h || Object])
], attachment_component_AttachmentComponent);

var attachment_component__a, attachment_component__b, attachment_component__c, attachment_component__d, attachment_component__e, attachment_component__f, attachment_component__g, attachment_component__h;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/attachment.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/match-type.enum.ts
var MatchTypeEnum;
(function (MatchTypeEnum) {
    MatchTypeEnum[MatchTypeEnum["EXACT_MATCH"] = 'Exact'] = "EXACT_MATCH";
    MatchTypeEnum[MatchTypeEnum["PARTIAL_MATCH"] = 'Partial'] = "PARTIAL_MATCH";
    MatchTypeEnum[MatchTypeEnum["NO_MATCH"] = 'NoMatch'] = "NO_MATCH";
})(MatchTypeEnum || (MatchTypeEnum = {}));
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/match-type.enum.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-nav/event-nav.component.ts
var event_nav_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_nav_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var event_nav_component_EventNavComponent = (function () {
    function EventNavComponent(eventStore, reservationCompareStore, route) {
        this.eventStore = eventStore;
        this.reservationCompareStore = reservationCompareStore;
        this.route = route;
        this.classes = 'margin-content';
        this.elementId = 'scrollSpyId';
        this.MatchTypeEnum = MatchTypeEnum;
    }
    EventNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onyxEvent = new OnyxEvent();
        this.eventStore.selectedEvent.subscribe(function (value) {
            _this.onyxEvent = new OnyxEvent(value);
        });
    };
    EventNavComponent.prototype.getReservationSummarySelected = function () {
        return this.reservationCompareStore.getShowReservationSummary();
    };
    EventNavComponent.prototype.isFilteredMatchListEmpty = function (matchType) {
        return this.reservationCompareStore.isFilteredMatchListEmpty(matchType);
    };
    EventNavComponent.prototype.shouldShowMatchTypeLink = function (matchType) {
        return this.reservationCompareStore.isMatchListEmpty(matchType).map(function (result) { return !result; });
    };
    EventNavComponent.prototype.getContractSummaryRouterLink = function () {
        var lastSegment = route_utils_RouteUtils.getLastUrlSegmentSnapshot(this.route);
        if (lastSegment && lastSegment.path === 'edit') {
            return ['/event/' + this.onyxEvent.eventId + '/edit'];
        }
        else {
            return ['/event/' + this.onyxEvent.eventId];
        }
    };
    EventNavComponent.prototype.getNoMatchNavTitle = function () {
        return reservation_utils_ReservationUtils.getNumberOfRsvps(this.reservationCompareStore.getReservationList()).map(function (size) {
            return size > 0 ? 'EVENT.RESERVATION.NO_MATCH_TITLE' : 'EVENT.RESERVATION.NO_RSVP_TITLE';
        });
    };
    return EventNavComponent;
}());
event_nav_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    event_nav_component___metadata("design:type", Object)
], event_nav_component_EventNavComponent.prototype, "classes", void 0);
event_nav_component___decorate([
    Object(core_es5["HostBinding"])('id'),
    event_nav_component___metadata("design:type", Object)
], event_nav_component_EventNavComponent.prototype, "elementId", void 0);
event_nav_component_EventNavComponent = event_nav_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-nav',
        template: __webpack_require__("op3L")
    }),
    event_nav_component___metadata("design:paramtypes", [typeof (event_nav_component__a = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && event_nav_component__a || Object, typeof (event_nav_component__b = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && event_nav_component__b || Object, typeof (event_nav_component__c = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && event_nav_component__c || Object])
], event_nav_component_EventNavComponent);

var event_nav_component__a, event_nav_component__b, event_nav_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-nav.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/rsvp-list/rsvp-list.component.ts
var rsvp_list_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var rsvp_list_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var RsvpListComponent = (function () {
    function RsvpListComponent(rsvpStore) {
        this.rsvpStore = rsvpStore;
    }
    Object.defineProperty(RsvpListComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    RsvpListComponent.prototype.ngOnInit = function () {
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the "pioneer-rsvp-list" component');
        }
    };
    Object.defineProperty(RsvpListComponent.prototype, "rsvps", {
        get: function () {
            return this.rsvpStore.rsvps;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpListComponent.prototype, "totalNights", {
        get: function () {
            return this.rsvpStore.totalNights;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpListComponent.prototype, "totalRevenue", {
        get: function () {
            return this.rsvpStore.totalRevenue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpListComponent.prototype, "totalCommission", {
        get: function () {
            return this.rsvpStore.totalCommission;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RsvpListComponent.prototype, "isRsvpListEmpty", {
        get: function () {
            return this.rsvps.map(function (rsvpList) { return rsvpList.size === 0; });
        },
        enumerable: true,
        configurable: true
    });
    RsvpListComponent.prototype.confirmBeforeDelete = function (rsvp) {
        this.rsvpToRemove = rsvp;
        this.confirmationModal.open();
    };
    RsvpListComponent.prototype.confirmHandler = function (deleteConfirmed) {
        if (deleteConfirmed) {
            this.deleteRsvp(this.rsvpToRemove);
        }
        this.rsvpToRemove = null;
    };
    RsvpListComponent.prototype.deleteRsvp = function (rsvp) {
        var obs = this.rsvpStore.deleteRsvp(rsvp);
        obs.subscribe();
        return obs;
    };
    return RsvpListComponent;
}());
rsvp_list_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    rsvp_list_component___metadata("design:type", typeof (rsvp_list_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && rsvp_list_component__a || Object)
], RsvpListComponent.prototype, "confirmationModal", void 0);
rsvp_list_component___decorate([
    Object(core_es5["Input"])('event'),
    rsvp_list_component___metadata("design:type", typeof (rsvp_list_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_list_component__b || Object),
    rsvp_list_component___metadata("design:paramtypes", [typeof (rsvp_list_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && rsvp_list_component__c || Object])
], RsvpListComponent.prototype, "event", null);
RsvpListComponent = rsvp_list_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-rsvp-list',
        template: __webpack_require__("lcuP")
    }),
    rsvp_list_component___metadata("design:paramtypes", [typeof (rsvp_list_component__d = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && rsvp_list_component__d || Object])
], RsvpListComponent);

var rsvp_list_component__a, rsvp_list_component__b, rsvp_list_component__c, rsvp_list_component__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/rsvp-list.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-filter/reservation-filter.component.ts
var reservation_filter_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_filter_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var reservation_filter_component_ReservationFilterComponent = (function () {
    function ReservationFilterComponent(logService, reservationCompareStore) {
        this.logService = logService;
        this.reservationCompareStore = reservationCompareStore;
        this.activeStatusCodes = reservation_compare_store_ReservationCompareStore.STATUS_CODES;
        this.ReservationStatusCode = ReservationStatusCode;
        this.reserved = true;
        this.checkedIn = true;
        this.checkedOut = true;
        this.cancelled = true;
        this.noShow = true;
        this.rsvp = true;
    }
    Object.defineProperty(ReservationFilterComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ReservationFilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.reservationCompareStore.getActiveStatusCodes().subscribe(function (statusCodes) {
            _this.reserved = _this.isPresent(ReservationStatusCode.RESERVED, statusCodes);
            _this.checkedOut = _this.isPresent(ReservationStatusCode.CHECKED_OUT, statusCodes);
            _this.checkedIn = _this.isPresent(ReservationStatusCode.CHECKED_IN, statusCodes);
            _this.cancelled = _this.isPresent(ReservationStatusCode.CANCELLED, statusCodes);
            _this.noShow = _this.isPresent(ReservationStatusCode.NO_SHOW, statusCodes);
        });
    };
    ReservationFilterComponent.prototype.toggleReserved = function () {
        this.toggleStatusCode(ReservationStatusCode.RESERVED);
    };
    ReservationFilterComponent.prototype.toggleCheckedIn = function () {
        this.toggleStatusCode(ReservationStatusCode.CHECKED_IN);
    };
    ReservationFilterComponent.prototype.toggleCheckedOut = function () {
        this.toggleStatusCode(ReservationStatusCode.CHECKED_OUT);
    };
    ReservationFilterComponent.prototype.toggleCancelled = function () {
        this.toggleStatusCode(ReservationStatusCode.CANCELLED);
    };
    ReservationFilterComponent.prototype.toggleNoShow = function () {
        this.toggleStatusCode(ReservationStatusCode.NO_SHOW);
    };
    ReservationFilterComponent.prototype.toggleRsvp = function () {
        this.toggleStatusCode(ReservationStatusCode.RSVP);
    };
    ReservationFilterComponent.prototype.isPresent = function (statusCode, statusCodes) {
        return !Object(util_util["isNullOrUndefined"])(statusCodes.find(function (code) { return code === statusCode; }));
    };
    ReservationFilterComponent.prototype.getActiveStatusCodes = function () {
        return this.reservationCompareStore.getActiveStatusCodes();
    };
    ReservationFilterComponent.prototype.getSummarySelected = function () {
        return this.reservationCompareStore.getShowReservationSummary();
    };
    ReservationFilterComponent.prototype.updateModelWithStatusCode = function (statusCode, value) {
        switch (statusCode) {
            case ReservationStatusCode.CANCELLED:
                this.cancelled = value;
                break;
            case ReservationStatusCode.CHECKED_OUT:
                this.checkedOut = value;
                break;
            case ReservationStatusCode.CHECKED_IN:
                this.checkedIn = value;
                break;
            case ReservationStatusCode.RESERVED:
                this.reserved = value;
                break;
            case ReservationStatusCode.NO_SHOW:
                this.noShow = value;
                break;
            case ReservationStatusCode.RSVP:
                this.rsvp = value;
                break;
        }
    };
    ReservationFilterComponent.prototype.toggleStatusCode = function (statusCode) {
        this.logService.verbose("toggleStatusCode " + statusCode + " ");
        var statusCodes = this.reservationCompareStore.getInstantActiveStatusCodes();
        var isPresent = this.isPresent(statusCode, statusCodes);
        this.logService.verbose("toggleStatusCode " + isPresent + " - " + JSON.stringify(statusCodes));
        this.updateModelWithStatusCode(statusCode, !isPresent);
        if (isPresent) {
            this.updateStatusCode(statusCodes.filter(function (code) { return code !== statusCode; }));
        }
        else {
            this.updateStatusCode(statusCodes.concat([statusCode]));
        }
    };
    ReservationFilterComponent.prototype.updateStatusCode = function (statusCodes) {
        this.logService.verbose("UpdateStatusCode: " + JSON.stringify(statusCodes));
        this.reservationCompareStore.setActiveStatusCodes(statusCodes);
    };
    return ReservationFilterComponent;
}());
reservation_filter_component___decorate([
    Object(core_es5["Input"])('event'),
    reservation_filter_component___metadata("design:type", typeof (reservation_filter_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_filter_component__a || Object),
    reservation_filter_component___metadata("design:paramtypes", [typeof (reservation_filter_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_filter_component__b || Object])
], reservation_filter_component_ReservationFilterComponent.prototype, "event", null);
reservation_filter_component_ReservationFilterComponent = reservation_filter_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-filter',
        template: __webpack_require__("c28g")
    }),
    reservation_filter_component___metadata("design:paramtypes", [typeof (reservation_filter_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_filter_component__c || Object, typeof (reservation_filter_component__d = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_filter_component__d || Object])
], reservation_filter_component_ReservationFilterComponent);

var reservation_filter_component__a, reservation_filter_component__b, reservation_filter_component__c, reservation_filter_component__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-filter.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-summary-table/reservation-summary-table.component.ts
var reservation_summary_table_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_summary_table_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var reservation_summary_table_component_ReservationSummaryTableComponent = (function () {
    function ReservationSummaryTableComponent(reservationCompareStore, translateService, logService) {
        this.reservationCompareStore = reservationCompareStore;
        this.translateService = translateService;
        this.logService = logService;
        this.filteredClass = '';
    }
    Object.defineProperty(ReservationSummaryTableComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ReservationSummaryTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.statusCodes = this.reservationCompareStore.getActiveStatusCodes();
        this.reservations = this.reservationCompareStore.getReservationList()
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyReservationsFilter(reservationList); });
        this.isFiltered().subscribe(function (isFiltered) {
            if (isFiltered) {
                _this.filteredClass = 'filtered';
            }
            else {
                _this.filteredClass = '';
            }
        });
    };
    ReservationSummaryTableComponent.prototype.getReservations = function () {
        return this.reservations;
    };
    ReservationSummaryTableComponent.prototype.getRsvps = function () {
        return this.reservationCompareStore.getReservationList()
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyRsvpFilter(reservationList); });
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservations = function () {
        return this.reservationCompareStore.getCurrentFilteredReservations()
            .map(function (reservationList) { return reservation_utils_ReservationUtils.onlyReservationsFilter(reservationList); });
    };
    ReservationSummaryTableComponent.prototype.getReservationRevenueTotal = function () {
        return reservation_utils_ReservationUtils.calculateRevenueTotal(this.getReservations());
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservationRevenueTotal = function () {
        return reservation_utils_ReservationUtils.calculateRevenueTotal(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.getReservationCommissionTotal = function () {
        return reservation_utils_ReservationUtils.calculateCommissionTotal(this.getReservations());
    };
    ReservationSummaryTableComponent.prototype.getRsvpCommissionTotal = function () {
        return reservation_utils_ReservationUtils.calculateRsvpCommissionTotal(this.getRsvps());
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservationCommissionTotal = function () {
        return reservation_utils_ReservationUtils.calculateCommissionTotal(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.getFilteredReservationNightsTotal = function () {
        return reservation_utils_ReservationUtils.calculateReservationTotalNights(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.isReservationListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.getReservations());
    };
    ReservationSummaryTableComponent.prototype.isRsvpListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.getRsvps());
    };
    ReservationSummaryTableComponent.prototype.isFilteredListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.getFilteredReservations());
    };
    ReservationSummaryTableComponent.prototype.isFiltered = function () {
        var filteredSizeObs = reservation_utils_ReservationUtils.getListSize(this.getFilteredReservations());
        var unfilteredSizeObs = reservation_utils_ReservationUtils.getListSize(this.getReservations());
        return filteredSizeObs.flatMap(function (filteredSize) {
            return unfilteredSizeObs.map(function (unfilteredSize) {
                return filteredSize !== unfilteredSize;
            });
        });
    };
    ReservationSummaryTableComponent.prototype.getCommissionDelta = function () {
        var reservationCommissionObj = this.getReservationCommissionTotal();
        var rsvpCommissionObj = this.getRsvpCommissionTotal();
        return reservationCommissionObj.flatMap(function (reservationCommission) {
            return rsvpCommissionObj.map(function (rsvpCommission) {
                return reservationCommission - rsvpCommission;
            });
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationSummaryTableComponent.prototype.getCommissionDeltaText = function () {
        var _this = this;
        return this.getCommissionDelta().flatMap(function (delta) {
            if (delta > 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_MORE');
            }
            else if (delta < 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_LESS');
            }
            else {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_EQUAL');
            }
        });
    };
    ReservationSummaryTableComponent.prototype.hasFilteredOutResults = function () {
        var _this = this;
        return reservation_utils_ReservationUtils.isListEmpty(this.getFilteredReservations()).flatMap(function (filteredListIsEmpty) {
            return _this.isReservationListEmpty().map(function (isReservationListEmpty) { return filteredListIsEmpty !== isReservationListEmpty; });
        });
    };
    ReservationSummaryTableComponent.prototype.resetStatusCodes = function () {
        this.reservationCompareStore.resetStatusCodes();
    };
    ReservationSummaryTableComponent.prototype.totalCommissionClass = function () {
        var _this = this;
        return this.reservationCompareStore.areRsvpsPresent().flatMap(function (hasRsvps) {
            return _this.getCommissionDelta().map(function (total) {
                return hasRsvps && total > 0 ? 'commission-up' : hasRsvps && total < 0 ? 'commission-down' : '';
            });
        });
    };
    ReservationSummaryTableComponent.prototype.getStatusClass = function (compare) {
        if (compare.reservation) {
            switch (compare.reservation.status) {
                case 'R':
                    return 'res-status-reserved';
                case 'I':
                    return 'res-status-checked-in';
                case 'O':
                    return 'res-status-checked-out';
                case 'C':
                    return 'res-status-cancelled';
                case 'N':
                    return 'res-status-no-show';
                default:
                    return '';
            }
        }
        return '';
    };
    ReservationSummaryTableComponent.prototype.isCommissionUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission > 0;
    };
    ReservationSummaryTableComponent.prototype.isCommissionDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission < 0;
    };
    return ReservationSummaryTableComponent;
}());
reservation_summary_table_component___decorate([
    Object(core_es5["Input"])('event'),
    reservation_summary_table_component___metadata("design:type", typeof (reservation_summary_table_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_summary_table_component__a || Object),
    reservation_summary_table_component___metadata("design:paramtypes", [typeof (reservation_summary_table_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_summary_table_component__b || Object])
], reservation_summary_table_component_ReservationSummaryTableComponent.prototype, "event", null);
reservation_summary_table_component_ReservationSummaryTableComponent = reservation_summary_table_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-summary-table',
        template: __webpack_require__("kYhW")
    }),
    reservation_summary_table_component___metadata("design:paramtypes", [typeof (reservation_summary_table_component__c = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_summary_table_component__c || Object, typeof (reservation_summary_table_component__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_summary_table_component__d || Object, typeof (reservation_summary_table_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_summary_table_component__e || Object])
], reservation_summary_table_component_ReservationSummaryTableComponent);

var reservation_summary_table_component__a, reservation_summary_table_component__b, reservation_summary_table_component__c, reservation_summary_table_component__d, reservation_summary_table_component__e;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-summary-table.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/add-rsvp/add-rsvp.component.ts
var add_rsvp_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var add_rsvp_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var add_rsvp_component_AddRsvpComponent = (function () {
    function AddRsvpComponent(formBuilder, rsvpStore, environment, flashMessagesService) {
        this.formBuilder = formBuilder;
        this.rsvpStore = rsvpStore;
        this.environment = environment;
        this.flashMessagesService = flashMessagesService;
    }
    Object.defineProperty(AddRsvpComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    AddRsvpComponent.prototype.ngOnInit = function () {
        this.isUploadInProgress = false;
        if (!this.onyxEvent) {
            throw new Error('The "event" attribute must be specified to use the AddRsvpComponent component');
        }
        this.rsvpForm = this.formBuilder.group({
            firstName: [null, [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(255)]],
            lastName: [null, [forms_es5["Validators"].required, forms_es5["Validators"].maxLength(255)]],
            nights: [null, [forms_es5["Validators"].required, dist["CustomValidators"].gte(1), pioneer_validators_PioneerValidators.isInteger]],
            roomRate: [null, [pioneer_validators_PioneerValidators.isValidCurrency]]
        });
        this.fileExtensions = this.environment.rsvps.acceptedFileExtensions;
    };
    Object.defineProperty(AddRsvpComponent.prototype, "commissionRoomPercentage", {
        get: function () {
            if (Object(util_util["isNullOrUndefined"])(this.onyxEvent)) {
                return 0;
            }
            return this.onyxEvent.commissionRoomPercentage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddRsvpComponent.prototype, "revenue", {
        /**
         * Will show placeholder if null
         * @return revenue
         */
        get: function () {
            var nights = this.rsvpForm.get('nights').value;
            var roomRate = this.rsvpForm.get('roomRate').value;
            // an empty form field comes in as null
            if (Object(util_util["isNullOrUndefined"])(nights) || Object(util_util["isNullOrUndefined"])(roomRate)) {
                return 0;
            }
            var calculation = Number(nights * roomRate);
            return Number(calculation.toFixed(2));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AddRsvpComponent.prototype, "commission", {
        /**
         * Will show placeholder if null
         * @return commission
         */
        get: function () {
            var calculation = Number(this.revenue * this.commissionRoomPercentage / 100);
            return Number(calculation.toFixed(2));
        },
        enumerable: true,
        configurable: true
    });
    AddRsvpComponent.prototype.addRsvp = function () {
        var _this = this;
        this.rsvpForm.disable();
        var rsvp = new Rsvp({
            eventId: this.onyxEvent.eventId,
            firstName: this.rsvpForm.get('firstName').value,
            lastName: this.rsvpForm.get('lastName').value,
            nights: this.rsvpForm.get('nights').value,
            roomRate: this.rsvpForm.get('roomRate').value
        });
        var obs = this.rsvpStore.addRsvp(rsvp).finally(function () {
            // always re enable form
            _this.rsvpForm.enable();
        });
        obs.subscribe(function () {
            _this.resetForm();
        });
        return obs;
    };
    AddRsvpComponent.prototype.handleUploadError = function (errorMessage, logMessage) {
        if (logMessage === void 0) { logMessage = null; }
        this.isUploadInProgress = false;
        this.flashMessagesService.error(errorMessage, logMessage);
    };
    AddRsvpComponent.prototype.importRsvpViaCsv = function (inputEvent) {
        var _this = this;
        this.isUploadInProgress = true;
        if (!inputEvent || !inputEvent.srcElement || !inputEvent.srcElement.files || inputEvent.srcElement.files.size === 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_RSVPS');
            return;
        }
        var file = inputEvent.srcElement.files[0];
        this.clearFileInput();
        if (this.environment.rsvps.acceptedFileTypes.indexOf(file.type) < 0) {
            this.handleUploadError('MESSAGES.ERROR.UPLOAD_RSVPS');
            return;
        }
        var eventId = this.onyxEvent.eventId;
        this.rsvpStore.importRsvpViaCsv(eventId, file)
            .finally(function () {
            _this.isUploadInProgress = false;
        })
            .catch((function (error) {
            _this.flashMessagesService.error('MESSAGES.ERROR.UPLOAD_RSVPS', "Error uploading RSVPs: " + error);
            return Observable["Observable"].throw(error);
        }))
            .subscribe(function (response) {
            _this.flashMessagesService.success('MESSAGES.SUCCESS.RSVP_IMPORT', null, { rsvpCount: Number(response.text()) });
        });
    };
    /**
     * This needs to be called whenever we do an upload so that someone could do a second upload with a different file
     * without having to reload the page.
     */
    AddRsvpComponent.prototype.clearFileInput = function () {
        this.fileInput.nativeElement.value = null;
    };
    AddRsvpComponent.prototype.resetForm = function () {
        this.rsvpForm.reset({
            firstName: null,
            lastName: null,
            nights: null,
            roomRate: null
        });
    };
    return AddRsvpComponent;
}());
add_rsvp_component___decorate([
    Object(core_es5["ViewChild"])('file'),
    add_rsvp_component___metadata("design:type", typeof (add_rsvp_component__a = typeof core_es5["ElementRef"] !== "undefined" && core_es5["ElementRef"]) === "function" && add_rsvp_component__a || Object)
], add_rsvp_component_AddRsvpComponent.prototype, "fileInput", void 0);
add_rsvp_component___decorate([
    Object(core_es5["Input"])('event'),
    add_rsvp_component___metadata("design:type", typeof (add_rsvp_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_rsvp_component__b || Object),
    add_rsvp_component___metadata("design:paramtypes", [typeof (add_rsvp_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && add_rsvp_component__c || Object])
], add_rsvp_component_AddRsvpComponent.prototype, "event", null);
add_rsvp_component_AddRsvpComponent = add_rsvp_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-add-rsvp',
        template: __webpack_require__("Upgs")
    }),
    add_rsvp_component___metadata("design:paramtypes", [typeof (add_rsvp_component__d = typeof forms_es5["FormBuilder"] !== "undefined" && forms_es5["FormBuilder"]) === "function" && add_rsvp_component__d || Object, typeof (add_rsvp_component__e = typeof rsvp_store_RsvpStore !== "undefined" && rsvp_store_RsvpStore) === "function" && add_rsvp_component__e || Object, typeof (add_rsvp_component__f = typeof EnvironmentConfiguration !== "undefined" && EnvironmentConfiguration) === "function" && add_rsvp_component__f || Object, typeof (add_rsvp_component__g = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && add_rsvp_component__g || Object])
], add_rsvp_component_AddRsvpComponent);

var add_rsvp_component__a, add_rsvp_component__b, add_rsvp_component__c, add_rsvp_component__d, add_rsvp_component__e, add_rsvp_component__f, add_rsvp_component__g;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/add-rsvp.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-table.component.ts
var reservation_detail_table_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var reservation_detail_table_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var reservation_detail_table_component___param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};











var reservation_detail_table_component_ReservationDetailTableComponent = (function () {
    function ReservationDetailTableComponent(reservationCompareStore, translateService, logService, pageScrollService, document) {
        this.reservationCompareStore = reservationCompareStore;
        this.translateService = translateService;
        this.logService = logService;
        this.pageScrollService = pageScrollService;
        this.document = document;
        this.MatchTypeEnum = MatchTypeEnum;
        this.pageScrollId = null;
        this.ui = {
            showCards: false,
            showNoMatchesCard: false,
            showNoMatchesDetails: false,
            showNoMatchesWarningCard: false,
            showPartialMatchesCard: false,
            showPartialMatchesDetails: false,
            showPartialMatchesWarningCard: false,
            showExactMatchesCard: false,
            showExactMatchesDetails: false,
            showExactMatchesWarningCard: false,
            showNoReservationsWarning: false,
            showNoMatchRsvpTotal: false
        };
    }
    Object.defineProperty(ReservationDetailTableComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    ReservationDetailTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.statusCodes = this.reservationCompareStore.getActiveStatusCodes();
        this.reservationCompareList = this.reservationCompareStore.getReservationList();
        // all cards
        this.isReservationCompareListEmpty().subscribe(function (value) {
            _this.ui.showNoReservationsWarning = value;
            _this.ui.showCards = !value;
        });
        // no matches
        this.isUnfilteredMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe(function (value) {
            _this.ui.showNoMatchesCard = !value;
        });
        this.isFilteredMatchListEmpty(MatchTypeEnum.NO_MATCH).subscribe(function (value) {
            _this.ui.showNoMatchesDetails = !value;
            _this.ui.showNoMatchesWarningCard = value;
        });
        // show RSVP total in 'no matches' section if RSVPs are present
        this.reservationCompareStore.areRsvpsPresent().subscribe(function (rsvpsPresent) {
            _this.ui.showNoMatchRsvpTotal = rsvpsPresent;
        });
        // partial matches
        this.isUnfilteredMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe(function (value) {
            _this.ui.showPartialMatchesCard = !value;
        });
        this.isFilteredMatchListEmpty(MatchTypeEnum.PARTIAL_MATCH).subscribe(function (value) {
            _this.ui.showPartialMatchesDetails = !value;
            _this.ui.showPartialMatchesWarningCard = value;
        });
        // exact matches
        this.isUnfilteredMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe(function (value) {
            _this.ui.showExactMatchesCard = !value;
        });
        this.isFilteredMatchListEmpty(MatchTypeEnum.EXACT_MATCH).subscribe(function (value) {
            _this.ui.showExactMatchesDetails = !value;
            _this.ui.showExactMatchesWarningCard = value;
        });
    };
    ReservationDetailTableComponent.prototype.ngAfterViewInit = function () {
        var rsvpId = this.reservationCompareStore.selectedRsvpId;
        var reservationId = this.reservationCompareStore.selectedReservationId;
        this.logService.verbose("rsvp: " + rsvpId + ", reservation: " + reservationId);
        var elem;
        if (reservationId) {
            var id = this.getReservationId(reservationId);
            elem = document.querySelector("[data-res-id=" + id + "]");
            elem.classList.add('highlight');
            this.logService.verbose("page scrolling to selector: [data-res-id=" + id + "]");
            this.scrollToElement(elem);
        }
        else if (rsvpId) {
            var id = this.getRsvpId(rsvpId);
            elem = document.querySelector("[data-rsvp-id=" + id + "]");
            elem.classList.add('highlight');
            this.logService.verbose("page scrolling to selector: [data-rsvp-id=" + id + "]");
            this.scrollToElement(elem);
        }
    };
    ReservationDetailTableComponent.prototype.scrollToElement = function (element) {
        var pageScrollInstance = ng2_page_scroll["c" /* PageScrollInstance */].simpleInstance(this.document, element);
        this.pageScrollService.start(pageScrollInstance);
    };
    ReservationDetailTableComponent.prototype.getFilteredComparisonList = function () {
        return this.reservationCompareStore.getCurrentFilteredReservations();
    };
    ReservationDetailTableComponent.prototype.getMatches = function (matchType) {
        return this.getFilteredComparisonList().map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        });
    };
    ReservationDetailTableComponent.prototype.getUnfilteredMatches = function (matchType) {
        return this.reservationCompareList.map(function (comparisonList) {
            return comparisonList.filter(function (comparison) { return comparison.matchType === matchType.toString(); }).toList();
        });
    };
    ReservationDetailTableComponent.prototype.getReservationFilteredRevenue = function (matchType) {
        return reservation_utils_ReservationUtils.calculateRevenueTotal(this.getMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.getReservationFilteredCommission = function (matchType) {
        return reservation_utils_ReservationUtils.calculateCommissionTotal(this.getMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.getReservationTotalCommission = function (matchType) {
        return reservation_utils_ReservationUtils.calculateCommissionTotal(this.getUnfilteredMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.getRsvpFilteredCommission = function (matchType) {
        return reservation_utils_ReservationUtils.calculateRsvpCommissionTotal(this.getMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.getRsvpId = function (value) {
        var rsvpId;
        if (typeof value === 'number') {
            rsvpId = value;
        }
        else if (value) {
            rsvpId = value.eventRsvpId;
        }
        else {
            return '';
        }
        if (rsvpId) {
            return "rsvp-" + rsvpId;
        }
        else {
            return '';
        }
    };
    ReservationDetailTableComponent.prototype.getReservationId = function (value) {
        var reservationId;
        if (typeof value === 'number') {
            reservationId = value;
        }
        else if (value) {
            reservationId = value.eventReservationId;
        }
        else {
            return '';
        }
        if (reservationId) {
            return "res-" + reservationId;
        }
        else {
            return '';
        }
    };
    ReservationDetailTableComponent.prototype.getRsvpTotalCommission = function (matchType) {
        return reservation_utils_ReservationUtils.calculateRsvpCommissionTotal(this.getUnfilteredMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.isReservationCompareListEmpty = function () {
        return reservation_utils_ReservationUtils.isListEmpty(this.reservationCompareList);
    };
    ReservationDetailTableComponent.prototype.isRsvpMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getMatches(matchType).map(function (list) { return reservation_utils_ReservationUtils.onlyRsvpFilter(list); }));
    };
    ReservationDetailTableComponent.prototype.isFilteredMatchListEmpty = function (matchType) {
        return this.reservationCompareStore.isFilteredMatchListEmpty(matchType);
    };
    ReservationDetailTableComponent.prototype.isUnfilteredMatchListEmpty = function (matchType) {
        return reservation_utils_ReservationUtils.isListEmpty(this.getUnfilteredMatches(matchType));
    };
    ReservationDetailTableComponent.prototype.hasFilteredOutResults = function () {
        var _this = this;
        return reservation_utils_ReservationUtils.isListEmpty(this.getFilteredComparisonList()).flatMap(function (filteredListIsEmpty) {
            return _this.isReservationCompareListEmpty().map(function (isReservationListEmpty) { return filteredListIsEmpty !== isReservationListEmpty; });
        });
    };
    ReservationDetailTableComponent.prototype.getCommissionDelta = function (matchType) {
        var reservationCommissionObj = this.getReservationTotalCommission(matchType);
        var rsvpCommissionObj = this.getRsvpTotalCommission(matchType);
        return reservationCommissionObj.flatMap(function (reservationCommission) {
            return rsvpCommissionObj.map(function (rsvpCommission) {
                return reservationCommission - rsvpCommission;
            });
        }).map(function (total) { return NumberUtils.round2Fixed(total); });
    };
    ReservationDetailTableComponent.prototype.getCommissionDeltaText = function (matchType) {
        var _this = this;
        return this.getCommissionDelta(matchType).flatMap(function (delta) {
            if (delta > 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_MORE');
            }
            else if (delta < 0) {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_LESS');
            }
            else {
                return _this.translateService.get('EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE_EQUAL');
            }
        });
    };
    ReservationDetailTableComponent.prototype.getTooltipHeaderText = function (matchType) {
        switch (matchType) {
            case MatchTypeEnum.EXACT_MATCH:
                return this.translateService.get('EVENT.RESERVATION.TOOLTIP_EXACT_MATCH_COMMISSION_TITLE');
            case MatchTypeEnum.PARTIAL_MATCH:
                return this.translateService.get('EVENT.RESERVATION.TOOLTIP_PARTIAL_MATCH_COMMISSION_TITLE');
            case MatchTypeEnum.NO_MATCH:
                return this.translateService.get('EVENT.RESERVATION.TOOLTIP_NO_MATCH_COMMISSION_TITLE');
            default:
                return Observable["Observable"].of('');
        }
    };
    ReservationDetailTableComponent.prototype.resetStatusCodes = function () {
        this.reservationCompareStore.resetStatusCodes();
    };
    ReservationDetailTableComponent.prototype.totalCommissionClass = function (matchType) {
        var _this = this;
        var rsvpCount;
        return this.reservationCompareStore.areRsvpsPresent().flatMap(function (result) {
            if (!result && matchType === MatchTypeEnum.NO_MATCH) {
                return Observable["Observable"].of('');
            }
            else {
                return _this.getCommissionDelta(matchType).map(function (total) {
                    return total > 0 ? 'commission-up' : total < 0 ? 'commission-down' : '';
                });
            }
        });
    };
    ReservationDetailTableComponent.prototype.getStatusClass = function (compare) {
        if (compare.reservation) {
            switch (compare.reservation.status) {
                case 'R':
                    return 'res-status-reserved';
                case 'I':
                    return 'res-status-checked-in';
                case 'O':
                    return 'res-status-checked-out';
                case 'C':
                    return 'res-status-cancelled';
                case 'N':
                    return 'res-status-no-show';
                default:
                    return '';
            }
        }
        return '';
    };
    ReservationDetailTableComponent.prototype.isTotalCommissionUp = function (matchType) {
        return this.getCommissionDelta(matchType).map(function (total) { return total > 0; });
    };
    ReservationDetailTableComponent.prototype.isTotalCommissionDown = function (matchType) {
        return this.getCommissionDelta(matchType).map(function (total) { return total < 0; });
    };
    ReservationDetailTableComponent.prototype.isCommissionUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission > 0;
    };
    ReservationDetailTableComponent.prototype.isCommissionDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.commission < 0;
    };
    ReservationDetailTableComponent.prototype.isRevenueUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.revenue > 0;
    };
    ReservationDetailTableComponent.prototype.isRevenueDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.revenue < 0;
    };
    ReservationDetailTableComponent.prototype.isRoomRateUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.roomRate > 0;
    };
    ReservationDetailTableComponent.prototype.isRoomRateDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.roomRate < 0;
    };
    ReservationDetailTableComponent.prototype.isNightsUp = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.nights > 0;
    };
    ReservationDetailTableComponent.prototype.isNightsDown = function (compare) {
        return compare.rsvp && compare.delta && compare.delta.nights < 0;
    };
    ReservationDetailTableComponent.prototype.getNoMatchCardHeaderTitle = function () {
        return this.reservationCompareStore.areRsvpsPresent().map(function (result) {
            return result ? 'EVENT.RESERVATION.NO_MATCH_TITLE' : 'EVENT.RESERVATION.NO_RSVP_TITLE';
        });
    };
    ReservationDetailTableComponent.prototype.getNoMatchCardHeaderTitleTooltip = function () {
        return reservation_utils_ReservationUtils.getNumberOfRsvps(this.reservationCompareStore.getReservationList()).map(function (size) {
            return size > 0 ? 'EVENT.RESERVATION.NO_MATCH_TITLE_TOOLTIP' : 'EVENT.RESERVATION.NO_RSVP_TITLE_TOOLTIP';
        });
    };
    return ReservationDetailTableComponent;
}());
reservation_detail_table_component___decorate([
    Object(core_es5["Input"])('event'),
    reservation_detail_table_component___metadata("design:type", typeof (reservation_detail_table_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_detail_table_component__a || Object),
    reservation_detail_table_component___metadata("design:paramtypes", [typeof (reservation_detail_table_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && reservation_detail_table_component__b || Object])
], reservation_detail_table_component_ReservationDetailTableComponent.prototype, "event", null);
reservation_detail_table_component_ReservationDetailTableComponent = reservation_detail_table_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-reservation-detail-table',
        template: __webpack_require__("OprT")
    }),
    reservation_detail_table_component___param(4, Object(core_es5["Inject"])(platform_browser_es5["DOCUMENT"])),
    reservation_detail_table_component___metadata("design:paramtypes", [typeof (reservation_detail_table_component__c = typeof reservation_compare_store_ReservationCompareStore !== "undefined" && reservation_compare_store_ReservationCompareStore) === "function" && reservation_detail_table_component__c || Object, typeof (reservation_detail_table_component__d = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && reservation_detail_table_component__d || Object, typeof (reservation_detail_table_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && reservation_detail_table_component__e || Object, typeof (reservation_detail_table_component__f = typeof ng2_page_scroll["d" /* PageScrollService */] !== "undefined" && ng2_page_scroll["d" /* PageScrollService */]) === "function" && reservation_detail_table_component__f || Object, Object])
], reservation_detail_table_component_ReservationDetailTableComponent);

var reservation_detail_table_component__a, reservation_detail_table_component__b, reservation_detail_table_component__c, reservation_detail_table_component__d, reservation_detail_table_component__e, reservation_detail_table_component__f;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/reservation-detail-table.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payment-record/payment-record.component.ts
var payment_record_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_record_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var payment_record_component_PaymentRecordComponent = (function () {
    function PaymentRecordComponent(errorHandlerService, translateService) {
        this.errorHandlerService = errorHandlerService;
        this.translateService = translateService;
        this.latestPayment = null;
        this.ui = {
            showRejectedMessage: false,
            strikeThroughPaymentLines: false
        };
    }
    Object.defineProperty(PaymentRecordComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentRecordComponent.prototype.ngOnInit = function () {
        if (!this.onyxEvent) {
            this.errorHandlerService.throw('Input property onyxEvent is null in PaymentRecordComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'PaymentRecordComponent'
            }));
        }
        if (!this.latestPayment) {
            this.errorHandlerService.throw('Input property latestPayment is null in PaymentRecordComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'latestPayment',
                className: 'PaymentRecordComponent'
            }));
        }
        var isError = PaymentStatusUtils.isError(this.latestPayment.status);
        if (isError) {
            this.ui.showRejectedMessage = true;
            this.ui.strikeThroughPaymentLines = true;
        }
    };
    return PaymentRecordComponent;
}());
payment_record_component___decorate([
    Object(core_es5["Input"])(),
    payment_record_component___metadata("design:type", typeof (payment_record_component__a = typeof Payment !== "undefined" && Payment) === "function" && payment_record_component__a || Object)
], payment_record_component_PaymentRecordComponent.prototype, "latestPayment", void 0);
payment_record_component___decorate([
    Object(core_es5["Input"])(),
    payment_record_component___metadata("design:type", typeof (payment_record_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_record_component__b || Object),
    payment_record_component___metadata("design:paramtypes", [typeof (payment_record_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_record_component__c || Object])
], payment_record_component_PaymentRecordComponent.prototype, "event", null);
payment_record_component_PaymentRecordComponent = payment_record_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-record',
        template: __webpack_require__("ch4d")
    }),
    payment_record_component___metadata("design:paramtypes", [typeof (payment_record_component__d = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && payment_record_component__d || Object, typeof (payment_record_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_record_component__e || Object])
], payment_record_component_PaymentRecordComponent);

var payment_record_component__a, payment_record_component__b, payment_record_component__c, payment_record_component__d, payment_record_component__e;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment-record.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payment-adjustment-calculation/payment-adjustment-equation.component.ts
var payment_adjustment_equation_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_adjustment_equation_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};











var payment_adjustment_equation_component_PaymentAdjustmentEquationComponent = (function () {
    function PaymentAdjustmentEquationComponent(currencyPipe, adjustmentStore, translateService, errorHandlerService, reservationStore) {
        this.currencyPipe = currencyPipe;
        this.adjustmentStore = adjustmentStore;
        this.translateService = translateService;
        this.errorHandlerService = errorHandlerService;
        this.reservationStore = reservationStore;
        this.defaultClasses = 'col form-container due-amount';
        this.hasAdjustmentCssClass = false;
        this.isEditMode = false;
        this.strikeThroughPaymentLines = false;
        this.confirmationModalConfig = new ConfirmationModalConfig();
        this.adjustmentToRemove = null;
    }
    Object.defineProperty(PaymentAdjustmentEquationComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentAdjustmentEquationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.areThereAnyAdjustments().subscribe(function (value) {
            _this.hasAdjustmentCssClass = value;
        });
        if (!this.onyxEvent) {
            this.errorHandlerService.throw('Input property onyxEvent is null in AddPaymentComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'PaymentEquationComponent'
            }));
        }
    };
    Object.defineProperty(PaymentAdjustmentEquationComponent.prototype, "adjustments", {
        get: function () {
            return this.adjustmentStore.adjustments;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentAdjustmentEquationComponent.prototype, "calculatedPayment", {
        get: function () {
            return this.adjustmentStore.getCalculatedPayment(ReservationStatusCode.CHECKED_OUT);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentAdjustmentEquationComponent.prototype, "totalCommissions", {
        get: function () {
            return this.reservationStore.getTotalCommissions(ReservationStatusCode.CHECKED_OUT);
        },
        enumerable: true,
        configurable: true
    });
    PaymentAdjustmentEquationComponent.prototype.areThereAnyAdjustments = function () {
        return this.adjustments.map(function (list) { return list.size > 0; });
    };
    PaymentAdjustmentEquationComponent.prototype.getAdjustmentCssClass = function (adjustment) {
        if (adjustment_utils_AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
            return 'adjustment up';
        }
        else {
            return 'adjustment down';
        }
    };
    PaymentAdjustmentEquationComponent.prototype.getAdjustmentAmountCssClass = function (adjustment) {
        if (adjustment_utils_AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
            return 'currency text-success';
        }
        else {
            return 'currency text-warning';
        }
    };
    PaymentAdjustmentEquationComponent.prototype.confirmBeforeDeletingAdjustment = function (adjustment) {
        this.adjustmentToRemove = adjustment;
        // set up the title of the confirmation modal
        var label = 'EVENT.COMMISSION.DELETE_ADJUSTMENT_CONFIRMATION_TITLE';
        var amount = adjustment.adjustmentAmount;
        var currencyFormat = this.currencyPipe.transform(amount, 'USD', true);
        var params = { adjustmentAmount: currencyFormat };
        this.confirmationModalConfig.title = this.translateService.instant(label, params);
        this.confirmationModal.open();
    };
    PaymentAdjustmentEquationComponent.prototype.deleteAdjustment = function (adjustmentId, eventId) {
        this.adjustmentStore
            .deleteAdjustment(adjustmentId, eventId)
            .subscribe();
    };
    PaymentAdjustmentEquationComponent.prototype.confirmBeforeDeletingAdjustmentHandler = function (value) {
        if (value) {
            var adjustmentId = this.adjustmentToRemove.eventAdjustmentId;
            var eventId = this.onyxEvent.eventId;
            this.deleteAdjustment(adjustmentId, eventId);
        }
        this.adjustmentToRemove = null;
    };
    return PaymentAdjustmentEquationComponent;
}());
payment_adjustment_equation_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    payment_adjustment_equation_component___metadata("design:type", Object)
], payment_adjustment_equation_component_PaymentAdjustmentEquationComponent.prototype, "defaultClasses", void 0);
payment_adjustment_equation_component___decorate([
    Object(core_es5["HostBinding"])('class.has-adjust'),
    payment_adjustment_equation_component___metadata("design:type", Object)
], payment_adjustment_equation_component_PaymentAdjustmentEquationComponent.prototype, "hasAdjustmentCssClass", void 0);
payment_adjustment_equation_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    payment_adjustment_equation_component___metadata("design:type", typeof (payment_adjustment_equation_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && payment_adjustment_equation_component__a || Object)
], payment_adjustment_equation_component_PaymentAdjustmentEquationComponent.prototype, "confirmationModal", void 0);
payment_adjustment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_adjustment_equation_component___metadata("design:type", Object)
], payment_adjustment_equation_component_PaymentAdjustmentEquationComponent.prototype, "isEditMode", void 0);
payment_adjustment_equation_component___decorate([
    Object(core_es5["Input"])(),
    Object(core_es5["HostBinding"])('class.status-rejected'),
    payment_adjustment_equation_component___metadata("design:type", Object)
], payment_adjustment_equation_component_PaymentAdjustmentEquationComponent.prototype, "strikeThroughPaymentLines", void 0);
payment_adjustment_equation_component___decorate([
    Object(core_es5["Input"])(),
    payment_adjustment_equation_component___metadata("design:type", typeof (payment_adjustment_equation_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_adjustment_equation_component__b || Object),
    payment_adjustment_equation_component___metadata("design:paramtypes", [typeof (payment_adjustment_equation_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_adjustment_equation_component__c || Object])
], payment_adjustment_equation_component_PaymentAdjustmentEquationComponent.prototype, "event", null);
payment_adjustment_equation_component_PaymentAdjustmentEquationComponent = payment_adjustment_equation_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-adjustment-equation',
        template: __webpack_require__("pWWq")
    }),
    payment_adjustment_equation_component___metadata("design:paramtypes", [typeof (payment_adjustment_equation_component__d = typeof common_es5["CurrencyPipe"] !== "undefined" && common_es5["CurrencyPipe"]) === "function" && payment_adjustment_equation_component__d || Object, typeof (payment_adjustment_equation_component__e = typeof adjustment_store_AdjustmentStore !== "undefined" && adjustment_store_AdjustmentStore) === "function" && payment_adjustment_equation_component__e || Object, typeof (payment_adjustment_equation_component__f = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_adjustment_equation_component__f || Object, typeof (payment_adjustment_equation_component__g = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && payment_adjustment_equation_component__g || Object, typeof (payment_adjustment_equation_component__h = typeof reservation_store_ReservationStore !== "undefined" && reservation_store_ReservationStore) === "function" && payment_adjustment_equation_component__h || Object])
], payment_adjustment_equation_component_PaymentAdjustmentEquationComponent);

var payment_adjustment_equation_component__a, payment_adjustment_equation_component__b, payment_adjustment_equation_component__c, payment_adjustment_equation_component__d, payment_adjustment_equation_component__e, payment_adjustment_equation_component__f, payment_adjustment_equation_component__g, payment_adjustment_equation_component__h;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment-adjustment-equation.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/payment-modifier-display-calculation/payment-modifier-display.component.ts
var payment_modifier_display_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var payment_modifier_display_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var payment_modifier_display_component_PaymentModifierDisplayComponent = (function () {
    function PaymentModifierDisplayComponent(translateService, errorHandlerService, logService, paymentStore) {
        this.translateService = translateService;
        this.errorHandlerService = errorHandlerService;
        this.logService = logService;
        this.paymentStore = paymentStore;
        this.defaultClasses = 'col form-container due-amount';
        this.hasModifiersCssClass = false;
        this.strikeThroughPaymentLines = false;
    }
    Object.defineProperty(PaymentModifierDisplayComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    PaymentModifierDisplayComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.areThereAnyModifiers().subscribe(function (modifierExists) {
            _this.logService.debug('ngOnInit - areThereAnyModifiers: hasModifiersCssClass: ' + modifierExists);
            _this.hasModifiersCssClass = modifierExists;
        });
        if (!this.onyxEvent) {
            this.errorHandlerService.throw('Input property onyxEvent is null in AddPaymentComponent', this.translateService.instant('MESSAGES.ERROR.INPUT_PROPERTY_NULL', {
                property: 'onyxEvent',
                className: 'PaymentEquationComponent'
            }));
        }
    };
    Object.defineProperty(PaymentModifierDisplayComponent.prototype, "latestPayment", {
        get: function () {
            return this.paymentStore.getLatestPayment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentModifierDisplayComponent.prototype, "calculatedPayment", {
        get: function () {
            var _this = this;
            return this.latestPayment.map(function (payment) {
                _this.logService.debug('calculatedPayment: payment' + payment);
                if (payment.commissionAmount) {
                    return payment.commissionAmount;
                }
                else {
                    return 0;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentModifierDisplayComponent.prototype, "modifiers", {
        get: function () {
            var _this = this;
            return this.latestPayment.share().map(function (payment) {
                _this.logService.debug('modifiers: payment' + payment);
                if (payment.eventPaymentModifiers) {
                    _this.logService.debug('modifiers: eventPaymentModifiers: ' + payment.eventPaymentModifiers);
                    return payment.eventPaymentModifiers;
                }
                else {
                    return [];
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentModifierDisplayComponent.prototype, "totalModifiersAmount", {
        get: function () {
            return this.modifiers.map(function (modifierArray) {
                return modifierArray.map(function (modifier) { return modifier.adjustmentAmount; })
                    .filter(function (amt) { return amt !== null; })
                    .reduce(function (prev, current) { return !!current ? prev + current : prev; }, 0);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PaymentModifierDisplayComponent.prototype, "totalCommission", {
        get: function () {
            var _this = this;
            return this.calculatedPayment.flatMap(function (paymentAmt) {
                return _this.totalModifiersAmount.map(function (modifierAmount) {
                    return paymentAmt - modifierAmount;
                });
            });
        },
        enumerable: true,
        configurable: true
    });
    PaymentModifierDisplayComponent.prototype.areThereAnyModifiers = function () {
        var _this = this;
        return this.modifiers.map(function (modifierArray) {
            var hasModifiers = false;
            if (modifierArray && modifierArray.length > 0) {
                hasModifiers = true;
            }
            _this.logService.debug('areThereAnyModifiers: modifierArray: ' + modifierArray);
            _this.logService.debug('areThereAnyModifiers: hasModifiers: ' + hasModifiers);
            return hasModifiers;
        });
    };
    PaymentModifierDisplayComponent.prototype.getModifierCssClass = function (adjustment) {
        if (adjustment_utils_AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
            return 'adjustment up';
        }
        else {
            return 'adjustment down';
        }
    };
    PaymentModifierDisplayComponent.prototype.getModifierAmountCssClass = function (adjustment) {
        if (adjustment_utils_AdjustmentUtils.isAdjustmentTypePositive(adjustment.adjustmentType)) {
            return 'currency text-success';
        }
        else {
            return 'currency text-warning';
        }
    };
    return PaymentModifierDisplayComponent;
}());
payment_modifier_display_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    payment_modifier_display_component___metadata("design:type", Object)
], payment_modifier_display_component_PaymentModifierDisplayComponent.prototype, "defaultClasses", void 0);
payment_modifier_display_component___decorate([
    Object(core_es5["HostBinding"])('class.has-adjust'),
    payment_modifier_display_component___metadata("design:type", Object)
], payment_modifier_display_component_PaymentModifierDisplayComponent.prototype, "hasModifiersCssClass", void 0);
payment_modifier_display_component___decorate([
    Object(core_es5["Input"])(),
    Object(core_es5["HostBinding"])('class.status-rejected'),
    payment_modifier_display_component___metadata("design:type", Object)
], payment_modifier_display_component_PaymentModifierDisplayComponent.prototype, "strikeThroughPaymentLines", void 0);
payment_modifier_display_component___decorate([
    Object(core_es5["Input"])(),
    payment_modifier_display_component___metadata("design:type", typeof (payment_modifier_display_component__a = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_modifier_display_component__a || Object),
    payment_modifier_display_component___metadata("design:paramtypes", [typeof (payment_modifier_display_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && payment_modifier_display_component__b || Object])
], payment_modifier_display_component_PaymentModifierDisplayComponent.prototype, "event", null);
payment_modifier_display_component_PaymentModifierDisplayComponent = payment_modifier_display_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-payment-modifier-display',
        template: __webpack_require__("0Dgx")
    }),
    payment_modifier_display_component___metadata("design:paramtypes", [typeof (payment_modifier_display_component__c = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && payment_modifier_display_component__c || Object, typeof (payment_modifier_display_component__d = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && payment_modifier_display_component__d || Object, typeof (payment_modifier_display_component__e = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && payment_modifier_display_component__e || Object, typeof (payment_modifier_display_component__f = typeof payment_store_PaymentStore !== "undefined" && payment_store_PaymentStore) === "function" && payment_modifier_display_component__f || Object])
], payment_modifier_display_component_PaymentModifierDisplayComponent);

var payment_modifier_display_component__a, payment_modifier_display_component__b, payment_modifier_display_component__c, payment_modifier_display_component__d, payment_modifier_display_component__e, payment_modifier_display_component__f;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/payment-modifier-display.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/automatic-payment-toggle/automatic-payment-toggle.component.ts
var automatic_payment_toggle_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var automatic_payment_toggle_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};







var automatic_payment_toggle_component_AutomaticPaymentToggleComponent = (function () {
    function AutomaticPaymentToggleComponent(errorHandlerService, translateService, eventStore) {
        this.errorHandlerService = errorHandlerService;
        this.translateService = translateService;
        this.eventStore = eventStore;
        this.confirmationModalConfig = new ConfirmationModalConfig();
    }
    Object.defineProperty(AutomaticPaymentToggleComponent.prototype, "event", {
        set: function (event) {
            this.onyxEvent = event;
        },
        enumerable: true,
        configurable: true
    });
    AutomaticPaymentToggleComponent.prototype.ngOnInit = function () {
        if (!this.onyxEvent) {
            var logMessage = 'Input property onyxEvent is null in AutomaticPaymentToggleComponent';
            var labelKey = 'MESSAGES.ERROR.INPUT_PROPERTY_NULL';
            var params = {
                property: 'onyxEvent',
                className: 'AutomaticPaymentToggleComponent'
            };
            var flashMessage = this.translateService.instant(labelKey, params);
            this.errorHandlerService.throw(logMessage, flashMessage);
        }
    };
    AutomaticPaymentToggleComponent.prototype.confirmBeforeTogglingAutoPayment = function () {
        this.confirmationModalConfig.content = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_CONTENT');
        if (this.onyxEvent.autoPayment) {
            this.confirmationModalConfig.title = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_OFF_TITLE');
            this.confirmationModalConfig.confirm = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_OFF_CONFIRM');
        }
        else {
            this.confirmationModalConfig.title = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_ON_TITLE');
            this.confirmationModalConfig.confirm = this.translateService.instant('EVENT.COMMISSION.AUTO_PAYMENT_CONFIRMATION_ON_CONFIRM');
        }
        this.confirmationModal.open();
        return false;
    };
    AutomaticPaymentToggleComponent.prototype.confirmBeforeAutopaymentToggleHandler = function (value) {
        if (value) {
            this.toggleAutoPaymentSetting();
        }
    };
    AutomaticPaymentToggleComponent.prototype.toggleAutoPaymentSetting = function () {
        // https://facebook.github.io/immutable-js/docs/#/Map/merge
        var updatedModel = this.onyxEvent.merge({
            autoPayment: !this.onyxEvent.autoPayment,
        });
        this.eventStore.updateEvent(updatedModel).subscribe();
    };
    return AutomaticPaymentToggleComponent;
}());
automatic_payment_toggle_component___decorate([
    Object(core_es5["ViewChild"])(confirmation_modal_component_ConfirmationModalComponent),
    automatic_payment_toggle_component___metadata("design:type", typeof (automatic_payment_toggle_component__a = typeof confirmation_modal_component_ConfirmationModalComponent !== "undefined" && confirmation_modal_component_ConfirmationModalComponent) === "function" && automatic_payment_toggle_component__a || Object)
], automatic_payment_toggle_component_AutomaticPaymentToggleComponent.prototype, "confirmationModal", void 0);
automatic_payment_toggle_component___decorate([
    Object(core_es5["Input"])(),
    automatic_payment_toggle_component___metadata("design:type", typeof (automatic_payment_toggle_component__b = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && automatic_payment_toggle_component__b || Object),
    automatic_payment_toggle_component___metadata("design:paramtypes", [typeof (automatic_payment_toggle_component__c = typeof OnyxEvent !== "undefined" && OnyxEvent) === "function" && automatic_payment_toggle_component__c || Object])
], automatic_payment_toggle_component_AutomaticPaymentToggleComponent.prototype, "event", null);
automatic_payment_toggle_component_AutomaticPaymentToggleComponent = automatic_payment_toggle_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-automatic-payment-toggle',
        template: __webpack_require__("f0B1")
    }),
    automatic_payment_toggle_component___metadata("design:paramtypes", [typeof (automatic_payment_toggle_component__d = typeof error_handler_service_ErrorHandlerService !== "undefined" && error_handler_service_ErrorHandlerService) === "function" && automatic_payment_toggle_component__d || Object, typeof (automatic_payment_toggle_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && automatic_payment_toggle_component__e || Object, typeof (automatic_payment_toggle_component__f = typeof event_store_EventStore !== "undefined" && event_store_EventStore) === "function" && automatic_payment_toggle_component__f || Object])
], automatic_payment_toggle_component_AutomaticPaymentToggleComponent);

var automatic_payment_toggle_component__a, automatic_payment_toggle_component__b, automatic_payment_toggle_component__c, automatic_payment_toggle_component__d, automatic_payment_toggle_component__e, automatic_payment_toggle_component__f;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/automatic-payment-toggle.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/dashboard/completed-unpaid/completed-unpaid.component.ts
var completed_unpaid_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var completed_unpaid_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var completed_unpaid_component_CompletedUnpaidComponent = (function () {
    function CompletedUnpaidComponent(completedUnpaidStore, predefinedSearchService) {
        this.completedUnpaidStore = completedUnpaidStore;
        this.predefinedSearchService = predefinedSearchService;
        this.defaultClasses = 'card collapse';
        this.id = 'card-1';
        this.dataSeId = 'completedAndUnpaidCard';
        this.classes = this.defaultClasses;
    }
    CompletedUnpaidComponent.prototype.ngOnInit = function () {
        var _this = this;
        var cardStateObs = this.completedUnpaidStore.cardStateCssClass().map(function (newClass) {
            return _this.defaultClasses + ' ' + newClass;
        });
        var combined = Observable["Observable"].combineLatest(cardStateObs, this.completedUnpaidStore.showCard());
        combined.subscribe(function (fromCombined) {
            var classes = fromCombined[0], show = fromCombined[1];
            if (show) {
                _this.classes = classes + " show";
            }
            else {
                _this.classes = classes;
            }
        });
    };
    Object.defineProperty(CompletedUnpaidComponent.prototype, "completedAndUnpaidLessThan14DaysTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.lessThan14DaysTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidComponent.prototype, "completedAndUnpaidBetween15And28DaysTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.between15And28DaysTotal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompletedUnpaidComponent.prototype, "completedAndUnpaidGreaterThan28DaysTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.greaterThan28DaysTotal);
        },
        enumerable: true,
        configurable: true
    });
    CompletedUnpaidComponent.prototype.completedAndUnpaidPredefinedSearch = function () {
        this.predefinedSearchService.completedAndUnpaid();
    };
    return CompletedUnpaidComponent;
}());
completed_unpaid_component___decorate([
    Object(core_es5["HostBinding"])('id'),
    completed_unpaid_component___metadata("design:type", Object)
], completed_unpaid_component_CompletedUnpaidComponent.prototype, "id", void 0);
completed_unpaid_component___decorate([
    Object(core_es5["HostBinding"])('attr.data-se-id'),
    completed_unpaid_component___metadata("design:type", Object)
], completed_unpaid_component_CompletedUnpaidComponent.prototype, "dataSeId", void 0);
completed_unpaid_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    completed_unpaid_component___metadata("design:type", Object)
], completed_unpaid_component_CompletedUnpaidComponent.prototype, "classes", void 0);
completed_unpaid_component_CompletedUnpaidComponent = completed_unpaid_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-completed-unpaid',
        template: __webpack_require__("mwq9")
    }),
    completed_unpaid_component___metadata("design:paramtypes", [typeof (completed_unpaid_component__a = typeof completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore !== "undefined" && completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore) === "function" && completed_unpaid_component__a || Object, typeof (completed_unpaid_component__b = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && completed_unpaid_component__b || Object])
], completed_unpaid_component_CompletedUnpaidComponent);

var completed_unpaid_component__a, completed_unpaid_component__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/completed-unpaid.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/dashboard/missing-agency/missing-agency.component.ts
var missing_agency_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var missing_agency_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var missing_agency_component_MissingAgencyComponent = (function () {
    function MissingAgencyComponent(missingAgencyStore, predefinedSearchService) {
        this.missingAgencyStore = missingAgencyStore;
        this.predefinedSearchService = predefinedSearchService;
        this.defaultClasses = 'card collapse';
        this.id = 'card-2';
        this.dataSeId = 'missingAgencyCard';
        this.classes = this.defaultClasses;
    }
    MissingAgencyComponent.prototype.ngOnInit = function () {
        var _this = this;
        var obs1 = this.missingAgencyStore.cardStateCssClass().map(function (newClass) {
            return _this.defaultClasses + ' ' + newClass;
        });
        var combined = Observable["Observable"].combineLatest(obs1, this.missingAgencyStore.showCard());
        combined.subscribe(function (fromCombined) {
            var classes = fromCombined[0], show = fromCombined[1];
            if (show) {
                _this.classes = classes + " show";
            }
            else {
                _this.classes = classes;
            }
        });
    };
    Object.defineProperty(MissingAgencyComponent.prototype, "missingAgencyTotal", {
        get: function () {
            return DashboardUtils.totalAsStringClampedTo99(this.missingAgencyStore.missingAgencyTotal);
        },
        enumerable: true,
        configurable: true
    });
    MissingAgencyComponent.prototype.missingAgencyPredefinedSearch = function () {
        this.predefinedSearchService.missingAgencySearch();
    };
    return MissingAgencyComponent;
}());
missing_agency_component___decorate([
    Object(core_es5["HostBinding"])('id'),
    missing_agency_component___metadata("design:type", Object)
], missing_agency_component_MissingAgencyComponent.prototype, "id", void 0);
missing_agency_component___decorate([
    Object(core_es5["HostBinding"])('attr.data-se-id'),
    missing_agency_component___metadata("design:type", Object)
], missing_agency_component_MissingAgencyComponent.prototype, "dataSeId", void 0);
missing_agency_component___decorate([
    Object(core_es5["HostBinding"])('class'),
    missing_agency_component___metadata("design:type", Object)
], missing_agency_component_MissingAgencyComponent.prototype, "classes", void 0);
missing_agency_component_MissingAgencyComponent = missing_agency_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-missing-agency',
        template: __webpack_require__("P7oG")
    }),
    missing_agency_component___metadata("design:paramtypes", [typeof (missing_agency_component__a = typeof missing_agency_dashboard_store_MissingAgencyDashboardStore !== "undefined" && missing_agency_dashboard_store_MissingAgencyDashboardStore) === "function" && missing_agency_component__a || Object, typeof (missing_agency_component__b = typeof predefined_search_service_PredefinedSearchService !== "undefined" && predefined_search_service_PredefinedSearchService) === "function" && missing_agency_component__b || Object])
], missing_agency_component_MissingAgencyComponent);

var missing_agency_component__a, missing_agency_component__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/missing-agency.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event.module.ts
var event_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};








































































var EventModule = (function () {
    function EventModule() {
    }
    return EventModule;
}());
EventModule = event_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            SharedModule,
            forms_es5["FormsModule"],
            forms_es5["ReactiveFormsModule"],
            router_es5["RouterModule"].forChild(event_routes_routes)
        ],
        declarations: [
            add_event_component_AddEventComponent,
            basic_event_data_component_BasicEventDataComponent,
            contact_form_component_ContactFormComponent,
            contact_lookup_form_component_ContactLookupFormComponent,
            event_list_component_EventListComponent,
            EventListDefaultTableComponent,
            event_list_financial_component_EventListFinancialComponent,
            event_component_EventComponent,
            commission_component_CommissionComponent,
            payment_reservations_component_PaymentReservationsComponent,
            ChildContactFormComponent,
            stay_summary_component_StaySummaryComponent,
            add_payment_component_AddPaymentComponent,
            attachment_component_AttachmentComponent,
            event_nav_component_EventNavComponent,
            RsvpComponent,
            RsvpListComponent,
            add_rsvp_component_AddRsvpComponent,
            reservation_filter_component_ReservationFilterComponent,
            reservation_page_component_ReservationPageComponent,
            reservation_summary_table_component_ReservationSummaryTableComponent,
            reservation_detail_table_component_ReservationDetailTableComponent,
            payment_record_component_PaymentRecordComponent,
            payment_adjustment_equation_component_PaymentAdjustmentEquationComponent,
            payment_modifier_display_component_PaymentModifierDisplayComponent,
            automatic_payment_toggle_component_AutomaticPaymentToggleComponent,
            dashboard_component_DashboardComponent,
            completed_unpaid_component_CompletedUnpaidComponent,
            missing_agency_component_MissingAgencyComponent
        ],
        providers: [
            AttachmentResolver,
            attachment_store_AttachmentStore,
            event_store_EventStore,
            event_list_store_EventListStore,
            event_http_service_EventHttpService,
            events_resolver_EventsResolver,
            EventResolver,
            attachment_http_service_AttachmentHttpService,
            property_lookup_http_service_PropertyLookupHttpService,
            property_lookup_store_PropertyLookupStore,
            reservation_http_service_ReservationService,
            ReservationResolver,
            reservation_store_ReservationStore,
            reservation_compare_http_service_ReservationCompareService,
            reservation_compare_resolver_ReservationCompareResolver,
            reservation_compare_store_ReservationCompareStore,
            payment_store_PaymentStore,
            payment_http_service_PaymentHttpService,
            rsvp_store_RsvpStore,
            rsvp_http_service_RsvpHttpService,
            RsvpListResolver,
            common_es5["CurrencyPipe"],
            adjustment_store_AdjustmentStore,
            adjustment_http_service_AdjustmentHttpService,
            AdjustmentResolver,
            LatestPaymentResolver,
            PaymentsResolver,
            grouppay_config_store_GroupPayConfigStore,
            grouppay_config_http_service_GroupPayConfigHttpService,
            event_search_parameters_store_EventSearchParametersStore,
            completed_unpaid_dashboard_store_CompletedUnpaidDashboardStore,
            missing_agency_dashboard_store_MissingAgencyDashboardStore,
            dashboard_totals_http_service_DashboardTotalsHttpService,
            CanDeactiveReservationDetailTable,
            event_filter_util_service_EventFilterUtilsService,
            event_menu_search_filter_mapper_EventMenuSearchFilterMapper,
            event_search_forms_store_EventSearchFormsStore,
            predefined_search_service_PredefinedSearchService
        ]
    })
], EventModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event.module.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/angulartics2/dist/es5/index.js
var es5 = __webpack_require__("AL9+");
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/app.component.ts
var app_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var app_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};








var app_component_AppComponent = (function () {
    function AppComponent(translate, authenticationStore, menuStore, angulartics2GoogleAnalytics, router) {
        var _this = this;
        this.router = router;
        // Configure the defaults and setup the translation service from ng-translate.
        translate.setDefaultLang('en-US');
        translate.use('en-US');
        // need to change duration, which otherwise would be 1250 milliseconds which feels very slow
        ng2_page_scroll["b" /* PageScrollConfig */].defaultDuration = 0;
        this.userIsLoggedIn = authenticationStore.isLoggedIn();
        menuStore.pageTitle.subscribe(function (pageTitle) {
            // to remove the ExpressionChangedAfterItHasBeenCheckedError
            // https://github.com/angular/angular/issues/17572
            setTimeout(function () { return _this.title = pageTitle; }, 0);
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        this.resetPage();
    };
    /**
     * Checks to see if navigation was successful and resets the page
     * to an expected state.
     */
    AppComponent.prototype.resetPage = function () {
        var _this = this;
        this.router.events.subscribe(function (routerEvent) {
            if (!(routerEvent instanceof router_es5["NavigationEnd"])) {
                return;
            }
            /**
             * Forces the app to scroll to the top of page when navigation is successful,
             * solving the issue where the user would change pages and stay in the middle
             * of the page.
             * See: https://stackoverflow.com/questions/39601026/angular-2-scroll-to-top-on-route-change
             */
            window.scrollTo(0, 0);
            /**
             * Resets any flash Messages that aren't set to be persistent.
             */
            _this.flashMessageComponent.clearNonPersistentMessages();
        });
    };
    return AppComponent;
}());
app_component___decorate([
    Object(core_es5["ViewChild"])(flash_messages_component_FlashMessagesComponent),
    app_component___metadata("design:type", typeof (app_component__a = typeof flash_messages_component_FlashMessagesComponent !== "undefined" && flash_messages_component_FlashMessagesComponent) === "function" && app_component__a || Object)
], app_component_AppComponent.prototype, "flashMessageComponent", void 0);
app_component_AppComponent = app_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-root',
        template: __webpack_require__("efyd")
    }),
    app_component___metadata("design:paramtypes", [typeof (app_component__b = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && app_component__b || Object, typeof (app_component__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && app_component__c || Object, typeof (app_component__d = typeof menu_store_MenuStore !== "undefined" && menu_store_MenuStore) === "function" && app_component__d || Object, typeof (app_component__e = typeof es5["Angulartics2GoogleAnalytics"] !== "undefined" && es5["Angulartics2GoogleAnalytics"]) === "function" && app_component__e || Object, typeof (app_component__f = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && app_component__f || Object])
], app_component_AppComponent);

var app_component__a, app_component__b, app_component__c, app_component__d, app_component__e, app_component__f;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/secured-home/secured-home.component.ts
var secured_home_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var secured_home_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};





var secured_home_component_SecuredHomeComponent = (function () {
    function SecuredHomeComponent(route, router, authenticationStore, logService) {
        this.route = route;
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.logService = logService;
        this.jwtHelper = new angular2_jwt["JwtHelper"]();
    }
    SecuredHomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.map(function (params) { return params['authorization']; }).filter(function (token) { return token; })
            .delay(100) // We get errors without this delay
            .subscribe(function (token) { return _this.storeTokenFromQueryString(token); });
    };
    SecuredHomeComponent.prototype.storeTokenFromQueryString = function (token) {
        var _this = this;
        // this is necessary in case they were already logged in before coming to this page
        this.authenticationStore.logout();
        this.authenticationStore.handleTokenFromExternalSource(token).subscribe(function (userPermission) {
            _this.logService.debug('subscribe handleTokenFromExternalSource');
            _this.router.navigate(['/']);
            _this.logService.debug("after navigate['/']");
        }, function (error) {
            if (error === ExternalSourceError.TOKEN_EXPIRED) {
                _this.router.navigate(['/external-login-expired']);
                _this.logService.debug("after navigate['/external-login-expired']");
            }
            else {
                _this.router.navigate(['/error', { error: 'MESSAGES.ERROR.EXTERNAL_LOGIN_ERROR' }]);
            }
        });
    };
    return SecuredHomeComponent;
}());
secured_home_component_SecuredHomeComponent = secured_home_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-secured-home',
        template: __webpack_require__("kt5u")
    }),
    secured_home_component___metadata("design:paramtypes", [typeof (secured_home_component__a = typeof router_es5["ActivatedRoute"] !== "undefined" && router_es5["ActivatedRoute"]) === "function" && secured_home_component__a || Object, typeof (secured_home_component__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && secured_home_component__b || Object, typeof (secured_home_component__c = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && secured_home_component__c || Object, typeof (secured_home_component__d = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && secured_home_component__d || Object])
], secured_home_component_SecuredHomeComponent);

var secured_home_component__a, secured_home_component__b, secured_home_component__c, secured_home_component__d;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/secured-home.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/login/login.component.ts
var login_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var login_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};






var LoginComponent = (function () {
    function LoginComponent(router, authenticationStore, logService, flashMessagesService, translateService) {
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.logService = logService;
        this.flashMessagesService = flashMessagesService;
        this.translateService = translateService;
        logService.debug('LoginComponent constructor');
    }
    LoginComponent.prototype.ngOnInit = function () {
    };
    LoginComponent.prototype.onLogin = function () {
        var _this = this;
        if (this.email == null || this.password == null) {
            this.flashMessagesService.error('MESSAGES.VALIDATION.ALL_FIELDS_REQUIRED', 'Login Error: email and password fields required');
            return;
        }
        var obs = this.authenticationStore.login(this.email, this.password);
        obs.subscribe(function (loginSuccess) { return _this.router.navigate(['/']); }, function (error) {
            _this.flashMessagesService.error('LOGIN.CREDENTIALS_INVALID', 'Login Error: ' + error);
        });
        return obs;
    };
    return LoginComponent;
}());
LoginComponent = login_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-login',
        template: __webpack_require__("K2V+")
    }),
    login_component___metadata("design:paramtypes", [typeof (login_component__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && login_component__a || Object, typeof (login_component__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && login_component__b || Object, typeof (login_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && login_component__c || Object, typeof (login_component__d = typeof flash_messages_service_FlashMessagesService !== "undefined" && flash_messages_service_FlashMessagesService) === "function" && login_component__d || Object, typeof (login_component__e = typeof core["c" /* TranslateService */] !== "undefined" && core["c" /* TranslateService */]) === "function" && login_component__e || Object])
], LoginComponent);

var login_component__a, login_component__b, login_component__c, login_component__d, login_component__e;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/login.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/logout/logout.component.ts
var logout_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var logout_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var LogoutComponent = (function () {
    function LogoutComponent(router, authenticationStore, logService) {
        this.router = router;
        this.authenticationStore = authenticationStore;
        this.logService = logService;
        this.errorMessage = null;
        this.logService.verbose('LogoutComponent constructor');
    }
    LogoutComponent.prototype.ngOnInit = function () {
        this.errorMessage = null;
    };
    LogoutComponent.prototype.onLogout = function () {
        this.authenticationStore.logout();
        this.router.navigate(['login']);
    };
    return LogoutComponent;
}());
LogoutComponent = logout_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-logout',
        template: __webpack_require__("1DO0")
    }),
    logout_component___metadata("design:paramtypes", [typeof (logout_component__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && logout_component__a || Object, typeof (logout_component__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && logout_component__b || Object, typeof (logout_component__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && logout_component__c || Object])
], LogoutComponent);

var logout_component__a, logout_component__b, logout_component__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/logout.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/guards/can-activate-via-guest-guard.ts
var can_activate_via_guest_guard___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var can_activate_via_guest_guard___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};




var CanActivateViaGuestGuard = (function () {
    function CanActivateViaGuestGuard(router, authService, logService) {
        this.router = router;
        this.authService = authService;
        this.logService = logService;
    }
    CanActivateViaGuestGuard.prototype.canActivate = function () {
        var _this = this;
        this.logService.debug('Checking if the user is already authenticated. If so, then redirect to the secure site');
        return this.authService.isLoggedIn().map(function (isLoggedIn) {
            _this.logService.verbose("isAuthenticated " + isLoggedIn);
            if (isLoggedIn) {
                _this.router.navigate(['/']);
            }
            // Returning !isLoggedIn since we only want to activate the guard is the user is not logged in.
            return !isLoggedIn;
        });
    };
    return CanActivateViaGuestGuard;
}());
CanActivateViaGuestGuard = can_activate_via_guest_guard___decorate([
    Object(core_es5["Injectable"])(),
    can_activate_via_guest_guard___metadata("design:paramtypes", [typeof (can_activate_via_guest_guard__a = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && can_activate_via_guest_guard__a || Object, typeof (can_activate_via_guest_guard__b = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && can_activate_via_guest_guard__b || Object, typeof (can_activate_via_guest_guard__c = typeof log_service_LogService !== "undefined" && log_service_LogService) === "function" && can_activate_via_guest_guard__c || Object])
], CanActivateViaGuestGuard);

var can_activate_via_guest_guard__a, can_activate_via_guest_guard__b, can_activate_via_guest_guard__c;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/can-activate-via-guest-guard.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/external-login-expired/external-login-expired.component.ts
var external_login_expired_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var external_login_expired_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var ExternalLoginExpiredComponent = (function () {
    function ExternalLoginExpiredComponent() {
    }
    return ExternalLoginExpiredComponent;
}());
ExternalLoginExpiredComponent = external_login_expired_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-external-login-expired',
        template: __webpack_require__("o9sb")
    }),
    external_login_expired_component___metadata("design:paramtypes", [])
], ExternalLoginExpiredComponent);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/external-login-expired.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/auth.routes.ts






var auth_routes_routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [CanActivateViaGuestGuard]
    },
    {
        path: 'logout',
        component: LogoutComponent,
        canActivate: [CanActivateViaAuthGuard]
    },
    {
        path: 'secured',
        component: secured_home_component_SecuredHomeComponent
    },
    {
        path: 'external-login-expired',
        component: ExternalLoginExpiredComponent,
        canActivate: [CanActivateViaGuestGuard]
    }
];
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/auth.routes.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/auth.module.ts
var auth_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
















var AuthModule = (function () {
    function AuthModule() {
    }
    return AuthModule;
}());
AuthModule = auth_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"],
            forms_es5["FormsModule"],
            SharedModule,
            PermissionModule,
            router_es5["RouterModule"].forChild(auth_routes_routes)
        ],
        declarations: [
            LoginComponent,
            LogoutComponent,
            secured_home_component_SecuredHomeComponent,
            ExternalLoginExpiredComponent
        ],
        providers: [
            CanActivateViaAuthGuard,
            CanActivateViaGuestGuard,
            PermissionGuard,
            authentication_store_AuthenticationStore,
            authentication_http_service_AuthenticationHttpService
        ],
        exports: []
    })
], AuthModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/auth.module.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/navigation/header/header.component.ts
var header_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var header_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var HeaderComponent = (function () {
    function HeaderComponent(authenticationStore, router) {
        this.authenticationStore = authenticationStore;
        this.router = router;
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userIsLoggedIn = this.authenticationStore.isLoggedIn();
        this.authenticationStore.user.subscribe(function (user) {
            _this.user = user;
        });
    };
    HeaderComponent.prototype.onLogout = function () {
        this.authenticationStore.logout();
        if (this.authenticationStore.isExternalLogin()) {
            this.router.navigate(['external-login-expired']);
        }
        else {
            this.router.navigate(['login']);
        }
    };
    Object.defineProperty(HeaderComponent.prototype, "email", {
        get: function () {
            return {
                email: this.user.email
            };
        },
        enumerable: true,
        configurable: true
    });
    return HeaderComponent;
}());
HeaderComponent = header_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-header',
        template: __webpack_require__("lS7k")
    }),
    header_component___metadata("design:paramtypes", [typeof (header_component__a = typeof authentication_store_AuthenticationStore !== "undefined" && authentication_store_AuthenticationStore) === "function" && header_component__a || Object, typeof (header_component__b = typeof router_es5["Router"] !== "undefined" && router_es5["Router"]) === "function" && header_component__b || Object])
], HeaderComponent);

var header_component__a, header_component__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/header.component.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/navigation/navigation.module.ts
var navigation_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var NavigationModule = (function () {
    function NavigationModule() {
    }
    return NavigationModule;
}());
NavigationModule = navigation_module___decorate([
    Object(core_es5["NgModule"])({
        imports: [
            common_es5["CommonModule"],
            SharedModule,
            router_es5["RouterModule"]
        ],
        declarations: [
            HeaderComponent
        ],
        exports: [
            HeaderComponent
        ]
    })
], NavigationModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/navigation.module.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/menus/event-search-filter/event-search-filter.component.ts
var event_search_filter_component___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var event_search_filter_component___metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};



var EventSearchFilterComponent = (function () {
    function EventSearchFilterComponent(eventSearchParametersStore, eventSearchFormsStore) {
        this.eventSearchParametersStore = eventSearchParametersStore;
        this.eventSearchFormsStore = eventSearchFormsStore;
        this.isEventFilterMenuExpanded = false;
    }
    EventSearchFilterComponent.prototype.ngOnInit = function () {
        this.eventFilterForm = this.eventSearchFormsStore.filterForm;
        this.isEventFilterMenuExpanded = this.eventSearchFormsStore.isEventFilterOptionSelected();
    };
    EventSearchFilterComponent.prototype.returnToSearchList = function () {
        this.eventSearchParametersStore.updateUrl();
    };
    EventSearchFilterComponent.prototype.applySearchFilters = function (model) {
        var filterRecord = this.eventSearchFormsStore.createFilterRecord(model);
        this.eventSearchFormsStore.searchFromFilter(filterRecord);
    };
    EventSearchFilterComponent.prototype.resetSearchFilters = function () {
        this.eventSearchParametersStore.resetFilters(true);
    };
    return EventSearchFilterComponent;
}());
EventSearchFilterComponent = event_search_filter_component___decorate([
    Object(core_es5["Component"])({
        selector: 'pioneer-event-search-filter',
        template: __webpack_require__("8Q4s")
    }),
    event_search_filter_component___metadata("design:paramtypes", [typeof (event_search_filter_component__a = typeof event_search_parameters_store_EventSearchParametersStore !== "undefined" && event_search_parameters_store_EventSearchParametersStore) === "function" && event_search_filter_component__a || Object, typeof (event_search_filter_component__b = typeof event_search_forms_store_EventSearchFormsStore !== "undefined" && event_search_forms_store_EventSearchFormsStore) === "function" && event_search_filter_component__b || Object])
], EventSearchFilterComponent);

var event_search_filter_component__a, event_search_filter_component__b;
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/event-search-filter.component.js.map
// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@ngx-translate/http-loader/index.js + 1 modules
var http_loader = __webpack_require__("kkjc");

// EXTERNAL MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/node_modules/@angular/common/@angular/common/http.es5.js
var common_http_es5 = __webpack_require__("XKz0");

// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/ng2-translate.config.ts



function createTranslateLoader(http) {
    return new http_loader["a" /* TranslateHttpLoader */](http, './assets/i18n/', '.json');
}
var TranslateModule = core["b" /* TranslateModule */].forRoot({
    loader: {
        provide: core["a" /* TranslateLoader */],
        useFactory: createTranslateLoader,
        deps: [common_http_es5["a" /* HttpClient */]]
    }
});
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/ng2-translate.config.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/app.module.ts
var app_module___decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




















var app_module_routes = [
    { path: 'version', component: VersionComponent },
    { path: '**', component: RouteNotFoundComponent }
];
var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule = app_module___decorate([
    Object(core_es5["NgModule"])({
        declarations: [
            app_component_AppComponent,
            app_menu_component_AppMenuComponent,
            event_menu_component_EventMenuComponent,
            EventSearchFilterComponent
        ],
        imports: [
            platform_browser_es5["BrowserModule"],
            forms_es5["FormsModule"],
            forms_es5["ReactiveFormsModule"],
            http_es5["HttpModule"],
            router_es5["RouterModule"],
            AuthModule,
            EventModule,
            NavigationModule,
            UserModule,
            SharedModule,
            TranslateModule,
            common_http_es5["b" /* HttpClientModule */],
            // enable HashLocationStrategy
            // https://angular.io/docs/ts/latest/guide/router.html#!#browser-url-styles
            router_es5["RouterModule"].forRoot(app_module_routes, { useHash: true }),
            es5["Angulartics2Module"].forRoot([es5["Angulartics2GoogleAnalytics"]])
        ],
        providers: [menu_store_MenuStore],
        bootstrap: [app_component_AppComponent]
    })
], AppModule);

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app.module.js.map
// CONCATENATED MODULE: /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/main.ts





/**
 * Setup ngx-bootstrap to use Bootstrap 4
 */
// `window` must be cast to `any` since the compiler does not understand the `__theme` property
window.__theme = 'bs4';
var main_environment = new EnvironmentConfiguration(environments);
ga('create', main_environment.googleAnalytics.id, main_environment.googleAnalytics.loadType);
/**
 * The below code is commented out and intentionally left here.
 * Google Analytics will tell you that it's required, but it's
 * handled by Angulartics2GoogleAnalytics
 */
// ga('send', 'pageview');
if (main_environment.production) {
    Object(core_es5["enableProdMode"])();
}
Object(platform_browser_dynamic_es5["a" /* platformBrowserDynamic */])().bootstrapModule(AppModule);
//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/main.js.map

/***/ }),

/***/ "ch4d":
/***/ (function(module, exports) {

module.exports = "<!--           Payment Record         -->\n<script\n  src=\"../payment-modifier-display-calculation/payment-modifier-display.component.ts\"></script>\n<div class=\"card\" data-se-id=\"payment-record\">\n  <div class=\"card-header\" id=\"card-commission-payment\">\n    {{'EVENT.COMMISSION.PAYMENT_RECORD' | translate}}\n  </div>\n  <div class=\"card-block\">\n\n    <!-- rejected message -->\n    <div class=\"row\"\n         *ngIf=\"ui.showRejectedMessage\"\n         data-se-id=\"payment-record-error-message\">\n      <div class=\"form-container pay-rejected mx-auto\">\n        <div class=\"row\">\n          <div class=\"col form-container col-md-12\">\n            <div class=\"form-group\">\n\n              <label class=\"form-control-label\">\n                {{ 'EVENT.COMMISSION.PROCESSING_ERROR' | translate }}\n              </label>\n              <p class=\"lead\">\n                {{ 'EVENT.COMMISSION.PROCESSING_ERROR_LEAD' | translate }}\n              </p>\n              <p class=\"lead text-center\">\n                <!-- todo: replace with support contact message when available: \"EVENT.COMMISSION.CONTACT_MESSAGE\" -->\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n\n      <!-- payment calculation / adjustment list -->\n      <div class=\"form-container pay-equation mx-auto\">\n        <div class=\"row\">\n          <pioneer-payment-modifier-display\n            [event]=\"onyxEvent\"\n            [strikeThroughPaymentLines]=\"ui.strikeThroughPaymentLines\">\n          </pioneer-payment-modifier-display>\n        </div>\n      </div>\n\n      <!-- status / transaction date-->\n      <div class=\"form-container pay-record mx-auto\">\n        <div class=\"row\">\n          <div class=\"col form-container pay-status\">\n            <div class=\"form-group\">\n              <label class=\"form-control-label\">\n                {{'EVENT.COMMISSION.STATUS' | translate}}\n              </label>\n              <p class=\"form-control readonly\">\n                {{latestPayment.status | paymentStatus }}\n              </p>\n            </div>\n          </div>\n          <div class=\"col form-container pay-date\">\n            <div class=\"form-group\">\n              <label class=\"form-control-label\">\n                {{'EVENT.COMMISSION.TRANSACTION_DATE' | translate}}\n              </label>\n              <p class=\"form-control readonly\">\n                {{latestPayment.modifiedDate | date: 'shortDate'}}\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- reference ids -->\n      <div class=\"form-container pay-ids\">\n        <div class=\"row\">\n          <div class=\"col form-container pay-id-item\">\n            <div class=\"form-group\">\n              <label class=\"form-control-label\">\n                {{'EVENT.COMMISSION.PAYMENT_ID' | translate}}\n              </label>\n              <p class=\"form-control readonly\">\n                {{latestPayment.paymentReferenceId}}\n              </p>\n            </div>\n          </div>\n          <div class=\"col form-container pay-id-item\">\n            <div class=\"form-group\">\n              <label class=\"form-control-label\">\n                {{'EVENT.COMMISSION.FUNDING_ID' | translate}}\n              </label>\n              <p class=\"form-control readonly\">\n                {{latestPayment.fundingReferenceId}}\n              </p>\n            </div>\n          </div>\n          <div class=\"col form-container pay-id-item\">\n            <div class=\"form-group\">\n              <label class=\"form-control-label\">\n                {{'EVENT.COMMISSION.COMMISSION_ID' | translate}}\n              </label>\n              <p class=\"form-control readonly\">\n                {{latestPayment.commissionId}}\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <!-- description -->\n      <div class=\"form-container pay-desc\">\n        <div class=\"form-group\">\n          <label class=\"form-control-label\">\n            {{'EVENT.COMMISSION.DESCRIPTION' | translate}}\n          </label>\n          <p class=\"form-control readonly\">\n            {{latestPayment.description}}\n          </p>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "efyd":
/***/ (function(module, exports) {

module.exports = "<pioneer-header *ngIf=\"userIsLoggedIn | async\"></pioneer-header>\n<div class=\"container-fluid\" *ngIf=\"userIsLoggedIn | async\">\n  <div class=\"row title-bar\">\n    <div class=\"page-title\"><h1>{{title}}</h1></div>\n    <div class=\"action-bar\"></div>\n  </div>\n</div>\n<pioneer-flash-messages></pioneer-flash-messages>\n<div class=\"container-fluid\">\n  <div class=\"row app-area\">\n    <router-outlet name=\"navigation\"></router-outlet>\n    <div class=\"content-area\">\n      <router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "f0B1":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"autopayment-confirmation-modal\"\n  [content]=\"confirmationModalConfig.content\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  [confirm]=\"confirmationModalConfig.confirm\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeAutopaymentToggleHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"form-group form-toggle\">\n  <label class=\"tgl\">\n    <input type=\"checkbox\"\n           (click)=\"confirmBeforeTogglingAutoPayment()\"\n           [checked]=\"onyxEvent.autoPayment\"\n           data-se-id=\"autoPaymentToggleCheckbox\"\n           hidden/>\n    <span class=\"tgl_body\" data-se-id=\"autoPaymentToggleSwitch\">\n      <span class=\"tgl_switch\"></span>\n      <span class=\"tgl_track\">\n        <span class=\"tgl_bgd\"></span>\n        <span class=\"tgl_bgd tgl_bgd-negative\"></span>\n      </span>\n    </span>\n    <!-- todo: replace labels -->\n    <span class=\"custom-control-description tooltip-hint\"\n          data-toggle=\"tooltip\"\n          data-html=\"false\"\n          data-placement=\"top\"\n          [tooltip]=\"'EVENT.COMMISSION.AUTO_PAYMENT_TOGGLE_TOOLTIP' | translate\">\n      {{ 'EVENT.COMMISSION.AUTO_PAYMENT' | translate }}\n    </span>\n  </label>\n</div>\n"

/***/ }),

/***/ "gFIY":
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "gFIY";

/***/ }),

/***/ "iC+n":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"eventForm\"\n      novalidate>\n  <div class=\"content-container\">\n    <div class=\"row\">\n      <div class=\"card-content\">\n        <div formGroupName=\"event\">\n          <pioneer-basic-event-data [parentForm]=\"eventForm\"\n                                    [event]=\"onyxEvent\"\n                                    [isReadOnly]=\"isReadOnly\"\n                                    [isNewEvent]=\"true\"></pioneer-basic-event-data>\n\n\n\n          <pioneer-contact-lookup-form\n            [parentForm]=\"eventForm\"\n            partyType=\"PROPERTY\"\n            [event]=\"onyxEvent\"\n            [isReadOnly]=\"isReadOnly\">\n          </pioneer-contact-lookup-form>\n\n          <pioneer-contact-lookup-form\n            [parentForm]=\"eventForm\"\n            partyType=\"AGENCY\"\n            [event]=\"onyxEvent\"\n            [isReadOnly]=\"isReadOnly\">\n          </pioneer-contact-lookup-form>\n\n          <pioneer-contact-form\n            [parentForm]=\"eventForm\"\n            partyType=\"CLIENT\"\n            [event]=\"onyxEvent\"\n            [isReadOnly]=\"isReadOnly\">\n          </pioneer-contact-form>\n\n          <div class=\"button-bar\">\n            <a class=\"btn btn-link\"\n               (click)=\"returnToSearchList()\"\n               data-se-id=\"cancelButton\">{{'COMMON.BUTTON.CANCEL'\n              | translate}}</a>\n            <button type=\"button\"\n                    [disabled]=\"!eventForm.valid\"\n                    (click)=\"save(eventForm.value)\"\n                    class=\"btn btn-primary\"\n                    data-se-id=\"saveButton\">\n              {{'COMMON.BUTTON.SAVE' | translate}}\n            </button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"margin-content\" id=\"scrollSpyId\">\n        <div class=\"page-nav\" id=\"pageNavAddEvent\" data-se-id=\"page-nav-add-event\" role=\"tablist\">\n          <ul class=\"list-group\">\n            <li class=\"list-group-item list-group-item-action active\" data-toggle=\"tab\" role=\"tab\">\n              <div class=\"item-text\">{{ \"EVENT.ADD_EVENT_NAVIGATION\" | translate }}</div>\n              <div class=\"page-nav-sub\">\n                <ol class=\"nav flex-column\">\n                  <li class=\"nav-item\">\n                    <a pageScroll href=\"#card-basic-event-data\" class=\"nav-link active\">{{\n                      \"EVENT.EVENT_INFO_NAVIGATION\" | translate }}</a>\n                  </li>\n                  <li class=\"nav-item\">\n                    <a pageScroll href=\"#card-property\" class=\"nav-link\">{{\n                      \"EVENT.PROPERTY_CONTENT_NAVIGATION\" | translate }}</a>\n                  </li>\n                  <li class=\"nav-item\">\n                    <a pageScroll href=\"#card-agency\" class=\"nav-link\">{{\n                      \"EVENT.AGENCY_CONTENT_NAVIGATION\" | translate }}</a>\n                  </li>\n                  <li class=\"nav-item\">\n                    <a pageScroll href=\"#card-client\" class=\"nav-link\">{{\n                      \"EVENT.CLIENT_CONTENT_NAVIGATION\" | translate }}</a>\n                  </li>\n                </ol>\n              </div>\n            </li>\n          </ul>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</form>\n"

/***/ }),

/***/ "iS/x":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("rP7Y")(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"route-not-found.component.css","sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "kD7v":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-container\">\n  <div class=\"row\">\n    <div class=\"card-content\">\n      <pioneer-add-rsvp *pioneerAuthorize=\"{permission: 'AddRsvp'}\"\n                        [event]=\"onyxEvent\">\n      </pioneer-add-rsvp>\n      <pioneer-rsvp-list [event]=\"onyxEvent\"></pioneer-rsvp-list>\n    </div>\n    <pioneer-event-nav></pioneer-event-nav>\n  </div>\n</div>\n"

/***/ }),

/***/ "kYhW":
/***/ (function(module, exports) {

module.exports = "<!--              Summary          -->\n<div class=\"card\" *ngIf=\"!(isReservationListEmpty() | async)\">\n  <template #commissionSummaryPopup>\n    <p class='lead' data-se-id=\"summary-tooltip-title\">{{\n      'EVENT.RESERVATION.TOOLTIP_SUMMARY_COMMISSION_TITLE' | translate }}</p>\n    <p class='res-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_TOTAL' | translate }}</span>\n      {{ getReservationCommissionTotal() | async | currency:'USD':true }}</p>\n    <div *ngIf=\"!(isRsvpListEmpty() | async)\">\n      <p class='rsvp-comm'><span class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_RSVP' | translate }}</span>\n        {{ getRsvpCommissionTotal() | async | currency:'USD':true }}</p>\n      <p class='diff-comm'>\n        <span\n          class='label'>{{ 'EVENT.RESERVATION.TOOLTIP_COMMISSION_DIFFERENCE' | translate }}</span>\n        {{ getCommissionDeltaText() | async }} {{ getCommissionDelta() | async | absolute |\n        currency:'USD':true }}\n      </p>\n    </div>\n  </template>\n\n  <div class=\"card-header\" id=\"card-reservation-list\">\n    {{ 'EVENT.RESERVATION.RESERVATION_SUMMARY_TITLE' | translate }}\n    <span class=\"commission-sum\" [ngClass]=\"totalCommissionClass() | async\">\n      <span class=\"res-value\" [tooltip]=\"commissionSummaryPopup\" placement=\"right\"\n            data-se-id=\"summary-commission-total\">\n        {{ getReservationCommissionTotal() | async | currency:'USD':true }}\n      </span>\n    </span>\n  </div>\n  <div class=\"table-responsive\" *ngIf=\"!(isFilteredListEmpty() | async)\"\n       data-se-id=\"reservation-summary-table\">\n    <table class=\"table reservation-list res-summary\" [ngClass]=\"filteredClass\">\n      <thead>\n      <tr>\n        <th>{{ 'EVENT.RESERVATION.NAME' | translate }}</th>\n        <th>{{ 'EVENT.RESERVATION.CONFIRMATION_NUMBER' | translate }}</th>\n        <th>{{ 'EVENT.RESERVATION.STATUS' | translate }}</th>\n        <th>{{ 'EVENT.RESERVATION.ROOM_TYPE' | translate }}</th>\n        <th class=\"nights\">{{ 'EVENT.RESERVATION.NUMBER_NIGHTS' | translate }}</th>\n        <th class=\"currency\">{{ 'EVENT.RESERVATION.ROOM_RATE' | translate }}</th>\n        <th class=\"currency\">{{ 'EVENT.RESERVATION.REVENUE' | translate }}</th>\n        <th class=\"currency\">{{ 'EVENT.RESERVATION.COMMISSION' | translate }}</th>\n      </tr>\n      </thead>\n      <tbody data-se-id=\"reservationSummary\">\n      <tr *ngFor=\"let compare of getFilteredReservations() | async\"\n          data-se-id=\"reservationSummaryEntry\"\n          [class.commission-up]=\"isCommissionUp(compare)\"\n          [class.commission-down]=\"isCommissionDown(compare)\"\n          [ngClass]=\"getStatusClass(compare)\">\n        <td class=\"res-guest-name\"\n          [routerLink]=\"['/event/' + onyxEvent.eventId + '/reservations/detail']\"\n          [queryParams]=\"{ reservation: compare.reservation.eventReservationId }\"\n          data-se-id=\"name\">\n          <span *ngIf=\"compare.reservation.firstName\">\n            {{ compare.reservation.lastName }}, {{ compare.reservation.firstName }}\n          </span>\n          <span *ngIf=\"!compare.reservation.firstName\">\n            {{ compare.reservation.lastName }}\n          </span>\n        </td>\n        <td data-se-id=\"confirmation\">\n          <span class=\"res-value\">{{ compare.reservation.confirmation }}</span>\n        </td>\n        <td class=\"res-status\" data-se-id=\"status\">\n          <span class=\"res-value\">{{ compare.reservation.status | reservationStatus }}</span>\n        </td>\n        <td data-se-id=\"roomType\">\n          <span class=\"res-value\">{{ compare.reservation.roomType }}</span>\n        </td>\n        <td class=\"nights\" data-se-id=\"nights\">\n          <span class=\"res-value\">{{ compare.reservation.nights }}</span>\n        </td>\n        <td class=\"currency\" data-se-id=\"roomRate\">\n          <span class=\"res-value\">{{ compare.reservation.roomRate | currency:'USD':true }}</span>\n        </td>\n        <td class=\"currency\" data-se-id=\"revenue\">\n          <span class=\"res-value\">{{ compare.reservation.revenue | currency:'USD':true }}</span>\n        </td>\n        <td class=\"currency rsvp-diff\" data-se-id=\"commission\">\n          <span class=\"res-value\">{{ compare.reservation.commission | currency:'USD':true }}</span>\n        </td>\n      </tr>\n      </tbody>\n      <tfoot *ngIf=\"!(isFilteredListEmpty() | async)\">\n      <tr class=\"commission\">\n        <td>{{ 'EVENT.RESERVATION.TOTAL' | translate }}</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td class=\"nights\">{{ getFilteredReservationNightsTotal() | async }}</td>\n        <td></td>\n        <td class=\"currency\" data-se-id=\"revenueTotal\">\n          {{ getFilteredReservationRevenueTotal() | async | currency:'USD':true }}\n        </td>\n        <td class=\"currency rsvp-diff\">\n          <span class=\"res-value\" data-se-id=\"commissionTotal\">\n            {{ getFilteredReservationCommissionTotal() | async | currency:'USD':true }}\n          </span>\n        </td>\n      </tr>\n      </tfoot>\n    </table>\n  </div>\n  <div *ngIf=\"hasFilteredOutResults() | async\" class=\"result-empty\"\n       data-se-id=\"reservation-filtered-out\">\n    <h3>{{ \"EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND\" | translate }}</h3>\n    <figure class=\"figure\">\n      <i class=\"glyph-page figure-img\"></i>\n      <figcaption class=\"figure-caption\"><a class=\"btn btn-link\"\n                                            data-se-id=\"reservation-filtered-reset\"\n                                            (click)=\"resetStatusCodes()\">\n        {{ \"EVENT.RESERVATION.NO_FILTERED_RESERVATIONS_FOUND_CAPTION\" | translate }}</a>\n      </figcaption>\n    </figure>\n  </div>\n</div>\n\n<div *ngIf=\"isReservationListEmpty() | async\" class=\"result-empty\"\n     data-se-id=\"reservationSummaryNotFound\">\n  <h3>{{ \"EVENT.RESERVATION.NO_RESERVATIONS_FOUND\" | translate }}</h3>\n  <figure class=\"figure\">\n    <i class=\"glyph-page figure-img\"></i>\n    <figcaption class=\"figure-caption\">{{ \"EVENT.RESERVATION.NO_RESERVATIONS_FOUND_CAPTION\" |\n      translate }}\n    </figcaption>\n  </figure>\n</div>\n\n"

/***/ }),

/***/ "kt5u":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"

/***/ }),

/***/ "lOyP":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"eventsPresent | async\" class=\"card\">\n  <div class=\"card-block\">\n    <h4 class=\"card-title\">\n      {{ 'EVENTS.RESULTS_RETURNED' | translate: (eventCountForTranslate | async) }}\n      <small *ngIf=\"eventsAboveMax | async\" class=\"text-warning\">\n        {{'EVENTS.MAX_EVENTS' | translate: maxEventsForTranslate }}\n      </small>\n    </h4>\n  </div>\n  <div class=\"table-responsive\">\n    <table class=\"table search-results\">\n      <thead>\n      <tr>\n        <th>{{'EVENTS.EVENT_NAME' | translate}}</th>\n        <th>{{'EVENTS.REFERENCE_ID' | translate}}</th>\n        <th>{{'EVENTS.START_DATE' | translate}}</th>\n        <th>{{'EVENTS.END_DATE' | translate}}</th>\n        <th>{{'EVENTS.PROPERTY_NAME' | translate}}</th>\n        <th>{{'EVENTS.PROPERTY_ADDRESS' | translate}}</th>\n        <th>{{'EVENTS.PROPERTY_CITY' | translate}}</th>\n        <th>{{'EVENTS.PROPERTY_STATE' | translate}}</th>\n        <th>{{'EVENTS.PROPERTY_ZIP' | translate}}</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let event of events | async\" (click)=\"onSelect(event)\">\n        <td data-se-id=\"name\">\n          <span *ngIf=\"event.autoGenerated\"\n                class=\"tooltip-hint\"\n                [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n                placement=\"right\">\n            {{event.name}}\n          </span>\n          <span *ngIf=\"!event.autoGenerated\">\n            {{event.name}}\n          </span>\n        </td>\n        <td data-se-id=\"eventReferenceNumber\">\n          {{event.eventReferenceNumber}}\n        </td>\n        <td data-se-id=\"startDate\">{{event.startDate | date: 'shortDate' }}</td>\n        <td data-se-id=\"endDate\">{{event.endDate | date: 'shortDate' }}</td>\n        <td data-se-id=\"propertyName\">{{event.propertyName}}</td>\n        <td>\n          {{event.propertyLine1}}\n          {{event.propertyLine2}}\n        </td>\n        <td>{{event.propertyCity}}</td>\n        <td>{{event.propertyState}}</td>\n        <td>{{event.propertyPostalCode}}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),

/***/ "lS7k":
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid\">\n  <div class=\"row app-header\">\n    <div class=\"header-left\">\n      <div class=\"header-logo sr-only\">{{ 'COMMON.APP_TITLE' | translate }}</div>\n    </div>\n    <div class=\"header-right\" *ngIf=\"userIsLoggedIn | async\">\n\n      <div class=\"btn-group\">\n        <button class=\"btn btn-link dropdown-toggle\" data-se-id=\"welcome-text\"\n                data-toggle=\"dropdown\">{{'COMMON.HEADER.WELCOME' | translate: email}}\n        </button>\n        <div class=\"dropdown-menu dropdown-menu-right\">\n          <button class=\"dropdown-item\" data-se-id=\"logout-button\" (click)=\"onLogout()\"\n                  type=\"button\">{{'LOGOUT.LOGOUT' | translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "lcuP":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"deleteRsvpConfirmationModal\"\n  content=\"EVENT.RSVPS.CONFIRM_DELETE_RSVP\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.RSVPS.DELETE_RSVP\"\n  (closed)=\"confirmHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div *ngIf=\"!(isRsvpListEmpty | async)\" class=\"card\" id=\"card-rsvp-list\" data-se-id=\"rsvpList\">\n  <div class=\"card-header\">\n    {{ \"EVENT.RSVPS.RSVP_LIST_HEADER\" | translate }}\n  </div>\n  <div class=\"table-responsive\">\n    <table class=\"table reservation-list rsvp-list\">\n      <thead>\n      <tr>\n        <th class=\"control-remove-row\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\"></th>\n        <th>{{ \"EVENT.RSVPS.NAME\" | translate }}</th>\n        <th class=\"nights \">{{ \"EVENT.RSVPS.NIGHTS\" | translate }}</th>\n        <th class=\"currency\">{{ \"EVENT.RSVPS.ROOM_RATE\" | translate }}</th>\n        <th class=\"currency\">{{ \"EVENT.RSVPS.REVENUE\" | translate }}</th>\n        <th class=\"currency\">{{ \"EVENT.RSVPS.COMMISSION\" | translate }}</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let rsvp of rsvps | async\" data-se-id=\"rsvpListEntry\">\n        <td class=\"control-remove-row\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\">\n          <i class=\"glyph-trash\" (click)=\"confirmBeforeDelete(rsvp)\" data-se-id=\"rsvpDelete\"></i>\n        </td>\n        <td class=\"res-guest-name\"\n            [routerLink]=\"['/event/' + onyxEvent.eventId + '/reservations/detail']\"\n            [queryParams]=\"{ rsvp: rsvp.eventRsvpId }\"\n            data-se-id=\"rsvpGuestName\">\n          {{ rsvp.lastName }}, {{ rsvp.firstName }}\n        </td>\n        <td class=\"nights\" data-se-id=\"rsvpNights\">{{ rsvp.nights }}</td>\n        <td class=\"currency\" data-se-id=\"rsvpRoomRate\">{{ rsvp.roomRate | currency:'USD':true }}\n        </td>\n        <td class=\"currency\" data-se-id=\"rsvpRevenue\">{{ rsvp.revenue | currency:'USD':true }}</td>\n        <td class=\"currency\" data-se-id=\"rsvpCommission\">{{ rsvp.commission | currency:'USD':true\n          }}\n        </td>\n      </tr>\n      </tbody>\n      <tfoot>\n      <tr>\n        <td class=\"control-remove-row\" *pioneerAuthorize=\"{permission: 'DeleteRsvp'}\"></td>\n        <td>{{ \"EVENT.RSVPS.TOTAL\" | translate }}</td>\n        <td class=\"nights \" data-se-id=\"rsvpNightsTotal\">{{ totalNights | async }}</td>\n        <td class=\"currency\"></td>\n        <td class=\"currency\" data-se-id=\"rsvpRevenueTotal\">{{ totalRevenue | async |\n          currency:'USD':true }}\n        </td>\n        <td class=\"currency\" data-se-id=\"rsvpCommissionTotal\">{{ totalCommission | async |\n          currency:'USD':true }}\n        </td>\n      </tr>\n      </tfoot>\n    </table>\n  </div>\n</div>\n\n<div *ngIf=\"isRsvpListEmpty | async\" class=\"result-empty\" data-se-id=\"rsvpsNotFound\">\n  <h3>{{ \"EVENT.RSVPS.NO_RSVPS_FOUND\" | translate }}</h3>\n  <figure class=\"figure\">\n    <i class=\"glyph-page figure-img\"></i>\n    <figcaption class=\"figure-caption\">{{ \"EVENT.RSVPS.NO_RSVPS_FOUND_CAPTION\" | translate }}\n    </figcaption>\n  </figure>\n</div>\n"

/***/ }),

/***/ "mwq9":
/***/ (function(module, exports) {

module.exports = "<div class=\"card-header\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID' | translate }}</div>\n<div class=\"card-block row\">\n  <div class=\"col-sm\">\n    <h5 class=\"card-title text-center \">{{ 'DASHBOARD.COMPLETED_AND_UNPAID_LT_14_DAYS' | translate }}</h5>\n    <p class=\"dashboard-display text-success\">\n      <span data-se-id = \"lessThan14DaysTotalBucket\" class=\"count\">{{ completedAndUnpaidLessThan14DaysTotal | async }}</span>\n    </p>\n  </div>\n  <div class=\"col-sm\">\n    <h5 class=\"card-title text-center\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID_15_TO_28_DAYS' | translate }}</h5>\n    <p class=\"dashboard-display text-warning\">\n      <span data-se-id = \"between15And28DaysTotalBucket\" class=\"count\">{{ completedAndUnpaidBetween15And28DaysTotal | async }}</span>\n    </p>\n  </div>\n  <div class=\"col-sm\">\n    <h5 class=\"card-title text-center\">{{ 'DASHBOARD.COMPLETED_AND_UNPAID_GT_28_DAYS' | translate }}</h5>\n    <p class=\"dashboard-display text-danger\">\n      <span data-se-id = \"greaterThan28DaysTotalBucket\" class=\"count\">{{ completedAndUnpaidGreaterThan28DaysTotal | async }}</span>\n    </p>\n  </div>\n</div>\n<div class=\"card-footer\">\n  <a href=\"javascript:void(0)\"\n     (click)=\"completedAndUnpaidPredefinedSearch()\"\n     data-se-id=\"completed-and-unpaid-predefined-search\">\n    {{ 'DASHBOARD.VIEW_COMPLETED_AND_UNPAID' | translate }}\n  </a>\n</div>\n"

/***/ }),

/***/ "o9sb":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div id=\"flashMessages\">\n    <div class=\"flash-message alert alert-danger\">\n      {{'EXTERNAL_LOGIN_EXPIRED.LOG_IN_AGAIN' | translate}}\n    </div>\n  </div>\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"

/***/ }),

/***/ "op3L":
/***/ (function(module, exports) {

module.exports = "<div class=\"page-nav\" id=\"pageNav\">\n  <ul class=\"list-group\">\n\n    <!-- Contract Summary -->\n    <li class=\"list-group-item list-group-item-action\"\n        data-se-id=\"viewContractSummary\"\n        [routerLink]=\"getContractSummaryRouterLink()\"\n        routerLinkActive=\"active\"\n        [routerLinkActiveOptions]=\"{exact:true}\">\n      <div class=\"item-text\">{{ 'EVENT.CONTRACT_SUMMARY_NAVIGATION' | translate }}</div>\n      <div class=\"page-nav-sub\">\n        <ol class=\"nav flex-column\" id=\"stickyNavContractSummary\">\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-basic-event-data\"\n               class=\"nav-link active\">{{ 'EVENT.EVENT_INFO_NAVIGATION' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-property\"\n               class=\"nav-link\">{{ 'EVENT.PROPERTY_CONTENT_NAVIGATION' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-agency\"\n               class=\"nav-link\">{{ 'EVENT.AGENCY_CONTENT_NAVIGATION' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-client\"\n               class=\"nav-link\">{{ 'EVENT.CLIENT_CONTENT_NAVIGATION' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-attachment\"\n               class=\"nav-link\">{{ 'EVENT.EVENT_DOCUMENTS_NAVIGATION' | translate }}</a>\n          </li>\n        </ol>\n      </div>\n    </li>\n\n    <!-- View RSVPs -->\n    <li class=\"list-group-item list-group-item-action\"\n        data-se-id=\"viewRsvps\"\n        [routerLink]=\"['/event/' + onyxEvent.eventId + '/rsvp']\"\n        routerLinkActive=\"active\">\n      <div class=\"item-text\">{{ 'EVENT.RSVPS_NAVIGATION' | translate }}</div>\n      <div class=\"page-nav-sub\">\n        <ol class=\"nav flex-column\" id=\"stickyNavRsvp\">\n          <li *pioneerAuthorize=\"{permission: 'AddRsvp'}\"\n              class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-add-rsvp\"\n               data-se-id=\"addGuest\"\n               class=\"nav-link active\">{{ 'EVENT.RSVP_LIST_NAVIGATION_ADD' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-rsvp-list\"\n               class=\"nav-link\">{{ 'EVENT.RSVP_LIST_NAVIGATION_VIEW' | translate }}</a>\n          </li>\n        </ol>\n      </div>\n    </li>\n\n    <!-- View Reservation Summary -->\n    <li *ngIf=\"getReservationSummarySelected() | async\"\n        class=\"list-group-item list-group-item-action\"\n        data-se-id=\"viewReservationInformation\"\n        [routerLink]=\"['/event/' + onyxEvent.eventId + '/reservations']\"\n        routerLinkActive=\"active\">\n      <div class=\"item-text\">{{ 'EVENT.RESERVATION_NAVIGATION' | translate }}</div>\n      <div class=\"page-nav-sub\">\n        <ol class=\"nav flex-column\">\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#filter-control\"\n               class=\"nav-link active\">{{ 'EVENT.RESERVATIONS_NAVIGATION_STATUS' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-reservation-list\"\n               class=\"nav-link\">{{ 'EVENT.RESERVATIONS_NAVIGATION_LIST' | translate }}</a>\n          </li>\n        </ol>\n      </div>\n    </li>\n\n    <!-- View Reservation Details -->\n    <li *ngIf=\"!(getReservationSummarySelected() | async)\"\n        class=\"list-group-item list-group-item-action\"\n        data-se-id=\"viewReservationDetailInformation\"\n        [routerLink]=\"['/event/' + onyxEvent.eventId + '/reservations/detail']\"\n        routerLinkActive=\"active\">\n      <div class=\"item-text\">{{ 'EVENT.RESERVATION_NAVIGATION' | translate }}</div>\n      <div class=\"page-nav-sub\">\n        <ol class=\"nav flex-column\">\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#filter-control\"\n               class=\"nav-link active\">{{ 'EVENT.RESERVATIONS_NAVIGATION_STATUS' | translate }}</a>\n          </li>\n          <li *ngIf=\"shouldShowMatchTypeLink(MatchTypeEnum.NO_MATCH) | async\" class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-no-match-list\"\n               class=\"nav-link\">{{ getNoMatchNavTitle() | async | translate }}</a>\n          </li>\n          <li *ngIf=\"shouldShowMatchTypeLink(MatchTypeEnum.PARTIAL_MATCH) | async\"\n              class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-partial-match-list\"\n               class=\"nav-link\">{{ 'EVENT.RESERVATIONS_NAVIGATION_PARTIAL_MATCH' | translate }}</a>\n          </li>\n          <li *ngIf=\"shouldShowMatchTypeLink(MatchTypeEnum.EXACT_MATCH) | async\"\n              class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-exact-match-list\"\n               class=\"nav-link\">{{ 'EVENT.RESERVATIONS_NAVIGATION_EXACT_MATCH' | translate }}</a>\n          </li>\n        </ol>\n      </div>\n    </li>\n\n    <!-- Commission Information / Payment -->\n    <li class=\"list-group-item list-group-item-action\"\n        data-se-id=\"viewCommissionInformation\"\n        [routerLink]=\"['/event/' + onyxEvent.eventId + '/commission']\"\n        routerLinkActive=\"active\">\n      <div class=\"item-text\">{{ 'EVENT.PAYMENT_NAVIGATION' | translate }}</div>\n      <div class=\"page-nav-sub\">\n        <ol class=\"nav flex-column\" id=\"stickyNavPayment\">\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-basic-event-data\"\n               class=\"nav-link active\">{{ 'EVENT.EVENT_INFO_NAVIGATION' | translate }}</a>\n          </li>\n          <li class=\"nav-item\" *pioneerAuthorize=\"{permission: 'PayCommission'}\">\n            <a pageScroll\n               href=\"#card-commission-payment\"\n               class=\"nav-link\">{{ 'EVENT.COMMISSION_PAYMENT_NAVIGATION' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-stay-summary\"\n               class=\"nav-link\">{{ 'EVENT.ROOM_SUMMARY_NAVIGATION' | translate }}</a>\n          </li>\n          <li class=\"nav-item\">\n            <a pageScroll\n               href=\"#card-stay-information\"\n               class=\"nav-link\">{{ 'EVENT.RESERVATIONS_NAVIGATION' | translate }}</a>\n          </li>\n        </ol>\n      </div>\n    </li>\n\n\n  </ul>\n</div>\n"

/***/ }),

/***/ "pGxJ":
/***/ (function(module, exports) {

module.exports = "<div [formGroup]=\"basicEventDataForm\">\n  <div class=\"card\" id=\"card-basic-event-data\">\n    <div class=\"card-header\">\n      {{ 'EVENT.EVENT_INFO_TITLE' | translate }}\n      <span *ngIf=\"isAutoGenerated()\"\n            class=\"generated-badge\"\n            data-se-id=\"auto-generated-label\">\n        {{ 'EVENT.AUTO_GENERATED' | translate }}\n      </span>\n      <div *pioneerAuthorize=\"{permission: 'UploadBulkEvents'}\" class=\"header-right\">\n        <label for=\"bulkEventFile\" class=\"btn btn-link btn-sm\"><i class=\"glyph-cloud-up\"></i> {{ 'EVENT.IMPORT_EVENTS' | translate }}</label>\n        <input #bulkEventFile id=\"bulkEventFile\" data-se-id=\"import-event\" hidden\n               type=\"file\"\n               accept=\".csv\"\n               [disabled]=\"isUploadInProgress\"\n               (change)=\"importEventsViaCsv($event)\" />\n      </div>\n    </div>\n    <div class=\"card-block\">\n      <div class=\"row\">\n        <div class=\"form-container info-name form-required\">\n          <div class=\"form-group form-required\">\n            <pioneer-form-input label=\"EVENT.NAME\" [isReadOnly]=\"isReadOnly\">\n              <input type=\"text\"\n                     class=\"form-control\"\n                     formControlName=\"name\"\n                     maxlength=\"45\"\n                     data-se-id=\"eventName\"\n                     [readonly]=\"isReadOnly\"\n                     placeholder=\"{{'EVENT.NAME_PLACEHOLDER' | translate }}\"/>\n            </pioneer-form-input>\n          </div>\n        </div>\n        <div class=\"form-container info-dates\">\n          <div class=\"row\">\n            <div class=\"form-container info-start\">\n              <div class=\"form-group form-required\">\n                <pioneer-form-input label=\"EVENT.START_DATE\">\n                  <input type=\"date\"\n                         class=\"form-control\"\n                         formControlName=\"startDate\"\n                         [readonly]=\"isReadOnly\"\n                         (change)=\"onStartDateEntered($event)\"\n                         placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\"/>\n                </pioneer-form-input>\n              </div>\n            </div>\n            <div class=\"form-container info-end\">\n              <div class=\"form-group form-required\">\n                <pioneer-form-input label=\"EVENT.END_DATE\">\n                  <input type=\"date\"\n                         class=\"form-control\"\n                         formControlName=\"endDate\"\n                         [readonly]=\"isReadOnly\"\n                         placeholder=\"{{'EVENT.DATE_PLACEHOLDER' | translate}}\"/>\n                  <div class=\"validation-messages\">\n                    <pioneer-validation-message *ngIf=\"!isReadOnly\"\n                                                error=\"greater\"\n                                                message=\"EVENT.VALIDATION_START_END_DATE\">\n                    </pioneer-validation-message>\n                  </div>\n                </pioneer-form-input>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-container info-commission\">\n          <div class=\"row\">\n            <div class=\"col form-container info-percent\">\n              <div class=\"form-group form-required\">\n                <pioneer-form-input label=\"EVENT.COMMISSION_RATE\" [isReadOnly]=\"isReadOnly\">\n                  <input type=\"number\"\n                         class=\"form-control\"\n                         formControlName=\"commissionRoomPercentage\"\n                         min=\"0\"\n                         max=\"100\"\n                         [readonly]=\"isReadOnly\"\n                         data-se-id=\"commissionRateInput\"\n                         placeholder=\"{{'EVENT.FINANCIAL_ROOM_COMMISSION_PLACEHOLDER' | translate}}\"/>\n                </pioneer-form-input>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-container info-group\">\n              <div class=\"form-group form-required\">\n                <pioneer-form-input label=\"EVENT.GROUP_CODE\" [isReadOnly]=\"isReadOnly\">\n                  <input type=\"text\"\n                         class=\"form-control\"\n                         formControlName=\"groupCodeNumber\"\n                         max=\"120\"\n                         [readonly]=\"isReadOnly\"\n                         data-se-id=\"groupCodeInput\"\n                         placeholder=\"{{!isReadOnly ? ('EVENT.GROUP_CODE_PLACEHOLDER' | translate) : '' }}\"/>\n                </pioneer-form-input>\n              </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "pWWq":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"payment-equation-confirmation-modal\"\n  content=\"EVENT.COMMISSION.CONFIRMATION_CONTENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"COMMON.BUTTON.CONFIRM\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeDeletingAdjustmentHandler($event)\">\n</pioneer-confirmation-modal>\n\n<div class=\"form-group\" data-se-id=\"adjustmentList\">\n  <label class=\"form-control-label\">\n    {{ 'EVENT.COMMISSION.AMOUNT_DUE' | translate }}\n  </label>\n  <div class=\"commission\">\n    <span class=\"currency\">\n      {{ totalCommissions | async | number:'1.2-2' }}\n    </span>\n    <span class=\"desc\">\n      {{ 'EVENT.COMMISSION.COMMISSIONS' | translate }}\n    </span>\n  </div>\n  <div *ngFor=\"let adjustment of adjustments | async\"\n       [class]=\"getAdjustmentCssClass(adjustment)\"\n       data-se-id=\"adjustmentEntry\">\n    <span [class]=\"getAdjustmentAmountCssClass(adjustment)\"\n          data-se-id=\"adjustmentAmount\">\n      {{ adjustment.adjustmentAmount | number:'1.2-2' }}\n    </span>\n    <span class=\"desc\">\n      {{ adjustment.adjustmentType | adjustmentType }}\n    </span>\n    <ng-container *ngIf=\"isEditMode\">\n      <i data-se-id=\"deleteIcon\"\n         class=\"glyph-trash icon-remove\"\n         *pioneerAuthorize=\"{permission: 'DeleteAdjustment'}\"\n         (click)=\"confirmBeforeDeletingAdjustment(adjustment)\">\n      </i>\n    </ng-container>\n  </div>\n  <div *ngIf=\"areThereAnyAdjustments() | async\" class=\"total\">\n    <span class=\"currency\"\n          data-se-id=\"calculatedPayment\">\n      {{ calculatedPayment | async | number:'1.2-2' }}\n    </span>\n    <span class=\"desc\">\n      {{ 'EVENT.COMMISSION.CALCULATED_PAYMENT' | translate }}\n    </span>\n  </div>\n</div>\n"

/***/ }),

/***/ "qwMY":
/***/ (function(module, exports) {

module.exports = "<script src=\"../event-list.component.ts\"></script>\n<div *ngIf=\"eventsPresent | async\" class=\"card\">\n  <div class=\"card-block\">\n    <h4 class=\"card-title\">\n      {{ 'EVENTS.RESULTS_RETURNED' | translate: (eventCountForTranslate | async) }}\n      <small *ngIf=\"eventsAboveMax | async\" class=\"text-warning\">\n        {{'EVENTS.MAX_EVENTS' | translate: maxEventsForTranslate }}\n      </small>\n    </h4>\n  </div>\n  <div class=\"table-responsive\">\n    <table class=\"table search-results\">\n      <thead>\n      <tr>\n        <th>{{'EVENTS.EVENT_NAME' | translate}}</th>\n        <th>{{'EVENTS.REFERENCE_ID' | translate}}</th>\n        <th>{{'EVENTS.END_DATE' | translate}}</th>\n        <th>{{'EVENTS.PAYMENT_STATUS' | translate}}</th>\n        <th>{{'EVENTS.STATUS_DATE' | translate}}</th>\n        <th>{{'EVENTS.PAY_DATE' | translate}}</th>\n        <th>{{'EVENTS.PAID_AMOUNT' | translate}}</th>\n        <th>{{'EVENTS.ADJUSTMENT_AMOUNT' | translate}}</th>\n        <th>{{'EVENTS.ESTIMATED_DUE_AMOUNT' | translate}}</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let event of events | async\" (click)=\"onSelect(event)\">\n        <td data-se-id=\"name\">\n          <span *ngIf=\"event.autoGenerated\"\n                class=\"tooltip-hint\"\n                [tooltip]=\"'EVENTS.AUTO_GENERATED_TOOLTIP' | translate\"\n                placement=\"right\">\n            {{event.name}}\n          </span>\n          <span *ngIf=\"!event.autoGenerated\">\n            {{event.name}}\n          </span>\n        </td>\n        <td data-se-id=\"eventReferenceNumber\">\n          {{event.eventReferenceNumber}}\n        </td>\n        <td data-se-id=\"endDate\">{{event.endDate | date: 'shortDate' }}</td>\n        <td data-se-id=\"payStatus\">{{event.payStatus | paymentStatus }}</td>\n        <td>{{event.paymentModifiedDate | date: 'shortDate' }}</td>\n        <td>{{event.paymentCreatedDate | date: 'shortDate' }}</td>\n        <td>{{getPaymentAmount(event) | currency:'USD':true }}</td>\n        <td>{{event.adjustmentAmount | currency:'USD':true }}</td>\n        <td>{{getEstimatedDue(event) | currency:'USD':true }}</td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n"

/***/ }),

/***/ "roPR":
/***/ (function(module, exports) {

//# sourceMappingURL=/var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/lookup.store.js.map

/***/ }),

/***/ "tzTa":
/***/ (function(module, exports) {

module.exports = "<li class=\"nav-item\">\n  <a (click)=\"navigateToSearch()\"\n     data-se-id=\"editEventLink\"\n     class=\"nav-link active\">\n    <i class=\"glyph-calendar nav-link-addon\"></i>\n    <span class=\"item-text\">{{ eventTitle | translate }}</span>\n    <i class=\"nav-link-addon glyph-close\"></i>\n  </a>\n</li>\n"

/***/ }),

/***/ "vFLc":
/***/ (function(module, exports) {

module.exports = "<div id=\"flashMessages\">\n  <div class=\"flash-message alert {{findClass(message)}}\" *ngFor='let message of messages'>\n    <div [innerHtml]=\"message.message\"></div>\n    <button class=\"close\" *ngIf=\"showClose(message)\" (click)=\"closeMessage(message)\">\n      <span>{{ 'COMMON.BUTTON.CLOSE' | translate }}</span>\n    </button>\n  </div>\n</div>\n"

/***/ }),

/***/ "vWpv":
/***/ (function(module, exports) {

module.exports = "<pioneer-confirmation-modal\n  data-se-id=\"add-payment-confirmation-modal\"\n  content=\"EVENT.COMMISSION.CONFIRMATION_CONTENT\"\n  cancel=\"COMMON.BUTTON.CANCEL\"\n  confirm=\"EVENT.COMMISSION.CONFIRMATION_CONFIRM\"\n  [title]=\"confirmationModalConfig.title\"\n  (closed)=\"confirmBeforeAddPaymentHandler($event)\">\n</pioneer-confirmation-modal>\n\n  <div class=\"card\">\n  <div class=\"card-header\" id=\"card-commission-payment\">\n    {{ 'EVENT.COMMISSION.ADD_PAYMENT_HEADER' | translate }}\n      <pioneer-automatic-payment-toggle [event]=\"onyxEvent\"></pioneer-automatic-payment-toggle>\n  </div>\n  <div class=\"card-block\">\n    <form [formGroup]=\"adjustmentForm\" data-se-id=\"addAdjustmentForm\">\n      <div class=\"row\">\n        <div class=\"form-container pay-equation\">\n          <div class=\"row\">\n            <pioneer-payment-adjustment-equation\n              [event]=\"onyxEvent\"\n              [isEditMode]=\"true\">\n            </pioneer-payment-adjustment-equation>\n          </div>\n        </div>\n        <div class=\"form-container pay-equation\">\n          <div class=\"row\">\n            <div class=\"form-container adj-add\">\n              <pioneer-form-input\n                label=\"EVENT.COMMISSION.INCLUDE_ADJUSTMENT\"\n                [isReadOnly]=\"false\"\n                [message]=\"'MESSAGES.ERROR.ADJUSTMENT_MUST_BE_POSITIVE' | translate\">\n                <div class=\"input-group\">\n                  <input type=\"number\"\n                         step=\"any\"\n                         class=\"form-control text-left\"\n                         id=\"amntAdjusted\"\n                         placeholder=\"{{ 'EVENT.COMMISSION.ADJUSTMENT_AMOUNT_PLACEHOLDER' | translate }}\"\n                         value=\"\"\n                         formControlName=\"adjustmentAmount\"/>\n                  <div class=\"input-group-addon addon-btn\">\n                    <div class=\"dropdown-toggle\" data-toggle=\"dropdown\" data-se-id=\"adjustmentDropdownToggle\">\n                      {{ 'EVENT.COMMISSION.ADD_AS' | translate }}\n                    </div>\n                    <div class=\"dropdown-menu dropdown-menu-right\">\n                      <a class=\"dropdown-item\"\n                         data-se-id=\"adjustmentTypePrepayment\"\n                         (click)=\"addAdjustment(adjustmentTypes.PREPAYMENT)\">\n                        {{ 'ADJUSTMENT_REASON.PREPAYMENT' | translate }}\n                      </a>\n                      <a class=\"dropdown-item\"\n                         data-se-id=\"adjustmentTypeRebate\"\n                         (click)=\"addAdjustment(adjustmentTypes.REBATE)\">\n                        {{ 'ADJUSTMENT_REASON.REBATE' | translate }}\n                      </a>\n                    </div>\n                  </div>\n                </div>\n              </pioneer-form-input>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n    <form *ngIf=\"ui.showDescription\"\n          [formGroup]=\"paymentForm\">\n      <div class=\"row\">\n        <div class=\"form-container pay-desc\">\n          <pioneer-form-input label=\"EVENT.COMMISSION.DESCRIPTION\" [isReadOnly]=\"false\">\n            <input type=\"text\"\n                   class=\"form-control\"\n                   placeholder=\"{{ 'EVENT.COMMISSION.DESCRIPTION_PLACEHOLDER' | translate }}\"\n                   id=\"paymentDesc\"\n                   formControlName=\"description\"/>\n          </pioneer-form-input>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n\n<div *ngIf=\"ui.showAuthorizePaymentButton\"\n     class=\"button-bar\">\n  <p *ngIf=\"isAddPaymentEnabled() | async\" class=\"text-hint\">{{ 'EVENT.COMMISSION.PAYMENTS_WILL_BE_PROCESSED' | translate }}</p>\n  <p *ngIf=\"!(isAddPaymentEnabled() | async)\" class=\"text-hint\">{{ 'EVENT.COMMISSION.PAYMENT_OPTION_DISABLED' | translate }}</p>\n  <button class=\"btn btn-primary\"\n          (click)=\"confirmBeforeAuthorizingPayment()\"\n          data-se-id=\"paymentSubmitButton\"\n          [disabled]=\"!(isAddPaymentEnabled() | async)\">\n    {{ 'EVENT.COMMISSION.AUTHORIZE_PAYMENT' | translate }}\n  </button>\n</div>\n"

/***/ }),

/***/ "wvGA":
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"!valid\">\n  <p class=\"form-control-feedback\">{{getValidationMessage(error)}}</p>\n</div>\n"

/***/ }),

/***/ "xhPN":
/***/ (function(module, exports) {

module.exports = "<div class=\"splash-content\">\n  <div class=\"splash-container\">\n    <div class=\"login-logo\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n    <div>\n      <h4>Frontend Version:</h4>\n      <pre class=\"splash-message\">{{frontendVersionObj | json}}</pre>\n    </div>\n    <div>\n      <h4>Backend Version:</h4>\n      <pre class=\"splash-message\">{{backendVersionObj | json}}</pre>\n    </div>\n  </div>\n</div>\n"

/***/ }),

/***/ "ys9C":
/***/ (function(module, exports) {

module.exports = "<div class=\"card\">\n  <div class=\"card-header\" id=\"card-stay-information\">{{'EVENT.COMMISSION.DETAILS' | translate}}\n  </div>\n  <div class=\"table-responsive\">\n    <table class=\"table\">\n      <thead>\n      <tr>\n        <th>{{'EVENT.COMMISSION.NAME' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.CONFIRMATION_NUMBER' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.STATUS' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.ROOM_TYPE' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.CHECKIN_DATE' | translate}}</th>\n        <th>{{'EVENT.COMMISSION.CHECKOUT_DATE' | translate}}</th>\n        <th class=\"nights\">{{'EVENT.COMMISSION.NUMBER_NIGHTS' | translate}}</th>\n        <th class=\"currency\">{{'EVENT.COMMISSION.ROOM_RATE' | translate}}</th>\n        <th class=\"currency\">{{'EVENT.COMMISSION.REVENUE' | translate}}</th>\n        <th class=\"currency\">{{'EVENT.COMMISSION.COMMISSION' | translate}}</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr *ngFor=\"let reservation of reservations | async\"\n          data-se-id=\"reservationRow\">\n        <td data-se-id=\"lastName\">{{reservation.lastName}}, {{reservation.firstName}}</td>\n        <td>{{reservation.confirmation}}</td>\n        <td>{{reservation.status | reservationStatus}}</td>\n        <td>{{reservation.roomType}}</td>\n        <td>{{reservation.checkInDate | date:'MMM-dd'}}</td>\n        <td>{{reservation.checkOutDate | date:'MMM-dd'}}</td>\n        <td class=\"nights\">{{reservation.nights}}</td>\n        <td class=\"currency\">{{reservation.roomRate | currency:'USD':true}}</td>\n        <td class=\"currency\" data-se-id=\"revenue\">{{ reservation.revenue | currency:'USD':true}}\n        </td>\n        <td class=\"currency\" data-se-id=\"commission\">{{ getCommission(reservation) |\n          currency:'USD':true}}\n        </td>\n      </tr>\n      </tbody>\n      <tfoot>\n      <tr data-se-id=\"reservationsSummaryRow\">\n        <td>{{'EVENT.COMMISSION.TOTAL' | translate}}</td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td class=\"nights\">{{(staySummary | async)?.totalNights}}</td>\n        <td></td>\n        <td class=\"currency\">{{(staySummary | async)?.totalRevenue | currency: 'USD':true}}</td>\n        <td class=\"currency\" data-se-id=\"totalCommission\">\n          {{ getCommissionFromStaySummary( (staySummary | async) ) | currency: 'USD':true}}\n        </td>\n      </tr>\n      </tfoot>\n    </table>\n  </div>\n</div>\n"

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.524821e8e1c757185a73.bundle.js